import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ViewChildren,
  QueryList,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';
import {
  BeneficiarioTarifa,
  ResumenTarifas,
} from '../../models/beneficiario-tarifa.model';
import {
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  Observable,
  Subject,
  BehaviorSubject,
  combineLatest,
  forkJoin,
  of,
  merge,
  firstValueFrom,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  takeUntil,
  map,
  switchMap,
  startWith,
  debounceTime,
  distinctUntilChanged,
  filter,
  catchError,
  finalize,
  defaultIfEmpty,
  retry,
} from 'rxjs/operators';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import {
  SolicitudActivaModalComponent,
  SolicitudActivaModalData,
} from '../solicitud-activa-modal/solicitud-activa-modal.component';
import { DebitoAutomaticoWarningModalComponent } from '../debito-automatico-warning-modal/debito-automatico-warning-modal.component';
import {
  ReglaPerfilamiento,
  ValidacionPerfilamientoResponse,
  CONSTANTS as MODEL_CONSTANTS,
} from '../../models/tipo-novedad.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DdMmYyyyDateAdapter } from '../../utils/custom-date-adapter';
import { FECHA_APLICACION_NOVEDAD_DATE_FORMATS } from '../../utils/date-format';
import { LocalStorageService } from '../../local-storage/local-storage.service';
import { TipoNovedadSelectorBridgeService } from '../../services/radicacion-traslados-service/tipo-novedad-selector-bridge.service';
import { EstadosCivilesService } from '../../services/estados-civiles/estados-civiles.service';
import { CortesService } from '../../services/cortes/cortes.service';
import { TiposDocumentoService } from '../../services/tipos-documento/tipos-documento.service';
import { EstratosSocialesService } from '../../services/estratos-sociales/estratos-sociales.service';
import { NacionalidadesService } from '../../services/nacionalidades/nacionalidades.service';
import { OcupacionesService } from '../../services/ocupaciones/ocupaciones.service';
import { ProfesionesService } from '../../services/profesiones/profesiones.service';
import { GenerosService } from '../../services/generos/generos.service';
import { SubcuentasProgramaService } from '../../services/subcuentas-programa/subcuentas-programa.service';
import {
  TiposNovedadService,
  TipoNovedadDTO,
} from '../../services/radicacion-traslados-service/tipos-novedad.service';
import {
  SubtiposNovedadService,
  SubtiposNovedadDTO,
  SubtipoDTO,
} from '../../services/radicacion-traslados-service/subtipos-novedad.service';
import {
  SolicitudesRadicadasService,
  SolicitudRadicadaDTO,
} from '../../services/radicacion-traslados-service/solicitudes-radicadas.service';
import { ValidacionSolicitudActivaService } from '../../services/radicacion-traslados-service/validacion-solicitud-activa.service';
import { ProgramasLineaNegocioService } from '../../services/radicacion-traslados-service/programas-linea-negocio.service';
import { TiposPrimaService } from '../../services/radicacion-traslados-service/tipos-prima.service';
import {
  TarifasDestinoService,
  TarifasDestinoRequest,
  TarifaCotizadorTrlRequest,
} from '../../services/radicacion-traslados-service/tarifas-destino.service';
import { TiposPlanService } from '../../services/tipos-plan/tipos-plan.service';
import { CuentaColectivoCorporativoService } from '../../services/radicacion-traslados-service/cuenta-colectivo-corporativo.service';
import { ValidacionContratoService } from '../../services/radicacion-traslados-service/validacion-contrato.service';
import { ContratosUsersService } from '../../services/radicacion-traslados-service/contratos-users.service';
import { PartidosComercialesService } from '../../services/radicacion-traslados-service/partidos-comerciales.service';
import { BeneficiariosTarifaService } from '../../services/radicacion-traslados-service/beneficiarios-tarifa.service';
import { AnexosDestinoService } from '../../services/radicacion-traslados-service/anexos-destino.service';
import {
  AdicionaAnexoConsultaService,
  AdicionaAnexoConsultaRequestPayload,
} from '../../services/radicacion-traslados-service/adiciona-anexo-consulta.service';
import {
  AdicionaAnexoConsultaResponse,
  AdicionaAnexoFilaConsultaDTO,
  CatalogoAnexoConsultaDTO,
} from '../../models/adiciona-anexo/adiciona-anexo-consulta.model';
import { ParentescosTrasladosService } from '../../services/radicacion-traslados-service/parentescos-traslados.service';
import { ContratoContratanteCabeceraService } from '../../services/radicacion-traslados-service/contrato-contratante-cabecera.service';
import { DatosAfiliadoPagadorService } from '../../services/radicacion-traslados-service/datos-afiliado-pagador.service';
import { ContratoContratanteCabeceraDTO } from '../../models/contrato-afilmed/contrato-contratante-cabecera.model';
import { ColectivoCorporativo } from '../../models/colectivo-corporativo/colectivo-corporativo.model';
import {
  ContratoAfilmedDTO,
  leerCuentaAfilmed,
} from '../../models/contrato-afilmed/contrato-afilmed.model';
import { environment } from '../../../environments/environment';
import {
  PerfilamientoValidarService,
  IntegrantePerfilamientoRequest,
  PerfilamientoValidarRequest,
} from '../../services/radicacion-traslados-service/perfilamiento-validar.service';
import { CatalogoTiposNovedadQuery } from '../../services/radicacion-traslados-service/tipos-novedad.service';
import { TipoSolicitudNovedadTrasladoIdService } from '../../services/radicacion-traslados-service/tipo-solicitud-novedad-traslado-id.service';
import { ProvinciasXPaisService } from '../../services/provincia-por-pais/provincia-por-pais.service';
import { MunicipiosPorDepartamentoService } from '../../services/municipios-por-pais/municipios-por-pais.service';
import { ProvinciaXPaisDTO } from '../../models/provincia-por-pais/provincia-por-pais.model';
import { ModalBasicComponent } from '../common/dialogs/modal-basic/modal-basic.component';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InfoAlertComponent } from '../info-alert/info-alert.component';
import { InfomedicalSubcuentaProgramaService } from '../../services/infomedical-subcuenta-programa/infomedical-subcuenta-programa.service';

registerLocaleData(localeEsCO);

export interface TipoNovedad {
  codigo: string;
  nombre: string;
  descripcion?: string;
  idTipoSolicitud?: number | null;
  estado: 'ACTIVO' | 'INACTIVO';
  tipoSolicitud: string;
  aplicaContratoTransitorio: boolean;
  codigoTipoNovedad: string;
}

export interface SubtipoNovedad {
  id: string;
  nombre: string;
  descripcion?: string;
  estado: 'ACTIVO' | 'INACTIVO';
  tipoNovedadCodigo: string;
  /** Catálogo BD (`aplicaNovedadIntegrantes`): «Si» fuerza selección de todos los integrantes. */
  aplicaNovedadIntegrantes?: string | null;
  codigoSubtipo: string;
}

export interface ContratoInfo {
  numero: string;
  estado: string;
  titular: string;
  fechaInicio: Date;
  ProgramaCodigo?: string;
  ProgramaNombre?: string;
  GrupoPrograma?: string;
  LineaNegocio?: string;
  TipoPrima?: string | null;
  ColectivoEspecial?: string | null;
  integrantes?: IntegranteContrato[];
}

/**
 * Subtipos donde debe resolverse el tipo de prima del contrato origen vía POST `/tipos-prima`.
 */
const SUBTIPOS_TRASLADO_TIPO_PRIMA_DESDE_PARAMETRIZACION = new Set<string>([
  'Traslado Downgrade',
  'Traslado Upgrade',
  'Traslado Lineal',
]);

const SUBTIPOS_FORZAR_INCLUIR_ANEXO_HABILITADO = new Set<string>([
  'Cambio de persona Natural a Jurídico',
  'Traslado a colectivo',
  'Traslado Downgrade',
  'Traslado Lineal',
  'Traslado Upgrade',
]);

/** Subtipos de «Cambio de cobertura» con tabla de integrantes + misma validación de anexos por fila (`filas` en adiciona-anexo/consulta). */
const SUBTIPOS_REGLA_TABLA_CAMBIO_COBERTURA = new Set<string>([
  'Cambio de persona Natural a Jurídico',
  'Traslado a colectivo',
  'Traslado Downgrade',
  'Traslado Lineal',
  'Traslado Upgrade',
]);

export interface IntegranteContrato {
  id: string;
  identificacion: string;
  nombre: string;
  parentesco: string;
  seleccionado: boolean;
}

export interface SolicitudActivaResponse {
  existeSolicitud: boolean;
  numeroSolicitud?: string;
  mensaje?: string;
}

interface TipoNovedadSelectorState {
  tipoNovedad: TipoNovedad | null;
  subtipoNovedad: SubtipoNovedad | null;
  tipoPlanDestino: any;
  programaDestino: any;
  tarifaDestino: any;
  corteDestino: any;
  proporcionalidad: string | null;
  incluirAnexo: boolean;
  tipoContratante: string | null;
  cambiarDatosContratante: boolean;
  codigoAsesorDestino: string | null;
  tipoDocumentoContratante: any;
  numeroDocumentoContratante: string | null;
  primerApellidoContratante: string | null;
  segundoApellidoContratante: string | null;
  primerNombreContratante: string | null;
  segundoNombreContratante: string | null;
  fechaNacimientoContratante: Date | string | null;
  estadoCivilContratante: any;
  generoContratante: any;
  estratoSocialContratante: any;
  nacionalidadContratante: any;
  profesionContratante: any;
  recibirCorrespondencia: string | null;
  emailContratante: string | null;
  ocupacionContratante: any;
  tipoIdentificacionNuevoContratante: any;
  numeroIdentificacionNuevoContratante: string | null;
  nombreNuevoContratante: string | null;
  nuevoTitularSeleccionado: any;
  tipoVia: any;
  numeroVia: number | null;
  // Débito automático - nuevo responsable
  activarDebitoAutomaticoNuevoResponsable?: boolean | null;
  metodoDebitoAutomatico?: 'tarjeta' | 'cuenta' | null;
  confirmacionGestionTarjeta?: boolean | null;
  tipoCuentaDebito?: 'AHO' | 'CTE' | null;
  bancoDebito?: any;
  bancoDebitoNombre?: string | null;
  numeroCuentaDebito?: string | null;
  numeroPlaca: string | null;
  direccion: string | null;
  complementoDireccion: string | null;
  barrio: any;
  departamento: any;
  municipio: any;
  telefonoResidencia: string | null;
  celular: string | null;
  colectivo: any;
  subcuentaDestino: any;
  sucursalDestino: any;
  programaDestinoColectivo: any;
  proporcionalidadColectivo: string | null;
  corteSubcuenta: any;
  tarifaDestinoColectivo: any;
  tipoPlanDestinoContrato: any;
  programaDestinoContrato: any;
  subcuentaDestinoContrato: any;
  corteDestinoContrato: any;
  tarifaDestinoContrato: any;
  sucursalComercializableContrato: any;
  proporcionalidadContrato: string | null;
  tipoIdentificacionContratanteDestino: any;
  numeroIdentificacionContratanteDestino: string | null;
  contratoDestino: any;
  corteContratoDestino: any;
  proporcionalidadExistente: string | null;
  tipoPlanDestinoExistente: any;
  lineaNegocioDestinoExistente: any;
  grupoProgramaDestinoExistente: any;
  /** Grupo programa destino (cambio cobertura / lineal) para documentos-parametrizados. */
  grupoProgramaDestino?: string;
  programaDestinoExistente: any;
  tipoPrimaDestinoExistente: any;
  codTarifaDestinoExistente: any;
  incluirAnexoExistente: boolean | null;
  tarifaCambio: any;
  valorTotalCuotaIva: number | null;
  selectedTipoNovedad: TipoNovedad | null;
  /** Id de `TRL_CAT_TIPO_SOLICITUD` resuelto al elegir tipo de novedad (radicar / documentos). */
  idTipoSolicitud?: number | null;
  selectedSubtipoNovedad: SubtipoNovedad | null;
  mostrarCampoColectivo: boolean;
  mostrarCambioTitular: boolean;
  mostrarCamposCambioCobertura: boolean;
  mostrarTablaBeneficiarios: boolean;
  mostrarCamposTrasladoContratoNuevo: boolean;
  mostrarTablaIntegrantesContratoNuevo: boolean;
  mostrarCamposTrasladoContratoExistente: boolean;
  mostrarTablaIntegrantesTrasladoExistente: boolean;
  mostrarTablaAdicionaAnexo: boolean;
  // Datos de las tablas
  beneficiariosTarifa: any[];
  integrantesTrasladoExistente: any[];
  integrantesContratoNuevo: any[];
  integrantesContratoDestino: any[];
  integrantesAdicionaAnexo: any[];
  /** Fecha en que aplica la novedad (paso 2). */
  fechaAplicacionNovedad: Date | string | null;
  /** Rehidratar flujo «Cambio de cobertura» sin reconsultar tipo de prima. */
  tipoPrimaObtenido?: boolean;
  errorTipoPrima?: string | null;
  tipoPrimaOrigenPersistido?: string;
  /** Snapshots de listas para mat-select tras F5 (referencias + opciones). */
  tiposPlanesUi?: any[];
  subcuentasDestinoUi?: any[];
  sucursalesDestinoUi?: any[];
  programasDestinoColectivoUi?: any[];
  cortesSubcuentaUi?: any[];
  tarifasDestinoColectivoUi?: any[];
  /** Totales del pie de tablas de tarifa (servicios ya devuelven valores con IVA; suma de filas, sin recalcular IVA en front). */
  totalCuotaIva?: number;
  totalCuotaIvaContratoNuevo?: number;
  totalCuotaIvaTrasladoExistente?: number;
  totalCuotaIvaAdicionaAnexo?: number;
}

const TIPOS_TODOS_INTEGRANTES = new Set([
  'CAMBIO_COBERTURA',
  'CAMBIO_CONTRATANTE',
  'CAMBIO_PLAN',
  'CAMBIO_TARIFA',
]);

const CODIGO_TIPO_NOVEDAD_CAMBIO_TARIFA = 'CAMBIO_TARIFA';
const CODIGO_TIPO_NOVEDAD_ADICIONA_ANEXO = 'ADICIONA_ANEXO';

/** Regla de negocio: traslado a contrato nuevo no puede incluir al 100% de integrantes del contrato origen. */
const MSG_NO_TRASLADO_TODOS_INTEGRANTES =
  'No se pueden trasladar a todos los integrantes del contrato actual al nuevo contrato.';

/** MP-FT-1358 1.1.3.4 — subtipo «Cambio de titular a responsable pagador» (texto literal del RS). */
const MSG_MP_FT_1358_TITULAR_NO_DEBE_SER_RESPONSABLE =
  'Para seleccionar este tipo de novedad, el titular no debe ser el responsable de pago del contrato.';

/** MP-FT-1358 1.1.3.6 — Cambio de tarifa: listado vacío (texto literal del RS). */
const MSG_MP_FT_1358_CAMBIO_TARIFA_SIN_REGISTROS =
  'No se encontraron tarifas activas asociadas a la línea de negocio, tipo de plan y programa seleccionado. Contacte al administrador del sistema o al administrador de operaciones.';

/** MP-FT-1358 1.1.3.1.b — lista programa destino vacía tras filtro por subtipo (Upgrade/Downgrade/Lineal). */
const MSG_MP_FT_1358_PROGRAMAS_SUBTIPO_VACIO =
  'No existen programas disponibles para el tipo y subtipo de novedad seleccionado.';

/** MP-FT-1358 1.1.3.2 — contratos destino distinta línea de negocio al filtrar resultados del servicio. */
const MSG_MP_FT_1358_CONTRATO_DESTINO_OTRA_LINEA =
  'No se encontró un contrato activo con los datos diligenciados en la misma línea de negocio que el contrato origen. Verifique los datos e intente nuevamente.';

/** MP-FT-1358 1.1.3.2 — listado vacío tras búsqueda por documento del contratante. */
const MSG_CONTRATO_DESTINO_SIN_RESULTADOS =
  'No se encontró un contrato activo con los datos diligenciados. Verifique los datos e intente nuevamente.';

/** MP-FT-1358 1.1.3.2 — cuenta 24690 / persuasión sin servicio. */
const MSG_CONTRATO_DESTINO_TRANSITORIO_24690 =
  'No se permite la selección de contratos transitorios de persuasión sin servicio.';
const CONSTANTS = {
  TIPO_SOLICITUD: 'Novedad de Traslado',
  ESTADO_ACTIVO: 'ACTIVO',
  ESTADO_INACTIVO: 'INACTIVO',
};

export const TIPO_NOVEDAD_STORAGE_KEY = 'tipoNovedadSelectorState';

/** Campos de destino que no deben pasar a null por un persist debounced al cambiar de paso. */
const CAMPOS_DESTINO_SIN_DEGRADAR: ReadonlyArray<
  keyof TipoNovedadSelectorState
> = [
  'tipoPlanDestino',
  'programaDestino',
  'tarifaDestino',
  'corteDestino',
  'subcuentaDestino',
  'sucursalDestino',
  'colectivo',
  'programaDestinoColectivo',
  'tarifaDestinoColectivo',
  'corteSubcuenta',
  'tipoPlanDestinoContrato',
  'programaDestinoContrato',
  'subcuentaDestinoContrato',
  'corteDestinoContrato',
  'tarifaDestinoContrato',
  'sucursalComercializableContrato',
];

/** Valores que alimentan el bloque «INFORMACIÓN DEL CONTRATANTE DESTINO». */
interface DatosContratantePrecarga {
  codigoAsesor: string;
  tipoDocumento: string;
  numeroDocumento: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  fechaNacimiento: Date;
  estadoCivil: any;
  genero: any;
  estratoSocial: any;
  nacionalidad: any;
  profesion: any;
  recibirCorrespondencia: string;
  email: string;
  ocupacion: any;
  tipoVia: any;
  numeroVia: any;
  numeroPlaca: string;
  direccion: string;
  complementoDireccion: string;
  barrio: any;
  departamento: any;
  municipio: any;
  telefonoResidencia: string;
  celular: string;
}

// Datos quemados - reemplazan los archivos JSON de la carpeta mocks

@Component({
  selector: 'app-tipo-novedad-selector',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatTableModule,
    MatTooltipModule,
    MatCardModule,
    MatDialogModule,
    NgbTooltipModule,
    InfoAlertComponent,
  ],
  templateUrl: './tipo-novedad-selector.component.html',
  styleUrls: ['./tipo-novedad-selector.component.css'],
  providers: [
    { provide: DateAdapter, useClass: DdMmYyyyDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: FECHA_APLICACION_NOVEDAD_DATE_FORMATS,
    },
  ],
})
export class TipoNovedadSelectorComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @Input() contratoSeleccionado: ContratoInfo | null = null;
  /** Respuesta cruda de `contratos-users` para el contrato del ojo; prioridad sobre localStorage. */
  @Input() filaContratoAfilmedPaso1: ContratoAfilmedDTO | null = null;
  /**
   * Número de contrato elegido en paso 1 (`selectedContract` en el padre).
   * Garantiza el query `numeroContrato` del GET aunque la fila Afilmed no llegue al hijo.
   */
  @Input() numeroContratoPaso1: string | null = null;
  @Input() integrantesSeleccionados: IntegranteContrato[] = [];
  @Input() integrantesSeleccionadosPaso1: IntegranteContrato[] = [];
  /** Filas completas del contrato en paso 1 (p. ej. `validacionTablaData`); necesario para validar que no se elijan todos los integrantes en traslado a contrato nuevo. */
  @Input() integrantesTotalesContratoActual: any[] = [];
  @Input() disabled: boolean = false;
  @Input() readonly = false;

  @ViewChildren(MatSelect) private matSelects!: QueryList<MatSelect>;

  @ViewChild('subtipoTrigger', { read: MatAutocompleteTrigger })
  private subtipoAutocompleteTrigger?: MatAutocompleteTrigger;

  @Output() tipoNovedadSeleccionada = new EventEmitter<TipoNovedad | null>();
  @Output() subtipoNovedadSeleccionada =
    new EventEmitter<SubtipoNovedad | null>();
  @Output() validacionCompletada = new EventEmitter<boolean>();
  @Output() integrantesActualizados = new EventEmitter<IntegranteContrato[]>();
  /** Actualiza `TipoPrima` del contrato origen (paso 1) tras consulta `/tipos-prima`. */
  @Output() contratoPaso1Actualizado = new EventEmitter<
    Partial<ContratoAfilmedDTO>
  >();

  private readonly storageKey = TIPO_NOVEDAD_STORAGE_KEY;

  tipoNovedadControl = new FormControl<TipoNovedad | null>(null, [
    Validators.required,
  ]);
  subtipoNovedadControl = new FormControl<SubtipoNovedad | null>(null);

  tipoPlanDestinoControl = new FormControl<any>(null);
  programaDestinoControl = new FormControl<any>(null);
  tarifaDestinoControl = new FormControl<any>(null);
  corteDestinoControl = new FormControl<any>(null);
  proporcionalidadControl = new FormControl<string>('Si', [
    Validators.required,
  ]);
  incluirAnexoControl = new FormControl<boolean>(false);

  /** Obligatorio para todos los tipos de novedad; precarga según corte destino + 1 (mes siguiente). */
  fechaAplicacionNovedadControl = new FormControl<Date | null>(null, [
    Validators.required,
  ]);

  tipoContratanteControl = new FormControl<string>('mantener', [
    Validators.required,
  ]);
  cambiarDatosContratanteControl = new FormControl<boolean>(false);
  codigoAsesorDestinoControl = new FormControl<string>('', [
    Validators.required,
  ]);
  tipoDocumentoContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  numeroDocumentoContratanteControl = new FormControl<string>('', [
    Validators.required,
  ]);
  primerApellidoContratanteControl = new FormControl<string>('', [
    Validators.required,
  ]);
  segundoApellidoContratanteControl = new FormControl<string>('');
  primerNombreContratanteControl = new FormControl<string>('', [
    Validators.required,
  ]);
  segundoNombreContratanteControl = new FormControl<string>('');
  fechaNacimientoContratanteControl = new FormControl<Date | null>(null, [
    Validators.required,
  ]);
  estadoCivilContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  generoContratanteControl = new FormControl<any>(null, [Validators.required]);
  estratoSocialContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  nacionalidadContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  profesionContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  recibirCorrespondenciaControl = new FormControl<string>('Si', [
    Validators.required,
  ]);
  emailContratanteControl = new FormControl<string>('', [
    Validators.required,
    Validators.email,
  ]);
  ocupacionContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);

  tipoIdentificacionNuevoContratanteControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  numeroIdentificacionNuevoContratanteControl = new FormControl<string>('', [
    Validators.required,
    this.numeroIdentificacionValidator(30),
  ]);
  nombreNuevoContratanteControl = new FormControl<string>(
    { value: '', disabled: true },
    [Validators.required],
  );
  nuevoTitularSeleccionadoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  motivoRetiroResponsableControl = new FormControl<any>(null);
  activarDebitoAutomaticoNuevoResponsableControl = new FormControl<boolean>(
    false,
  );
  metodoDebitoAutomaticoControl = new FormControl<'tarjeta' | 'cuenta' | null>(
    null,
  );
  confirmacionGestionTarjetaControl = new FormControl<boolean>(false);
  tipoCuentaDebitoControl = new FormControl<'AHO' | 'CTE' | null>(null);
  bancoDebitoControl = new FormControl<any>(null, {
    validators: [Validators.required],
  });
  bancoDebitoNombreControl = new FormControl<string>('');
  // numeroCuentaDebitoControl = new FormControl<string>('');
  numeroCuentaDebitoControl = new FormControl<string>('', {
    validators: [Validators.required],
  });

  tipoViaControl = new FormControl<any>(null, [Validators.required]);
  numeroViaControl = new FormControl<number | null>(null);
  numeroPlacaControl = new FormControl<string>('');
  direccionControl = new FormControl<string>('', [Validators.required]);
  complementoDireccionControl = new FormControl<string>('');
  barrioControl = new FormControl<any>(null, [Validators.required]);
  departamentoControl = new FormControl<any>(null, [Validators.required]);
  municipioControl = new FormControl<any>(null, [Validators.required]);
  telefonoResidenciaControl = new FormControl<string>('', [
    Validators.required,
  ]);
  celularControl = new FormControl<string>('', [Validators.required]);

  private tiposNovedadSubject = new BehaviorSubject<TipoNovedad[]>([]);
  public tiposNovedad$ = this.tiposNovedadSubject.asObservable();
  public filteredTiposNovedad$!: Observable<TipoNovedad[]>;
  /** Texto de búsqueda del input (no el valor del FormControl: puede ser objeto o string según Material). */
  private tipoNovedadBusqueda$ = new BehaviorSubject<string>('');

  private subtiposNovedadSubject = new BehaviorSubject<SubtipoNovedad[]>([]);
  public subtiposNovedad$ = this.subtiposNovedadSubject.asObservable();
  public filteredSubtiposNovedad$!: Observable<SubtipoNovedad[]>;
  private subtipoNovedadBusqueda$ = new BehaviorSubject<string>('');
  public isLoadingTipos = false;
  public isLoadingSubtipos = false;
  public hasErrorTipos = false;
  public hasErrorSubtipos = false;
  /**
   * Sin día de corte disponible para sugerir la fecha por defecto.
   * El usuario puede elegir la fecha manualmente o usar Reintentar.
   */
  public fechaAplicacionNovedadDefaultError = false;
  public errorMessage = '';

  public showSubtipoField = false;
  public isSubtipoRequired = false;
  public subtipoHabilitado = false;

  public tipoPrimaOrigen: string = '';
  public tipoPrimaDestino: string = '';
  public lineaNegocioDestino: string = 'Medicina Integral';
  public grupoProgramaDestino: string = '';
  public subcuentaDestino: string = '';

  public programasDestinoFiltrados: any[] = [];
  public selectedTipoNovedad: TipoNovedad | null = null;
  public selectedSubtipoNovedad: SubtipoNovedad | null = null;

  public mostrarCamposCambioCobertura = false;
  public isLoadingTipoPrima = false;
  public tipoPrimaObtenido = false;
  /** Evita repetir POST `/tipos-prima` para el mismo contrato origen. */
  private tipoPrimaConsultaOrigenKey = '';
  /** Tras quitar Downgrade/Upgrade/Lineal, la próxima selección debe reconsultar `/tipos-prima`. */
  private tipoPrimaReconsultaPendiente = false;
  public errorTipoPrima: string | null = null;
  public isLoadingProgramas = false;

  public tiposPlanes: any[] = [];
  public programasDestino: any[] = [];
  public filtroProgramaDestino = '';
  public filtroSubcuentaDestino = '';
  public filtroSubcuentaContrato = '';
  public filtroProgramaDestinoColectivo = '';
  public filtroTarifaDestinoContrato = '';
  public filtroTarifaDestino = '';
  public filtroTarifaDestinoColectivo = '';
  private filtroProgramaContratoNuevoSubject = new BehaviorSubject<string>('');
  public programasContratoFiltrados$!: Observable<any[]>;
  public tarifasDestino: any[] = [];
  public cortesDestino: any[] = [];
  public opcionesProporcionalidad = [
    { valor: 'Si', nombre: 'Si' },
    { valor: 'No', nombre: 'No' },
  ];

  public tiposDocumentoContratante: any[] = [];
  public estadosCiviles: any[] = [];
  public generos: any[] = [];
  public estratosSociales: any[] = [];
  public nacionalidades: any[] = [];
  public profesiones: any[] = [];
  public ocupaciones: any[] = [];
  public tiposVia: any[] = [];
  public barrios: any[] = [];
  public departamentos: any[] = [];
  public municipios: any[] = [];

  public puedeEditarDatosContratante: boolean = false;
  public esCampoEditableContratante: boolean = false;
  /** Demografía, contacto y dirección: solo si “Cambio de datos del contratante” está activo (RF mockups). */
  public contratanteEdicionComplementariaActiva: boolean = false;
  public puedeEditarCodigoAsesor: boolean = false;
  public puedeActualizarAfilmed: boolean = false;

  public mostrarCambioTitular: boolean = false;
  public mostrarCambioResponsablePagador: boolean = false;
  public integrantesSinTitular: IntegranteContrato[] = [];
  public datosContratanteActual: any = null;
  public isLoadingActualizacionAfilmed: boolean = false;

  /**
   * Titular actual: integrante con parentesco «Titular» (MP-FT-1358 1.1.3.4).
   * Solo lectura en pantalla.
   */
  public titularActualVista: {
    tipoTexto: string;
    numeroTexto: string;
    nombreCompleto: string;
  } | null = null;

  /** Mensaje de error de negocio o fallo al validar responsable de pago. */
  public cambioTitularMensajeAlerta = '';

  /**
   * true cuando hay titular en contrato, se obtuvo responsable de pago y no aplica bloqueo MP-FT-1358.
   * Habilita elegir nuevo titular en tabla y exige selección para «Siguiente».
   */
  public cambioTitularRequisitosPreviosOk = false;
  public motivosRetiroResponsable: any[] = [
    { codigo: 'FALLECIMIENTO', nombre: 'FALLECIMIENTO' },
    { codigo: 'SOLICITUD', nombre: 'SOLICITUD DEL USUARIO' },
    { codigo: 'OTRO', nombre: 'OTRO' },
  ];
  public bancosDebitoAutomatico: any[] = [
    { codigo: 'BANCOLOMBIA', nombre: 'BANCOLOMBIA' },
    { codigo: 'AVVILLAS', nombre: 'BANCO AV VILLAS' },
    { codigo: 'BOGOTA', nombre: 'BANCO DE BOGOTA' },
  ];
  public advertenciaDebitoActualCambioResponsable = '';
  public tieneDebitoAutomaticoContratoActual: boolean | null = null;

  public beneficiariosTarifa: BeneficiarioTarifa[] = [];
  public totalCuotaIva: number = 0;
  public mostrarTablaBeneficiarios: boolean = false;
  public cargandoBeneficiarios: boolean = false;
  public advertenciaIntegrantesCambioCobertura: string | null = null;

  public mostrarCampoColectivo: boolean = false;
  colectivoControl = new FormControl<ColectivoCorporativo | null>(null, [
    Validators.required,
  ]);
  subcuentaDestinoControl = new FormControl<any>(null, [Validators.required]);
  sucursalDestinoControl = new FormControl<any>(null, [Validators.required]);
  programaDestinoColectivoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  proporcionalidadColectivoControl = new FormControl<string>('Si', [
    Validators.required,
  ]);
  corteSubcuentaControl = new FormControl<any>(null, [Validators.required]);
  tarifaDestinoColectivoControl = new FormControl<any>(null, [
    Validators.required,
  ]);

  public isLoadingColectivos = false;
  public hasErrorColectivos = false;
  public colectivoNoEncontrado = false;

  private colectivosSubject = new BehaviorSubject<ColectivoCorporativo[]>([]);
  public colectivos$ = this.colectivosSubject.asObservable();
  public filteredColectivos$!: Observable<ColectivoCorporativo[]>;

  ngAfterViewInit(): void {
    this.applyCompareWithToAllSelects();

    this.matSelects.changes
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.applyCompareWithToAllSelects());
  }

  public subcuentasDestino: any[] = [];
  public sucursalesDestino: any[] = [];
  public programasDestinoColectivo: any[] = [];
  public cortesSubcuenta: any[] = [];
  public tarifasDestinoColectivo: any[] = [];

  public anexosDestino: any[] = [];

  public displayedColumnsColectivo: string[] = [
    'numero',
    'identificacion',
    'nombreUsuario',
    'parentesco',
    'edad',
    'genero',
    'anexosDestino',
    'valorTarifaAnexo',
    'valorTarifaPrograma',
    'totalTarifa',
  ];

  public columnasTrasladoExistente: string[] = [
    'numero',
    'identificacion',
    'nombreUsuario',
    'parentescoDestino',
    'edad',
    'genero',
    'anexoDestino',
    'valorTarifaAnexo',
    'valorTarifaPrograma',
    'totalTarifa',
  ];

  public mostrarCamposTrasladoContratoNuevo: boolean = false;
  public mostrarTablaIntegrantesContratoNuevo: boolean = false;
  public errorTrasladoContrato: string = '';
  public isLoadingTrasladoContrato: boolean = false;

  public mostrarCamposTrasladoContratoExistente: boolean = false;
  public mostrarTablaIntegrantesTrasladoExistente: boolean = false;
  public errorTrasladoContratoExistente: string = '';
  /** Bloquea avance si se eligió (o solo hay) contrato transitorio cuenta 24690. */
  public contratoDestinoTransitorioBloqueado = false;
  /** Código del único contrato destino elegido (selección única). */
  public contratoDestinoSeleccionadoCodigo: string | null = null;
  public isLoadingTrasladoContratoExistente: boolean = false;
  public errorValidacionIntegrantes: string = '';
  public mensajeErrorTodosIntegrantesTrasladoNuevo = '';

  tipoPlanDestinoContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  programaDestinoContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  subcuentaDestinoContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  corteDestinoContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  tarifaDestinoContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  sucursalComercializableContratoControl = new FormControl<any>(null, [
    Validators.required,
  ]);
  proporcionalidadContratoControl = new FormControl<string>('Si', [
    Validators.required,
  ]);

  public isLoadingProgramasContrato = false;
  public hasErrorProgramasContrato = false;
  public isLoadingSubcuentasContrato = false;
  public isLoadingTarifasContrato = false;
  public hasErrorTarifasContrato = false;
  public isCorteDestinoReadonly = false;
  public isSucursalComercializableReadonly = false;
  public isIncluirAnexoContratoEnabled = false;

  private programasContratoSubject = new BehaviorSubject<any[]>([]);
  public programasContrato$ = this.programasContratoSubject.asObservable();

  private subcuentasContratoSubject = new BehaviorSubject<any[]>([]);
  public subcuentasContrato$ = this.subcuentasContratoSubject.asObservable();

  private tarifasContratoSubject = new BehaviorSubject<any[]>([]);
  public tarifasContrato$ = this.tarifasContratoSubject.asObservable();
  public tarifasDestinoContrato: any[] = [];

  public tiposPlanesContratoNuevo: any[] = [];
  public cortesDestinoContrato: any[] = [];
  public sucursalesComercializablesContrato: any[] = [];
  public opcionesProporcionalidadContrato: any[] = [
    { valor: 'Si', nombre: 'Si' },
    { valor: 'No', nombre: 'No' },
  ];
  public anexosDestinoContrato: any[] = [];
  private usarRespuestaFilasAnexoCambioPlan = false;
  public parentescosActivos: any[] = [];

  tipoIdentificacionContratanteDestinoControl = new FormControl<any>(null, [
    Validators.required,
  ]);

  numeroIdentificacionContratanteDestinoControl = new FormControl<string>('', [
    Validators.required,
  ]);
  contratoDestinoControl = new FormControl<any>(null, [Validators.required]);
  /** MP-FT-1358 1.1.3.2 — solo lectura (valor fijado al elegir contrato destino). */
  corteContratoDestinoControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  proporcionalidadExistenteControl = new FormControl<string>('Si', [
    Validators.required,
  ]);
  tipoPlanDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  lineaNegocioDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  grupoProgramaDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  programaDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  tipoPrimaDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  codTarifaDestinoExistenteControl = new FormControl<any>({
    value: null,
    disabled: true,
  });
  incluirAnexoExistenteControl = new FormControl<boolean>({
    value: false,
    disabled: true,
  });

  public isLoadingContratosDestino = false;

  // Utility to allow mat-select to match persisted objects after reload
  public compareByCodigoOrId = (option: any, value: any): boolean => {
    if (option === value) {
      return true;
    }

    if (!option || !value) {
      return false;
    }

    if (option.codigo != null && value.codigo != null) {
      return String(option.codigo).trim() === String(value.codigo).trim();
    }

    if (option.id != null && value.id != null) {
      return String(option.id).trim() === String(value.id).trim();
    }

    if (option.numero != null && value.numero != null) {
      return String(option.numero).trim() === String(value.numero).trim();
    }

    if (option.nit != null && value.nit != null) {
      return String(option.nit).trim() === String(value.nit).trim();
    }

    return false;
  };

  private applyCompareWithToAllSelects(): void {
    if (!this.matSelects) {
      return;
    }

    this.matSelects.forEach((select) => {
      select.compareWith = this.compareByCodigoOrId;
    });
  }
  public hasErrorContratosDestino = false;
  public isLoadingTarifasExistente = false;
  public hasErrorTarifasExistente = false;

  public tiposIdentificacionContratante: any[] = [];
  private contratosDestinoSubject = new BehaviorSubject<any[]>([]);
  public contratosDestino$ = this.contratosDestinoSubject.asObservable();
  public filteredContratosDestino$!: Observable<any[]>;
  public cortesContratoDestino: any[] = [];
  public opcionesProporcionalidadExistente: any[] = [
    { valor: 'Si', nombre: 'Si' },
    { valor: 'No', nombre: 'No' },
  ];
  public anexosDestinoExistente: any[] = [];
  public integrantesTrasladoExistente: any[] = [];
  public integrantesContratoDestino: any[] = [];

  public integrantesContratoNuevo: any[] = [];
  public cargandoIntegrantesContrato: boolean = false;
  public totalCuotaIvaContratoNuevo: number = 0;

  tarifaCambioControl = new FormControl<any>(null, [Validators.required]);
  valorTotalCuotaIvaControl = new FormControl<number | null>({
    value: null,
    disabled: true,
  });

  public isLoadingTarifasCambio = false;
  public hasErrorTarifasCambio = false;
  public errorMessageTarifasCambio = '';

  private tarifasCambioSubject = new BehaviorSubject<any[]>([]);
  public tarifasCambio$ = this.tarifasCambioSubject.asObservable();
  public filteredTarifasCambio$!: Observable<any[]>;

  public tarifasCambioDisponibles: any[] = [];

  public mostrarTablaAdicionaAnexo: boolean = false;
  public integrantesAdicionaAnexo: any[] = [];
  public anexosDisponibles: any[] = [];
  public totalCuotaIvaAdicionaAnexo: number = 0;
  public cargandoIntegrantesAdicionaAnexo: boolean = false;
  public errorAdicionaAnexo: string = '';
  /** Aviso no bloqueante devuelto por `adiciona-anexo/consulta` (`mensajeAdvertencia`). */
  public advertenciaAdicionaAnexo: string = '';
  public isLoadingAnexos: boolean = false;
  public hasErrorAnexos: boolean = false;
  private anexosCargados: boolean = false;

  private isRestoringState = false;
  private resetVersion = 0;
  private readonly controlsDisabledByReadonly = new Set<AbstractControl>();
  /**
   * Tras pulsar «Siguiente» en el padre, mat-select puede reemitir `selectionChange`
   * y vaciar dependientes; se suprime un instante (mayor al debounce de persistencia).
   */
  private suprimirEfectosSeleccionContratoNuevo = false;
  private estadoNavegacionCongelado: TipoNovedadSelectorState | null = null;
  private navegacionCongeladaHasta = 0;
  private readonly persistApi = {
    prepararPersistenciaAntesDeAvanzarPaso: () =>
      this.prepararPersistenciaAntesDeAvanzarPaso(),
    obtenerEstadoActual: () =>
      this.buildPersistedState() as unknown as Record<string, unknown>,
    sincronizarEstadoParaRadicar: () => this.persistStateParaRadicar(),
    resetState: () => this.resetState(),
  };
  /** Evita registrar varias veces los mismos valueChanges (pisaban selección / disparaban cargas). */
  private listenersCamposDestinoRegistrados = false;
  private listenersContratoNuevoCascadaRegistrados = false;
  private listenersColectivoCascadaRegistrados = false;
  private fechaAplicacionNovedadUsuarioEdito = false;

  public displayedColumnsAdicionaAnexo: string[] = [
    'numero',
    'identificacion',
    'nombreUsuario',
    'anexoDestino',
    'valorTarifaAnexo',
    'valorTarifaPrograma',
    'totalTarifa',
  ];

  private isProcessingSolicitudActiva = false;
  private perfilamientoBloqueoMostrado = false;
  private destroy$ = new Subject<void>();
  private partidosComercialesCache: any[] | null = null;
  private anexosConsultaCache = new Map<
    string,
    {
      catalog: CatalogoAnexoConsultaDTO[];
      filas: any[];
      mensajeAdvertencia: string | null;
    }
  >();
  private anexosConsultaInFlight = new Map<
    string,
    Promise<{
      catalog: CatalogoAnexoConsultaDTO[];
      filas: any[];
      mensajeAdvertencia: string | null;
    }>
  >();
  private procesandoCambioIncluirAnexo = false;
  private beneficiariosTarifaRequestId = 0;
  private precargaContratanteRequestId = 0;
  /** Descarta respuestas viejas de `cargarProgramasColectivo` si hubo llamadas superpuestas. */
  private cargarProgramasColectivoRequestId = 0;
  /** Bandera explícita para evitar ambigüedad de detección en plantilla. */
  public cambioPlanActivo = false;

  constructor(
    private modalService: NgbModal,
    private dialog: MatDialog,
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private tipoNovedadSelectorBridge: TipoNovedadSelectorBridgeService,
    private estadosCivilesService: EstadosCivilesService,
    private cortesService: CortesService,
    private tiposDocumentoService: TiposDocumentoService,
    private estratosSocialesService: EstratosSocialesService,
    private nacionalidadesService: NacionalidadesService,
    private ocupacionesService: OcupacionesService,
    private profesionesService: ProfesionesService,
    private generosService: GenerosService,
    private subcuentasProgramaService: SubcuentasProgramaService,
    private infomedicalSubcuentaProgramaService: InfomedicalSubcuentaProgramaService,
    private tiposNovedadService: TiposNovedadService,
    private subtiposNovedadService: SubtiposNovedadService,
    private solicitudesRadicadasService: SolicitudesRadicadasService,
    private validacionSolicitudActivaService: ValidacionSolicitudActivaService,
    private programasLineaNegocioService: ProgramasLineaNegocioService,
    private tiposPrimaService: TiposPrimaService,
    private tarifasDestinoService: TarifasDestinoService,
    private tiposPlanService: TiposPlanService,
    private cuentaColectivoCorporativoService: CuentaColectivoCorporativoService,
    private validacionContratoService: ValidacionContratoService,
    private contratosUsersService: ContratosUsersService,
    private partidosComercialesService: PartidosComercialesService,
    private beneficiariosTarifaService: BeneficiariosTarifaService,
    private anexosDestinoService: AnexosDestinoService,
    private adicionaAnexoConsultaService: AdicionaAnexoConsultaService,
    private parentescosTrasladosService: ParentescosTrasladosService,
    private contratoContratanteCabeceraService: ContratoContratanteCabeceraService,
    private datosAfiliadoPagadorService: DatosAfiliadoPagadorService,
    private perfilamientoValidarService: PerfilamientoValidarService,
    private tipoSolicitudNovedadTrasladoIdService: TipoSolicitudNovedadTrasladoIdService,
    private cdr: ChangeDetectorRef,
    private provinciasXPaisService: ProvinciasXPaisService,
    private municipiosPorDepartamentoService: MunicipiosPorDepartamentoService,
  ) {
    this.initializeObservables();
  }

  /** `idTipoSolicitud` enlazado en cada fila de `GET tipos-novedad` (TRL_P_TIPO_NOVEDAD_TIPO_SOLICITUD). */
  private idTipoSolicitudDesdeDtoTipoNovedad(
    dto: TipoNovedadDTO | Record<string, unknown> | null | undefined,
  ): number | null {
    if (!dto) {
      return null;
    }
    const raw =
      (dto as TipoNovedadDTO).idTipoSolicitud ??
      (dto as { IdTipoSolicitud?: unknown }).IdTipoSolicitud;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  private idTipoSolicitudDesdeTipoNovedad(
    tipoNovedad: TipoNovedad | null | undefined,
  ): number | null {
    if (!tipoNovedad) {
      return null;
    }
    return this.idTipoSolicitudDesdeDtoTipoNovedad(
      tipoNovedad as unknown as TipoNovedadDTO,
    );
  }

  /** Comparación robusta por nombre (ignora mayúsculas, tildes y dobles espacios). */
  private normalizarTextoComparacion(valor: string): string {
    return String(valor ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  /** Cambio de plan: se determina por nombre (el id puede variar por ambiente). */
  private esCambioPlanNovedadTipo(tipo: TipoNovedad | null): boolean {
    return this.esTipoNombre(tipo, 'cambio de plan');
  }

  /** Cambio de plan activo en UI. */
  public esCambioPlanTipoSeleccionado(): boolean {
    if (this.cambioPlanActivo) {
      return true;
    }
    const t = this.selectedTipoNovedad ?? this.tipoNovedadControl.value;
    if (!t) {
      return false;
    }
    return this.esCambioPlanNovedadTipo(t);
  }

  /**
   * Cambio de plan y traslado a contrato nuevo: tarifas con `tipoPlanDestinoContrato` /
   * `programaDestinoContrato`; la línea de negocio sigue viniendo del contrato origen.
   */
  private usaSelectoresDestinoContratoParaTarifas(): boolean {
    if (this.esCambioPlanTipoSeleccionado()) {
      return true;
    }
    if (
      !this.mostrarCamposTrasladoContratoNuevo ||
      this.mostrarCampoColectivo
    ) {
      return false;
    }
    const t = this.selectedTipoNovedad ?? this.tipoNovedadControl.value;
    if (!t) {
      return true;
    }
    const cod = String(t.codigo ?? '').trim();
    return cod === '3' || this.esTipoNombre(t, 'traslado a contrato nuevo');
  }

  /** Misma selección de contrato aunque venga con ceros/formato distinto en distintas fuentes. */
  private contratoMismaSeleccion(a: string, b: string): boolean {
    const sa = String(a ?? '').trim();
    const sb = String(b ?? '').trim();
    if (sa !== '' && sa === sb) {
      return true;
    }
    const da = sa.replace(/\D/g, '');
    const db = sb.replace(/\D/g, '');
    if (da.length > 0 && da === db) {
      return true;
    }
    const na = da.replace(/^0+/, '') || '0';
    const nb = db.replace(/^0+/, '') || '0';
    return na.length > 0 && na === nb;
  }

  /**
   * Cuando `info-contrato-user` responde vacío pero en paso 1 ya se cargó la tabla
   * (Input o `frmConsultState.validacionTablaData`).
   */
  private filasIntegrantesDesdePaso1OPersistencia(
    numeroContrato: string,
    totalesPaso1: any[],
    state: Record<string, unknown> | null | undefined,
    stateContract: string,
    cached: any[] | undefined,
  ): any[] {
    const toFilas = (rows: any[]) =>
      rows.map((row: any, i: number) =>
        this.mapearFilaValidacionStorageABeneficiario(row, i),
      );

    if (Array.isArray(totalesPaso1) && totalesPaso1.length > 0) {
      return toFilas(totalesPaso1);
    }

    if (!Array.isArray(cached) || cached.length === 0) {
      return [];
    }

    const form = state?.['form'] as Record<string, unknown> | undefined;
    const formContract = String(form?.['contractNumber'] ?? '').trim();

    if (
      this.contratoMismaSeleccion(stateContract, numeroContrato) ||
      this.contratoMismaSeleccion(formContract, numeroContrato)
    ) {
      return toFilas(cached);
    }

    return [];
  }

  /**
   * Contrato para POST `info-contrato-user` (en Cambio de plan prioriza la fila Afilmed del paso 1).
   */
  private obtenerNumeroContratoParaInfoUsuario(
    priorizarFilaPaso1 = false,
  ): string {
    const fila = this.filaContratoAfilmedPaso1 as Record<
      string,
      unknown
    > | null;
    const contratoFila = String(
      fila?.['contrato'] ?? fila?.['Contrato'] ?? '',
    ).trim();

    if (priorizarFilaPaso1 && contratoFila) {
      return contratoFila;
    }

    const desde = this.obtenerNumeroContratoSeleccionado();
    if (desde) {
      return desde;
    }

    if (contratoFila) {
      return contratoFila;
    }

    const state = this.localStorageService.load('frmConsultState') as
      | Record<string, unknown>
      | null
      | undefined;
    const form = state?.['form'] as Record<string, unknown> | undefined;
    return String(form?.['contractNumber'] ?? '').trim();
  }

  private obtenerContratoPaso1(): any | null {
    const contratoStorage = this.obtenerContratoDesdeStorage();
    if (contratoStorage) {
      return contratoStorage;
    }

    if (this.contratoSeleccionado?.numero) {
      return {
        contrato: this.contratoSeleccionado.numero,
        ProgramaCodigo: this.contratoSeleccionado.ProgramaCodigo,
        ProgramaNombre: this.contratoSeleccionado.ProgramaNombre,
        GrupoPrograma: this.contratoSeleccionado.GrupoPrograma,
        LineaNegocio: this.contratoSeleccionado.LineaNegocio,
        TipoPrima: this.contratoSeleccionado.TipoPrima,
      };
    }

    return null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['readonly']) {
      this.syncReadonlyControlState();
    }
    if (changes['disabled']) {
      this.updateTipoControlState();
      this.updateSubtipoControlState();
      this.syncTarifaCambioControlDisabled();
    }
    if (
      changes['integrantesSeleccionados'] ||
      changes['integrantesTotalesContratoActual'] ||
      changes['contratoSeleccionado']
    ) {
      this.checkValidacionCompletada();
    }
    if (changes['integrantesTotalesContratoActual']) {
      const cur = changes['integrantesTotalesContratoActual'].currentValue as
        | any[]
        | undefined;
      if (
        Array.isArray(cur) &&
        cur.length > 0 &&
        this.esCambioPlanTipoSeleccionado() &&
        this.mostrarCamposTrasladoContratoNuevo &&
        this.beneficiariosTarifa.length === 0
      ) {
        void this.cargarBeneficiariosTarifa({
          forzarConsultaInfoContratoPrimero: true,
        });
      }
    }
    if (
      changes['contratoSeleccionado'] &&
      !changes['contratoSeleccionado'].firstChange
    ) {
      // Catálogo tipos/subtipos depende del estado del contrato (transitorio).
      this.loadTiposNovedad();
    }
    if (
      changes['contratoSeleccionado'] &&
      !changes['contratoSeleccionado'].firstChange &&
      this.tipoContratanteControl.value === 'mantener'
    ) {
      this.precargarDatosContratanteActual();
    }
    if (
      changes['filaContratoAfilmedPaso1'] &&
      this.filaContratoAfilmedPaso1 &&
      this.tipoContratanteControl.value === 'mantener'
    ) {
      this.precargarDatosContratanteActual();
    }
    if (
      changes['numeroContratoPaso1'] &&
      String(this.numeroContratoPaso1 ?? '').trim() !== '' &&
      this.tipoContratanteControl.value === 'mantener'
    ) {
      this.precargarDatosContratanteActual();
    }
    if (changes['filaContratoAfilmedPaso1']) {
      this.sincronizarFechaAplicacionPorDefectoSiCorresponde();
      if (this.esCambioTarifaSeleccionado() && this.filaContratoAfilmedPaso1) {
        this.cargarTarifasParaCambio();
      }
    }
    if (
      changes['numeroContratoPaso1'] &&
      !changes['numeroContratoPaso1'].firstChange &&
      this.esCambioTarifaSeleccionado()
    ) {
      this.cargarTarifasParaCambio();
    }
  }

  ngOnInit(): void {
    this.contratoSeleccionado;

    this.subtipoHabilitado = false;

    // Sincroniza el estado inicial de habilitación/deshabilitación de los controles principales
    this.updateTipoControlState();
    this.updateSubtipoControlState();
    this.syncTarifaCambioControlDisabled();
    this.syncReadonlyControlState();

    this.setupValidators();
    this.numeroIdentificacionContratanteDestinoControl.setValidators([
      Validators.required,
      this.numeroIdentificacionValidator(30),
    ]);
    this.numeroIdentificacionContratanteDestinoControl.updateValueAndValidity();
    this.setupControlListeners();
    this.setupPersistence();
    this.tipoNovedadSelectorBridge.register(this.persistApi);

    this.filteredTiposNovedad$.subscribe((tipos: TipoNovedad[]) => {});

    this.actualizarEstadoTipoNumeroDocumento();
    this.tipoContratanteControl.valueChanges.subscribe((value) => {
      this.actualizarEstadoTipoNumeroDocumento();
    });

    setTimeout(() => {
      this.loadTiposNovedad();
      this.initializeMockDataContratante();
      this.setupContratanteListeners();
      void this.restoreState();
    }, 100);
  }

  ngOnDestroy(): void {
    this.tipoNovedadSelectorBridge.unregister(this.persistApi);
    this.destroy$.next();
    this.destroy$.complete();
  }

  public resetState(): void {
    this.resetVersion++;
    this.isRestoringState = false;
    this.fechaAplicacionNovedadUsuarioEdito = false;
    this.fechaAplicacionNovedadDefaultError = false;

    this.getPersistableControls().forEach((control) =>
      control.reset(null, { emitEvent: false }),
    );
    // Este campo requerido no tiene selector visible en el flujo colectivo.
    this.proporcionalidadColectivoControl.setValue('Si', { emitEvent: false });
    this.tipoNovedadControl.reset(null, { emitEvent: false });
    this.subtipoNovedadControl.reset(null, { emitEvent: false });

    this.selectedTipoNovedad = null;
    this.selectedSubtipoNovedad = null;
    this.colectivoNoEncontrado = false;
    this.programasDestinoFiltrados = [];
    this.tiposPlanes = [];
    this.programasDestino = [];
    this.tarifasDestino = [];
    this.cortesDestino = [];
    this.subcuentasDestino = [];
    this.sucursalesDestino = [];
    this.programasDestinoColectivo = [];
    this.cortesSubcuenta = [];
    this.tarifasDestinoColectivo = [];
    this.anexosDestino = [];
    this.tarifasDestinoContrato = [];
    this.tiposPlanesContratoNuevo = [];
    this.cortesDestinoContrato = [];
    this.sucursalesComercializablesContrato = [];
    this.anexosDestinoContrato = [];
    this.parentescosActivos = [];
    this.cortesContratoDestino = [];
    this.anexosDestinoExistente = [];
    this.programasContratoSubject.next([]);
    this.subcuentasContratoSubject.next([]);
    this.tarifasContratoSubject.next([]);
    this.contratosDestinoSubject.next([]);
    this.tarifasCambioSubject.next([]);
    this.anexosDisponibles = [];
    this.filtroProgramaDestino = '';
    this.filtroSubcuentaDestino = '';
    this.filtroSubcuentaContrato = '';
    this.filtroProgramaDestinoColectivo = '';
    this.filtroTarifaDestinoContrato = '';
    this.filtroTarifaDestino = '';
    this.filtroTarifaDestinoColectivo = '';
    this.filtroProgramaContratoNuevoSubject.next('');
    this.cambioPlanActivo = false;
    this.mostrarCampoColectivo = false;
    this.mostrarCambioTitular = false;
    this.mostrarCambioResponsablePagador = false;
    this.mostrarCamposCambioCobertura = false;
    this.mostrarCamposTrasladoContratoNuevo = false;
    this.mostrarCamposTrasladoContratoExistente = false;
    this.mostrarTablaBeneficiarios = false;
    this.mostrarTablaIntegrantesContratoNuevo = false;
    this.mostrarTablaIntegrantesTrasladoExistente = false;
    this.mostrarTablaAdicionaAnexo = false;
    this.beneficiariosTarifa = [];
    this.integrantesContratoNuevo = [];
    this.integrantesContratoDestino = [];
    this.integrantesTrasladoExistente = [];
    this.integrantesAdicionaAnexo = [];
    this.updateTipoControlState();
    this.updateSubtipoControlState();
    this.syncTarifaCambioControlDisabled();
    this.validacionCompletada.emit(false);
  }

  public displayTipoNovedad = (tipo: TipoNovedad | null): string => {
    return tipo ? tipo.nombre : '';
  };

  public displaySubtipoNovedad = (subtipo: SubtipoNovedad | null): string => {
    return subtipo ? subtipo.nombre : '';
  };

  public onTipoNovedadInput(event: Event): void {
    const v = (event.target as HTMLInputElement)?.value ?? '';
    this.tipoNovedadBusqueda$.next(v);
    this.validacionCompletada.emit(false);
  }

  /** Al abrir el panel se muestra el catálogo completo; el filtro lo aplica solo lo tecleado después. */
  public onTipoNovedadPanelOpened(): void {
    this.tipoNovedadBusqueda$.next('');
  }

  public onSubtipoNovedadInput(event: Event): void {
    const v = (event.target as HTMLInputElement)?.value ?? '';
    this.subtipoNovedadBusqueda$.next(v);
  }

  public onSubtipoNovedadPanelOpened(): void {
    this.subtipoNovedadBusqueda$.next('');
  }

  private initializeObservables(): void {
    // El filtro debe basarse en lo que el usuario escribe en el input (`input`), no en
    // `valueChanges` del FormControl: MatAutocomplete alterna entre objeto seleccionado y
    // string mientras se teclea, y termina dejando una cadena que recorta el listado.
    this.filteredTiposNovedad$ = combineLatest([
      this.tiposNovedadSubject.asObservable(),
      this.tipoNovedadBusqueda$.pipe(debounceTime(150), distinctUntilChanged()),
    ]).pipe(
      map(([tipos, q]) => this.filterTipos(tipos, q)),
      takeUntil(this.destroy$),
    );

    this.filteredSubtiposNovedad$ = combineLatest([
      this.subtiposNovedadSubject.asObservable(),
      this.subtipoNovedadBusqueda$.pipe(
        debounceTime(150),
        distinctUntilChanged(),
      ),
    ]).pipe(
      map(([subtipos, q]) => this.filterSubtipos(subtipos, q)),
      takeUntil(this.destroy$),
    );

    this.filteredColectivos$ = combineLatest([
      this.colectivosSubject.asObservable(),
      this.colectivoControl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
      ),
    ]).pipe(
      map(([colectivos, searchValue]) => {
        const filterText =
          typeof searchValue === 'string'
            ? searchValue
            : searchValue?.nit || searchValue?.razonSocial || '';
        return this.filterColectivos(colectivos, filterText);
      }),
      takeUntil(this.destroy$),
    );

    this.filteredContratosDestino$ = combineLatest([
      this.contratosDestinoSubject.asObservable(),
      this.contratoDestinoControl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
      ),
    ]).pipe(
      map(([contratos, searchValue]) => {
        if (searchValue && typeof searchValue === 'object') {
          return contratos;
        }
        const filterText =
          typeof searchValue === 'string' ? searchValue.trim() : '';
        return this.filterContratosDestino(contratos, filterText);
      }),
      takeUntil(this.destroy$),
    );

    this.filteredTarifasCambio$ = combineLatest([
      this.tarifasCambioSubject.asObservable(),
      this.tarifaCambioControl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
      ),
    ]).pipe(
      map(([tarifas, searchValue]) => {
        const filterText =
          typeof searchValue === 'string'
            ? searchValue
            : searchValue?.codigo || searchValue?.nombre || '';
        return this.filterTarifasCambio(tarifas, filterText);
      }),
      takeUntil(this.destroy$),
    );

    this.programasContratoFiltrados$ = combineLatest([
      this.programasContratoSubject.asObservable(),
      this.filtroProgramaContratoNuevoSubject
        .asObservable()
        .pipe(debounceTime(100)),
    ]).pipe(
      map(([programas, texto]) =>
        this.filtrarProgramasPorTexto(programas, texto),
      ),
      takeUntil(this.destroy$),
    );

    this.tarifasContrato$.pipe(takeUntil(this.destroy$)).subscribe((lista) => {
      this.tarifasDestinoContrato = lista || [];
    });
  }

  private setupValidators(): void {
    this.tipoNovedadControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateSubtipoValidators());
  }

  private updateSubtipoValidators(): void {
    if (this.isSubtipoRequired) {
      this.subtipoNovedadControl.setValidators([Validators.required]);
    } else {
      this.subtipoNovedadControl.clearValidators();
    }
    this.subtipoNovedadControl.updateValueAndValidity();
  }

  private configurarModoSoloPagadorDireccion(activar: boolean): void {
    const controles = [
      this.ocupacionContratanteControl,
      this.barrioControl,
      this.departamentoControl,
      this.municipioControl,
    ];
    controles.forEach((control) => {
      if (activar) {
        control.clearValidators();
      } else {
        control.setValidators([Validators.required]);
      }
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  private setupControlListeners(): void {
    this.tipoNovedadControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (tipoNovedad: TipoNovedad | null) => {
        if (
          tipoNovedad === null ||
          (tipoNovedad && typeof tipoNovedad === 'object' && tipoNovedad.codigo)
        ) {
          await this.onTipoNovedadChanged(tipoNovedad);
        }
      });

    this.subtipoNovedadControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (subtipoNovedad: SubtipoNovedad | null) => {
        if (
          subtipoNovedad === null ||
          (subtipoNovedad &&
            typeof subtipoNovedad === 'object' &&
            subtipoNovedad.id)
        ) {
          await this.onSubtipoNovedadChanged(subtipoNovedad);
        }
      });

    this.motivoRetiroResponsableControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());
    this.activarDebitoAutomaticoNuevoResponsableControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((activo) => {
        if (!activo) {
          this.metodoDebitoAutomaticoControl.setValue(null, {
            emitEvent: false,
          });
          this.confirmacionGestionTarjetaControl.setValue(false, {
            emitEvent: false,
          });
          this.tipoCuentaDebitoControl.setValue(null, { emitEvent: false });
          this.bancoDebitoControl.setValue(null, { emitEvent: false });
          this.numeroCuentaDebitoControl.setValue('', { emitEvent: false });
        }
        this.checkValidacionCompletada();
      });
    this.metodoDebitoAutomaticoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((metodo) => {
        if (metodo !== 'tarjeta') {
          this.confirmacionGestionTarjetaControl.setValue(false, {
            emitEvent: false,
          });
        }
        if (metodo !== 'cuenta') {
          this.tipoCuentaDebitoControl.setValue(null, { emitEvent: false });
          this.bancoDebitoControl.setValue(null, { emitEvent: false });
          this.numeroCuentaDebitoControl.setValue('', { emitEvent: false });
        }
        this.checkValidacionCompletada();
      });
    this.confirmacionGestionTarjetaControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());
    this.tipoCuentaDebitoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());
    this.bancoDebitoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((codigo) => {
        const b = this.bancosDebitoAutomatico.find(
          (x) => String(x.codigo) === String(codigo),
        );
        this.bancoDebitoNombreControl.setValue(b ? b.nombre : '', {
          emitEvent: false,
        });
        this.checkValidacionCompletada();
      });
    this.numeroCuentaDebitoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.tipoPlanDestinoControl.valueChanges
      .pipe(
        distinctUntilChanged(
          (prev, curr) =>
            this.claveSeleccionContratoNuevo(prev) ===
            this.claveSeleccionContratoNuevo(curr),
        ),
        filter((tipoPlan) => !!tipoPlan),
        takeUntil(this.destroy$),
      )
      .subscribe(() => void this.cargarSubcuentasDestino());

    this.tipoPlanDestinoExistenteControl.valueChanges
      .pipe(
        distinctUntilChanged(
          (prev, curr) =>
            this.claveSeleccionContratoNuevo(prev) ===
            this.claveSeleccionContratoNuevo(curr),
        ),
        filter((tipoPlan) => !!tipoPlan),
        takeUntil(this.destroy$),
      )
      .subscribe((tipoPlan) => {
        const contrato = this.contratoDestinoControl.value;
        const lineaNegocio = String(contrato?.lineaNegocio ?? '').trim();
        const tipoPlanSeleccionado = String(tipoPlan ?? '').trim();
        if (lineaNegocio && tipoPlanSeleccionado) {
          void this.consultarSubcuentasInfomedical(
            lineaNegocio,
            tipoPlanSeleccionado,
          ).catch((error) =>
            console.error(
              'Error consultando subcuentas de contrato destino:',
              error,
            ),
          );
        }
      });

    // Listeners para validación de campos de Traslado a colectivo
    this.colectivoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        const texto = typeof value === 'string' ? value : '';
        this.colectivoNoEncontrado =
          texto.length > 0 &&
          this.filterColectivos(this.colectivosSubject.getValue(), texto)
            .length === 0;

        if (!this.esColectivoValido(value)) {
          this.limpiarCamposDependientesColectivo();
          if (texto.trim()) {
            this.persistState();
          }
        }
        this.checkValidacionCompletada();
      });

    this.subcuentaDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.sucursalDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.programaDestinoColectivoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (programa) => {
        this.checkValidacionCompletada();
        if (!this.mostrarCampoColectivo) {
          return;
        }
        if (programa) {
          await this.cargarAnexosDestino();
          return;
        }
        this.anexosDestino = [];
      });

    this.corteSubcuentaControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.tarifaDestinoColectivoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.proporcionalidadColectivoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    // Listeners para validación de campos de Traslado a contrato nuevo
    this.tipoPlanDestinoContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.programaDestinoContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.subcuentaDestinoContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.corteDestinoContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.tarifaDestinoContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.sucursalComercializableContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.proporcionalidadContratoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    // Cambio del checkbox "Incluir Anexo" (Tipo novedad 5).
    // Al deshabilitar, se debe dejar el anexo en "No aplica" para que la tarifa anexo sea 0.
    this.incluirAnexoControl.valueChanges
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe(async () => {
        if (this.procesandoCambioIncluirAnexo) {
          return;
        }
        this.procesandoCambioIncluirAnexo = true;
        const incluir = this.getIncluirAnexoContratoValue();
        const esCambioPlan = this.esCambioPlanTipoSeleccionado();

        // Regla solicitada: al marcar "Incluir anexo", refrescar catálogo desde backend.
        try {
          if (incluir) {
            if (esCambioPlan) {
              await this.validarAnexosActivosContrato(
                this.programaDestinoContratoControl.value,
                true,
              );
            } else {
              await this.cargarAnexosDestino(true);
            }
          }

          if (!esCambioPlan) {
            this.checkValidacionCompletada();
            return;
          }

          if (!incluir) {
            for (const b of this.beneficiariosTarifa ?? []) {
              b.anexoDestino = ['NO_APLICA'];
            }
          } else {
            // Si se activa el checkbox y el usuario dejó vacío, aseguramos "No aplica".
            // No recalcular aquí: los valores base deben mantenerse estables.
            for (const b of this.beneficiariosTarifa ?? []) {
              const codigos = this.normalizarAnexosSeleccionadosCambioPlan(
                b.anexoDestino,
              );
              if (!codigos.length) {
                b.anexoDestino = ['NO_APLICA'];
              }
            }
          }

          this.checkValidacionCompletada();
        } finally {
          this.procesandoCambioIncluirAnexo = false;
        }
      });

    // Listeners para validación de campos de Traslado a contrato existente
    this.tipoIdentificacionContratanteDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.numeroIdentificacionContratanteDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.contratoDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.proporcionalidadExistenteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    // Listeners para cambio de titular
    this.tipoIdentificacionNuevoContratanteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.numeroIdentificacionNuevoContratanteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.nombreNuevoContratanteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.nuevoTitularSeleccionadoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());

    this.setupContratoNuevoCascadaListeners();
    this.setupColectivoCascadaListeners();
    this.setupFechaAplicacionNovedadListeners();
  }

  /**
   * Cascada destino contrato nuevo vía `valueChanges` (no `selectionChange` del mat-select,
   * que al pulsar «Siguiente» pierde foco y vaciaba programa/tarifa aunque el valor no cambiara).
   */
  private setupContratoNuevoCascadaListeners(): void {
    if (this.listenersContratoNuevoCascadaRegistrados) {
      return;
    }
    this.listenersContratoNuevoCascadaRegistrados = true;

    const distinctClave = <T>() =>
      distinctUntilChanged<T>(
        (prev, curr) =>
          this.claveSeleccionContratoNuevo(prev) ===
          this.claveSeleccionContratoNuevo(curr),
      );

    this.tipoPlanDestinoContratoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter((tipoPlan) => !!this.claveSeleccionContratoNuevo(tipoPlan)),
        takeUntil(this.destroy$),
      )
      .subscribe((tipoPlan) => {
        void this.cargarSubcuentasContratoNuevo();
        this.onTipoPlanDestinoContratoSelected(tipoPlan);
      });

    this.programaDestinoContratoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter((programa) => !!this.claveSeleccionContratoNuevo(programa)),
        takeUntil(this.destroy$),
      )
      .subscribe((programa) => void this.onProgramaContratoSelected(programa));

    this.subcuentaDestinoContratoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter((subcuenta) => !!this.claveSeleccionContratoNuevo(subcuenta)),
        takeUntil(this.destroy$),
      )
      .subscribe((subcuenta) => this.onSubcuentaContratoSelected(subcuenta));

    this.corteDestinoContratoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter((corte) => this.claveSeleccionContratoNuevo(corte) !== ''),
        takeUntil(this.destroy$),
      )
      .subscribe((corte) => void this.onCorteContratoSelected(corte));

    this.tarifaDestinoContratoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter((tarifa) => !!this.claveSeleccionContratoNuevo(tarifa)),
        takeUntil(this.destroy$),
      )
      .subscribe((tarifa) => void this.onTarifaContratoSelected(tarifa));
  }

  /**
   * Cascada colectivo vía `valueChanges` (no `selectionChange`: al hacer clic en otro
   * campo el mat-select pierde foco y re-disparaba la cascada aunque el valor no cambiara).
   */
  private setupColectivoCascadaListeners(): void {
    if (this.listenersColectivoCascadaRegistrados) {
      return;
    }
    this.listenersColectivoCascadaRegistrados = true;

    const distinctClave = <T>() =>
      distinctUntilChanged<T>(
        (prev, curr) =>
          this.claveSeleccionContratoNuevo(prev) ===
          this.claveSeleccionContratoNuevo(curr),
      );

    const puedeCascadearColectivo = () =>
      this.mostrarCampoColectivo && !this.suprimirEfectosSeleccionContratoNuevo;

    this.subcuentaDestinoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter(() => puedeCascadearColectivo()),
        filter((subcuenta) => !!this.claveSeleccionContratoNuevo(subcuenta)),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (subcuenta) => void this.ejecutarCascadaSubcuentaColectivo(subcuenta),
      );

    this.sucursalDestinoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter(() => puedeCascadearColectivo()),
        filter((sucursal) => !!this.claveSeleccionContratoNuevo(sucursal)),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (sucursal) => void this.ejecutarCascadaSucursalColectivo(sucursal),
      );

    this.programaDestinoColectivoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter(() => puedeCascadearColectivo()),
        filter((programa) => !!this.claveSeleccionContratoNuevo(programa)),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (programa) => void this.ejecutarCascadaProgramaColectivo(programa),
      );

    this.corteSubcuentaControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter(() => puedeCascadearColectivo()),
        filter((corte) => this.claveSeleccionContratoNuevo(corte) !== ''),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (corte) => void this.cargarTarifasColectivo(String(corte.codigo)),
      );

    this.tarifaDestinoColectivoControl.valueChanges
      .pipe(
        distinctClave<any>(),
        filter(() => puedeCascadearColectivo()),
        filter((tarifa) => !!this.claveSeleccionContratoNuevo(tarifa)),
        takeUntil(this.destroy$),
      )
      .subscribe(() => void this.cargarBeneficiariosTarifa());
  }

  private setupFechaAplicacionNovedadListeners(): void {
    merge(
      this.corteDestinoControl.valueChanges,
      this.corteSubcuentaControl.valueChanges,
      this.corteDestinoContratoControl.valueChanges,
      this.corteContratoDestinoControl.valueChanges,
    )
      .pipe(debounceTime(250), takeUntil(this.destroy$))
      .subscribe(() =>
        this.sincronizarFechaAplicacionPorDefectoSiCorresponde(),
      );

    this.fechaAplicacionNovedadControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkValidacionCompletada());
  }

  /**
   * Día de corte del contrato destino según el flujo activo; si no aplica aún, Afilmed paso 1.
   */
  private resolverDiaCorteContratoDestino(): number | null {
    if (this.mostrarCamposTrasladoContratoNuevo) {
      const d = this.extraerDiaNumericoDeCorte(
        this.corteDestinoContratoControl.value,
      );
      if (d != null) {
        return d;
      }
    }
    if (this.mostrarCampoColectivo) {
      const d = this.extraerDiaNumericoDeCorte(
        this.corteSubcuentaControl.value,
      );
      if (d != null) {
        return d;
      }
    }
    if (this.mostrarCamposTrasladoContratoExistente) {
      const d = this.extraerDiaNumericoDeCorte(
        this.corteContratoDestinoControl.value,
      );
      if (d != null) {
        return d;
      }
    }
    if (
      this.esCambioPlanTipoSeleccionado() ||
      this.mostrarCamposCambioCobertura
    ) {
      const d = this.extraerDiaNumericoDeCorte(this.corteDestinoControl.value);
      if (d != null) {
        return d;
      }
    }
    const afil = this.filaContratoAfilmedPaso1;
    if (afil?.DiaCorte != null) {
      const n = Number(afil.DiaCorte);
      if (Number.isFinite(n)) {
        const f = Math.floor(n);
        if (f >= 1 && f <= 31) {
          return f;
        }
      }
    }
    return null;
  }

  private extraerDiaNumericoDeCorte(val: unknown): number | null {
    if (val == null || val === '') {
      return null;
    }
    if (typeof val === 'number' && Number.isFinite(val)) {
      const n = Math.floor(val);
      return n >= 1 && n <= 31 ? n : null;
    }
    if (typeof val === 'string') {
      const n = parseInt(String(val).replace(/\D/g, ''), 10);
      return n >= 1 && n <= 31 ? n : null;
    }
    if (typeof val === 'object') {
      const o = val as Record<string, unknown>;
      const keys = [
        'corte',
        'Corte',
        'codigo',
        'Codigo',
        'diaCorte',
        'DiaCorte',
      ];
      for (const k of keys) {
        const d = this.extraerDiaNumericoDeCorte(o[k]);
        if (d != null) {
          return d;
        }
      }
    }
    return null;
  }

  /**
   * Corte + 1 en el mes siguiente al actual (regla negocio 0011054).
   * Ej.: hoy 22/01/2026, corte 25 → 26/02/2026.
   */
  private calcularFechaDefectoDesdeDiaCorte(diaCorte: number): Date {
    const hoy = new Date();
    const y = hoy.getFullYear();
    const m = hoy.getMonth();
    const primerDiaMesSiguiente = new Date(y, m + 1, 1);
    const ultimoDiaMes = new Date(
      primerDiaMesSiguiente.getFullYear(),
      primerDiaMesSiguiente.getMonth() + 1,
      0,
    ).getDate();
    const diaObjetivo = diaCorte + 1;
    const dia = Math.min(Math.max(1, diaObjetivo), ultimoDiaMes);
    return new Date(
      primerDiaMesSiguiente.getFullYear(),
      primerDiaMesSiguiente.getMonth(),
      dia,
    );
  }

  private sincronizarFechaAplicacionPorDefectoSiCorresponde(): void {
    if (this.isRestoringState || this.fechaAplicacionNovedadUsuarioEdito) {
      return;
    }
    const dia = this.resolverDiaCorteContratoDestino();
    if (dia == null) {
      if (!this.selectedTipoNovedad && !this.tipoNovedadControl.value) {
        this.fechaAplicacionNovedadDefaultError = false;
        return;
      }
      this.fechaAplicacionNovedadDefaultError =
        this.fechaAplicacionNovedadControl.value == null;
      return;
    }
    this.fechaAplicacionNovedadDefaultError = false;
    const fecha = this.calcularFechaDefectoDesdeDiaCorte(dia);
    this.fechaAplicacionNovedadControl.setValue(fecha, { emitEvent: true });
    this.fechaAplicacionNovedadControl.markAsPristine();
  }

  public onFechaAplicacionNovedadUsuarioCambio(): void {
    this.fechaAplicacionNovedadUsuarioEdito = true;
    this.fechaAplicacionNovedadDefaultError = false;
    this.checkValidacionCompletada();
  }

  public reintentarFechaAplicacionNovedadPorDefecto(): void {
    this.fechaAplicacionNovedadUsuarioEdito = false;
    this.sincronizarFechaAplicacionPorDefectoSiCorresponde();
    this.checkValidacionCompletada();
  }

  private setupPersistence(): void {
    const controls = this.getPersistableControls();

    merge(...controls.map((c) => c.valueChanges))
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe(() => this.persistState());
  }

  private getPersistableControls(): FormControl[] {
    return [
      this.tipoNovedadControl,
      this.subtipoNovedadControl,
      this.tipoPlanDestinoControl,
      this.programaDestinoControl,
      this.tarifaDestinoControl,
      this.corteDestinoControl,
      this.proporcionalidadControl,
      this.incluirAnexoControl,
      this.tipoContratanteControl,
      this.cambiarDatosContratanteControl,
      this.codigoAsesorDestinoControl,
      this.tipoDocumentoContratanteControl,
      this.numeroDocumentoContratanteControl,
      this.primerApellidoContratanteControl,
      this.segundoApellidoContratanteControl,
      this.primerNombreContratanteControl,
      this.segundoNombreContratanteControl,
      this.fechaNacimientoContratanteControl,
      this.estadoCivilContratanteControl,
      this.generoContratanteControl,
      this.estratoSocialContratanteControl,
      this.nacionalidadContratanteControl,
      this.profesionContratanteControl,
      this.recibirCorrespondenciaControl,
      this.emailContratanteControl,
      this.ocupacionContratanteControl,
      this.tipoIdentificacionNuevoContratanteControl,
      this.numeroIdentificacionNuevoContratanteControl,
      this.nombreNuevoContratanteControl,
      this.nuevoTitularSeleccionadoControl,
      this.activarDebitoAutomaticoNuevoResponsableControl,
      this.metodoDebitoAutomaticoControl,
      this.confirmacionGestionTarjetaControl,
      this.tipoCuentaDebitoControl,
      this.bancoDebitoControl,
      this.bancoDebitoNombreControl,
      this.numeroCuentaDebitoControl,
      this.tipoViaControl,
      this.numeroViaControl,
      this.numeroPlacaControl,
      this.direccionControl,
      this.complementoDireccionControl,
      this.barrioControl,
      this.departamentoControl,
      this.municipioControl,
      this.telefonoResidenciaControl,
      this.celularControl,
      this.colectivoControl,
      this.subcuentaDestinoControl,
      this.sucursalDestinoControl,
      this.programaDestinoColectivoControl,
      this.proporcionalidadColectivoControl,
      this.corteSubcuentaControl,
      this.tarifaDestinoColectivoControl,
      this.tipoPlanDestinoContratoControl,
      this.programaDestinoContratoControl,
      this.subcuentaDestinoContratoControl,
      this.corteDestinoContratoControl,
      this.tarifaDestinoContratoControl,
      this.sucursalComercializableContratoControl,
      this.proporcionalidadContratoControl,
      this.tipoIdentificacionContratanteDestinoControl,
      this.numeroIdentificacionContratanteDestinoControl,
      this.contratoDestinoControl,
      this.corteContratoDestinoControl,
      this.proporcionalidadExistenteControl,
      this.tipoPlanDestinoExistenteControl,
      this.lineaNegocioDestinoExistenteControl,
      this.grupoProgramaDestinoExistenteControl,
      this.programaDestinoExistenteControl,
      this.tipoPrimaDestinoExistenteControl,
      this.codTarifaDestinoExistenteControl,
      this.incluirAnexoExistenteControl,
      this.tarifaCambioControl,
      this.valorTotalCuotaIvaControl,
      this.fechaAplicacionNovedadControl,
    ];
  }

  private syncReadonlyControlState(): void {
    const controls = [
      ...this.getPersistableControls(),
      this.motivoRetiroResponsableControl,
    ];
    const uniqueControls = [...new Set(controls)];

    if (this.readonly) {
      uniqueControls.forEach((control) => {
        if (control.enabled) {
          control.disable({ emitEvent: false });
          this.controlsDisabledByReadonly.add(control);
        }
      });
      return;
    }

    if (!this.disabled) {
      this.controlsDisabledByReadonly.forEach((control) => {
        control.enable({ emitEvent: false });
      });
      this.controlsDisabledByReadonly.clear();
    }
  }

  /** Guarda el estado actual y evita limpiar selects al avanzar de paso en el stepper. */
  public prepararPersistenciaAntesDeAvanzarPaso(): void {
    if (this.isRestoringState) {
      return;
    }
    this.estadoNavegacionCongelado = this.buildPersistedState();
    this.navegacionCongeladaHasta = Date.now() + 2000;
    this.suprimirEfectosSeleccionContratoNuevo = true;
    this.persistState();
    setTimeout(() => {
      this.suprimirEfectosSeleccionContratoNuevo = false;
      this.estadoNavegacionCongelado = null;
      this.navegacionCongeladaHasta = 0;
    }, 2000);
  }

  private fusionarSinDegradarDestinoANull(
    actual: TipoNovedadSelectorState,
    referencia: TipoNovedadSelectorState,
  ): TipoNovedadSelectorState {
    const fusionado = { ...actual };
    for (const campo of CAMPOS_DESTINO_SIN_DEGRADAR) {
      if (fusionado[campo] == null && referencia[campo] != null) {
        fusionado[campo] = referencia[campo];
      }
    }
    return fusionado;
  }

  private fusionarSinDegradarSeleccionANull(
    actual: TipoNovedadSelectorState,
    referencia: TipoNovedadSelectorState,
  ): TipoNovedadSelectorState {
    const fusionado = { ...actual };
    const campos: Array<keyof TipoNovedadSelectorState> = [
      'tipoNovedad',
      'subtipoNovedad',
      'selectedTipoNovedad',
      'selectedSubtipoNovedad',
      'idTipoSolicitud',
      'proporcionalidadColectivo',
      'mostrarCampoColectivo',
      'mostrarCamposCambioCobertura',
      'beneficiariosTarifa',
    ];
    for (const campo of campos) {
      if (fusionado[campo] == null && referencia[campo] != null) {
        fusionado[campo] = referencia[campo];
      }
    }
    const idActual = Number(fusionado.idTipoSolicitud ?? 0);
    const idRef = Number(referencia.idTipoSolicitud ?? 0);
    if (!(idActual > 0) && idRef > 0) {
      fusionado.idTipoSolicitud = idRef;
    }
    return fusionado;
  }

  private claveSeleccionContratoNuevo(valor: unknown): string {
    if (valor == null) {
      return '';
    }
    if (typeof valor === 'object') {
      const obj = valor as { codigo?: unknown; nombre?: unknown };
      const codigo = String(obj.codigo ?? '').trim();
      if (codigo) {
        return codigo;
      }
      return String(obj.nombre ?? '').trim();
    }
    return String(valor).trim();
  }

  private persistState(): void {
    if (this.isRestoringState) {
      return;
    }

    const anterior = this.localStorageService.load(
      this.storageKey,
    ) as TipoNovedadSelectorState | null;

    let state = this.buildPersistedState();

    if (anterior) {
      state = this.fusionarSinDegradarDestinoANull(state, anterior);
      state = this.fusionarSinDegradarSeleccionANull(state, anterior);
    }

    if (
      this.estadoNavegacionCongelado &&
      Date.now() < this.navegacionCongeladaHasta
    ) {
      state = this.fusionarSinDegradarDestinoANull(
        state,
        this.estadoNavegacionCongelado,
      );
      state = this.fusionarSinDegradarSeleccionANull(
        state,
        this.estadoNavegacionCongelado,
      );
    }

    const valorColectivoActual = this.colectivoControl.value;
    const escribiendoColectivo =
      typeof valorColectivoActual === 'string' && valorColectivoActual;
    if (
      escribiendoColectivo ||
      (state.colectivo != null && !this.esColectivoValido(state.colectivo))
    ) {
      state = {
        ...state,
        colectivo: null,
        subcuentaDestino: null,
        sucursalDestino: null,
        programaDestinoColectivo: null,
        corteSubcuenta: null,
        tarifaDestinoColectivo: null,
      };
    }

    this.localStorageService.save(this.storageKey, state);
  }

  /** Al radicar el formulario puede estar vacío (acordeón cerrado). */
  private persistStateParaRadicar(): void {
    this.persistState();
  }

  private buildPersistedState(): TipoNovedadSelectorState {
    const tipoNovedadPersistido = (() => {
      const t = this.tipoNovedadControl.value as TipoNovedad | null;
      if (!t) {
        return null;
      }
      const id =
        this.idTipoSolicitudDesdeTipoNovedad(this.selectedTipoNovedad) ??
        this.idTipoSolicitudDesdeTipoNovedad(t);
      return id != null ? { ...t, idTipoSolicitud: id } : t;
    })();

    return {
      tipoNovedad: tipoNovedadPersistido,
      subtipoNovedad: this.subtipoNovedadControl.value,
      tipoPlanDestino: this.tipoPlanDestinoControl.value,
      programaDestino: this.programaDestinoControl.value,
      tarifaDestino: this.tarifaDestinoControl.value,
      corteDestino: this.corteDestinoControl.value,
      proporcionalidad: this.proporcionalidadControl.value,
      incluirAnexo: this.incluirAnexoControl.value ?? false,
      tipoContratante: this.tipoContratanteControl.value,
      cambiarDatosContratante:
        this.cambiarDatosContratanteControl.value ?? false,
      codigoAsesorDestino: this.codigoAsesorDestinoControl.value,
      tipoDocumentoContratante: this.tipoDocumentoContratanteControl.value,
      numeroDocumentoContratante: this.numeroDocumentoContratanteControl.value,
      primerApellidoContratante: this.primerApellidoContratanteControl.value,
      segundoApellidoContratante: this.segundoApellidoContratanteControl.value,
      primerNombreContratante: this.primerNombreContratanteControl.value,
      segundoNombreContratante: this.segundoNombreContratanteControl.value,
      fechaNacimientoContratante: this.fechaNacimientoContratanteControl.value,
      estadoCivilContratante: this.estadoCivilContratanteControl.value,
      generoContratante: this.generoContratanteControl.value,
      estratoSocialContratante: this.estratoSocialContratanteControl.value,
      nacionalidadContratante: this.nacionalidadContratanteControl.value,
      profesionContratante: this.profesionContratanteControl.value,
      recibirCorrespondencia: this.recibirCorrespondenciaControl.value,
      emailContratante: this.emailContratanteControl.value,
      ocupacionContratante: this.ocupacionContratanteControl.value,
      tipoIdentificacionNuevoContratante:
        this.tipoIdentificacionNuevoContratanteControl.value,
      numeroIdentificacionNuevoContratante:
        this.numeroIdentificacionNuevoContratanteControl.value,
      nombreNuevoContratante: this.nombreNuevoContratanteControl.value,
      nuevoTitularSeleccionado: this.nuevoTitularSeleccionadoControl.value,
      // Débito automático - nuevo responsable
      activarDebitoAutomaticoNuevoResponsable:
        this.activarDebitoAutomaticoNuevoResponsableControl.value ?? false,
      metodoDebitoAutomatico: this.metodoDebitoAutomaticoControl.value,
      confirmacionGestionTarjeta:
        this.confirmacionGestionTarjetaControl.value ?? false,
      tipoCuentaDebito: this.tipoCuentaDebitoControl.value,
      bancoDebito: this.bancoDebitoControl.value,
      bancoDebitoNombre: this.bancoDebitoNombreControl.value ?? null,
      numeroCuentaDebito: this.numeroCuentaDebitoControl.value,
      tipoVia: this.tipoViaControl.value,
      numeroVia: this.numeroViaControl.value,
      numeroPlaca: this.numeroPlacaControl.value,
      direccion: this.direccionControl.value,
      complementoDireccion: this.complementoDireccionControl.value,
      barrio: this.barrioControl.value,
      departamento: this.departamentoControl.value,
      municipio: this.municipioControl.value,
      telefonoResidencia: this.telefonoResidenciaControl.value,
      celular: this.celularControl.value,
      colectivo: this.colectivoControl.value,
      subcuentaDestino: this.subcuentaDestinoControl.value,
      sucursalDestino: this.sucursalDestinoControl.value,
      programaDestinoColectivo: this.programaDestinoColectivoControl.value,
      proporcionalidadColectivo: this.proporcionalidadColectivoControl.value,
      corteSubcuenta: this.corteSubcuentaControl.value,
      tarifaDestinoColectivo: this.tarifaDestinoColectivoControl.value,
      tipoPlanDestinoContrato: this.tipoPlanDestinoContratoControl.value,
      programaDestinoContrato: this.programaDestinoContratoControl.value,
      subcuentaDestinoContrato: this.subcuentaDestinoContratoControl.value,
      corteDestinoContrato: this.corteDestinoContratoControl.value,
      tarifaDestinoContrato: this.tarifaDestinoContratoControl.value,
      sucursalComercializableContrato:
        this.sucursalComercializableContratoControl.value,
      proporcionalidadContrato: this.proporcionalidadContratoControl.value,
      tipoIdentificacionContratanteDestino:
        this.tipoIdentificacionContratanteDestinoControl.value,
      numeroIdentificacionContratanteDestino:
        this.numeroIdentificacionContratanteDestinoControl.value,
      contratoDestino: this.contratoDestinoControl.value,
      corteContratoDestino: this.corteContratoDestinoControl.value,
      proporcionalidadExistente: this.proporcionalidadExistenteControl.value,
      tipoPlanDestinoExistente: this.tipoPlanDestinoExistenteControl.value,
      lineaNegocioDestinoExistente:
        this.lineaNegocioDestinoExistenteControl.value,
      grupoProgramaDestinoExistente:
        this.grupoProgramaDestinoExistenteControl.value,
      grupoProgramaDestino:
        String(this.grupoProgramaDestino ?? '').trim() || undefined,
      programaDestinoExistente: this.programaDestinoExistenteControl.value,
      tipoPrimaDestinoExistente: this.tipoPrimaDestinoExistenteControl.value,
      codTarifaDestinoExistente: this.codTarifaDestinoExistenteControl.value,
      incluirAnexoExistente: this.incluirAnexoExistenteControl.value,
      tarifaCambio: this.tarifaCambioControl.value,
      valorTotalCuotaIva: this.valorTotalCuotaIvaControl.value,
      fechaAplicacionNovedad: (() => {
        const v = this.fechaAplicacionNovedadControl.value;
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString();
        }
        return null;
      })(),
      selectedTipoNovedad: this.selectedTipoNovedad,
      idTipoSolicitud: (() => {
        const id =
          this.idTipoSolicitudDesdeTipoNovedad(this.selectedTipoNovedad) ??
          this.idTipoSolicitudDesdeTipoNovedad(tipoNovedadPersistido) ??
          this.idTipoSolicitudDesdeTipoNovedad(
            this.tipoNovedadControl.value as TipoNovedad | null,
          );
        return id;
      })(),
      selectedSubtipoNovedad: this.selectedSubtipoNovedad,
      mostrarCampoColectivo: this.mostrarCampoColectivo,
      mostrarCambioTitular: this.mostrarCambioTitular,
      mostrarCamposCambioCobertura: this.mostrarCamposCambioCobertura,
      mostrarTablaBeneficiarios: this.mostrarTablaBeneficiarios,
      mostrarCamposTrasladoContratoNuevo:
        this.mostrarCamposTrasladoContratoNuevo,
      mostrarTablaIntegrantesContratoNuevo:
        this.mostrarTablaIntegrantesContratoNuevo,
      mostrarCamposTrasladoContratoExistente:
        this.mostrarCamposTrasladoContratoExistente,
      mostrarTablaIntegrantesTrasladoExistente:
        this.mostrarTablaIntegrantesTrasladoExistente,
      mostrarTablaAdicionaAnexo: this.mostrarTablaAdicionaAnexo,
      // Datos de las tablas
      beneficiariosTarifa: this.beneficiariosTarifa,
      integrantesTrasladoExistente: this.integrantesTrasladoExistente,
      integrantesContratoNuevo: this.integrantesContratoNuevo,
      integrantesContratoDestino: this.integrantesContratoDestino,
      integrantesAdicionaAnexo: this.integrantesAdicionaAnexo,
      tipoPrimaObtenido: this.tipoPrimaObtenido,
      // No persistir mensaje para evitar alertas obsoletas tras F5.
      errorTipoPrima: null,
      tipoPrimaOrigenPersistido: this.tipoPrimaOrigen || '',
      tiposPlanesUi: [...(this.tiposPlanes || [])],
      subcuentasDestinoUi: [...(this.subcuentasDestino || [])],
      sucursalesDestinoUi: [...(this.sucursalesDestino || [])],
      programasDestinoColectivoUi: [...(this.programasDestinoColectivo || [])],
      cortesSubcuentaUi: [...(this.cortesSubcuenta || [])],
      tarifasDestinoColectivoUi: [...(this.tarifasDestinoColectivo || [])],
      totalCuotaIva: this.totalCuotaIva,
      totalCuotaIvaContratoNuevo: this.totalCuotaIvaContratoNuevo,
      totalCuotaIvaTrasladoExistente: this.totalCuotaIvaTrasladoExistente,
      totalCuotaIvaAdicionaAnexo: this.totalCuotaIvaAdicionaAnexo,
    };
  }

  private async restoreState(): Promise<void> {
    const restoreVersion = this.resetVersion;
    this.isRestoringState = true;

    try {
      const savedState = this.localStorageService.load(
        this.storageKey,
      ) as TipoNovedadSelectorState | null;

      if (!savedState) {
        return;
      }

      this.patchControlValue(this.tipoNovedadControl, savedState.tipoNovedad);
      this.patchControlValue(
        this.subtipoNovedadControl,
        savedState.subtipoNovedad,
      );
      this.patchControlValue(
        this.tipoPlanDestinoControl,
        savedState.tipoPlanDestino,
      );
      this.patchControlValue(
        this.programaDestinoControl,
        savedState.programaDestino,
      );
      this.patchControlValue(
        this.tarifaDestinoControl,
        savedState.tarifaDestino,
      );
      this.patchControlValue(this.corteDestinoControl, savedState.corteDestino);
      this.patchControlValue(
        this.proporcionalidadControl,
        savedState.proporcionalidad,
      );
      this.patchControlValue(this.incluirAnexoControl, savedState.incluirAnexo);
      this.patchControlValue(
        this.tipoContratanteControl,
        savedState.tipoContratante,
      );
      this.patchControlValue(
        this.cambiarDatosContratanteControl,
        savedState.cambiarDatosContratante,
      );
      const saltarContratantePersistido =
        savedState.tipoContratante === 'mantener';
      if (!saltarContratantePersistido) {
        this.patchControlValue(
          this.codigoAsesorDestinoControl,
          savedState.codigoAsesorDestino,
        );
        this.patchControlValue(
          this.tipoDocumentoContratanteControl,
          savedState.tipoDocumentoContratante,
        );
        this.patchControlValue(
          this.numeroDocumentoContratanteControl,
          savedState.numeroDocumentoContratante,
        );
        this.patchControlValue(
          this.primerApellidoContratanteControl,
          savedState.primerApellidoContratante,
        );
        this.patchControlValue(
          this.segundoApellidoContratanteControl,
          savedState.segundoApellidoContratante,
        );
        this.patchControlValue(
          this.primerNombreContratanteControl,
          savedState.primerNombreContratante,
        );
        this.patchControlValue(
          this.segundoNombreContratanteControl,
          savedState.segundoNombreContratante,
        );
        this.patchControlValue(
          this.fechaNacimientoContratanteControl,
          savedState.fechaNacimientoContratante
            ? new Date(savedState.fechaNacimientoContratante)
            : null,
        );
        this.patchControlValue(
          this.estadoCivilContratanteControl,
          savedState.estadoCivilContratante,
        );
        this.patchControlValue(
          this.generoContratanteControl,
          savedState.generoContratante,
        );
        this.patchControlValue(
          this.estratoSocialContratanteControl,
          savedState.estratoSocialContratante,
        );
        this.patchControlValue(
          this.nacionalidadContratanteControl,
          savedState.nacionalidadContratante,
        );
        this.patchControlValue(
          this.profesionContratanteControl,
          savedState.profesionContratante,
        );
        this.patchControlValue(
          this.recibirCorrespondenciaControl,
          savedState.recibirCorrespondencia,
        );
        this.patchControlValue(
          this.emailContratanteControl,
          savedState.emailContratante,
        );
        this.patchControlValue(
          this.ocupacionContratanteControl,
          savedState.ocupacionContratante,
        );
      }
      this.patchControlValue(
        this.tipoIdentificacionNuevoContratanteControl,
        savedState.tipoIdentificacionNuevoContratante,
      );
      this.patchControlValue(
        this.numeroIdentificacionNuevoContratanteControl,
        savedState.numeroIdentificacionNuevoContratante,
      );
      this.patchControlValue(
        this.nombreNuevoContratanteControl,
        savedState.nombreNuevoContratante,
      );
      this.patchControlValue(
        this.nuevoTitularSeleccionadoControl,
        savedState.nuevoTitularSeleccionado,
      );
      // Restaurar valores de débito automático para nuevo responsable
      this.patchControlValue(
        this.activarDebitoAutomaticoNuevoResponsableControl,
        savedState.activarDebitoAutomaticoNuevoResponsable,
      );
      this.patchControlValue(
        this.metodoDebitoAutomaticoControl,
        savedState.metodoDebitoAutomatico,
      );
      this.patchControlValue(
        this.confirmacionGestionTarjetaControl,
        savedState.confirmacionGestionTarjeta,
      );
      this.patchControlValue(
        this.tipoCuentaDebitoControl,
        savedState.tipoCuentaDebito,
      );
      this.patchControlValue(this.bancoDebitoControl, savedState.bancoDebito);
      this.patchControlValue(
        this.numeroCuentaDebitoControl,
        savedState.numeroCuentaDebito,
      );
      this.patchControlValue(
        this.bancoDebitoNombreControl,
        savedState.bancoDebitoNombre,
      );
      this.patchControlValue(this.tipoViaControl, savedState.tipoVia);
      this.patchControlValue(this.numeroViaControl, savedState.numeroVia);
      this.patchControlValue(this.numeroPlacaControl, savedState.numeroPlaca);
      this.patchControlValue(this.direccionControl, savedState.direccion);
      this.patchControlValue(
        this.complementoDireccionControl,
        savedState.complementoDireccion,
      );
      this.patchControlValue(this.barrioControl, savedState.barrio);
      this.patchControlValue(this.departamentoControl, savedState.departamento);
      this.patchControlValue(this.municipioControl, savedState.municipio);
      this.patchControlValue(
        this.telefonoResidenciaControl,
        savedState.telefonoResidencia,
      );
      this.patchControlValue(this.celularControl, savedState.celular);
      this.patchControlValue(this.colectivoControl, savedState.colectivo);
      this.patchControlValue(
        this.subcuentaDestinoControl,
        savedState.subcuentaDestino,
      );
      this.patchControlValue(
        this.sucursalDestinoControl,
        savedState.sucursalDestino,
      );
      this.patchControlValue(
        this.programaDestinoColectivoControl,
        savedState.programaDestinoColectivo,
      );
      this.patchControlValue(
        this.proporcionalidadColectivoControl,
        savedState.proporcionalidadColectivo,
      );
      this.patchControlValue(
        this.corteSubcuentaControl,
        savedState.corteSubcuenta,
      );
      this.patchControlValue(
        this.tarifaDestinoColectivoControl,
        savedState.tarifaDestinoColectivo,
      );
      this.patchControlValue(
        this.tipoPlanDestinoContratoControl,
        savedState.tipoPlanDestinoContrato,
      );
      this.patchControlValue(
        this.programaDestinoContratoControl,
        savedState.programaDestinoContrato,
      );
      this.patchControlValue(
        this.subcuentaDestinoContratoControl,
        savedState.subcuentaDestinoContrato,
      );
      this.patchControlValue(
        this.corteDestinoContratoControl,
        savedState.corteDestinoContrato,
      );
      this.patchControlValue(
        this.tarifaDestinoContratoControl,
        savedState.tarifaDestinoContrato,
      );
      this.patchControlValue(
        this.sucursalComercializableContratoControl,
        savedState.sucursalComercializableContrato,
      );
      this.patchControlValue(
        this.proporcionalidadContratoControl,
        savedState.proporcionalidadContrato,
      );
      this.patchControlValue(
        this.tipoIdentificacionContratanteDestinoControl,
        savedState.tipoIdentificacionContratanteDestino,
      );
      this.patchControlValue(
        this.numeroIdentificacionContratanteDestinoControl,
        savedState.numeroIdentificacionContratanteDestino,
      );
      this.patchControlValue(
        this.contratoDestinoControl,
        savedState.contratoDestino,
      );
      if (savedState.contratoDestino?.codigo) {
        this.contratoDestinoSeleccionadoCodigo = String(
          savedState.contratoDestino.codigo,
        ).trim();
      }
      this.patchControlValue(
        this.corteContratoDestinoControl,
        savedState.corteContratoDestino,
      );
      this.patchControlValue(
        this.proporcionalidadExistenteControl,
        savedState.proporcionalidadExistente,
      );
      this.patchControlValue(
        this.tipoPlanDestinoExistenteControl,
        savedState.tipoPlanDestinoExistente,
      );
      this.patchControlValue(
        this.lineaNegocioDestinoExistenteControl,
        savedState.lineaNegocioDestinoExistente,
      );
      this.patchControlValue(
        this.grupoProgramaDestinoExistenteControl,
        savedState.grupoProgramaDestinoExistente,
      );
      this.patchControlValue(
        this.programaDestinoExistenteControl,
        savedState.programaDestinoExistente,
      );
      this.patchControlValue(
        this.tipoPrimaDestinoExistenteControl,
        savedState.tipoPrimaDestinoExistente,
      );
      this.patchControlValue(
        this.codTarifaDestinoExistenteControl,
        savedState.codTarifaDestinoExistente,
      );
      this.patchControlValue(
        this.incluirAnexoExistenteControl,
        savedState.incluirAnexoExistente,
      );
      this.patchControlValue(this.tarifaCambioControl, savedState.tarifaCambio);
      this.patchControlValue(
        this.valorTotalCuotaIvaControl,
        savedState.valorTotalCuotaIva,
      );
      const fa = savedState.fechaAplicacionNovedad;
      if (fa) {
        const d = fa instanceof Date ? fa : new Date(fa as string);
        if (!Number.isNaN(d.getTime())) {
          this.patchControlValue(this.fechaAplicacionNovedadControl, d);
          this.fechaAplicacionNovedadUsuarioEdito = true;
        }
      }

      this.selectedTipoNovedad = savedState.selectedTipoNovedad;
      this.selectedSubtipoNovedad = savedState.selectedSubtipoNovedad;
      this.mostrarCampoColectivo = savedState.mostrarCampoColectivo ?? false;
      this.mostrarCambioTitular = savedState.mostrarCambioTitular ?? false;
      this.mostrarCamposCambioCobertura =
        savedState.mostrarCamposCambioCobertura ?? false;
      this.mostrarTablaBeneficiarios =
        savedState.mostrarTablaBeneficiarios ?? false;
      this.mostrarCamposTrasladoContratoNuevo =
        savedState.mostrarCamposTrasladoContratoNuevo ?? false;
      this.mostrarTablaIntegrantesContratoNuevo =
        savedState.mostrarTablaIntegrantesContratoNuevo ?? false;
      this.mostrarCamposTrasladoContratoExistente =
        savedState.mostrarCamposTrasladoContratoExistente ?? false;
      this.mostrarTablaIntegrantesTrasladoExistente =
        savedState.mostrarTablaIntegrantesTrasladoExistente ?? false;
      this.mostrarTablaAdicionaAnexo =
        savedState.mostrarTablaAdicionaAnexo ?? false;

      // Restaurar datos de las tablas
      this.beneficiariosTarifa = savedState.beneficiariosTarifa ?? [];
      this.integrantesTrasladoExistente =
        savedState.integrantesTrasladoExistente ?? [];
      this.integrantesContratoNuevo = savedState.integrantesContratoNuevo ?? [];
      this.integrantesContratoDestino =
        savedState.integrantesContratoDestino ?? [];
      this.integrantesAdicionaAnexo = savedState.integrantesAdicionaAnexo ?? [];

      if (savedState.tipoPrimaObtenido != null) {
        this.tipoPrimaObtenido = savedState.tipoPrimaObtenido;
      }
      this.errorTipoPrima = null;
      const tpo = savedState.tipoPrimaOrigenPersistido;
      if (tpo != null && String(tpo).trim() !== '') {
        this.tipoPrimaOrigen = String(tpo).trim();
      }
      if ((savedState.tiposPlanesUi?.length ?? 0) > 0) {
        this.tiposPlanes = [...(savedState.tiposPlanesUi as any[])];
      }
      if ((savedState.subcuentasDestinoUi?.length ?? 0) > 0) {
        this.subcuentasDestino = [...(savedState.subcuentasDestinoUi as any[])];
      }
      if ((savedState.sucursalesDestinoUi?.length ?? 0) > 0) {
        this.sucursalesDestino = [...(savedState.sucursalesDestinoUi as any[])];
      }
      if ((savedState.programasDestinoColectivoUi?.length ?? 0) > 0) {
        this.programasDestinoColectivo = [
          ...(savedState.programasDestinoColectivoUi as any[]),
        ];
      }
      if ((savedState.cortesSubcuentaUi?.length ?? 0) > 0) {
        this.cortesSubcuenta = [...(savedState.cortesSubcuentaUi as any[])];
      }
      if ((savedState.tarifasDestinoColectivoUi?.length ?? 0) > 0) {
        this.tarifasDestinoColectivo = [
          ...(savedState.tarifasDestinoColectivoUi as any[]),
        ];
      }

      if (savedState.tipoNovedad) {
        await this.onTipoNovedadChanged(savedState.tipoNovedad);
        if (restoreVersion !== this.resetVersion) {
          return;
        }
      }

      if (savedState.subtipoNovedad) {
        await this.onSubtipoNovedadChanged(savedState.subtipoNovedad);
        if (restoreVersion !== this.resetVersion) {
          return;
        }
      }

      await this.restoreDependentSelections(savedState);
      if (restoreVersion !== this.resetVersion) {
        return;
      }

      // El estado persistido puede traer valores viejos del contratante; la fuente de verdad
      // para "Mantener contratante actual" es siempre la fila de contratos-users del paso 1.
      this.reaplicarDatosContratanteDesdeContratoUsersSiMantener();

      this.sincronizarTotalesCuotaPostRestauracion(savedState);

      this.checkValidacionCompletada();

      this.actualizarEstadoTipoNumeroDocumento();
    } finally {
      if (restoreVersion !== this.resetVersion) {
        return;
      }
      this.isRestoringState = false;
      this.sincronizarFechaAplicacionPorDefectoSiCorresponde();
      this.persistState();
      queueMicrotask(() => {
        void this.asegurarProgramasColectivoTrasRestauracion();
      });
    }
  }

  /**
   * Tras `restoreState`, volvemos a poblar identidad/contacto desde el contrato elegido
   * (ojo) para no quedar con datos mock o null guardados en sesiones anteriores.
   */
  private reaplicarDatosContratanteDesdeContratoUsersSiMantener(): void {
    if (this.tipoContratanteControl.value !== 'mantener') {
      return;
    }
    this.precargarDatosContratanteActual();
  }

  private async restoreDependentSelections(
    savedState: TipoNovedadSelectorState,
  ): Promise<void> {
    // Restaurar flujo de colectivo (Traslado a Colectivo)
    if (savedState.colectivo) {
      await this.loadColectivos();
      await this.onColectivoSelected(savedState.colectivo);
      if (!this.esColectivoValido()) {
        return;
      }

      if (savedState.subcuentaDestino?.codigo) {
        await this.cargarSucursalesDestino(savedState.subcuentaDestino.codigo, {
          modoRestauracion: true,
        });
      }
      this.patchControlValue(
        this.subcuentaDestinoControl,
        savedState.subcuentaDestino,
      );
      this.sincronizarGrupoProgramaDestinoDesdeSubcuentaColectivo();

      if (savedState.sucursalDestino?.codigo) {
        await this.cargarProgramasColectivo(savedState.sucursalDestino.codigo, {
          preservarSiRespuestaVacia: true,
        });
      }
      this.patchControlValue(
        this.sucursalDestinoControl,
        savedState.sucursalDestino,
      );

      this.patchControlValue(
        this.programaDestinoColectivoControl,
        savedState.programaDestinoColectivo,
      );
      this.ajustarProgramaColectivoAMismaReferenciaEnLista();

      if (savedState.programaDestinoColectivo?.codigo) {
        await this.cargarCortesSubcuenta(
          savedState.programaDestinoColectivo.codigo,
          { preservarSiError: true },
        );
      }
      this.patchControlValue(
        this.corteSubcuentaControl,
        savedState.corteSubcuenta,
      );
      this.ajustarCorteSubcuentaAMismaReferenciaEnLista();

      if (savedState.corteSubcuenta?.codigo) {
        await this.cargarTarifasColectivo(savedState.corteSubcuenta.codigo, {
          preservarSiVacio: true,
        });
      }
      this.patchControlValue(
        this.tarifaDestinoColectivoControl,
        savedState.tarifaDestinoColectivo,
      );
      this.ajustarTarifaDestinoColectivoAMismaReferenciaEnLista();
    }

    // Restaurar flujo de Cambio de Cobertura (sin colectivo)
    if (
      savedState.mostrarCamposCambioCobertura &&
      !savedState.mostrarCampoColectivo
    ) {
      if (savedState.programaDestino?.codigo) {
        this.grupoProgramaDestino = String(
          savedState.programaDestino.grupoPrograma ?? '',
        ).trim();
        await this.cargarTarifasDestino();
      }
    }

    // Restaurar flujo de Traslado a Contrato Nuevo
    if (savedState.mostrarCamposTrasladoContratoNuevo) {
      await this.cargarTiposPlanesContratoNuevo();

      // Cargar programas si hay un tipo de plan guardado
      if (savedState.tipoPlanDestinoContrato) {
        await this.cargarProgramasContratoNuevo(
          savedState.tipoPlanDestinoContrato,
        );
      }

      // Cargar subcuentas si hay un programa guardado
      if (savedState.programaDestinoContrato) {
        await this.cargarSubcuentasContratoNuevo(
          savedState.programaDestinoContrato,
        );
      }

      // Cargar cortes si hay una subcuenta guardada
      if (savedState.subcuentaDestinoContrato) {
        await this.cargarCortesDestinoContrato(
          savedState.subcuentaDestinoContrato,
        );
      }

      // Cargar tarifas
      await this.cargarTarifasContratoNuevo();

      // Cargar sucursales comercializables si hay una tarifa guardada
      if (savedState.tarifaDestinoContrato) {
        await this.cargarSucursalesComercializablesContrato();
      }
    }

    // Restaurar flujo de Traslado a Contrato Existente
    if (savedState.mostrarCamposTrasladoContratoExistente) {
      this.cargarTiposIdentificacionContratante();
    }

    // Cambio de titular: ya se inicializa en `onSubtipoNovedadChanged` al restaurar el subtipo.
  }

  private patchControlValue(control: FormControl, value: any): void {
    control.setValue(value ?? null, { emitEvent: false });
  }

  private async onTipoNovedadChanged(
    tipoNovedad: TipoNovedad | null,
  ): Promise<void> {
    // Importante: limpiar tablas ANTES del primer `await`. `onTipoSelected` corre en el mismo
    // turno tras `setValue` y puede activar «Traslado a contrato existente»; si este bloque
    // corre después de un await, `ocultarTodasLasTablas()` pisaba esos flags y quedaban
    // visibles la tabla de beneficiarios + la de traslado a la vez.
    if (!this.isRestoringState) {
      this.clearSubtipoSelection();
      this.ocultarCamposCambioCobertura();
      this.ocultarTodasLasTablas();
      this.disableSubtipoSelector();
    }

    const idTipoSolicitudEfectivo =
      this.idTipoSolicitudDesdeTipoNovedad(tipoNovedad);
    const tipoNovedadConId = tipoNovedad
      ? {
          ...tipoNovedad,
          idTipoSolicitud: idTipoSolicitudEfectivo,
        }
      : null;
    this.selectedTipoNovedad = tipoNovedadConId;
    this.tipoNovedadSeleccionada.emit(tipoNovedadConId);
    if (!this.isRestoringState && tipoNovedadConId) {
      this.persistState();
    }

    if (!tipoNovedadConId) {
      this.cambioPlanActivo = false;
      this.checkValidacionCompletada();
      return;
    }

    this.validateRequiereTodosIntegrantes(tipoNovedadConId);

    if (this.isRestoringState) {
      const esCambioPlanRestore =
        this.esCambioPlanNovedadTipo(tipoNovedadConId);
      this.cambioPlanActivo = esCambioPlanRestore;
      if (esCambioPlanRestore) {
        // Solo UI: los controles ya vienen de `patchControlValue`; `procesarCambioPlan`
        // completo llama `clearAllContratoNuevoFields` y borra lo restaurado.
        await this.procesarCambioPlan(tipoNovedadConId, {
          modoRestauracion: true,
        });
        this.checkValidacionCompletada();
        return;
      }
      const esCambioTarifaRestore =
        this.esCambioTarifaNovedadTipo(tipoNovedadConId);
      if (esCambioTarifaRestore) {
        this.disableSubtipoSelector();
        this.cargarTarifasParaCambio();
        this.checkValidacionCompletada();
        return;
      }
      await this.loadSubtiposNovedad(tipoNovedadConId.codigo);
      if (
        !this.esTipoNombre(tipoNovedadConId, 'cambio de cobertura') &&
        !this.esTipoNombre(tipoNovedadConId, 'cambio de plan')
      ) {
        this.ocultarCamposCambioCobertura();
      }
      this.checkValidacionCompletada();
      return;
    }

    const tieneSolicitudActiva =
      await this.verificarSolicitudesActivas(tipoNovedadConId);
    if (tieneSolicitudActiva) {
      return;
    }

    const perfilamientoValido =
      await this.validarPerfilamiento(tipoNovedadConId);
    if (!perfilamientoValido) {
      return;
    }

    // MP-FT-1358: Cambio de plan no requiere subtipo.
    // Además, el flujo debe inicializarse sin esperar a un subtipo seleccionado.
    const esCambioPlan = this.esCambioPlanNovedadTipo(tipoNovedadConId);
    this.cambioPlanActivo = esCambioPlan;
    if (esCambioPlan) {
      this.disableSubtipoSelector();
      await this.procesarCambioPlan(tipoNovedadConId);
      this.checkValidacionCompletada();
      this.persistState();
      return;
    }

    // MP-FT-1358 1.1.3.6: Cambio de tarifa — sin subtipo; tarifas desde parametrización origen.
    const esCambioTarifa = this.esCambioTarifaNovedadTipo(tipoNovedadConId);
    if (esCambioTarifa) {
      this.disableSubtipoSelector();
      if (!this.isRestoringState) {
        this.tarifaCambioControl.setValue(null, { emitEvent: false });
        this.valorTotalCuotaIvaControl.setValue(null, { emitEvent: false });
        this.tarifasCambioDisponibles = [];
        this.tarifasCambioSubject.next([]);
        this.hasErrorTarifasCambio = false;
        this.errorMessageTarifasCambio = '';
      }
      this.cargarTarifasParaCambio();
      this.checkValidacionCompletada();
      this.persistState();
      return;
    }

    await this.loadSubtiposNovedad(tipoNovedadConId.codigo);

    // Para Cambio de Cobertura los campos se muestran solo tras elegir el subtipo
    if (
      !this.esTipoNombre(tipoNovedadConId, 'cambio de cobertura') &&
      !this.esTipoNombre(tipoNovedadConId, 'cambio de plan')
    ) {
      this.ocultarCamposCambioCobertura();
    }

    this.checkValidacionCompletada();
  }

  private esSubtipoTrasladoTipoPrimaDesdeParametrizacion(
    subtipo: SubtipoNovedad | null | undefined,
  ): boolean {
    if (!subtipo) {
      return false;
    }
    const nombre = this.normalizarNombreCatalogo(subtipo.nombre);
    for (const ref of SUBTIPOS_TRASLADO_TIPO_PRIMA_DESDE_PARAMETRIZACION) {
      if (nombre === this.normalizarNombreCatalogo(ref)) {
        return true;
      }
    }
    return false;
  }

  private esSubtipoColectivo(subtipo: SubtipoNovedad | null): boolean {
    const codigo = String(subtipo?.codigoSubtipo ?? '')
      .trim()
      .toUpperCase();
    return (
      codigo === 'TRASLADO_COLECTIVO' ||
      codigo === 'CAMBIO_PERSONA_NATURAL_A_JURIDICO'
    );
  }

  private obtenerIndicadorColectivoTiposPlanes(): string {
    const subtipo =
      this.selectedSubtipoNovedad ?? this.subtipoNovedadControl.value;
    return this.esSubtipoColectivo(subtipo) ? '1' : '0';
  }

  private marcarReconsultaTipoPrimaPendiente(
    subtipo: SubtipoNovedad | null | undefined,
  ): void {
    if (!this.esSubtipoTrasladoTipoPrimaDesdeParametrizacion(subtipo)) {
      return;
    }
    this.tipoPrimaReconsultaPendiente = true;
    this.invalidarConsultaTipoPrimaOrigen();
  }

  /**
   * Limpia estado local y caché HTTP de `/tipos-prima` para el contrato origen actual.
   * Se usa al quitar Downgrade / Upgrade / Lineal y volver a seleccionarlos.
   */
  private invalidarConsultaTipoPrimaOrigen(): void {
    this.tipoPrimaObtenido = false;
    this.tipoPrimaConsultaOrigenKey = '';
    this.tipoPrimaOrigen = '';
    this.errorTipoPrima = null;

    const grupoPrograma = this.obtenerGrupoProgramaTextoContratoOrigen();
    const lineaNegocio = this.obtenerLineaNegocioTextoContratoOrigen();
    if (grupoPrograma && lineaNegocio) {
      this.tiposPrimaService.invalidarCache(grupoPrograma, lineaNegocio);
    }
  }

  private async onSubtipoNovedadChanged(
    subtipoNovedad: SubtipoNovedad | null,
  ): Promise<void> {
    const subtipoAnterior = this.selectedSubtipoNovedad;
    this.selectedSubtipoNovedad = subtipoNovedad;
    this.subtipoNovedadSeleccionada.emit(subtipoNovedad);

    if (!this.isRestoringState) {
      this.mostrarCampoColectivo = false;
      this.mostrarCambioTitular = false;
      this.mostrarCambioResponsablePagador = false;
      this.limpiarEstadoUiCambioTitularResponsable();
    }

    if (this.selectedTipoNovedad && subtipoNovedad) {
      if (!this.isRestoringState) {
        const perfilamientoValido = await this.validarPerfilamiento(
          this.selectedTipoNovedad,
        );
        if (!perfilamientoValido) {
          this.subtipoNovedadControl.setValue(null);
          return;
        }
      }

      if (this.esSubtipoColectivo(subtipoNovedad)) {
        if (!this.isRestoringState) {
          this.mostrarCampoColectivo = true;
        }
        await this.loadColectivos();

        await this.cargarTiposPlanes({
          preservarSeleccionSiPosible:
            this.isRestoringState || !!this.tipoPlanDestinoControl.value,
        });
        if (!this.isRestoringState || !this.beneficiariosTarifa?.length) {
          await this.cargarBeneficiariosTarifa();
        }
      }

      if (
        (this.selectedTipoNovedad?.codigoTipoNovedad === 'CAMBIO_CONTRATANTE' ||
          this.esTipoNombre(
            this.selectedTipoNovedad,
            'cambio de contratante',
          )) &&
        subtipoNovedad.nombre === 'Cambio de titular a responsable pagador'
      ) {
        if (!this.isRestoringState) {
          this.mostrarCambioTitular = true;
        }
        await this.inicializarCambioTitular();
      }

      if (
        (this.selectedTipoNovedad?.codigoTipoNovedad === 'CAMBIO_CONTRATANTE' ||
          this.esTipoNombre(
            this.selectedTipoNovedad,
            'cambio de contratante',
          )) &&
        this.esSubtipoCambioResponsablePagador(subtipoNovedad)
      ) {
        this.mostrarCambioResponsablePagador = true;
        await this.inicializarCambioResponsablePagador();
        this.actualizarEstadoTipoNumeroDocumento();
      }

      if (this.esTipoNombre(this.selectedTipoNovedad, 'cambio de cobertura')) {
        if (
          this.isRestoringState &&
          this.tipoPrimaObtenido &&
          this.mostrarCamposCambioCobertura
        ) {
          this.configurarValidadoresCambioCobertura();
          this.configurarListenersCamposDestino();
        } else if (this.mostrarCampoColectivo) {
          // Traslado a colectivo: no usar `procesarCambioCobertura` (recarga tipos/programa/cortes
          // del bloque sin colectivo). Al re-abrir el catálogo de subtipos tras F5 se volvía a
          // disparar y dejaba el programa colectivo sin referencia en la lista.
          this.mostrarCamposCambioCobertura = true;
          this.isLoadingTipoPrima = true;
          this.errorTipoPrima = null;
          try {
            await this.consultarTipoPrima();
          } finally {
            this.isLoadingTipoPrima = false;
          }
          if (this.tipoPrimaObtenido) {
            this.configurarValidadoresCambioCobertura();
            this.configurarListenersCamposDestino();
            this.ajustarProgramaColectivoAMismaReferenciaEnLista();
          }
        } else {
          await this.procesarCambioCobertura(this.selectedTipoNovedad);
        }
      }

      if (this.esCambioPlanTipoSeleccionado() && !this.isRestoringState) {
        await this.procesarCambioPlan(this.selectedTipoNovedad);
      }

      if (
        this.subtipoRequiereTodosLosIntegrantes(subtipoNovedad) &&
        !this.isRestoringState
      ) {
        this.seleccionarTodosIntegrantesContratoOrigen();
      }
    } else if (!subtipoNovedad && this.selectedTipoNovedad) {
      // Se deseleccionó el subtipo: ocultar campos y tabla
      // MP-FT-1358: Cambio de plan NO depende de subtipo.
      if (!this.esTipoNombre(this.selectedTipoNovedad, 'cambio de plan')) {
        if (
          this.esTipoNombre(this.selectedTipoNovedad, 'cambio de cobertura') ||
          this.esTipoNombre(this.selectedTipoNovedad, 'cambio de plan')
        ) {
          if (
            this.esSubtipoTrasladoTipoPrimaDesdeParametrizacion(subtipoAnterior)
          ) {
            this.marcarReconsultaTipoPrimaPendiente(subtipoAnterior);
          }
          this.ocultarCamposCambioCobertura();
          this.ocultarTodasLasTablas();
        }
      }
    }

    this.checkValidacionCompletada();
    this.persistState();
  }

  private validateRequiereTodosIntegrantes(tipoNovedad: TipoNovedad): void {
    if (this.isRestoringState) {
      return;
    }

    const porTipoNovedad = TIPOS_TODOS_INTEGRANTES.has(
      tipoNovedad.codigoTipoNovedad,
    );

    const sub = this.selectedSubtipoNovedad ?? this.subtipoNovedadControl.value;

    const porSubtipo =
      sub != null && this.subtipoRequiereTodosLosIntegrantes(sub);

    if (porTipoNovedad || porSubtipo) {
      this.seleccionarTodosIntegrantesContratoOrigen();
    } else {
      this.restaurarIntegrantesSeleccionadosPaso1();
    }
  }

  private restaurarIntegrantesSeleccionadosPaso1(): void {
    if (
      Array.isArray(this.integrantesSeleccionadosPaso1) &&
      this.integrantesSeleccionadosPaso1.length > 0
    ) {
      this.integrantesActualizados.emit(
        this.integrantesSeleccionadosPaso1.map((i) => ({
          ...i,
          seleccionado: true,
        })),
      );
    }
  }

  /** Subtipo parametrizado para aplicar la novedad a todos los integrantes (MP-FT-1358). */
  private subtipoRequiereTodosLosIntegrantes(
    sub: SubtipoNovedad | null,
  ): boolean {
    const v = String((sub as SubtipoNovedad)?.aplicaNovedadIntegrantes ?? '')
      .trim()
      .toLowerCase();
    return v === 'si' || v === 'sí' || v === '1' || v === 'true';
  }

  private seleccionarTodosIntegrantesContratoOrigen(): void {
    const raw = this.integrantesTotalesContratoActual;

    if (Array.isArray(raw) && raw.length > 0) {
      const todos = raw.map((row: any) => ({
        ...row,
        seleccionado: true,
      }));

      this.integrantesActualizados.emit(todos);
      return;
    }

    const todosIntegrantes =
      this.contratoSeleccionado?.integrantes?.map((i: IntegranteContrato) => ({
        ...i,
        seleccionado: true,
      })) || [];

    if (todosIntegrantes.length) {
      this.integrantesActualizados.emit(todosIntegrantes);
    }
  }

  /** Query común a GET `tipos-novedad` / `subtipos-novedad` (id tipo solicitud opcional + transitorio). */
  private buildQueryCatalogoTiposNovedad(
    idTipoSolicitud?: number,
  ): CatalogoTiposNovedadQuery {
    const q: CatalogoTiposNovedadQuery = {
      contratoTransitorio: this.esContratoEstadoTransitorio(),
    };
    if (idTipoSolicitud != null && Number.isFinite(Number(idTipoSolicitud))) {
      q.idTipoSolicitud = idTipoSolicitud;
    }
    return q;
  }

  /** RF: contrato «ACTIVO, TRANSITORIO» → `contratoTransitorio=true` en catálogos. */
  private esContratoEstadoTransitorio(): boolean {
    const e = String(
      this.contratoSeleccionado?.estado ??
        (this.filaContratoAfilmedPaso1 as any)?.EstadoContrato ??
        '',
    )
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    return e.includes('TRANSITORIO');
  }

  private async verificarSolicitudesActivas(
    tipoNovedad: TipoNovedad,
  ): Promise<boolean> {
    if (!this.contratoSeleccionado || this.isProcessingSolicitudActiva) {
      return false;
    }

    const numeroContrato = this.obtenerNumeroContratoSeleccionado();
    if (!numeroContrato) {
      return false;
    }

    const idTipoNovedad = Number(String(tipoNovedad.codigo ?? '').trim());
    if (!Number.isFinite(idTipoNovedad)) {
      return this.verificarSolicitudesActivasListadoLegacy(
        tipoNovedad,
        numeroContrato,
      );
    }

    try {
      const payload: {
        numeroContrato: string;
        idTipoNovedad: number;
        idSubtipoNovedad?: number;
        noRegistrosIntegrantes?: string[];
        paresDocumentosIntegrantes?: {
          tipoDocumento: string;
          numeroDocumento: string;
        }[];
      } = {
        numeroContrato,
        idTipoNovedad,
      };

      const subtipo =
        this.selectedSubtipoNovedad ?? this.subtipoNovedadControl.value;
      if (subtipo?.id != null && String(subtipo.id).trim() !== '') {
        const sid = Number(String(subtipo.id).trim());
        if (Number.isFinite(sid)) {
          payload.idSubtipoNovedad = sid;
        }
      }

      const noRegs = this.obtenerNoRegistrosIntegrantesParaValidacionActiva();
      if (noRegs.length > 0) {
        payload.noRegistrosIntegrantes = noRegs;
      }

      const paresDoc =
        this.obtenerParesDocumentosIntegrantesParaValidacionActiva();
      if (paresDoc.length > 0) {
        payload.paresDocumentosIntegrantes = paresDoc;
      }

      const res = await firstValueFrom(
        this.validacionSolicitudActivaService.validar(payload),
      );

      if (res.conflicto) {
        this.isProcessingSolicitudActiva = true;
        const nro =
          res.numeroSolicitudTraslado != null
            ? String(res.numeroSolicitudTraslado)
            : '';
        this.showSolicitudActivaModal(nro || '—', res.mensaje ?? undefined);
        return true;
      }

      return false;
    } catch (error) {
      console.warn(
        'validacion-solicitud-activa no disponible o error; se usa listado legado de solicitudes',
        error,
      );
      return this.verificarSolicitudesActivasListadoLegacy(
        tipoNovedad,
        numeroContrato,
      );
    }
  }

  /**
   * No. Registro Afilmed de integrantes elegidos en paso 1 (si el padre los envía en `integrantesSeleccionados` / storage).
   */
  private obtenerNoRegistrosIntegrantesParaValidacionActiva(): string[] {
    const seleccionados = this.obtenerIntegrantesSeleccionados();
    const ids = seleccionados
      .map((i) => {
        const x = i as any;
        return String(
          x.noRegistroAfilmed ?? x.noRegistro ?? x.NoRegistro ?? i.id ?? '',
        ).trim();
      })
      .filter((s) => s.length > 0);
    return [...new Set(ids)];
  }

  /**
   * Cruce por documento (`modo-cruce-integrantes=DOCUMENTO` en servidor).
   */
  private obtenerParesDocumentosIntegrantesParaValidacionActiva(): {
    tipoDocumento: string;
    numeroDocumento: string;
  }[] {
    const seleccionados = this.obtenerIntegrantesSeleccionados();
    const out: { tipoDocumento: string; numeroDocumento: string }[] = [];
    for (const i of seleccionados) {
      const raw = String((i as any)?.identificacion ?? '').trim();
      if (!raw) {
        continue;
      }
      const p = this.parseIdentificacionTipoNumero(raw);
      const tipo = (
        p.tipoCodigo ||
        this.normalizarCodigoTipoDocumento((i as any)?.tipoIdentificacion)
      ).trim();
      const num = (p.numero || this.soloDigitosIdentificacion(raw)).trim();
      if (tipo && num) {
        out.push({ tipoDocumento: tipo.toUpperCase(), numeroDocumento: num });
      }
    }
    return out;
  }

  /** Antes: GET solicitudes-radicadas + filtro en cliente. Respaldo si falla el POST del microservicio. */
  private async verificarSolicitudesActivasListadoLegacy(
    tipoNovedad: TipoNovedad,
    numeroContrato: string,
  ): Promise<boolean> {
    try {
      const solicitudes: SolicitudRadicadaDTO[] = await firstValueFrom(
        this.solicitudesRadicadasService.getSolicitudesRadicadas(
          numeroContrato,
        ),
      );

      const ESTADOS_NO_FINALIZADOS = [
        'ACTIVA',
        'PENDIENTE',
        'EN_PROCESO',
        'EN PROCESO',
        'CREADA',
      ];

      const solicitudEncontrada = solicitudes.find(
        (s) =>
          s.numeroContrato === numeroContrato &&
          (s.tipoNovedad === tipoNovedad.codigo ||
            s.tipoNovedad === tipoNovedad.nombre) &&
          ESTADOS_NO_FINALIZADOS.some((e) => s.estado?.toUpperCase() === e),
      );

      if (solicitudEncontrada) {
        this.isProcessingSolicitudActiva = true;
        this.showSolicitudActivaModal(
          String(solicitudEncontrada.nroSolicitudTraslado),
        );
        return true;
      }

      return false;
    } catch {
      return false;
    }
  }

  private showSolicitudActivaModal(
    numeroSolicitud: string,
    mensaje?: string | null,
  ): void {
    const dialogData: SolicitudActivaModalData = {
      numeroSolicitud,
      mensaje: mensaje ?? undefined,
    };

    const dialogRef = this.dialog.open(SolicitudActivaModalComponent, {
      width: '500px',
      disableClose: true,
      data: dialogData,
      panelClass: 'solicitud-activa-modal',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.disableSubtipoSelector();

      this.isProcessingSolicitudActiva = false;
      this.validacionCompletada.emit(false);
    });
  }

  private showDebitoAutomaticoWarningModal(): void {
    this.dialog.open(DebitoAutomaticoWarningModalComponent, {
      width: '980px',
      maxWidth: '95vw',
      disableClose: true,
      panelClass: 'debito-automatico-warning-modal',
    });
  }

  private async validarPerfilamiento(
    tipoNovedad: TipoNovedad,
  ): Promise<boolean> {
    const idTipo = Number(String(tipoNovedad.codigo ?? '').trim());

    if (!Number.isFinite(idTipo)) {
      return true;
    }

    const nro = this.obtenerNumeroContratoSeleccionado();
    if (!nro) {
      const modalRef = this.modalService.open(ModalBasicComponent, {
        centered: true,
        windowClass: 'custom-modal-radius',
      });
      modalRef.componentInstance.title = 'Información';
      modalRef.componentInstance.content =
        'No hay número de contrato para validar el perfilamiento.';
      modalRef.componentInstance.buttons = [
        { text: 'Cerrar', color: 'btn-primary', action: 'close', value: true },
      ];
      return false;
    }

    const integrantesPayload =
      await this.construirIntegrantesPerfilamientoRequest(nro);
    if (integrantesPayload.length === 0) {
      const modalRef = this.modalService.open(ModalBasicComponent, {
        centered: true,
        windowClass: 'custom-modal-radius',
      });
      modalRef.componentInstance.title = 'Información';
      modalRef.componentInstance.content =
        'Debe seleccionar al menos un integrante del contrato en el paso 1 para validar el perfilamiento.';
      modalRef.componentInstance.buttons = [
        { text: 'Cerrar', color: 'btn-primary', action: 'close', value: true },
      ];
      this.tipoNovedadControl.setValue(null, { emitEvent: false });
      this.validacionCompletada.emit(false);
      return false;
    }

    const resValidarContrato = await firstValueFrom(
      this.validacionContratoService.validarContrato(nro),
    );

    const req: PerfilamientoValidarRequest = {
      idTipoNovedad: idTipo,
      numeroContrato: nro,
      moraContrato: resValidarContrato[0]?.moraContrato,
      estadoContrato: this.obtenerEstadoContratoParaPerfilamiento(),
      acuerdoPagoVigente: resValidarContrato[0]?.acuerdoPago,
      integrantes: integrantesPayload,
      ...this.obtenerCamposAdicionalesPerfilamientoOpcionales(),
    };

    try {
      const res = await firstValueFrom(
        this.perfilamientoValidarService.validar(req),
      );

      if (res.procesoBloqueado) {
        if (this.perfilamientoBloqueoMostrado) {
          return false;
        }
        this.perfilamientoBloqueoMostrado = true;

        const esBloqueoPorContrato = (res.resultadosPorIntegrante ?? []).some(
          (r) => r.bloqueaProceso,
        );

        let contenido =
          res.mensajeBloqueo ||
          'Los integrantes seleccionados no cumplen con el perfilamiento, por lo tanto, no es posible radicar una solicitud de traslado.';

        if (!esBloqueoPorContrato) {
          const detalles = Array.from(
            new Set(
              (res.resultadosPorIntegrante ?? [])
                .filter((r) => r.mensajeAlerta)
                .map((r) => r.mensajeAlerta),
            ),
          );
          if (detalles.length > 0) {
            contenido = `${contenido}\n\n${detalles.join('\n\n')}`;
          }
        }

        const modalRef = this.modalService.open(ModalBasicComponent, {
          centered: true,
          windowClass: 'custom-modal-radius',
        });
        modalRef.componentInstance.title = 'Información';
        modalRef.componentInstance.content = contenido;
        modalRef.componentInstance.buttons = [
          {
            text: 'Cerrar',
            color: 'btn-primary',
            action: 'close',
            value: true,
          },
        ];
        this.resetearFormularioTrasBloqueoPerfilamiento();
        return false;
      }

      const mensajesAMostrar = Array.from(
        new Set(
          (res.resultadosPorIntegrante ?? [])
            .filter(
              (r) =>
                (r.tieneAdvertencia || r.bloqueaUsuario) && r.mensajeAlerta,
            )
            .map((r) => r.mensajeAlerta),
        ),
      );

      if (mensajesAMostrar.length > 0) {
        const modalRef = this.modalService.open(ModalBasicComponent, {
          centered: true,
          windowClass: 'custom-modal-radius',
        });
        modalRef.componentInstance.title = 'Información';
        modalRef.componentInstance.content = mensajesAMostrar.join('\n\n');
        modalRef.componentInstance.buttons = [
          {
            text: 'Cerrar',
            color: 'btn-primary',
            action: 'close',
            value: true,
          },
        ];
      }
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  private resetearFormularioTrasBloqueoPerfilamiento(): void {
    this.selectedTipoNovedad = null;
    this.selectedSubtipoNovedad = null;
    this.tipoNovedadBusqueda$.next('');
    this.subtipoNovedadBusqueda$.next('');
    this.tipoNovedadControl.setValue(null, { emitEvent: false });
    this.subtipoNovedadControl.setValue(null, { emitEvent: false });
    this.tipoNovedadControl.markAsPristine();
    this.tipoNovedadControl.markAsUntouched();
    this.tipoNovedadControl.setErrors(null);
    this.subtipoNovedadControl.markAsPristine();
    this.subtipoNovedadControl.markAsUntouched();
    this.subtipoNovedadControl.setErrors(null);
    this.subtiposNovedadSubject.next([]);

    this.ocultarCamposCambioCobertura();
    this.ocultarTodasLasTablas();
    this.mostrarCambioTitular = false;
    this.mostrarCambioResponsablePagador = false;
    this.limpiarEstadoUiCambioTitularResponsable();
    this.clearAllContratoNuevoFields();
    this.clearAllContratoExistenteFields();
    this.clearAllCambioTarifaFields();
    this.clearAllAdicionaAnexoFields();
    this.disableSubtipoSelector();
    this.validacionCompletada.emit(false);
  }

  private async construirIntegrantesPerfilamientoRequest(
    nroContrato: string,
  ): Promise<IntegrantePerfilamientoRequest[]> {
    const sub = this.selectedSubtipoNovedad ?? this.subtipoNovedadControl.value;

    const tipo = this.selectedTipoNovedad;

    const forzarTodos =
      (tipo != null && TIPOS_TODOS_INTEGRANTES.has(tipo.codigoTipoNovedad)) ||
      (sub != null && this.subtipoRequiereTodosLosIntegrantes(sub));

    const totales = this.integrantesTotalesContratoActual || [];

    if (forzarTodos && Array.isArray(totales) && totales.length > 0) {
      return Promise.all(
        totales.map((row) =>
          this.mapFilaAIntegrantePerfilamiento(nroContrato, row),
        ),
      );
    }

    const seleccionados = this.obtenerIntegrantesSeleccionados().filter(
      (x: any) => x && x.seleccionado !== false,
    );

    const out: IntegrantePerfilamientoRequest[] = [];

    for (const sel of seleccionados) {
      const key = String((sel as any).identificacion ?? '').trim();

      const row =
        totales.find(
          (t: any) => String(t.identificacion ?? '').trim() === key,
        ) || {};

      const merged = { ...row, ...sel };

      out.push(await this.mapFilaAIntegrantePerfilamiento(nroContrato, merged));
    }

    return out;
  }

  private async mapFilaAIntegrantePerfilamiento(
    nroContrato: string,
    row: any,
  ): Promise<IntegrantePerfilamientoRequest> {
    const rawId = String(row.identificacion ?? '').trim();

    const parsed = this.parseIdentificacionTipoNumero(rawId);

    const noReg = String(
      row.no ?? row.NoRegistro ?? row.noRegistro ?? row.id ?? '',
    ).trim();

    const validacion = await firstValueFrom(
      this.validacionContratoService.validarContratoUser(
        parsed.tipoCodigo || '',
        parsed.numero || '',
        nroContrato,
      ),
    );

    const datosValidacion = validacion[0];

    return {
      noRegistro: noReg || '0',
      identificacion: rawId,
      tipoIdentificacion: parsed.tipoCodigo || '',
      nombreUsuario: String(row.nombreUsuario ?? row.nombre ?? ''),
      parentesco: String(row.parentesco ?? ''),

      campaniaVigente: row.campaniaVigente === '' ? 'NO' : 'SI',

      congelamiento: row.congelamiento,

      licenciaViajeExterior: datosValidacion?.licenciaViajeExterior,

      idIntegrantesSolicitudRadicacion: null,
    };
  }

  private obtenerEstadoContratoParaPerfilamiento(): string {
    const fila = this.obtenerFilaContratoOrigenParaTarifas();
    return String(
      (fila as any)?.EstadoContrato ?? this.contratoSeleccionado?.estado ?? '',
    ).trim();
  }

  private obtenerCamposAdicionalesPerfilamientoOpcionales(): Partial<PerfilamientoValidarRequest> {
    const fila = this.filaContratoAfilmedPaso1 as any;
    if (!fila || typeof fila !== 'object') {
      return {};
    }
    return {
      lineaNegocioId:
        fila.LineaNegocio != null && String(fila.LineaNegocio).trim() !== ''
          ? String(fila.LineaNegocio)
          : null,
      grupoProgramaId:
        fila.GrupoPrograma != null && String(fila.GrupoPrograma).trim() !== ''
          ? String(fila.GrupoPrograma)
          : null,
      programaId:
        fila.ProgramaCodigo != null && String(fila.ProgramaCodigo).trim() !== ''
          ? String(fila.ProgramaCodigo)
          : null,
      tipoPlanOrigenId:
        fila.TipoPlan != null && String(fila.TipoPlan).trim() !== ''
          ? String(fila.TipoPlan)
          : null,
    };
  }

  /** Afilmed / ova-back pueden enviar estado en varios formatos; por defecto se considera activo si viene nombre. */
  private esSubtipoEstadoActivo(
    estadoRaw: unknown,
    tieneNombre: boolean,
  ): boolean {
    if (estadoRaw === 1 || estadoRaw === '1' || estadoRaw === true) {
      return true;
    }
    if (estadoRaw === 0 || estadoRaw === '0' || estadoRaw === false) {
      return false;
    }
    const t = String(estadoRaw ?? '')
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    if (!t) {
      return tieneNombre;
    }
    if (
      t === 'ACTIVO' ||
      t === 'A' ||
      t === 'ACTIVE' ||
      t === 'SI' ||
      t === 'S'
    ) {
      return true;
    }
    if (
      t === 'INACTIVO' ||
      t === 'I' ||
      t === 'NO' ||
      t === 'N' ||
      t === 'INACTIVE'
    ) {
      return false;
    }
    return tieneNombre;
  }

  private mapSubtipoDtoToSubtipoNovedad(
    s: any,
    codigoTipoNovedad: string,
  ): SubtipoNovedad {
    const nombre = String(s.subtipoNovedad ?? s.nombre ?? '').trim();
    const activo = this.esSubtipoEstadoActivo(s.estado, nombre.length > 0);
    return {
      id: String(s.idSubtipoNovedad ?? s.id ?? s.codigo ?? ''),
      nombre,
      tipoNovedadCodigo: String(
        s.tipoNovedadCodigo ?? s.tipoNovedadId ?? codigoTipoNovedad,
      ),
      codigoSubtipo: s.codigoSubtipo,
      estado: activo ? 'ACTIVO' : 'INACTIVO',
      aplicaNovedadIntegrantes:
        s.aplicaNovedadIntegrantes != null
          ? String(s.aplicaNovedadIntegrantes)
          : undefined,
    };
  }

  private normalizarNombreCatalogo(val: string | undefined | null): string {
    return String(val ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private async loadSubtiposNovedad(codigoTipoNovedad: string): Promise<void> {
    this.isLoadingSubtipos = true;
    this.hasErrorSubtipos = false;
    this.updateSubtipoControlState();

    try {
      const idTipoSolicitud = await firstValueFrom(
        this.tipoSolicitudNovedadTrasladoIdService.getIdTipoSolicitudNovedadTraslado(),
      );
      const qCat = this.buildQueryCatalogoTiposNovedad(idTipoSolicitud);
      let subtipos: SubtipoNovedad[] = [];

      try {
        const porTipo = await firstValueFrom(
          this.subtiposNovedadService.getSubtiposPorTipoNovedad(
            codigoTipoNovedad,
            qCat,
          ),
        );
        if (Array.isArray(porTipo) && porTipo.length > 0) {
          subtipos = porTipo.map((s) =>
            this.mapSubtipoDtoToSubtipoNovedad(s, codigoTipoNovedad),
          );
        }
      } catch {
        // Fallback: catálogo anidado GET /subtipos-novedad
      }

      if (subtipos.length === 0) {
        const dtos: SubtiposNovedadDTO[] = await firstValueFrom(
          this.subtiposNovedadService.getSubtiposNovedad(qCat),
        );
        const codNorm = String(codigoTipoNovedad).trim();
        let grupo = dtos.find((d) => String(d.idTipoNovedad) === codNorm);
        if (!grupo && this.selectedTipoNovedad?.nombre) {
          const want = this.normalizarNombreCatalogo(
            this.selectedTipoNovedad.nombre,
          );
          grupo = dtos.find(
            (d) => this.normalizarNombreCatalogo(d.tipoNovedad) === want,
          );
        }
        if (!grupo && this.selectedTipoNovedad?.nombre) {
          const want = this.normalizarNombreCatalogo(
            this.selectedTipoNovedad.nombre,
          );
          grupo = dtos.find((d) =>
            this.normalizarNombreCatalogo(d.tipoNovedad).includes(want),
          );
        }
        if (grupo?.subtipos?.length) {
          subtipos = grupo.subtipos.map((s) =>
            this.mapSubtipoDtoToSubtipoNovedad(s, codigoTipoNovedad),
          );
        }
      }

      const activos = subtipos.filter((s) => s.estado === 'ACTIVO');
      const lista = activos.length > 0 ? activos : subtipos;
      this.subtiposNovedadSubject.next(lista);
      this.aplicarEstadoSubtipoTrasCarga(this.selectedTipoNovedad);
      this.updateSubtipoControlState();
    } catch (error) {
      this.hasErrorSubtipos = true;
      this.disableSubtipoSelector();
    } finally {
      this.isLoadingSubtipos = false;
      this.updateSubtipoControlState();
    }
  }

  /**
   * Tras cargar subtipos: mantiene coherente `subtipoHabilitado` con el tipo (p. ej. traslado existente sin subtipo).
   * Evita condiciones de carrera entre `onTipoSelected` y `onTipoNovedadChanged`.
   */
  private aplicarEstadoSubtipoTrasCarga(tipo: TipoNovedad | null): void {
    if (!tipo) {
      return;
    }
    const cod = tipo.codigoTipoNovedad;
    const esNuevo = cod === 'TRASLADO_CONTRATO_NUEVO';
    const esExistente = cod === 'TRASLADO_CONTRATO_EXISTENTE';
    if (esNuevo) {
      this.disableSubtipoSelector();
      return;
    }
    if (esExistente) {
      this.disableSubtipoSelector();
      return;
    }
    if (this.esCambioTarifaNovedadTipo(tipo)) {
      this.disableSubtipoSelector();
      return;
    }
    if (this.esAdicionaAnexoNovedadTipo(tipo)) {
      this.disableSubtipoSelector();
      return;
    }
    this.enableSubtipoSelector(true);
  }

  public loadTiposNovedad(): void {
    this.isLoadingTipos = true;
    this.hasErrorTipos = false;
    this.updateTipoControlState();

    const listarSinFiltroTipoSolicitud =
      environment.TIPOS_NOVEDAD_LISTAR_SIN_FILTRO_TIPO_SOLICITUD === true;

    const catalogo$ = listarSinFiltroTipoSolicitud
      ? this.tiposNovedadService
          .getTiposNovedad(this.buildQueryCatalogoTiposNovedad())
          .pipe(
            map((dtos) => ({
              dtos,
              qCat: this.buildQueryCatalogoTiposNovedad(),
            })),
          )
      : this.tipoSolicitudNovedadTrasladoIdService
          .getIdTipoSolicitudNovedadTraslado()
          .pipe(
            switchMap((idTipoSolicitud) => {
              const qCat = this.buildQueryCatalogoTiposNovedad(idTipoSolicitud);
              return this.tiposNovedadService
                .getTiposNovedad(qCat)
                .pipe(map((dtos) => ({ dtos, qCat })));
            }),
          );

    catalogo$.pipe(takeUntil(this.destroy$)).subscribe({
      next: ({ dtos, qCat }) => {
        try {
          let tipos: TipoNovedad[] = dtos.map((dto) => {
            const codigoTipoNovedad = String(
              dto.codigoTipoNovedad ??
                (dto as { CodigoTipoNovedad?: string }).CodigoTipoNovedad ??
                '',
            ).trim();
            return {
              codigo: String(dto.idTipoNovedad),
              nombre: dto.tipoNovedad,
              codigoTipoNovedad,
              estado:
                dto.estado === 1 || dto.estado === '1'
                  ? CONSTANTS.ESTADO_ACTIVO
                  : CONSTANTS.ESTADO_INACTIVO,
              tipoSolicitud: CONSTANTS.TIPO_SOLICITUD,
              idTipoSolicitud: this.idTipoSolicitudDesdeDtoTipoNovedad(dto),
              aplicaContratoTransitorio:
                dto.aplicaContratoTransitorio === 1 ||
                dto.aplicaContratoTransitorio === true,
            } as TipoNovedad;
          });

          tipos = tipos.filter((t) => t.estado === CONSTANTS.ESTADO_ACTIVO);

          tipos.sort((a, b) => Number(a.codigo) - Number(b.codigo));

          this.tiposNovedadSubject.next(tipos);
          this.sincronizarIdTipoSolicitudTipoNovedadSeleccionado(tipos);
          this.isLoadingTipos = false;
          this.updateTipoControlState();
        } catch (error) {
          console.error('❌ Error procesando tipos de novedad:', error);
          this.hasErrorTipos = true;
          this.isLoadingTipos = false;
          this.updateTipoControlState();
        }
      },
      error: (error) => {
        console.error(
          '❌ Error cargando tipos de novedad desde el servicio:',
          error,
        );
        this.hasErrorTipos = true;
        this.isLoadingTipos = false;
        this.updateTipoControlState();
      },
    });
  }

  private sincronizarIdTipoSolicitudTipoNovedadSeleccionado(
    tipos: TipoNovedad[],
  ): void {
    const codigo = String(
      this.selectedTipoNovedad?.codigo ??
        this.tipoNovedadControl.value?.codigo ??
        '',
    ).trim();
    if (!codigo) {
      return;
    }
    const refreshed = tipos.find((t) => String(t.codigo).trim() === codigo);
    if (!refreshed) {
      return;
    }
    const id = this.idTipoSolicitudDesdeTipoNovedad(refreshed);
    const merged: TipoNovedad = {
      ...(this.selectedTipoNovedad ??
        (this.tipoNovedadControl.value as TipoNovedad)),
      ...refreshed,
      idTipoSolicitud: id,
    };
    this.selectedTipoNovedad = merged;
    this.tipoNovedadControl.setValue(merged, { emitEvent: false });
    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  private enableSubtipoSelector(required: boolean): void {
    this.subtipoHabilitado = true;
    this.isSubtipoRequired = required;
    this.updateSubtipoValidators();
    this.updateSubtipoControlState();
  }

  private disableSubtipoSelector(): void {
    this.subtipoHabilitado = false;
    this.isSubtipoRequired = false;
    // Si el autocomplete quedó abierto, ciérralo para el usuario.
    this.subtipoAutocompleteTrigger?.closePanel();
    this.updateSubtipoValidators();
    this.clearSubtipoSelection();
    this.updateSubtipoControlState();
  }

  private clearSubtipoSelection(): void {
    this.selectedSubtipoNovedad = null;
    this.subtipoNovedadBusqueda$.next('');
    // Evitar disparar listeners (onSubtipoNovedadChanged) cuando el subtipo no aplica.
    this.subtipoNovedadControl.setValue(null, { emitEvent: false });
    this.subtiposNovedadSubject.next([]);
  }

  private checkValidacionCompletada(): void {
    const tipoSeleccionado = this.tipoNovedadControl.value;
    const tipoValido =
      this.tipoNovedadControl.valid &&
      typeof tipoSeleccionado === 'object' &&
      tipoSeleccionado !== null;
    const subtipoValido =
      !this.isSubtipoRequired || this.subtipoNovedadControl.valid;
    const fechaAplicacionValida = this.fechaAplicacionNovedadControl.valid;

    let cambioTitularValido = true;
    if (this.mostrarCambioTitular) {
      const titularSeleccionado = this.nuevoTitularSeleccionadoControl.valid;
      cambioTitularValido =
        this.cambioTitularRequisitosPreviosOk && titularSeleccionado;
    }

    let cambioPlanValido = true;
    const esCambioPlan = this.esCambioPlanTipoSeleccionado();

    if (esCambioPlan) {
      const filas = this.beneficiariosTarifa ?? [];
      if (filas.length === 0) {
        cambioPlanValido = false;
      } else {
        const todosBeneficiariosConParentesco = filas.every((b) => {
          if (!b.parentescoDestino) {
            return false;
          }
          if (typeof b.parentescoDestino === 'string') {
            return b.parentescoDestino.trim() !== '';
          }
          return !!b.parentescoDestino?.nombre;
        });

        const incluirAnexo = this.getIncluirAnexoContratoValue();
        const todosBeneficiariosConAnexoValido = filas.every((b) => {
          if (!incluirAnexo) return true;

          const codigos = this.normalizarAnexosSeleccionadosCambioPlan(
            b.anexoDestino,
          );
          if (!codigos.length) return false;

          const codigosNorm = codigos.map((c) => c.toUpperCase());
          const tieneNoAplica = codigosNorm.includes('NO_APLICA');

          if (tieneNoAplica) {
            // "No aplica" no puede estar en combinación con otros anexos.
            return codigosNorm.every((c) => c === 'NO_APLICA');
          }

          // Debe haber al menos un anexo distinto de "No aplica".
          return codigosNorm.every(
            (c) => c !== '' && c !== 'NO_APLICA' && c != null,
          );
        });

        cambioPlanValido =
          todosBeneficiariosConParentesco && todosBeneficiariosConAnexoValido;
      }
    }

    let cambioTarifaValido = true;
    if (this.esCambioTarifaNovedadTipo(this.selectedTipoNovedad)) {
      const valorIva = this.valorTotalCuotaIvaControl.value;
      cambioTarifaValido =
        !this.hasErrorTarifasCambio &&
        !this.isLoadingTarifasCambio &&
        this.tarifaCambioControl.valid &&
        this.tarifaCambioControl.value != null &&
        valorIva != null &&
        Number.isFinite(Number(valorIva));
    }

    // Validación para "Traslado a colectivo"
    let trasladoColectivoValido = true;
    if (this.mostrarCampoColectivo) {
      trasladoColectivoValido =
        this.esColectivoValido() &&
        this.colectivoControl.valid &&
        this.subcuentaDestinoControl.valid &&
        this.subcuentaDestinoControl.value != null &&
        this.sucursalDestinoControl.valid &&
        this.sucursalDestinoControl.value != null &&
        this.programaDestinoColectivoControl.valid &&
        this.programaDestinoColectivoControl.value != null &&
        this.corteSubcuentaControl.valid &&
        this.corteSubcuentaControl.value != null &&
        this.tarifaDestinoColectivoControl.valid &&
        this.tarifaDestinoColectivoControl.value != null &&
        this.proporcionalidadColectivoControl.valid;
    }

    // Validación para "Traslado a contrato nuevo"
    let trasladoContratoNuevoValido = true;
    if (this.mostrarCamposTrasladoContratoNuevo) {
      const tipoPlanValido =
        this.tipoPlanDestinoContratoControl.valid &&
        this.tipoPlanDestinoContratoControl.value !== null;
      const programaValido =
        this.programaDestinoContratoControl.valid &&
        this.programaDestinoContratoControl.value !== null;
      const subcuentaValida =
        this.subcuentaDestinoContratoControl.valid &&
        this.subcuentaDestinoContratoControl.value !== null;
      const corteValido =
        this.corteDestinoContratoControl.valid &&
        this.corteDestinoContratoControl.value !== null;
      const tarifaValida =
        this.tarifaDestinoContratoControl.valid &&
        this.tarifaDestinoContratoControl.value !== null;
      const sucursalValida =
        this.sucursalComercializableContratoControl.valid &&
        this.sucursalComercializableContratoControl.value !== null;
      const proporcionalidadValida = this.proporcionalidadContratoControl.valid;

      trasladoContratoNuevoValido =
        tipoPlanValido &&
        programaValido &&
        subcuentaValida &&
        corteValido &&
        tarifaValida &&
        sucursalValida &&
        proporcionalidadValida;
    }

    // Validación para "Traslado a contrato existente"
    let trasladoContratoExistenteValido = true;
    if (this.mostrarCamposTrasladoContratoExistente) {
      const tipoIdValido =
        this.tipoIdentificacionContratanteDestinoControl.value !== null;
      const numeroId = String(
        this.numeroIdentificacionContratanteDestinoControl.value ?? '',
      ).trim();
      const numeroIdValido =
        numeroId !== '' &&
        this.numeroIdentificacionContratanteDestinoControl.valid;
      const contratoValido = this.contratoDestinoControl.value !== null;
      const proporcionalidadValida =
        this.proporcionalidadExistenteControl.value !== null &&
        this.proporcionalidadExistenteControl.value !== '';

      trasladoContratoExistenteValido =
        tipoIdValido &&
        numeroIdValido &&
        contratoValido &&
        proporcionalidadValida &&
        !this.contratoDestinoTransitorioBloqueado;
    }

    const trasladoNuevoSeleccionIntegrantesValida =
      !this.esTipoTrasladoContratoNuevoActivo() ||
      !this.hayTodosLosIntegrantesSeleccionadosParaTrasladoNuevo();

    if (
      this.esTipoTrasladoContratoNuevoActivo() &&
      this.hayTodosLosIntegrantesSeleccionadosParaTrasladoNuevo()
    ) {
      this.mensajeErrorTodosIntegrantesTrasladoNuevo =
        MSG_NO_TRASLADO_TODOS_INTEGRANTES;
    } else {
      this.mensajeErrorTodosIntegrantesTrasladoNuevo = '';
    }

    let adicionaAnexoValido = true;
    if (this.esAdicionaAnexoSeleccionado()) {
      adicionaAnexoValido =
        !this.cargandoIntegrantesAdicionaAnexo &&
        this.mostrarTablaAdicionaAnexo &&
        !this.errorAdicionaAnexo &&
        this.validarAnexosRequeridos();
    }

    let cambioCoberturaTipoPrimaParamOk = true;
    let cambioCoberturaValido = true;
    if (this.mostrarCamposCambioCobertura) {
      const sub = this.subtipoNovedadControl.value;
      if (
        SUBTIPOS_TRASLADO_TIPO_PRIMA_DESDE_PARAMETRIZACION.has(
          String(sub?.nombre ?? '').trim(),
        )
      ) {
        cambioCoberturaTipoPrimaParamOk =
          this.tipoPrimaObtenido &&
          !this.errorTipoPrima &&
          !this.isLoadingTipoPrima;
      }

      if (!this.mostrarCampoColectivo) {
        cambioCoberturaValido =
          this.tipoPlanDestinoControl.valid &&
          this.tipoPlanDestinoControl.value != null &&
          this.programaDestinoControl.valid &&
          this.programaDestinoControl.value != null &&
          this.tarifaDestinoControl.valid &&
          this.tarifaDestinoControl.value != null &&
          this.corteDestinoControl.valid &&
          this.corteDestinoControl.value != null &&
          this.proporcionalidadControl.valid;
      }
    }

    let cambioResponsableValido = true;
    if (this.mostrarCambioResponsablePagador) {
      const motivoOk = !!this.motivoRetiroResponsableControl.value;
      const parentescosOk =
        (this.integrantesSinTitular?.length ?? 0) > 0 &&
        this.integrantesSinTitular.every((i: any) => !!i?.parentescoDestino);
      let debitoOk = true;
      const activarDebito =
        this.activarDebitoAutomaticoNuevoResponsableControl.value === true;
      if (activarDebito) {
        const metodo = this.metodoDebitoAutomaticoControl.value;
        if (!metodo) {
          debitoOk = false;
        } else if (metodo === 'tarjeta') {
          debitoOk = this.confirmacionGestionTarjetaControl.value === true;
        } else if (metodo === 'cuenta') {
          debitoOk =
            !!this.tipoCuentaDebitoControl.value &&
            !!this.bancoDebitoControl.value &&
            /^\d{12}$/.test(
              String(this.numeroCuentaDebitoControl.value ?? '').trim(),
            );
        }
      }
      cambioResponsableValido =
        this.cambioTitularRequisitosPreviosOk &&
        motivoOk &&
        parentescosOk &&
        debitoOk;
    }

    const todasValidaciones =
      tipoValido &&
      subtipoValido &&
      fechaAplicacionValida &&
      cambioTitularValido &&
      cambioResponsableValido &&
      cambioPlanValido &&
      cambioTarifaValido &&
      trasladoColectivoValido &&
      trasladoContratoNuevoValido &&
      trasladoContratoExistenteValido &&
      trasladoNuevoSeleccionIntegrantesValida &&
      adicionaAnexoValido &&
      cambioCoberturaTipoPrimaParamOk &&
      cambioCoberturaValido;

    this.validacionCompletada.emit(todasValidaciones);
    if (todasValidaciones) {
      this.persistState();
    }
  }

  public async onTipoSelected(tipo: TipoNovedad): Promise<void> {
    // Una nueva selección invalida temporalmente la validación anterior mientras
    // se cargan subtipos y campos dependientes.
    this.perfilamientoBloqueoMostrado = false;
    this.validacionCompletada.emit(false);
    this.tipoNovedadControl.setValue(tipo);
    this.selectedTipoNovedad = tipo;

    const codigoTipo = tipo.codigoTipoNovedad;

    const esCambioPlan = this.esCambioPlanNovedadTipo(tipo);
    if (esCambioPlan) {
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoExistente = false;
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.mostrarTablaIntegrantesTrasladoExistente = false;
      this.integrantesTrasladoExistente = [];
      this.integrantesContratoDestino = [];
      this.disableSubtipoSelector();
      this.checkValidacionCompletada();
      return;
    }

    const esTrasladoContratoExistente =
      codigoTipo === 'TRASLADO_CONTRATO_EXISTENTE';

    const esTrasladoContratoNuevo = codigoTipo === 'TRASLADO_CONTRATO_NUEVO';

    if (esTrasladoContratoExistente) {
      this.configurarModoSoloPagadorDireccion(false);
      this.mostrarCamposTrasladoContratoExistente = true;
      this.mostrarTablaBeneficiarios = false;
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoNuevo = false;
      // Evitar que quede visible la tabla de «Traslado a contrato nuevo» (otro flujo o estado persistido).
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.integrantesContratoNuevo = [];
      this.totalCuotaIvaContratoNuevo = 0;
      // En este tipo no se requiere subtipo; deshabilitar selector
      this.disableSubtipoSelector();
      this.cargarTiposIdentificacionContratante();
      await this.procesarTrasladoContratoExistente();
    } else if (esTrasladoContratoNuevo) {
      this.configurarModoSoloPagadorDireccion(true);
      this.mostrarCamposTrasladoContratoNuevo = true;
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoExistente = false;
      this.mostrarTablaIntegrantesTrasladoExistente = false;
      this.integrantesTrasladoExistente = [];
      this.integrantesContratoDestino = [];
      // MP-FT-1358 / UX: en "traslado a contrato nuevo" el subtipo no aplica.
      // Se mantiene visible, pero bloqueado/deshabilitado.
      this.disableSubtipoSelector();
      this.cargarTiposPlanesContratoNuevo();
      // Reforzar precarga del bloque "INFORMACIÓN DEL CONTRATANTE DESTINO" al entrar al flujo.
      // (evita quedar con placeholders cuando la carga inicial ocurrió antes de seleccionar este tipo).
      this.precargarDatosContratanteActual();
      // En traslado a contrato nuevo la tabla se debe renderizar desde el ingreso al flujo.
      // La carga de tarifas/subcuentas solo recalcula valores, pero no debe ocultar esta tabla.
      void this.cargarIntegrantesContratoNuevo();
      /**
       * Cambio de tarifa (1.1.3.6): reconocer por id catálogo (p. ej. 18) o por nombre.
       * No usar solo `codigo === '6'`: en varios catálogos el 6 es otro tipo (p. ej. «Novedad de Traslado»).
       */
    } else if (this.esCambioTarifaNovedadTipo(tipo)) {
      this.configurarModoSoloPagadorDireccion(false);
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoNuevo = false;
      this.mostrarCamposTrasladoContratoExistente = false;
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.mostrarTablaIntegrantesTrasladoExistente = false;
      this.integrantesContratoNuevo = [];
      this.integrantesTrasladoExistente = [];
      this.disableSubtipoSelector();
    } else if (this.esAdicionaAnexoNovedadTipo(tipo)) {
      this.configurarModoSoloPagadorDireccion(false);
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoNuevo = false;
      this.mostrarCamposTrasladoContratoExistente = false;
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.mostrarTablaIntegrantesTrasladoExistente = false;
      this.integrantesContratoNuevo = [];
      this.integrantesTrasladoExistente = [];
      this.disableSubtipoSelector();
      this.procesarAdicionaAnexo();
    } else {
      this.configurarModoSoloPagadorDireccion(false);
      this.mostrarCamposTrasladoContratoNuevo = false;
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.mostrarCamposTrasladoContratoExistente = false;
      this.mostrarTablaIntegrantesTrasladoExistente = false;
      this.enableSubtipoSelector(true);
      this.clearAllCambioTarifaFields();
      this.clearAllAdicionaAnexoFields();
    }
  }

  private numeroIdentificacionValidator(maxDigits: number): ValidatorFn {
    return (control: AbstractControl) => {
      const raw = control.value || '';
      const cleaned = String(raw).replace(/\D/g, '');

      if (!cleaned) {
        return null;
      }

      if (!/^\d+$/.test(cleaned)) {
        return { pattern: true };
      }

      if (cleaned.length > maxDigits) {
        return {
          maxlength: {
            requiredLength: maxDigits,
            actualLength: cleaned.length,
          },
        };
      }

      return null;
    };
  }

  public async onSubtipoSelected(subtipo: SubtipoNovedad): Promise<void> {
    this.subtipoNovedadControl.setValue(subtipo);
  }

  public clearTipoSelection(): void {
    this.selectedTipoNovedad = null;
    this.tipoNovedadBusqueda$.next('');
    this.tipoNovedadControl.setValue(null);
    this.tipoNovedadSeleccionada.emit(null);

    // Limpiar campos de Traslado a contrato nuevo
    this.mostrarCamposTrasladoContratoNuevo = false;
    this.mostrarTablaIntegrantesContratoNuevo = false;
    this.clearAllContratoNuevoFields();

    // Limpiar campos de Traslado a contrato existente
    this.mostrarCamposTrasladoContratoExistente = false;
    this.mostrarTablaIntegrantesTrasladoExistente = false;
    this.clearAllContratoExistenteFields();

    // Limpiar campos de Cambio de tarifa
    this.clearAllCambioTarifaFields();

    // Limpiar campos de Adiciona Anexo
    this.clearAllAdicionaAnexoFields();

    this.clearSubtipoSelection();

    // Limpiar el estado guardado en localStorage
    this.localStorageService.remove(this.storageKey);
  }

  public clearSubSelection(): void {
    this.marcarReconsultaTipoPrimaPendiente(
      this.selectedSubtipoNovedad ?? this.subtipoNovedadControl.value,
    );
    this.subtipoNovedadBusqueda$.next('');
    this.subtipoNovedadControl.setValue(null);
  }

  private clearAllContratoNuevoFields(): void {
    this.tipoPlanDestinoContratoControl.setValue(null, { emitEvent: false });
    this.programaDestinoContratoControl.setValue(null, { emitEvent: false });
    this.subcuentaDestinoContratoControl.setValue(null, { emitEvent: false });
    this.corteDestinoContratoControl.setValue(null, { emitEvent: false });
    this.tarifaDestinoContratoControl.setValue(null, { emitEvent: false });
    this.sucursalComercializableContratoControl.setValue(null, {
      emitEvent: false,
    });
    this.proporcionalidadContratoControl.setValue('Si', { emitEvent: false });
    this.incluirAnexoControl.setValue(false, { emitEvent: false });

    this.integrantesContratoNuevo = [];
    this.totalCuotaIvaContratoNuevo = 0;
    this.errorTrasladoContrato = '';
    this.errorValidacionIntegrantes = '';
  }

  private clearAllCambioTarifaFields(): void {
    this.tarifaCambioControl.setValue(null);
    this.valorTotalCuotaIvaControl.setValue(null);
    this.tarifasCambioDisponibles = [];
    this.tarifasCambioSubject.next([]);
    this.isLoadingTarifasCambio = false;
    this.hasErrorTarifasCambio = false;
    this.errorMessageTarifasCambio = '';
    this.syncTarifaCambioControlDisabled();
  }

  /** Evita [disabled] en plantilla junto a [formControl] (warning de Angular). */
  private syncTarifaCambioControlDisabled(): void {
    const shouldDisable =
      this.disabled ||
      this.isLoadingTarifasCambio ||
      this.hasErrorTarifasCambio;
    if (shouldDisable) {
      if (!this.tarifaCambioControl.disabled) {
        this.tarifaCambioControl.disable({ emitEvent: false });
      }
    } else if (this.tarifaCambioControl.disabled) {
      this.tarifaCambioControl.enable({ emitEvent: false });
    }
  }

  public clearTipo(): void {
    this.clearTipoSelection();
  }

  public clearSubtipo(): void {
    this.clearSubSelection();
  }

  public async onColectivoSelected(colectivo: any): Promise<void> {
    const nitNew = String(colectivo?.nit ?? '').trim();
    const colectivoCatalogo = this.colectivosSubject
      .getValue()
      .find((opcion) => String(opcion?.nit ?? '').trim() === nitNew);

    if (!nitNew || !colectivoCatalogo) {
      this.colectivoNoEncontrado = true;
      this.colectivoControl.setValue(null, { emitEvent: false });
      this.limpiarCamposDependientesColectivo();
      this.checkValidacionCompletada();
      return;
    }

    const nitPrev = String(this.colectivoControl.value?.nit ?? '').trim();
    const yaCargadoMismoColectivo =
      nitNew !== '' &&
      nitNew === nitPrev &&
      (this.subcuentasDestino?.length ?? 0) > 0;

    this.colectivoNoEncontrado = false;
    this.colectivoControl.setValue(colectivoCatalogo);

    if (yaCargadoMismoColectivo) {
      return;
    }

    await this.cargarSubcuentasDestino();
  }

  public clearColectivoSelection(): void {
    this.colectivoNoEncontrado = false;
    this.colectivoControl.setValue(null);
    this.limpiarCamposDependientesColectivo();
  }

  private limpiarCamposDependientesColectivo(): void {
    this.subcuentaDestinoControl.setValue(null);
    this.sucursalDestinoControl.setValue(null);
    this.programaDestinoColectivoControl.setValue(null);
    this.corteSubcuentaControl.setValue(null);
    this.tarifaDestinoColectivoControl.setValue(null);
    this.subcuentasDestino = [];
    this.sucursalesDestino = [];
    this.programasDestinoColectivo = [];
    this.cortesSubcuenta = [];
    this.tarifasDestinoColectivo = [];
  }

  public esColectivoValido(
    colectivo: unknown = this.colectivoControl.value,
  ): boolean {
    if (!colectivo || typeof colectivo !== 'object') return false;
    const nit = String((colectivo as any)?.nit ?? '').trim();
    return (
      nit !== '' &&
      this.colectivosSubject
        .getValue()
        .some((opcion) => String(opcion?.nit ?? '').trim() === nit)
    );
  }

  public displayColectivo(colectivo: any): string {
    if (typeof colectivo === 'string') return colectivo;
    const nit = String(colectivo?.nit ?? '').trim();
    const razonSocial = String(colectivo?.razonSocial ?? '').trim();
    return nit && razonSocial ? `${nit} - ${razonSocial}` : '';
  }

  /**
   * Oculta la lupa si ya hay colectivo elegido, o si el plan destino es COL/ACO
   * (en ese caso el tipo plan ya quedó seleccionado y solo debe verse la X al elegir NIT).
   */
  public mostrarIconoBusquedaCampoColectivo(): boolean {
    if (this.colectivoControl.value) {
      return false;
    }
    const cod = (v: unknown) =>
      String((v as { codigo?: string })?.codigo ?? '').toUpperCase();
    if (
      cod(this.tipoPlanDestinoControl.value) === 'COL' ||
      cod(this.tipoPlanDestinoControl.value) === 'ACO'
    ) {
      return false;
    }
    if (
      cod(this.tipoPlanDestinoContratoControl.value) === 'COL' ||
      cod(this.tipoPlanDestinoContratoControl.value) === 'ACO'
    ) {
      return false;
    }
    return true;
  }

  public trackByColectivoNit(index: number, item: any): any {
    return item.nit;
  }

  public retryLoadColectivos(): void {
    this.loadColectivos();
  }

  public getIncluirAnexoValue(): boolean {
    return this.incluirAnexoControl.value || false;
  }

  /** Para mostrar en mat-select el parentesco devuelto por el servicio aunque no esté en catálogo. */
  public parentescoCodigoEnCatalogo(
    codigo: string | null | undefined,
  ): boolean {
    const c = String(codigo ?? '').trim();
    if (!c) return false;
    return !!this.parentescosActivos?.some(
      (p: any) => String(p?.codigo ?? '').trim() === c,
    );
  }

  public hasFieldError(control: FormControl, errorType: string): boolean {
    return control.hasError(errorType) && (control.dirty || control.touched);
  }

  public getFieldErrorMessage(fieldName: string): string {
    const control =
      fieldName === 'tipo'
        ? this.tipoNovedadControl
        : this.subtipoNovedadControl;

    if (this.hasFieldError(control, 'required')) {
      return `${
        fieldName === 'tipo' ? 'Tipo' : 'Subtipo'
      } de novedad es obligatorio`;
    }

    return '';
  }

  public trackByTipoCodigo(index: number, item: TipoNovedad): string {
    return item.codigo;
  }

  public trackBySubtipoId(index: number, item: SubtipoNovedad): string {
    return item.id;
  }

  public trackByFilaTabla = (index: number, fila: any): string | number => {
    if (this.esAdicionaAnexoNovedadTipo(this.selectedTipoNovedad)) {
      return fila?.id ?? `${fila?.identificacion ?? 'fila'}-${index}`;
    }

    return fila?.numero ?? `${fila?.identificacion ?? 'fila'}-${index}`;
  };

  public retryLoadTipos(): void {
    this.hasErrorTipos = false;
    this.loadTiposNovedad();
  }

  public retryLoadSubtipos(): void {
    if (this.selectedTipoNovedad) {
      this.hasErrorSubtipos = false;
      this.updateSubtipoControlState();
      this.loadSubtiposNovedad(this.selectedTipoNovedad.codigo);
    }
  }

  private filterTipos(
    tipos: TipoNovedad[],
    searchValue: string,
  ): TipoNovedad[] {
    if (!searchValue) return tipos;

    const filterValue = searchValue.toLowerCase().trim();

    return tipos.filter(
      (tipo: TipoNovedad) =>
        tipo.codigo.toLowerCase().includes(filterValue) ||
        tipo.nombre.toLowerCase().includes(filterValue) ||
        (tipo.descripcion &&
          tipo.descripcion.toLowerCase().includes(filterValue)),
    );
  }

  private filterSubtipos(
    subtipos: SubtipoNovedad[],
    searchValue: string | SubtipoNovedad | null,
  ): SubtipoNovedad[] {
    const raw =
      typeof searchValue === 'string' ? searchValue : searchValue?.nombre || '';
    const filterValue = raw.trim().toLowerCase();
    if (!filterValue) {
      return subtipos;
    }

    return subtipos.filter(
      (subtipo: SubtipoNovedad) =>
        subtipo.nombre.toLowerCase().includes(filterValue) ||
        (subtipo.descripcion &&
          subtipo.descripcion.toLowerCase().includes(filterValue)),
    );
  }

  private filterColectivos(colectivos: any[], searchValue: string): any[] {
    if (!searchValue) return colectivos || [];

    const filterValue = searchValue.toLowerCase().trim();

    return (colectivos || []).filter(
      (colectivo: any) =>
        String(colectivo?.nit ?? '')
          .toLowerCase()
          .includes(filterValue) ||
        String(colectivo?.razonSocial ?? '')
          .toLowerCase()
          .includes(filterValue),
    );
  }

  private filtrarProgramasPorTexto(lista: any[], texto: string): any[] {
    const t = String(texto ?? '')
      .trim()
      .toLowerCase();
    if (!t) {
      return lista || [];
    }
    return (lista || []).filter((p: any) => {
      const codigo = String(p?.codigo ?? '').toLowerCase();
      const nombre = String(p?.programa ?? p?.nombre ?? '').toLowerCase();
      return codigo.includes(t) || nombre.includes(t);
    });
  }

  public get programasDestinoFiltradosBusqueda(): any[] {
    return this.filtrarProgramasPorTexto(
      this.programasDestino,
      this.filtroProgramaDestino,
    );
  }

  public filtrarSubcuentasPorTexto(lista: any[], texto: string): any[] {
    const filtro = String(texto ?? '')
      .trim()
      .toLowerCase();
    if (!filtro) return lista || [];
    return (lista || []).filter((subcuenta: any) => {
      const codigo = String(subcuenta?.codigo ?? '').toLowerCase();
      const nombre = String(subcuenta?.nombre ?? '').toLowerCase();
      return codigo.includes(filtro) || nombre.includes(filtro);
    });
  }

  public get subcuentasDestinoFiltradasBusqueda(): any[] {
    return this.filtrarSubcuentasPorTexto(
      this.subcuentasDestino,
      this.filtroSubcuentaDestino,
    );
  }

  public onFiltroSubcuentaDestinoInput(event: Event): void {
    this.filtroSubcuentaDestino =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroSubcuentaContratoInput(event: Event): void {
    this.filtroSubcuentaContrato =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public get programasDestinoColectivoFiltradosBusqueda(): any[] {
    return this.filtrarProgramasPorTexto(
      this.programasDestinoColectivo,
      this.filtroProgramaDestinoColectivo,
    );
  }

  public get tarifasDestinoFiltradasBusqueda(): any[] {
    return this.filterTarifasCambio(
      this.tarifasDestino,
      this.filtroTarifaDestino,
    );
  }

  public get tarifasDestinoColectivoFiltradasBusqueda(): any[] {
    return this.filterTarifasCambio(
      this.tarifasDestinoColectivo,
      this.filtroTarifaDestinoColectivo,
    );
  }

  public get tarifasDestinoContratoFiltradasBusqueda(): any[] {
    return this.filterTarifasCambio(
      this.tarifasDestinoContrato,
      this.filtroTarifaDestinoContrato,
    );
  }

  public onFiltroProgramaDestinoInput(event: Event): void {
    this.filtroProgramaDestino =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroProgramaDestinoColectivoInput(event: Event): void {
    this.filtroProgramaDestinoColectivo =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroTarifaDestinoContratoInput(event: Event): void {
    this.filtroTarifaDestinoContrato =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroTarifaDestinoInput(event: Event): void {
    this.filtroTarifaDestino = (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroTarifaDestinoColectivoInput(event: Event): void {
    this.filtroTarifaDestinoColectivo =
      (event.target as HTMLInputElement)?.value ?? '';
  }

  public onFiltroProgramaContratoNuevoInput(event: Event): void {
    const v = (event.target as HTMLInputElement)?.value ?? '';
    this.filtroProgramaContratoNuevoSubject.next(v);
  }

  private filterTarifasCambio(tarifas: any[], searchValue: string): any[] {
    if (!searchValue) return tarifas;

    const filterValue = searchValue.toLowerCase().trim();

    return tarifas.filter(
      (tarifa: any) =>
        String(tarifa.codigo ?? '')
          .toLowerCase()
          .includes(filterValue) ||
        String(tarifa.nombre ?? '')
          .toLowerCase()
          .includes(filterValue) ||
        String(tarifa.descripcion ?? '')
          .toLowerCase()
          .includes(filterValue),
    );
  }

  public getDebugInfo(): any {
    return {
      isLoadingTipos: this.isLoadingTipos,
      hasErrorTipos: this.hasErrorTipos,
      tiposCount: this.tiposNovedadSubject.value.length,
      subtiposCount: this.subtiposNovedadSubject.value.length,
      selectedTipo: this.selectedTipoNovedad,
      selectedSubtipo: this.selectedSubtipoNovedad,
      contratoSeleccionado: this.contratoSeleccionado,
      subtipoHabilitado: this.subtipoHabilitado,
    };
  }

  public isTooltipVisible(): boolean {
    return !this.subtipoHabilitado;
  }

  private esTipoNombre(tipo: TipoNovedad | null, fragmento: string): boolean {
    if (!tipo) {
      return false;
    }
    const nombre = this.normalizarTextoComparacion(tipo.nombre);
    const frag = this.normalizarTextoComparacion(fragmento);
    return nombre.includes(frag);
  }

  /** MP-FT-1358 1.1.3.6 — ids catálogo «Cambio de tarifa» o nombre (p. ej. id 18 en BD vs 6 en doc). */
  private esCambioTarifaNovedadTipo(tipo: TipoNovedad | null): boolean {
    if (!tipo) {
      return false;
    }

    const codigoTipo = String(tipo.codigoTipoNovedad ?? '').trim();

    if (CODIGO_TIPO_NOVEDAD_CAMBIO_TARIFA === codigoTipo) {
      return true;
    }

    return this.esTipoNombre(tipo, 'cambio de tarifa');
  }

  /** Expuesto a plantilla: bloque UI de cambio de tarifa. */
  public esCambioTarifaSeleccionado(): boolean {
    return this.esCambioTarifaNovedadTipo(this.selectedTipoNovedad);
  }

  public esTipoTrasladoContratoExistenteActivo(): boolean {
    const tipo = this.selectedTipoNovedad ?? this.tipoNovedadControl.value;
    if (!tipo) {
      return false;
    }

    const codigoTipo = tipo.codigoTipoNovedad;
    return codigoTipo === 'TRASLADO_CONTRATO_EXISTENTE';
  }

  private esAdicionaAnexoNovedadTipo(tipo: TipoNovedad | null): boolean {
    if (!tipo) {
      return false;
    }

    const codigoTipo = tipo.codigoTipoNovedad;

    if (CODIGO_TIPO_NOVEDAD_ADICIONA_ANEXO === codigoTipo) {
      return true;
    }

    return this.esTipoNombre(tipo, 'adiciona anexo');
  }

  /** Expuesto a plantilla: flujo / tabla «Adiciona anexo». */
  public esAdicionaAnexoSeleccionado(): boolean {
    return this.esAdicionaAnexoNovedadTipo(this.selectedTipoNovedad);
  }

  private async procesarCambioCobertura(
    tipoNovedad: TipoNovedad,
  ): Promise<void> {
    this.mostrarCamposCambioCobertura = true;
    this.isLoadingTipoPrima = true;
    this.errorTipoPrima = null;

    try {
      await this.consultarTipoPrima();
    } finally {
      this.isLoadingTipoPrima = false;
    }

    // Cargas independientes: un fallo no debe vaciar toda la pantalla.
    try {
      await this.cargarTiposPlanes();
    } catch (e) {
      console.error('cargarTiposPlanes (cambio cobertura):', e);
    }
    try {
      await this.cargarProgramasDestino();
      this.aplicarFiltroProgramasCambioCobertura();
    } catch (e) {
      console.error('cargarProgramasDestino (cambio cobertura):', e);
    }
    try {
      await this.cargarCortesDestino();
    } catch (e) {
      console.error('cargarCortesDestino (cambio cobertura):', e);
    }
    try {
      await this.cargarBeneficiariosTarifa();
    } catch (e) {
      console.error('cargarBeneficiariosTarifa (cambio cobertura):', e);
    }
    try {
      this.configurarValidadoresCambioCobertura();
      this.configurarListenersCamposDestino();
    } catch (e) {
      console.error('validadores/listeners cambio cobertura:', e);
    }
    await this.cargarAnexosDestino();
  }

  /**
   * MP-FT-1358 1.1.3.1.a y criterio DBA: el tipo de prima del contrato **origen** se toma
   * primero del campo `TipoPrima` del servicio de contratos (paso 1) cuando viene informado.
   * Mientras ese campo se alimenta (p. ej. llega null), se usa como respaldo la parametrización
   * «Programas por Tipo de Prima» (línea de negocio y grupo programa del mismo contrato).
   */
  private variantesTextoParametroParametrizacion(valor: string): string[] {
    const raw = (valor || '').replace(/\s+/g, ' ').trim();
    if (!raw) {
      return [];
    }
    const out: string[] = [];
    const add = (s: string) => {
      const t = s.replace(/\s+/g, ' ').trim();
      if (t && !out.includes(t)) {
        out.push(t);
      }
    };
    add(raw);
    // Coincidir con BD que guarda " - " uniforme (ej. "CEM -COOMEVA" vs "CEM - COOMEVA")
    add(raw.replace(/\s*-\s*/g, ' - '));
    // Variante compacta sin espacios alrededor del guion
    add(raw.replace(/\s*-\s*/g, '-'));
    return out;
  }

  /**
   * Soporta respuesta plana, { data }, arrays, u otros envoltorios del gateway.
   */
  private extraerTipoPrimaDeCualquierRespuesta(res: unknown): string | null {
    const seen = new WeakSet<object>();
    const walk = (val: unknown, depth: number): string | null => {
      if (val == null || depth > 8) {
        return null;
      }
      if (typeof val === 'string') {
        const t = val.trim();
        return t !== '' ? t : null;
      }
      if (typeof val !== 'object') {
        return null;
      }
      if (seen.has(val as object)) {
        return null;
      }
      seen.add(val as object);
      if (Array.isArray(val)) {
        for (const item of val) {
          const t = walk(item, depth + 1);
          if (t) {
            return t;
          }
        }
        return null;
      }
      const o = val as Record<string, unknown>;
      for (const k of [
        'tipoPrima',
        'tipo_prima',
        'TipoPrima',
        'nombreTipoPrima',
      ]) {
        const v = o[k];
        if (typeof v === 'string' && v.trim() !== '') {
          return v.trim();
        }
      }
      for (const k of ['data', 'content', 'result', 'body', 'payload']) {
        if (k in o) {
          const t = walk(o[k], depth + 1);
          if (t) {
            return t;
          }
        }
      }
      return null;
    };
    return walk(res, 0);
  }

  /** Texto completo `GrupoPrograma` del contrato origen para POST `/tipos-prima`. */
  private obtenerGrupoProgramaTextoContratoOrigen(): string {
    return String(
      this.filaContratoAfilmedPaso1?.GrupoPrograma ??
        this.contratoSeleccionado?.GrupoPrograma ??
        this.obtenerContratoDesdeStorage()?.GrupoPrograma ??
        '',
    ).trim();
  }

  /** Texto completo `LineaNegocio` del contrato origen para POST `/tipos-prima`. */
  private obtenerLineaNegocioTextoContratoOrigen(): string {
    return String(this.obtenerLineaNegocioContrato() ?? '').trim();
  }

  /**
   * Tras resolver tipo de prima, propaga `TipoPrima` al contrato del paso 1
   * (fila Afilmed, seleccionado, storage y padre `currentContract`).
   */
  private aplicarTipoPrimaEnContratoActual(
    tipoPrima: string,
    idTipoPrima?: number,
  ): void {
    const valor = String(tipoPrima ?? '').trim();
    if (!valor) {
      return;
    }

    if (this.filaContratoAfilmedPaso1) {
      this.filaContratoAfilmedPaso1.TipoPrima = valor;
      if (idTipoPrima != null && Number.isFinite(idTipoPrima)) {
        (this.filaContratoAfilmedPaso1 as any).idTipoPrima = idTipoPrima;
      }
    }

    if (this.contratoSeleccionado) {
      this.contratoSeleccionado.TipoPrima = valor;
    }

    const numero = this.obtenerNumeroContratoSeleccionado();
    const state = this.localStorageService.load('frmConsultState') as Record<
      string,
      any
    > | null;
    const contratosData = state?.['contratosData'];
    if (numero && Array.isArray(contratosData)) {
      const filas = contratosData as ContratoAfilmedDTO[];
      const idx = filas.findIndex(
        (c) =>
          String(c?.contrato ?? (c as any)?.Contrato ?? '').trim() === numero,
      );
      if (idx >= 0) {
        filas[idx] = {
          ...filas[idx],
          TipoPrima: valor,
          ...(idTipoPrima != null && Number.isFinite(idTipoPrima)
            ? { idTipoPrima }
            : {}),
        } as ContratoAfilmedDTO;
        const currentContract = state?.['currentContract'];
        this.localStorageService.save('frmConsultState', {
          ...state,
          contratosData: filas,
          currentContract: currentContract
            ? { ...currentContract, TipoPrima: valor }
            : currentContract,
        });
      }
    }

    this.contratoPaso1Actualizado.emit({
      TipoPrima: valor,
      ...(idTipoPrima != null && Number.isFinite(idTipoPrima)
        ? ({ idTipoPrima } as any)
        : {}),
    });
  }

  private async consultarTipoPrima(): Promise<void> {
    const subtipoSeleccionado = this.subtipoNovedadControl.value;

    if (!subtipoSeleccionado) {
      this.tipoPrimaObtenido = true;
      return;
    }

    if (
      !this.esSubtipoTrasladoTipoPrimaDesdeParametrizacion(subtipoSeleccionado)
    ) {
      this.tipoPrimaObtenido = true;
      return;
    }

    const grupoPrograma = this.obtenerGrupoProgramaTextoContratoOrigen();
    const lineaNegocio = this.obtenerLineaNegocioTextoContratoOrigen();

    if (!grupoPrograma || !lineaNegocio) {
      this.tipoPrimaObtenido = false;
      this.errorTipoPrima =
        'No hay grupo programa o línea de negocio del contrato origen para consultar el tipo de prima.';
      return;
    }

    const consultaKey = `${grupoPrograma}\0${lineaNegocio}`;
    const forzarReconsulta = this.tipoPrimaReconsultaPendiente;
    if (forzarReconsulta) {
      this.tipoPrimaReconsultaPendiente = false;
      this.tipoPrimaObtenido = false;
      this.tipoPrimaConsultaOrigenKey = '';
      this.tiposPrimaService.invalidarCache(grupoPrograma, lineaNegocio);
    }
    if (
      !forzarReconsulta &&
      this.tipoPrimaObtenido &&
      String(this.tipoPrimaOrigen ?? '').trim() &&
      this.tipoPrimaConsultaOrigenKey === consultaKey
    ) {
      return;
    }

    try {
      const tiposPrima = await firstValueFrom(
        this.tiposPrimaService.consultarTiposPrima(
          {
            grupoPrograma,
            lineaNegocio,
          },
          { forceRefresh: forzarReconsulta },
        ),
      );

      const item =
        (tiposPrima || []).find((t) => String(t?.tipoPrima ?? '').trim()) ??
        null;

      if (!item?.tipoPrima) {
        this.tipoPrimaObtenido = false;
        this.errorTipoPrima =
          `El tipo de prima no está configurado en el sistema para la línea de negocio ${lineaNegocio} y grupo programa ${grupoPrograma}. ` +
          'No podrá continuar hasta obtener el valor del tipo de prima.';
        return;
      }

      const tipoPrimaResuelto = String(item.tipoPrima).trim();
      this.tipoPrimaOrigen = tipoPrimaResuelto;
      this.lineaNegocioDestino = lineaNegocio;
      this.aplicarTipoPrimaEnContratoActual(
        tipoPrimaResuelto,
        item.idTipoPrima,
      );
      this.tipoPrimaObtenido = true;
      this.tipoPrimaConsultaOrigenKey = consultaKey;
      this.errorTipoPrima = null;

      if (!environment.production) {
        console.info('[tipos-prima] Tipo prima contrato origen:', {
          grupoPrograma,
          lineaNegocio,
          tipoPrima: tipoPrimaResuelto,
          idTipoPrima: item.idTipoPrima,
        });
      }
    } catch (error) {
      this.tipoPrimaObtenido = false;
      this.errorTipoPrima =
        'Error al consultar la configuración del tipo de prima';
      console.error('Error consultando tipo prima:', error);
    }
  }

  private async cargarTiposPlanes(opciones?: {
    preservarSeleccionSiPosible?: boolean;
  }): Promise<void> {
    try {
      this.tiposPlanes = await firstValueFrom(
        this.tiposPlanService.getTiposPlanes(
          this.obtenerIndicadorColectivoTiposPlanes(),
        ),
      );

      if (this.tiposPlanes.length > 0) {
        const cur = this.tipoPlanDestinoControl.value;
        if (opciones?.preservarSeleccionSiPosible && cur) {
          const cod = (x: unknown) =>
            String((x as { codigo?: string })?.codigo ?? '').trim();
          const id = (x: unknown) =>
            String((x as { id?: string | number })?.id ?? '').trim();
          const match = this.tiposPlanes.find(
            (p) =>
              (cod(p) && cod(p) === cod(cur)) || (id(p) && id(p) === id(cur)),
          );
          if (match) {
            this.tipoPlanDestinoControl.setValue(match, { emitEvent: false });
            return;
          }
        }
        this.tipoPlanDestinoControl.setValue(this.tiposPlanes[0]);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }

  private async cargarProgramasDestino(): Promise<void> {
    this.isLoadingProgramas = true;

    try {
      const programas = await this.consultarProgramasDestinoCambioCobertura();
      this.programasDestino = programas;
      this.programasDestinoFiltrados = [...programas];
      this.cdr.markForCheck();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.isLoadingProgramas = false;
    }
  }

  /**
   * Cambio de cobertura y Cambio de plan: programas destino vía
   * `POST /programas-linea-negocio` (`getProgGrupoProgXLnNeg`) con `prm_linea_neg`
   * numérico del contrato origen (paso 1).
   */
  private async consultarProgramasDestinoCambioCobertura(): Promise<any[]> {
    const prm_linea_neg =
      this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato();
    if (!prm_linea_neg) {
      this.errorTrasladoContrato =
        'No hay línea de negocio del contrato origen para cargar programas destino.';
      return [];
    }

    const items = await firstValueFrom(
      this.programasLineaNegocioService.getProgramasPorLineaNegocio({
        prm_linea_neg,
      }),
    );

    const uniq = new Map<string, any>();
    for (const item of items || []) {
      const mapped = this.mapProgramaLineaNegocioParaSelector(item);
      const claveUnica = String(
        mapped?.programa ?? mapped?.nombre ?? mapped?.codigo ?? '',
      ).trim();
      if (!claveUnica) {
        continue;
      }
      if (!uniq.has(claveUnica)) {
        uniq.set(claveUnica, mapped);
      }
    }

    const lista = Array.from(uniq.values()).sort((a, b) =>
      String(a.nombre ?? '').localeCompare(String(b.nombre ?? '')),
    );

    if (!lista.length) {
      this.errorTrasladoContrato =
        'No existen programas disponibles para la línea de negocio del contrato origen.';
    } else if (
      this.errorTrasladoContrato ===
      'No existen programas disponibles para la línea de negocio del contrato origen.'
    ) {
      this.errorTrasladoContrato = '';
    }

    if (!environment.production && lista.length) {
      console.info(
        '[programas-linea-negocio] Programas mapeados:',
        lista.length,
      );
    }

    return lista;
  }

  private mapProgramaLineaNegocioParaSelector(item: {
    programa?: string;
    grupo_programa?: string;
    tipoPrima?: string;
  }): any {
    const programaRaw = String(item?.programa ?? '').trim();
    const grupoRaw = String(item?.grupo_programa ?? '').trim();
    const codigoPrograma = (programaRaw.split('|')[0] ?? '').trim();
    const codigoGrupo = (grupoRaw.split('|')[0] ?? '').trim();
    const codigo =
      codigoPrograma ||
      codigoGrupo ||
      this.normalizarCodigoGrupoPrograma(programaRaw) ||
      this.normalizarCodigoGrupoPrograma(grupoRaw) ||
      programaRaw ||
      grupoRaw;
    const grupoPrograma =
      codigoGrupo || this.normalizarCodigoGrupoPrograma(grupoRaw) || grupoRaw;
    const tipoPrima = String(item?.tipoPrima ?? '').trim();

    return {
      codigo,
      nombre: programaRaw || codigo,
      programa: programaRaw || codigo,
      grupoPrograma,
      grupoProgramaTexto: grupoRaw || programaRaw,
      ...(tipoPrima ? { tipoPrima } : {}),
    };
  }

  /** Solo `GrupoPrograma` del contrato (no `ProgramaCodigo` / `ProgramaNombre`). */
  private obtenerParametroGrupoProgramaContrato(): string {
    return (
      this.filaContratoAfilmedPaso1?.GrupoPrograma ||
      this.contratoSeleccionado?.GrupoPrograma ||
      this.obtenerContratoDesdeStorage()?.GrupoPrograma ||
      ''
    )
      .toString()
      .trim();
  }

  /**
   * `/grupos-programas-activos` usa `prm_grp_programa` (grupo/criterio de programa
   * del contrato), no el texto de línea de negocio. Igual criterio que Cambio de cobertura.
   */
  private obtenerPrmGrupoProgramaParaProgramasCambioPlan(): string {
    const desdeFila = String(
      this.filaContratoAfilmedPaso1?.GrupoPrograma ?? '',
    ).trim();
    if (desdeFila) {
      return desdeFila;
    }

    const desdeContrato = String(
      this.contratoSeleccionado?.GrupoPrograma ?? '',
    ).trim();
    if (desdeContrato) {
      return desdeContrato;
    }

    const storage = this.obtenerContratoDesdeStorage();
    const desdeStorage = String(storage?.GrupoPrograma ?? '').trim();
    if (desdeStorage) {
      return desdeStorage;
    }

    const param = String(
      this.obtenerParametroGrupoProgramaContrato() ?? '',
    ).trim();
    if (param) {
      return param;
    }

    return String(this.lineaNegocioDestino ?? '').trim();
  }

  private obtenerLineaNegocioDestino(): string {
    return (
      this.contratoSeleccionado?.LineaNegocio ||
      this.lineaNegocioDestino ||
      ''
    )
      .toString()
      .trim();
  }

  private aplicarFiltroProgramasCambioCobertura(): void {
    const sub = this.subtipoNovedadControl.value;
    const subtipoNombre = String(sub?.nombre ?? '').trim();
    if (
      !SUBTIPOS_TRASLADO_TIPO_PRIMA_DESDE_PARAMETRIZACION.has(subtipoNombre)
    ) {
      return;
    }

    const raw = [...(this.programasDestino ?? [])];
    const codOrigenRaw = String(
      this.filaContratoAfilmedPaso1?.ProgramaCodigo ??
        this.contratoSeleccionado?.ProgramaCodigo ??
        '',
    ).trim();
    const codOrigen =
      (codOrigenRaw.split('|')[0] ?? '').trim() ||
      this.normalizarCodigoGrupoPrograma(codOrigenRaw) ||
      codOrigenRaw;

    const excluirProgramaOrigen = (list: any[]): any[] =>
      codOrigen
        ? list.filter((p) => {
            const cod = String(p?.codigo ?? '').trim();
            const prog = String(p?.programa ?? p?.nombre ?? '').trim();
            const progCod = (prog.split('|')[0] ?? '').trim();
            return cod !== codOrigen && progCod !== codOrigen;
          })
        : list;

    if (!this.tipoPrimaObtenido || !String(this.tipoPrimaOrigen ?? '').trim()) {
      this.programasDestino = excluirProgramaOrigen(raw);
      this.programasDestinoFiltrados = [...this.programasDestino];
      this.cdr.markForCheck();
      return;
    }

    const algunoConTipoPrima = raw.some(
      (p) => this.indiceTipoPrimaEnJerarquia(p?.tipoPrima) >= 0,
    );

    let filtrados = algunoConTipoPrima
      ? this.filtrarProgramasPorTipoTraslado(
          raw,
          subtipoNombre,
          this.tipoPrimaOrigen,
        )
      : raw;
    filtrados = excluirProgramaOrigen(filtrados);

    const idxOrigen = this.indiceTipoPrimaEnJerarquia(this.tipoPrimaOrigen);
    const vacioLegitimoNegocio =
      (subtipoNombre === 'Traslado Upgrade' && idxOrigen === 2) ||
      (subtipoNombre === 'Traslado Downgrade' && idxOrigen === 0);

    if (
      filtrados.length === 0 &&
      raw.length > 0 &&
      !vacioLegitimoNegocio &&
      algunoConTipoPrima
    ) {
      this.programasDestino = [];
      this.programasDestinoFiltrados = [];
      this.errorTrasladoContrato = MSG_MP_FT_1358_PROGRAMAS_SUBTIPO_VACIO;
      this.cdr.markForCheck();
      return;
    }

    if (filtrados.length === 0 && raw.length > 0 && !algunoConTipoPrima) {
      filtrados = excluirProgramaOrigen(raw);
    }

    this.programasDestino = filtrados;
    this.programasDestinoFiltrados = [...filtrados];
    if (
      filtrados.length > 0 &&
      this.errorTrasladoContrato === MSG_MP_FT_1358_PROGRAMAS_SUBTIPO_VACIO
    ) {
      this.errorTrasladoContrato = '';
    }
    this.cdr.markForCheck();
  }

  /** 0 = Prima Baja, 1 = Media, 2 = Alta; -1 = no reconocido. */
  private indiceTipoPrimaEnJerarquia(valor: unknown): number {
    const s = String(valor ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!s) {
      return -1;
    }
    if (/\b(prima\s*)?baja\b/.test(s) || /(^|\s)pb(\s|$)/i.test(s)) {
      return 0;
    }
    if (/\b(prima\s*)?media\b/.test(s) || /(^|\s)pm(\s|$)/i.test(s)) {
      return 1;
    }
    if (/\b(prima\s*)?alta\b/.test(s) || /(^|\s)pa(\s|$)/i.test(s)) {
      return 2;
    }
    return -1;
  }

  private filtrarProgramasPorTipoTraslado(
    programas: any[],
    subtipoNombre: string,
    tipoPrimaOrigen: string,
  ): any[] {
    const indexOrigen = this.indiceTipoPrimaEnJerarquia(tipoPrimaOrigen);

    if (indexOrigen === -1) {
      console.warn('Tipo prima origen no reconocido:', tipoPrimaOrigen);
      return programas;
    }

    return programas.filter((programa) => {
      const indexDestino = this.indiceTipoPrimaEnJerarquia(programa?.tipoPrima);

      const programaActual = 'PROGRAMA_ACTUAL';
      const esProgramaActual = programa.codigo === programaActual;
      if (esProgramaActual) {
        return false;
      }

      // Sin tipo de prima resuelto en el catálogo: no excluir por jerarquía.
      if (indexDestino === -1) {
        return true;
      }

      switch (subtipoNombre) {
        case 'Traslado Upgrade':
          return indexDestino > indexOrigen;
        case 'Traslado Downgrade':
          return indexDestino < indexOrigen && indexDestino >= 0;
        case 'Traslado Lineal':
          return indexDestino === indexOrigen && indexDestino >= 0;
        default:
          return true;
      }
    });
  }

  private async cargarCortesDestino(): Promise<void> {
    try {
      this.cortesService.getCortes().subscribe({
        next: (data) => (this.cortesDestino = data),
        error: (err) => console.error(err),
      });

      if (this.cortesDestino.length > 0) {
        const corte20 = this.cortesDestino.find((c) => c.corte === 20);
        if (corte20) {
          this.corteDestinoControl.setValue(corte20);
        } else {
          this.corteDestinoControl.setValue(this.cortesDestino[0]);
        }
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }

  private configurarValidadoresCambioCobertura(): void {
    this.tipoPlanDestinoControl.setValidators([Validators.required]);

    if (this.mostrarCampoColectivo) {
      this.programaDestinoControl.clearValidators();
      this.tarifaDestinoControl.clearValidators();
      this.corteDestinoControl.clearValidators();
      this.proporcionalidadControl.clearValidators();
    } else {
      this.programaDestinoControl.setValidators([Validators.required]);
      this.tarifaDestinoControl.setValidators([Validators.required]);
      this.corteDestinoControl.setValidators([Validators.required]);
      this.proporcionalidadControl.setValidators([Validators.required]);
    }

    const ev = { emitEvent: false } as const;
    this.tipoPlanDestinoControl.updateValueAndValidity(ev);
    this.programaDestinoControl.updateValueAndValidity(ev);
    this.tarifaDestinoControl.updateValueAndValidity(ev);
    this.corteDestinoControl.updateValueAndValidity(ev);
    this.proporcionalidadControl.updateValueAndValidity(ev);
  }

  private async cargarAnexosDestino(forceRefresh = false): Promise<void> {
    const payloadConsulta = this.construirPayloadConsultaAnexosContratoOrigen();
    if (!payloadConsulta?.grupoPrograma) {
      this.anexosDestino = [];
      this.usarRespuestaFilasAnexoCambioPlan = false;
      if (this.debeHabilitarCheckboxIncluirAnexo()) {
        this.incluirAnexoControl.enable();
        this.isIncluirAnexoContratoEnabled = true;
      } else {
        this.incluirAnexoControl.disable();
        this.isIncluirAnexoContratoEnabled = false;
      }
      this.incluirAnexoControl.setValue(false, { emitEvent: false });
      return;
    }
    try {
      const { catalog, filas } =
        await this.consultarAnexosContratoOrigen(forceRefresh);
      this.anexosDestino = catalog.map((c) => this.mapCatalogoItemInterno(c));
      const noAplica = {
        codigo: 'NO_APLICA',
        nombre: 'No aplica',
        valorTarifa: 0,
      };
      if (
        (filas?.length ?? 0) > 0 &&
        (this.beneficiariosTarifa?.length ?? 0) > 0
      ) {
        this.aplicarFilasConsultaAnexoACambioPlan(filas, noAplica);
      } else {
        this.usarRespuestaFilasAnexoCambioPlan = false;
      }
      if (this.anexosDestino.length > 0) {
        this.incluirAnexoControl.enable();
        this.isIncluirAnexoContratoEnabled = true;
      } else {
        if (this.debeHabilitarCheckboxIncluirAnexo()) {
          this.incluirAnexoControl.enable();
          this.isIncluirAnexoContratoEnabled = true;
        } else {
          this.incluirAnexoControl.disable();
          this.isIncluirAnexoContratoEnabled = false;
        }
        this.incluirAnexoControl.setValue(false, { emitEvent: false });
      }
    } catch (error) {
      console.error('Error al cargar anexos destino:', error);
      this.anexosDestino = [];
      this.usarRespuestaFilasAnexoCambioPlan = false;
      if (this.debeHabilitarCheckboxIncluirAnexo()) {
        this.incluirAnexoControl.enable();
        this.isIncluirAnexoContratoEnabled = true;
      } else {
        this.incluirAnexoControl.disable();
        this.isIncluirAnexoContratoEnabled = false;
      }
      this.incluirAnexoControl.setValue(false, { emitEvent: false });
    }
  }

  /**
   * Cache por contrato origen (plan + línea + grupo programa).
   */
  private async consultarAnexosContratoOrigen(forceRefresh = false): Promise<{
    catalog: CatalogoAnexoConsultaDTO[];
    filas: any[];
    mensajeAdvertencia: string | null;
  }> {
    const payload = this.construirPayloadConsultaAnexosContratoOrigen();
    if (!payload?.grupoPrograma) {
      return { catalog: [], filas: [], mensajeAdvertencia: null };
    }

    const key = [
      payload.tipoPlan ?? '',
      payload.lineaNegocio ?? '',
      payload.grupoPrograma,
    ].join('|');

    if (forceRefresh) {
      this.anexosConsultaCache.delete(key);
    } else {
      const cached = this.anexosConsultaCache.get(key);
      if (cached) {
        return cached;
      }
    }

    const inFlight = this.anexosConsultaInFlight.get(key);
    if (inFlight) {
      return inFlight;
    }

    const request = firstValueFrom(
      this.adicionaAnexoConsultaService.consulta(payload),
    )
      .then((resp) => {
        let catalog = this.extraerAnexosDesdeRespuestaConsulta(resp);
        const filas = Array.isArray(resp?.filas) ? resp.filas : [];
        if (catalog.length === 0 && filas.length > 0) {
          catalog = this.catalogoAgregadoDesdeOpcionesFilas(filas as any[]);
        }
        const result = {
          catalog,
          filas,
          mensajeAdvertencia: resp?.mensajeAdvertencia ?? null,
        };
        this.anexosConsultaCache.set(key, result);
        return result;
      })
      .finally(() => {
        this.anexosConsultaInFlight.delete(key);
      });

    this.anexosConsultaInFlight.set(key, request);
    return request;
  }

  /**
   * Misma fuente que el paso 1 (radicación): POST info-contrato-user / integrantes Afilmed.
   */
  private mapearFilaInfoContratoABeneficiario(item: any, index: number): any {
    const identificacion = String(
      item.Identificacion ??
        item.identificacion ??
        item.NumeroIdentificacion ??
        item.numeroIdentificacion ??
        item.NumeroDocumento ??
        item.numeroDocumento ??
        '',
    ).trim();
    const nombreUsuario = String(
      item.NombreUsuario ??
        item.nombreUsuario ??
        item.NombreCompleto ??
        item.nombreCompleto ??
        '',
    ).trim();
    const codPar = item.CodigoParentesco ?? item.codigoParentesco ?? '';
    const nomPar =
      item.NombreParentesco ??
      item.nombreParentesco ??
      item.DescripcionParentesco ??
      item.descripcionParentesco ??
      '';
    let parentesco = item.Parentesco ?? item.parentesco ?? '';
    if (!String(parentesco).trim() && (codPar || nomPar)) {
      parentesco = [codPar, nomPar].filter(Boolean).join('-');
    }
    parentesco = String(parentesco ?? '').trim();
    const edad = Number(item.Edad ?? item.edad ?? 0) || 0;
    const genero = String(item.Genero ?? item.genero ?? '').trim() || '—';
    const codAnexo = item.CodigoAnexo ?? item.codigoAnexo ?? '';
    const nomAnexo = item.NombreAnexo ?? item.nombreAnexo ?? '';
    let anexoRaw =
      item.Anexo ?? item.anexo ?? item.AnexoDestino ?? item.anexoDestino ?? '';
    if (!String(anexoRaw).trim() && codAnexo) {
      anexoRaw = nomAnexo ? `${codAnexo}-${nomAnexo}` : String(codAnexo);
    }
    anexoRaw = String(anexoRaw ?? '').trim();
    const anexoInfo = this.parseAnexoValor(anexoRaw);
    const valorTarifaAnexo =
      Number(item.ValorTarifaAnexo ?? item.valorTarifaAnexo ?? 0) || 0;
    const valorTarifaPrograma =
      Number(item.ValorTarifaPrograma ?? item.valorTarifaPrograma ?? 0) || 0;
    const totalTarifa =
      Number(
        item.TotalTarifa ??
          item.totalTarifa ??
          valorTarifaAnexo + valorTarifaPrograma,
      ) || 0;

    const esCambioPlanRow = this.esCambioPlanTipoSeleccionado();

    const parentescoNorm = this.normalizarParentescoDestino(parentesco || null);
    const codigoParentescoUi =
      parentescoNorm && typeof parentescoNorm === 'object'
        ? String((parentescoNorm as any).codigo ?? '').trim() || null
        : null;

    const anexoCodigoServicio = anexoInfo?.codigo
      ? String(anexoInfo.codigo).trim()
      : '';
    const anexoNombreServicio =
      anexoInfo?.nombre || String(anexoRaw).trim() || anexoCodigoServicio;

    const anexosHabilitadosIniciales = (() => {
      if (!esCambioPlanRow) {
        return undefined;
      }
      const noAp = { codigo: 'NO_APLICA', nombre: 'No aplica', valorTarifa: 0 };
      const base = anexoCodigoServicio
        ? [
            {
              codigo: anexoCodigoServicio,
              nombre: anexoNombreServicio,
              valorTarifa: valorTarifaAnexo,
              condiciones: null,
            },
            noAp,
          ]
        : [noAp];
      const seen = new Set<string>();
      return base.filter((a) => {
        const c = String(a?.codigo ?? '')
          .trim()
          .toUpperCase();
        if (!c || seen.has(c)) {
          return false;
        }
        seen.add(c);
        return true;
      });
    })();

    return {
      numero: index + 1,
      identificacion: String(identificacion).trim(),
      nombreUsuario: String(nombreUsuario).trim(),
      nombre: String(nombreUsuario).trim(),
      codigoParentesco: String(codPar ?? '').trim(),
      parentesco: String(parentesco).trim() || String(nomPar ?? '').trim(),
      // Cambio de plan: precargar parentesco destino desde el servicio cuando se pueda enlazar al catálogo.
      parentescoDestino: esCambioPlanRow
        ? codigoParentescoUi
        : this.normalizarParentescoDestino(parentesco),
      edad,
      sexo:
        String(item.Sexo ?? item.sexo ?? '').trim() ||
        String(genero ?? '').trim() ||
        '',
      genero,
      anexoDestino: esCambioPlanRow
        ? anexoCodigoServicio
          ? [anexoCodigoServicio]
          : ['NO_APLICA']
        : anexoInfo?.codigo || '',
      anexoDestinoLabel: esCambioPlanRow
        ? anexoNombreServicio
        : anexoInfo?.nombre || String(anexoRaw).trim() || '',
      anexosDestino: esCambioPlanRow
        ? anexoRaw || 'NO_APLICA'
        : anexoRaw || '-',
      /** Anexo devuelto por info-contrato-user: se fusiona en catálogo por fila al validar anexos. */
      _anexoServicio:
        esCambioPlanRow && anexoCodigoServicio
          ? {
              codigo: anexoCodigoServicio,
              nombre: anexoNombreServicio,
              valorTarifa: valorTarifaAnexo,
            }
          : null,
      // Mantener los valores retornados por info-contrato-user también en Cambio de plan.
      valorTarifaAnexo: valorTarifaAnexo,
      valorTarifaPrograma: valorTarifaPrograma,
      totalTarifa: totalTarifa,
      ...(anexosHabilitadosIniciales?.length
        ? { anexosHabilitados: anexosHabilitadosIniciales }
        : {}),
    };
  }

  /** Filas ya normalizadas guardadas en `frmConsultState.validacionTablaData`. */
  private mapearFilaValidacionStorageABeneficiario(
    row: any,
    index: number,
  ): any {
    return this.mapearFilaInfoContratoABeneficiario(
      {
        Identificacion: row.identificacion,
        NombreUsuario: row.nombreUsuario,
        Parentesco: row.parentesco,
        CodigoParentesco: row.codigoParentesco,
        NombreParentesco: row.nombreParentesco,
        Edad: row.edad,
        Genero: row.genero,
        Anexo: row.anexo,
        CodigoAnexo: row.codigoAnexo,
        NombreAnexo: row.nombreAnexo,
        ValorTarifaAnexo: row.valorTarifaAnexo,
        ValorTarifaPrograma: row.valorTarifaPrograma,
        TotalTarifa: row.totalTarifa,
      },
      index,
    );
  }

  private soloDigitosIdentificacion(val: unknown): string {
    return String(val ?? '').replace(/\D/g, '');
  }

  private filaBeneficiarioCoincideConSeleccion(
    fila: { identificacion: string },
    seleccionados: any[],
  ): boolean {
    const a = String(fila.identificacion || '').trim();
    const digA = this.soloDigitosIdentificacion(a);
    return seleccionados.some((s) => {
      const b = String(s.identificacion ?? s.numeroIdentificacion ?? '').trim();
      const digB = this.soloDigitosIdentificacion(b);
      if (digA && digB && digA === digB) {
        return true;
      }
      return a !== '' && b !== '' && a === b;
    });
  }

  private async cargarBeneficiariosTarifa(opciones?: {
    forzarConsultaInfoContratoPrimero?: boolean;
  }): Promise<void> {
    const requestId = ++this.beneficiariosTarifaRequestId;
    let esCambioPlan = false;
    try {
      this.cargandoBeneficiarios = true;
      if (!this.parentescosActivos.length) {
        await this.cargarParentescosActivos();
      }

      esCambioPlan =
        !!opciones?.forzarConsultaInfoContratoPrimero ||
        this.esCambioPlanTipoSeleccionado();

      const numeroContrato =
        this.obtenerNumeroContratoParaInfoUsuario(esCambioPlan);
      if (!numeroContrato) {
        if (esCambioPlan && (this.beneficiariosTarifa?.length ?? 0) > 0) {
          // Evitar borrar una grilla ya visible por recargas tardías sin contrato resuelto.
          this.mostrarTablaBeneficiarios = true;
          return;
        }
        this.beneficiariosTarifa = [];
        this.totalCuotaIva = 0;
        this.mostrarTablaBeneficiarios = false;
        return;
      }

      let filas: any[] = [];
      const totalesPaso1 = this.integrantesTotalesContratoActual;
      const state = this.localStorageService.load('frmConsultState') as
        | Record<string, unknown>
        | null
        | undefined;
      const stateContract = (state?.['selectedContract'] || '')
        .toString()
        .trim();
      const cached = state?.['validacionTablaData'] as any[] | undefined;
      const filasPreviasCambioPlan = esCambioPlan
        ? [...(this.beneficiariosTarifa ?? [])]
        : [];

      /** Igual que radicación (`getInfoContratoUser` + `retry(1)`). */
      const filasDesdeInfoContratoUser = async (): Promise<any[]> => {
        const raw = await firstValueFrom(
          this.validacionContratoService
            .getInfoContratoUser(numeroContrato)
            .pipe(
              retry(1),
              catchError(() => of([])),
            ),
        );
        const arr = Array.isArray(raw) ? raw : [];
        return arr.map((item: any, i: number) =>
          this.mapearFilaInfoContratoABeneficiario(item, i),
        );
      };

      // Cambio de plan: reconsultar info-contrato-user; si el backend devuelve [],
      // usar la misma tabla del paso 1 (Input / localStorage).
      if (esCambioPlan) {
        filas = await filasDesdeInfoContratoUser();
        if (filas.length > 0) {
          if (requestId !== this.beneficiariosTarifaRequestId) {
            return;
          }
          this.beneficiariosTarifa = filas.map((row: any, idx: number) => ({
            ...row,
            numero: idx + 1,
          }));
          this.mostrarTablaBeneficiarios = true;
          this.calcularTotalCuotaIva();
          return;
        }
        if (!filas.length) {
          filas = this.filasIntegrantesDesdePaso1OPersistencia(
            numeroContrato,
            totalesPaso1,
            state,
            stateContract,
            cached,
          );
        }
        if (!filas.length && Array.isArray(cached) && cached.length > 0) {
          filas = cached.map((row: any, i: number) =>
            this.mapearFilaValidacionStorageABeneficiario(row, i),
          );
        }
        if (
          !filas.length &&
          Array.isArray(this.integrantesTotalesContratoActual) &&
          this.integrantesTotalesContratoActual.length > 0
        ) {
          filas = this.integrantesTotalesContratoActual.map(
            (row: any, i: number) =>
              this.mapearFilaValidacionStorageABeneficiario(row, i),
          );
        }
      } else if (Array.isArray(totalesPaso1) && totalesPaso1.length > 0) {
        filas = totalesPaso1.map((row: any, i: number) =>
          this.mapearFilaValidacionStorageABeneficiario(row, i),
        );
      } else if (
        Array.isArray(cached) &&
        cached.length > 0 &&
        this.contratoMismaSeleccion(stateContract, numeroContrato)
      ) {
        filas = cached.map((row: any, i: number) =>
          this.mapearFilaValidacionStorageABeneficiario(row, i),
        );
      } else {
        filas = await filasDesdeInfoContratoUser();
      }

      const seleccionados = this.obtenerIntegrantesSeleccionados();
      // Cambio de plan: listar todos los integrantes del contrato (mismo criterio que la grilla del paso 1).
      // MP-FT-1358 1.1.3.1 — en el resto de tipos, la tabla debe reflejar solo quienes se eligieron en paso 1
      // (sin volver a mostrar a todo el contrato si el cruce por documento no coincide).
      if (!esCambioPlan && seleccionados.length > 0) {
        filas = filas.filter((fila) =>
          this.filaBeneficiarioCoincideConSeleccion(fila, seleccionados),
        );
        filas = filas.map((fila, idx) => ({ ...fila, numero: idx + 1 }));
      }

      // En Cambio de plan NO consultar servicio alterno de beneficiarios:
      // la fuente válida es info-contrato-user (con respaldo local de paso 1).
      if (!esCambioPlan && !filas.length) {
        try {
          const response = await firstValueFrom(
            this.beneficiariosTarifaService
              .getBeneficiariosTarifa(numeroContrato)
              .pipe(catchError(() => of(null))),
          );
          const lista = response?.beneficiarios;
          if (Array.isArray(lista) && lista.length > 0) {
            filas = lista.map((b: any, i: number) =>
              this.mapearFilaInfoContratoABeneficiario(b, i),
            );
            if (!esCambioPlan && seleccionados.length > 0) {
              filas = filas.filter((fila) =>
                this.filaBeneficiarioCoincideConSeleccion(fila, seleccionados),
              );
              filas = filas.map((fila, idx) => ({ ...fila, numero: idx + 1 }));
            }
          }
        } catch {
          /* ya vacío */
        }
      }

      // Cambio de plan: si la reconsulta llega vacía, conservar lo ya mostrado
      // (normalmente proveniente del paso 1) para evitar tabla en blanco.
      if (
        esCambioPlan &&
        filas.length === 0 &&
        filasPreviasCambioPlan.length > 0
      ) {
        filas = filasPreviasCambioPlan.map((row: any, idx: number) => ({
          ...row,
          numero: idx + 1,
        }));
      }

      // Evitar que respuestas tardías pisen la tabla de una consulta más reciente.
      if (requestId !== this.beneficiariosTarifaRequestId) {
        return;
      }

      // Última defensa: si esta consulta llega vacía pero ya hay filas visibles en cambio de plan,
      // conservarlas para no dejar la tabla en blanco por una carrera entre llamadas.
      if (
        esCambioPlan &&
        filas.length === 0 &&
        this.beneficiariosTarifa.length > 0
      ) {
        filas = this.beneficiariosTarifa.map((row: any, idx: number) => ({
          ...row,
          numero: idx + 1,
        }));
      }

      if (this.debeAplicarReglasTablaCambioCobertura()) {
        filas = this.aplicarReglasTablaCambioCobertura(filas);
      } else {
        this.advertenciaIntegrantesCambioCobertura = null;
      }

      this.beneficiariosTarifa = filas;
      this.mostrarTablaBeneficiarios = filas.length > 0;
      if (
        this.mostrarCamposTrasladoContratoExistente ||
        this.mostrarTablaIntegrantesTrasladoExistente
      ) {
        this.mostrarTablaBeneficiarios = false;
      }
      this.calcularTotalCuotaIva();
    } catch (error) {
      console.error('Error al cargar beneficiarios y tarifas:', error);
      if (requestId !== this.beneficiariosTarifaRequestId) {
        return;
      }
      if (esCambioPlan && (this.beneficiariosTarifa?.length ?? 0) > 0) {
        // Si ya había datos en pantalla para cambio de plan, conservarlos.
        this.mostrarTablaBeneficiarios = true;
        return;
      }
      this.beneficiariosTarifa = [];
      this.totalCuotaIva = 0;
      this.mostrarTablaBeneficiarios = false;
    } finally {
      if (requestId === this.beneficiariosTarifaRequestId) {
        this.cargandoBeneficiarios = false;
        this.cdr.markForCheck();
      }
    }
  }

  private obtenerIntegrantesSeleccionados(): any[] {
    if (this.integrantesSeleccionados?.length) {
      return this.integrantesSeleccionados;
    }

    const state = this.localStorageService.load('frmConsultState') as
      | Record<string, unknown>
      | null
      | undefined;
    /** `radicacion-traslados` persiste `integrantesSeleccionados` / `selectedContractUsers` (no `selectedContracts`). */
    const fromState =
      state?.['integrantesSeleccionados'] ?? state?.['selectedContractUsers'];
    return Array.isArray(fromState) ? fromState : [];
  }

  private debeAplicarReglasTablaCambioCobertura(): boolean {
    if (!this.esTipoNombre(this.selectedTipoNovedad, 'cambio de cobertura')) {
      return false;
    }
    const subtipo = String(
      this.subtipoNovedadControl.value?.nombre ?? '',
    ).trim();
    return SUBTIPOS_REGLA_TABLA_CAMBIO_COBERTURA.has(subtipo);
  }

  private normalizarParentescoTabla(valor: unknown): string {
    return String(valor ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  /** Normaliza `grupoPrograma` descriptivo a código corto (ej. `CEM -COOMEVA...` -> `CEM`). */
  private normalizarCodigoGrupoPrograma(raw: unknown): string {
    const s = String(raw ?? '').trim();
    if (!s) {
      return '';
    }
    const beforePipe = (s.split('|')[0] ?? s).trim();
    const beforeDash = (beforePipe.split('-')[0] ?? beforePipe).trim();
    const firstToken = (beforeDash.split(/\s+/)[0] ?? beforeDash).trim();
    return firstToken || beforeDash || beforePipe || s;
  }

  private aplicarReglasTablaCambioCobertura(filas: any[]): any[] {
    // Si el usuario seleccionó integrantes explícitamente en paso 1,
    // respetar esa selección sin podas automáticas.
    const seleccionadosPaso1 = this.obtenerIntegrantesSeleccionados();
    if (seleccionadosPaso1.length > 0) {
      this.advertenciaIntegrantesCambioCobertura = null;
      return (filas || []).map((fila: any, idx: number) => ({
        ...fila,
        numero: idx + 1,
      }));
    }

    const sinTitular = (filas || []).filter((fila: any) => {
      const p = this.normalizarParentescoTabla(fila?.parentesco);
      return !p.includes('titular');
    });

    let conyugeVisto = false;
    let removidosConyuge = 0;
    const depurados = sinTitular.filter((fila: any) => {
      const p = this.normalizarParentescoTabla(fila?.parentesco);
      const esConyuge = p.includes('conyuge');
      if (!esConyuge) {
        return true;
      }
      if (!conyugeVisto) {
        conyugeVisto = true;
        return true;
      }
      removidosConyuge++;
      return false;
    });

    if (removidosConyuge > 0) {
      this.advertenciaIntegrantesCambioCobertura =
        'Se detectaron varios integrantes con parentesco cónyuge. Solo se muestra uno para cumplir la regla de negocio.';
    } else {
      this.advertenciaIntegrantesCambioCobertura = null;
    }

    return depurados.map((fila: any, idx: number) => ({
      ...fila,
      numero: idx + 1,
    }));
  }

  private obtenerNumeroContratoSeleccionado(): string {
    const desdePaso1 = (this.numeroContratoPaso1 ?? '').toString().trim();
    if (desdePaso1) {
      return desdePaso1;
    }
    const numero = (this.contratoSeleccionado?.numero || '').toString().trim();
    if (numero) {
      return numero;
    }

    const state = this.localStorageService.load('frmConsultState');
    return (state?.selectedContract || '').toString().trim();
  }

  /**
   * `GrupoPrograma` del contrato origen (paso 1), tal como viene en Afilmed
   * (p. ej. `ORI 2`, `ASOA`).
   */
  private obtenerGrupoProgramaParaConsultaAnexos(): string {
    return this.obtenerGrupoProgramaDesdeContratoSeleccionadoPaso1();
  }

  /**
   * Body de `adiciona-anexo/consulta` con datos del contrato origen.
   * Si faltan plan o línea, se envía al menos `grupoPrograma`.
   */
  private construirPayloadConsultaAnexosContratoOrigen(): AdicionaAnexoConsultaRequestPayload | null {
    const grupoPrograma = this.obtenerGrupoProgramaParaConsultaAnexos();
    if (!grupoPrograma) {
      return null;
    }
    const tipoPlan = String(this.obtenerTipoPlanContratoOrigen() ?? '').trim();
    const lineaNegocio = String(
      this.obtenerLineaNegocioContrato() ?? '',
    ).trim();
    return {
      grupoPrograma,
      ...(tipoPlan ? { tipoPlan } : {}),
      ...(lineaNegocio ? { lineaNegocio } : {}),
    };
  }

  private extraerAnexosDesdeRespuestaConsulta(
    resp: AdicionaAnexoConsultaResponse | null | undefined,
  ): CatalogoAnexoConsultaDTO[] {
    const lista = resp?.anexos ?? resp?.catalogoAnexos ?? [];
    return Array.isArray(lista) ? lista : [];
  }

  /**
   * Habilitar checkbox "Incluir anexo" en todos los tipos/subtipos cuando hay contrato (paso 1)
   * para consultar anexos; se mantiene el listado forzado por subtipo como respaldo.
   */
  private debeHabilitarCheckboxIncluirAnexo(): boolean {
    return (
      !!this.obtenerGrupoProgramaParaConsultaAnexos().trim() ||
      this.debeForzarIncluirAnexoHabilitado()
    );
  }

  private aplicarUiCambioPlan(tipoNovedad: TipoNovedad): void {
    this.selectedTipoNovedad = tipoNovedad;
    this.cambioPlanActivo = true;
    this.disableSubtipoSelector();
    this.mostrarCamposCambioCobertura = false;
    this.mostrarCamposTrasladoContratoExistente = false;
    this.mostrarCampoColectivo = false;
    this.mostrarCamposTrasladoContratoNuevo = true;
    this.mostrarTablaIntegrantesContratoNuevo = false;
  }

  private async procesarCambioPlan(
    tipoNovedad: TipoNovedad,
    opts?: { modoRestauracion?: boolean },
  ): Promise<void> {
    // Flujo MP-FT-1358 1.1.3.5 — Tipo de novedad 5 (Cambio de plan).
    // Se deben mostrar los campos de "Traslado a contrato nuevo" (Tipo plan/Programa/Línea/Subcuenta/Corte/Tarifa/Sucursal + Incluir Anexo)
    // y validar que se diligencie "Parentesco destino" en la tabla de integrantes.
    this.aplicarUiCambioPlan(tipoNovedad);

    if (opts?.modoRestauracion) {
      return;
    }

    // Reset de mensajes/estado.
    this.errorTrasladoContrato = '';
    this.errorValidacionIntegrantes = '';
    this.errorTipoPrima = null;

    // Reset de controles del bloque de contrato nuevo y del estado de anexos.
    this.clearAllContratoNuevoFields();
    this.incluirAnexoControl.disable({ emitEvent: false });
    this.isIncluirAnexoContratoEnabled = false;
    this.anexosDestino = [];
    this.anexosDestinoContrato = [];

    // Reset de tablas/valores de tabla.
    this.mostrarTablaBeneficiarios = false;
    this.beneficiariosTarifa = [];
    this.totalCuotaIva = 0;

    // Campos ocultos del PDF.
    this.lineaNegocioDestino =
      String(
        this.filaContratoAfilmedPaso1?.LineaNegocio ||
          this.contratoSeleccionado?.LineaNegocio ||
          '',
      ).trim() || 'Medicina Integral';
    this.grupoProgramaDestino = '';

    // Cargar catálogos base (incluye el plan actual del contrato para que el usuario lo vea y pueda elegir otro).
    await this.cargarTiposPlanesContratoNuevo();
    // La fila "colectivo" del template usa `tiposPlanes`, no `tiposPlanesContratoNuevo`; sin esto el mat-select queda vacío al ser COL/ACO.
    this.tiposPlanes = [...this.tiposPlanesContratoNuevo];
    await this.prefillCambioPlanSeleccionDesdeContratoOrigen();

    await this.cargarParentescosActivos();
    await this.cargarBeneficiariosTarifa({
      forzarConsultaInfoContratoPrimero: true,
    });

    // Si el prefill no alcanzó a validar anexos (p. ej. sin programa en catálogo), habilitar aquí.
    if (
      this.esCambioPlanTipoSeleccionado() &&
      !this.mostrarCampoColectivo &&
      this.incluirAnexoControl.disabled
    ) {
      await this.validarAnexosActivosContrato(
        this.programaDestinoContratoControl.value,
      );
    }

    if (
      this.esCambioPlanTipoSeleccionado() &&
      !this.mostrarCampoColectivo &&
      this.tarifaDestinoContratoControl.value &&
      this.beneficiariosTarifa?.length
    ) {
      for (const b of this.beneficiariosTarifa) {
        this.recalcularTarifasBeneficiario(b);
      }
      this.calcularTotalCuotaIva();
    }
    this.checkValidacionCompletada();
  }

  /** Datos del contrato en paso 1 (fila Afilmed) o lo disponible en `contratoSeleccionado`. */
  private obtenerDtoContratoParaCambioPlan(): any | null {
    if (this.filaContratoAfilmedPaso1) {
      return this.filaContratoAfilmedPaso1;
    }
    const sel = this.contratoSeleccionado;
    if (!sel?.numero) {
      return null;
    }
    const x = sel as any;
    return {
      contrato: sel.numero,
      TipoPlan: x.TipoPlan,
      ProgramaCodigo: sel.ProgramaCodigo,
      ProgramaNombre: sel.ProgramaNombre,
      LineaNegocio: sel.LineaNegocio,
      DiaCorte: x.DiaCorte,
      CodigoTarifa: x.CodigoTarifa,
      Sucursal: x.Sucursal,
      Cuenta: x.Cuenta,
      TipoSubCuenta: x.TipoSubCuenta,
      GrupoPrograma: sel.GrupoPrograma,
      EstadoContrato: x.EstadoContrato,
    };
  }

  /**
   * Precarga destino con lo que ya tiene el contrato (mismos códigos en catálogo),
   * manteniendo el resto de opciones en los desplegables.
   */
  private async prefillCambioPlanSeleccionDesdeContratoOrigen(): Promise<void> {
    const c = this.obtenerDtoContratoParaCambioPlan();
    if (!c) {
      return;
    }

    const codTipoPlan = String(c.TipoPlan ?? '').trim();
    const tipoPlan =
      (codTipoPlan &&
        this.tiposPlanesContratoNuevo.find((p) => p.codigo === codTipoPlan)) ||
      null;

    if (!tipoPlan) {
      return;
    }

    if (tipoPlan.codigo === 'COL' || tipoPlan.codigo === 'ACO') {
      this.mostrarCampoColectivo = true;
      this.mostrarCamposTrasladoContratoNuevo = false;
      this.grupoProgramaDestino = String(c.GrupoPrograma ?? '').trim();
      await this.loadColectivos();
      this.tipoPlanDestinoControl.setValue(tipoPlan, { emitEvent: false });
      return;
    }

    this.tipoPlanDestinoContratoControl.setValue(tipoPlan, {
      emitEvent: false,
    });
    await this.cargarProgramasContratoNuevo(tipoPlan);

    const codProg = String(c.ProgramaCodigo ?? '').trim();
    const programas = this.programasContratoSubject.getValue();
    const programa =
      (codProg && programas.find((p) => p.codigo === codProg)) || null;

    if (!programa) {
      return;
    }

    this.programaDestinoContratoControl.setValue(programa, {
      emitEvent: false,
    });
    this.grupoProgramaDestino = String(
      programa.grupoPrograma || c.GrupoPrograma || '',
    ).trim();

    const codSub = String(c.TipoSubCuenta ?? c.Cuenta ?? '').trim();
    const subcuentas = this.subcuentasContratoSubject.getValue();
    const subcuenta =
      (codSub && subcuentas.find((s) => s.codigo === codSub)) || null;

    if (subcuenta) {
      this.subcuentaDestinoContratoControl.setValue(subcuenta, {
        emitEvent: false,
      });
      await this.cargarCortesDestinoContrato(subcuenta);
      await this.ajustarCortePrefillDesdeContratoOrigen(c);

      const codTar = String(c.CodigoTarifa ?? '').trim();
      if (codTar) {
        const lista = this.tarifasContratoSubject.getValue();
        const t = lista.find((x: any) => String(x.codigo).trim() === codTar);
        if (t) {
          this.tarifaDestinoContratoControl.setValue(t, { emitEvent: false });
        }
      }
      await this.cargarSucursalesComercializablesContrato();
    }

    await this.validarAnexosActivosContrato(programa);

    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  private async ajustarCortePrefillDesdeContratoOrigen(c: any): Promise<void> {
    const n = Number(c?.DiaCorte);
    if (!Number.isFinite(n) || !this.cortesDestinoContrato?.length) {
      return;
    }
    const match = this.cortesDestinoContrato.find(
      (row: any) => Number(row?.corte) === n,
    );
    if (!match) {
      return;
    }
    const cur = this.corteDestinoContratoControl.value;
    if (Number(cur) === n) {
      return;
    }
    this.corteDestinoContratoControl.setValue(match.corte, {
      emitEvent: false,
    });
    await this.cargarTarifasContratoNuevo();
  }

  private async cargarParentescosActivos(): Promise<void> {
    try {
      const lista = await firstValueFrom(
        this.parentescosTrasladosService.getParentescos(),
      );

      this.parentescosActivos = (lista || [])
        .map((p: any) => ({
          codigo: String(p.id ?? '').trim(),
          nombre: String(p.parentesco ?? '').trim(),
        }))
        .filter((p) => p.codigo && p.nombre);
    } catch (error) {
      console.error('Error cargando parentescos activos:', error);
      this.parentescosActivos = [];
    }
  }

  public onParentescoDestinoChange(beneficiario: any, parentesco: any): void {
    if (beneficiario) {
      if (typeof parentesco === 'string') {
        beneficiario.parentescoDestino = parentesco;
        const found = this.parentescosActivos?.find(
          (p: any) =>
            String(p?.codigo ?? '').trim() === String(parentesco).trim(),
        );
        if (found?.nombre) {
          beneficiario.parentesco = found.nombre;
        }
      } else {
        beneficiario.parentescoDestino = parentesco;
        if (parentesco && parentesco.nombre) {
          beneficiario.parentesco = parentesco.nombre;
        }
      }
      this.recalcularTarifasBeneficiario(beneficiario);
      // MP-FT-1358: al cambiar el parentesco, cambia la elegibilidad de anexos.
      this.actualizarAnexosHabilitadosBeneficiariosCambioPlan();
      this.checkValidacionCompletada();
    }
  }

  public onAnexoDestinoTipo5Selected(
    beneficiario: any,
    anexosSeleccionados: any[],
  ): void {
    if (!beneficiario) return;

    let codigos =
      this.normalizarAnexosSeleccionadosCambioPlan(anexosSeleccionados);

    // No se permite "No aplica" en combinación: si viene con otros, lo removemos.
    const tieneNoAplica = codigos.some((c) => c.toUpperCase() === 'NO_APLICA');
    if (tieneNoAplica && codigos.length > 1) {
      codigos = codigos.filter((c) => c.toUpperCase() !== 'NO_APLICA');
    }

    beneficiario.anexoDestino = codigos;
    this.recalcularTarifasBeneficiario(beneficiario);
    this.checkValidacionCompletada();
  }

  private recalcularTarifasBeneficiario(beneficiario: any): void {
    const tarifaDestino = this.tarifaDestinoContratoControl?.value;
    const valorProgramaDesdeTarifa =
      this.obtenerValorTarifaProgramaSeleccionadaCambioPlan();
    const valorProgramaActual =
      Number(beneficiario.valorTarifaPrograma ?? 0) || 0;

    // Cambio de plan: los montos de programa vienen de info-contrato-user.
    // Al elegir programa/corte arriba se limpia la tarifa destino → no pisar con 0.
    if (this.esCambioPlanTipoSeleccionado() && !tarifaDestino) {
      const codigosAnexos = this.normalizarAnexosSeleccionadosCambioPlan(
        beneficiario.anexoDestino,
      );
      const valorTarifaAnexo = this.calcularValorTarifaAnexoCambioPlan(
        codigosAnexos,
        beneficiario,
      );
      beneficiario.valorTarifaAnexo = valorTarifaAnexo;
      beneficiario.totalTarifa = valorProgramaActual + valorTarifaAnexo;
      this.calcularTotalCuotaIva();
      return;
    }

    // Si la tarifa seleccionada no trae valor numérico, conservar el valor que vino del servicio.
    const valorProgramaFinal =
      valorProgramaDesdeTarifa == null
        ? valorProgramaActual
        : valorProgramaDesdeTarifa;
    beneficiario.valorTarifaPrograma = valorProgramaFinal;

    const codigosAnexos = this.normalizarAnexosSeleccionadosCambioPlan(
      beneficiario.anexoDestino,
    );
    const valorTarifaAnexo = this.calcularValorTarifaAnexoCambioPlan(
      codigosAnexos,
      beneficiario,
    );
    beneficiario.valorTarifaAnexo = valorTarifaAnexo;

    beneficiario.totalTarifa = valorProgramaFinal + valorTarifaAnexo;
    this.calcularTotalCuotaIva();
  }

  private calcularTotalCuotaIva(): void {
    const total = this.beneficiariosTarifa.reduce(
      (acc, beneficiario) => acc + (beneficiario.totalTarifa || 0),
      0,
    );
    /** Tarifas del backend ya incluyen IVA; no aplicar factor en front. */
    this.totalCuotaIva = total;
    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  private obtenerValorTarifaProgramaSeleccionadaCambioPlan(): number | null {
    const tarifa = this.tarifaDestinoContratoControl?.value;
    if (!tarifa || typeof tarifa !== 'object') {
      return null;
    }
    const raw =
      tarifa?.valorTarifa ??
      tarifa?.valor_tarifa ??
      tarifa?.valor ??
      tarifa?.VALOR ??
      null;
    if (raw == null || String(raw).trim() === '') {
      return null;
    }
    const num = Number(raw);
    return Number.isFinite(num) ? num : null;
  }

  private normalizarAnexosSeleccionadosCambioPlan(value: any): string[] {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map((v) => String(v ?? '').trim()).filter((v) => v !== '');
    }
    if (typeof value === 'string') {
      const v = value.trim();
      return v ? [v] : [];
    }
    return [];
  }

  private calcularValorTarifaAnexoCambioPlan(
    codigosAnexos: string[],
    beneficiario?: any,
  ): number {
    const anexosNorm = (codigosAnexos ?? [])
      .map((c) => String(c ?? '').trim())
      .filter(Boolean);
    if (!anexosNorm.length) return 0;

    const tieneNoAplica = anexosNorm.some(
      (c) => c.toUpperCase() === 'NO_APLICA',
    );

    // Si solo está "No aplica", el valor anexo debe ser 0.
    if (
      tieneNoAplica &&
      anexosNorm.every((c) => c.toUpperCase() === 'NO_APLICA')
    ) {
      return 0;
    }

    const porFila = (beneficiario?.anexosHabilitados ?? []) as any[];

    let total = 0;
    for (const codigo of anexosNorm) {
      const codigoNorm = codigo.toUpperCase();
      if (codigoNorm === 'NO_APLICA') continue;

      const anexo =
        porFila.find(
          (a: any) =>
            String(a?.codigo ?? '')
              .trim()
              .toUpperCase() === codigoNorm,
        ) ??
        (this.anexosDestinoContrato ?? []).find(
          (a: any) =>
            String(a?.codigo ?? '')
              .trim()
              .toUpperCase() === codigoNorm,
        ) ??
        (this.anexosDestino ?? []).find(
          (a: any) =>
            String(a?.codigo ?? '')
              .trim()
              .toUpperCase() === codigoNorm,
        );
      const valor = Number(anexo?.valorTarifa ?? 0) || 0;
      total += valor;
    }
    return total;
  }

  /** Tabla genérica (no tipo 5): opciones por integrante desde `filas` / `anexosHabilitados`. */
  opcionesAnexoDestinoGenerico(fila: any): any[] {
    if (
      Array.isArray(fila?.anexosHabilitados) &&
      fila.anexosHabilitados.length > 0
    ) {
      return fila.anexosHabilitados.filter(
        (a: any) =>
          String(a?.codigo ?? '')
            .trim()
            .toUpperCase() !== 'NO_APLICA',
      );
    }
    return this.anexosDestino ?? [];
  }

  /** Mostrar opción «Ninguno» (vacío) cuando el servicio incluye «No aplica» en la fila. */
  anexoGenericoIncluyeNinguno(fila: any): boolean {
    if (
      Array.isArray(fila?.anexosHabilitados) &&
      fila.anexosHabilitados.length > 0
    ) {
      return fila.anexosHabilitados.some(
        (a: any) =>
          String(a?.codigo ?? '')
            .trim()
            .toUpperCase() === 'NO_APLICA',
      );
    }
    return true;
  }

  /** Fila sin anexos parametrizados: selector deshabilitado (sin mezclar catálogo global). */
  anexoGenericoSinOpcionesElegibles(fila: any): boolean {
    return (
      fila?.anexoDestinoHabilitado === false &&
      (!fila?.anexosHabilitados || fila.anexosHabilitados.length === 0)
    );
  }

  private recalcularBeneficiariosCambioPlan(): void {
    for (const b of this.beneficiariosTarifa ?? []) {
      this.recalcularTarifasBeneficiario(b);
    }
  }

  private resetAnexosBeneficiariosCambioPlanNoAplica(): void {
    const noAplica = (this.anexosDestinoContrato ?? []).find(
      (a: any) =>
        String(a?.codigo ?? '')
          .trim()
          .toUpperCase() === 'NO_APLICA',
    ) ?? { codigo: 'NO_APLICA', nombre: 'No aplica', valorTarifa: 0 };

    for (const b of this.beneficiariosTarifa ?? []) {
      b.anexoDestino = ['NO_APLICA'];
      b.anexosHabilitados = [noAplica];
      b.valorTarifaAnexo = 0;
      b.totalTarifa = Number(b.valorTarifaPrograma ?? 0) + 0;
    }
    this.calcularTotalCuotaIva();
  }

  private cumpleCondicionesAnexoCambioPlan(
    beneficiario: any,
    condiciones: any,
  ): boolean {
    if (!condiciones) return true;

    const edad = Number(beneficiario?.edad ?? 0);

    const edadMinRaw = condiciones.edadMinima ?? condiciones.edad_minima;
    const edadMaxRaw = condiciones.edadMaxima ?? condiciones.edad_maxima;
    const edadMin =
      edadMinRaw === null || edadMinRaw === undefined || edadMinRaw === ''
        ? null
        : Number(edadMinRaw);
    const edadMax =
      edadMaxRaw === null || edadMaxRaw === undefined || edadMaxRaw === ''
        ? null
        : Number(edadMaxRaw);

    if (edadMin !== null && Number.isFinite(edadMin) && edad < edadMin) {
      return false;
    }
    if (edadMax !== null && Number.isFinite(edadMax) && edad > edadMax) {
      return false;
    }

    const generoCond = condiciones.genero ?? condiciones.sexo ?? null;
    if (
      generoCond !== null &&
      generoCond !== undefined &&
      String(generoCond).trim() !== ''
    ) {
      const gCond = String(generoCond).trim().toUpperCase();
      const gBen = String(beneficiario?.genero ?? '')
        .trim()
        .toUpperCase();
      if (gCond && gBen && gCond !== gBen) return false;
    }

    const parentescoCond = condiciones.parentesco ?? null;
    if (
      parentescoCond !== null &&
      parentescoCond !== undefined &&
      !(
        typeof parentescoCond === 'string' &&
        String(parentescoCond).trim() === ''
      ) &&
      !(Array.isArray(parentescoCond) && parentescoCond.length === 0)
    ) {
      const benParentescoCodigo = String(
        beneficiario?.parentescoDestino ?? '',
      ).trim();
      const benParentescoNombre = String(beneficiario?.parentesco ?? '').trim();
      const norm = (v: any) =>
        String(v ?? '')
          .trim()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase();

      const benCodes = [benParentescoCodigo, benParentescoNombre].map(norm);

      if (Array.isArray(parentescoCond)) {
        const lista = parentescoCond.map(norm).filter(Boolean);
        const ok = lista.some((c) => benCodes.includes(c));
        if (!ok) return false;
      } else {
        const condNorm = norm(parentescoCond);
        if (condNorm && !benCodes.includes(condNorm)) return false;
      }
    }

    return true;
  }

  private actualizarAnexosHabilitadosBeneficiariosCambioPlan(): void {
    if (!this.beneficiariosTarifa?.length) return;

    // Si ya se aplicó elegibilidad por `filas` (nro por integrante), no sobreescribir
    // con el catálogo global para evitar contaminar opciones entre filas.
    if (this.usarRespuestaFilasAnexoCambioPlan) {
      const esPlan = this.esCambioPlanTipoSeleccionado();
      for (const b of this.beneficiariosTarifa) {
        const row: any = b as any;
        const habilitados = Array.isArray(row?.anexosHabilitados)
          ? row.anexosHabilitados
          : [];
        const filaVacia = habilitados.length === 0;
        const tieneReal = habilitados.some(
          (a: any) =>
            String(a?.codigo ?? '')
              .trim()
              .toUpperCase() !== 'NO_APLICA',
        );
        const tieneNoAplicaOpcion = habilitados.some(
          (a: any) =>
            String(a?.codigo ?? '')
              .trim()
              .toUpperCase() === 'NO_APLICA',
        );
        if (filaVacia) {
          row.anexoDestinoHabilitado = false;
          row.anexoDestino = esPlan ? ['NO_APLICA'] : '';
        } else {
          row.anexoDestinoHabilitado = tieneReal || tieneNoAplicaOpcion;
        }
        this.recalcularTarifasBeneficiario(row);
      }
      this.calcularTotalCuotaIva();
      return;
    }
    const anexos = this.anexosDestinoContrato ?? [];

    const noAplicaDefault = {
      codigo: 'NO_APLICA',
      nombre: 'No aplica',
      valorTarifa: 0,
    };
    const noAplica =
      anexos.find(
        (a: any) =>
          String(a?.codigo ?? '')
            .trim()
            .toUpperCase() === 'NO_APLICA',
      ) ?? noAplicaDefault;
    const anexosSinNoAplica = anexos.filter(
      (a: any) =>
        String(a?.codigo ?? '')
          .trim()
          .toUpperCase() !== 'NO_APLICA',
    );

    const dedupeAnexosPorCodigo = (list: any[]): any[] => {
      const seen = new Set<string>();
      const out: any[] = [];
      for (const a of list) {
        const c = String(a?.codigo ?? '')
          .trim()
          .toUpperCase();
        if (!c || seen.has(c)) continue;
        seen.add(c);
        out.push(a);
      }
      return out;
    };

    for (const b of this.beneficiariosTarifa) {
      const srv = (b as any)._anexoServicio as
        | { codigo: string; nombre: string; valorTarifa?: number }
        | null
        | undefined;
      const extras: any[] = [];
      if (srv?.codigo) {
        const cSrv = String(srv.codigo).trim().toUpperCase();
        if (cSrv && cSrv !== 'NO_APLICA') {
          extras.push({
            codigo: String(srv.codigo).trim(),
            nombre: String(srv.nombre || srv.codigo).trim(),
            valorTarifa: Number(srv.valorTarifa ?? 0) || 0,
            condiciones: null,
          });
        }
      }

      const elegibles =
        anexosSinNoAplica.length > 0
          ? anexosSinNoAplica.filter((a: any) =>
              this.cumpleCondicionesAnexoCambioPlan(b, a?.condiciones),
            )
          : [];

      const habilitados = dedupeAnexosPorCodigo([
        ...extras,
        ...elegibles,
        noAplica,
      ]);

      b.anexosHabilitados = habilitados;

      // Validar selección actual contra lo permitido para este integrante.
      const codigosSeleccionados = this.normalizarAnexosSeleccionadosCambioPlan(
        b.anexoDestino,
      );
      const allowed = new Set(
        habilitados.map((a: any) =>
          String(a?.codigo ?? '')
            .trim()
            .toUpperCase(),
        ),
      );

      let codSelNorm = codigosSeleccionados
        .map((c) => String(c).trim().toUpperCase())
        .filter((c) => allowed.has(c));

      if (!codSelNorm.length) {
        codSelNorm = ['NO_APLICA'];
      }

      const tieneNoAplica = codSelNorm.includes('NO_APLICA');
      if (tieneNoAplica && codSelNorm.length > 1) {
        codSelNorm = codSelNorm.filter((c) => c !== 'NO_APLICA');
      }
      if (!codSelNorm.length) {
        codSelNorm = ['NO_APLICA'];
      }

      b.anexoDestino = codSelNorm;

      // Recalcular totales por integrante.
      this.recalcularTarifasBeneficiario(b);
    }
  }

  private async cargarTarifasDestino(): Promise<void> {
    const params = this.construirRequestTarifasCambioCobertura();

    this.tarifaDestinoControl.setValue(null, { emitEvent: false });

    if (!params) {
      console.info('Tarifas destino: faltan datos para consultar', {
        programaDestino: this.programaDestinoControl.value,
        lineaNegocio:
          this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato(),
      });
      this.tarifasDestino = [];
      this.checkValidacionCompletada();
      return;
    }

    try {
      const payload = params;

      console.info('Tarifas destino: consultando', payload);

      const tarifas = await firstValueFrom(
        this.tarifasDestinoService.getTarifasDestino(payload),
      );

      console.info('Tarifas destino: respuesta', tarifas);
      this.tarifasDestino = tarifas;

      if (tarifas.length === 1) {
        this.tarifaDestinoControl.setValue(tarifas[0], { emitEvent: false });
        this.tarifaDestinoControl.updateValueAndValidity();
      }
    } catch (error) {
      console.error('Error cargando tarifas destino:', error);
      this.tarifasDestino = [];
    } finally {
      this.checkValidacionCompletada();
    }
  }

  private mostrarMensajeTarifasNoEncontradas(): void {}

  private configurarListenersCamposDestino(): void {
    if (this.listenersCamposDestinoRegistrados) {
      return;
    }
    this.listenersCamposDestinoRegistrados = true;

    this.tipoPlanDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (tipoPlan) => {
        if (!tipoPlan) {
          return;
        }
        if (this.mostrarCampoColectivo) {
          const corte = this.corteSubcuentaControl.value;
          if (this.programaDestinoColectivoControl.value && corte?.codigo) {
            await this.cargarTarifasColectivo(String(corte.codigo));
          }
          return;
        }
        if (this.programaDestinoControl.value) {
          await this.cargarTarifasDestino();
        }
        await this.cargarAnexosDestino();
      });

    this.programaDestinoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (programa) => {
        if (this.mostrarCampoColectivo) {
          return;
        }
        if (programa) {
          this.tipoPrimaDestino = programa.tipoPrima || '';
          this.grupoProgramaDestino = programa.grupoPrograma || '';
          this.subcuentaDestino = programa.subcuenta || '';

          await this.cargarTarifasDestino();
          await this.cargarAnexosDestino();
        } else {
          if (this.debeHabilitarCheckboxIncluirAnexo()) {
            this.incluirAnexoControl.enable();
          } else {
            this.incluirAnexoControl.disable();
          }
          this.incluirAnexoControl.setValue(false, { emitEvent: false });
          this.tarifasDestino = [];
          this.anexosDestino = [];
        }
      });
  }

  private debeForzarIncluirAnexoHabilitado(): boolean {
    const subtipoNombre = String(
      this.subtipoNovedadControl.value?.nombre ?? '',
    ).trim();
    return SUBTIPOS_FORZAR_INCLUIR_ANEXO_HABILITADO.has(subtipoNombre);
  }

  /**
   * Subtipos de Cambio de cobertura con tabla activa: al marcar "Incluir anexo" se refresca
   * el catálogo y se aplican `filas` por integrante (misma validación de anexos en todos).
   */
  private esSubtipoCambioCoberturaConTablaActiva(): boolean {
    if (!this.esTipoNombre(this.selectedTipoNovedad, 'cambio de cobertura')) {
      return false;
    }
    const nombreSubtipo = String(
      this.selectedSubtipoNovedad?.nombre ??
        this.subtipoNovedadControl.value?.nombre ??
        '',
    ).trim();
    return SUBTIPOS_REGLA_TABLA_CAMBIO_COBERTURA.has(nombreSubtipo);
  }

  private ocultarCamposCambioCobertura(): void {
    this.mostrarCamposCambioCobertura = false;
    this.tipoPrimaObtenido = false;
    this.tipoPrimaConsultaOrigenKey = '';
    this.tipoPrimaOrigen = '';
    this.errorTipoPrima = null;
    this.advertenciaIntegrantesCambioCobertura = null;

    this.tipoPlanDestinoControl.setValue(null);
    this.programaDestinoControl.setValue(null);
    this.tarifaDestinoControl.setValue(null);
    this.corteDestinoControl.setValue(null);
    this.incluirAnexoControl.setValue(false);
    this.incluirAnexoControl.disable();

    this.tipoPlanDestinoControl.clearValidators();
    this.programaDestinoControl.clearValidators();
    this.tarifaDestinoControl.clearValidators();
    this.corteDestinoControl.clearValidators();

    this.tipoPlanDestinoControl.updateValueAndValidity();
    this.programaDestinoControl.updateValueAndValidity();
    this.tarifaDestinoControl.updateValueAndValidity();
    this.corteDestinoControl.updateValueAndValidity();
  }

  private ocultarTodasLasTablas(): void {
    this.cambioPlanActivo = false;
    this.mostrarTablaBeneficiarios = false;
    this.mostrarTablaIntegrantesContratoNuevo = false;
    this.mostrarTablaIntegrantesTrasladoExistente = false;
    this.mostrarCamposTrasladoContratoNuevo = false;
    this.mostrarCamposTrasladoContratoExistente = false;
    this.mostrarCampoColectivo = false;

    this.integrantesTrasladoExistente = [];
    this.integrantesContratoNuevo = [];
    this.beneficiariosTarifa = [];
  }

  public async loadColectivos(): Promise<void> {
    this.isLoadingColectivos = true;
    this.hasErrorColectivos = false;

    try {
      const colectivos = await firstValueFrom(
        this.cuentaColectivoCorporativoService.getColectivos(),
      );

      const colectivosOrdenados = (colectivos || []).sort((a, b) =>
        a.razonSocial.localeCompare(b.razonSocial),
      );

      this.colectivosSubject.next(colectivosOrdenados);
    } catch (error) {
      console.error('Error cargando colectivos:', error);
      this.hasErrorColectivos = true;
      this.colectivosSubject.next([]);
    } finally {
      this.isLoadingColectivos = false;
    }
  }

  public async cargarSubcuentasDestino(): Promise<void> {
    try {
      const lineaNegocio = this.obtenerLineaNegocioContrato();
      const tipoPlan = this.tipoPlanDestinoControl.value;
      const nombreTipoPlan = String(tipoPlan?.nombre ?? '').trim();
      if (!lineaNegocio || !nombreTipoPlan) {
        this.subcuentasDestino = [];
        return;
      }

      const subcuentas = await this.consultarSubcuentasInfomedical(
        lineaNegocio,
        nombreTipoPlan,
      );

      this.subcuentasDestino = (subcuentas || [])
        .map((subcuenta: any) => ({
          codigo: subcuenta.plan_codi,
          nombre: subcuenta.programa,
        }))
        .filter((s: any) => s.codigo && s.nombre);

      this.sucursalesDestino = [];
      this.programasDestinoColectivo = [];
      this.cortesSubcuenta = [];
      this.tarifasDestinoColectivo = [];

      this.sucursalDestinoControl.setValue(null);
      this.programaDestinoColectivoControl.setValue(null);
      this.corteSubcuentaControl.setValue(null);
      this.tarifaDestinoColectivoControl.setValue(null);

      // Habilitar campo de subcuenta
      this.subcuentaDestinoControl.enable();
    } catch (error) {
      console.error('Error cargando subcuentas destino:', error);
      this.subcuentasDestino = [];
    }
  }

  public async cargarSucursalesDestino(
    _codigoSubcuenta: string,
    opciones?: { modoRestauracion?: boolean },
  ): Promise<void> {
    try {
      this.sucursalesDestino = await this.obtenerSucursalesComerciales();

      // En restauración solo cargamos sucursales: no vaciar programa/cortes/tarifa ni la
      // lista `programasDestinoColectivo` (snapshot/API puede ir detrás del contrato padre).
      if (!opciones?.modoRestauracion) {
        this.programasDestinoColectivo = [];
        this.cortesSubcuenta = [];
        this.tarifasDestinoColectivo = [];

        this.programaDestinoColectivoControl.setValue(null);
        this.corteSubcuentaControl.setValue(null);
        this.tarifaDestinoColectivoControl.setValue(null);
      }

      this.sucursalDestinoControl.enable();

      if (opciones?.modoRestauracion) {
        return;
      }

      const sucursalContrato = this.obtenerSucursalContrato();
      const sucursalSeleccionada = sucursalContrato
        ? this.sucursalesDestino.find(
            (s) => s.codigo === sucursalContrato.codigo,
          )
        : null;

      if (sucursalSeleccionada) {
        this.sucursalDestinoControl.setValue(sucursalSeleccionada);
        await this.cargarProgramasColectivo(sucursalSeleccionada.codigo);
      } else if (this.sucursalesDestino.length === 1) {
        this.sucursalDestinoControl.setValue(this.sucursalesDestino[0]);
        await this.cargarProgramasColectivo(this.sucursalesDestino[0].codigo);
      }
    } catch (error) {
      console.error('Error cargando sucursales destino:', error);
      this.sucursalesDestino = [];
    }
  }

  public async cargarProgramasColectivo(
    _codigoSucursal: string,
    opts?: {
      preservarSiRespuestaVacia?: boolean;
      evitarLimpiarCascadaColectivoSiProgramaSigueEnLista?: boolean;
    },
  ): Promise<void> {
    const reqId = ++this.cargarProgramasColectivoRequestId;
    try {
      const programasLn = await this.consultarProgramasDestinoCambioCobertura();

      if (reqId !== this.cargarProgramasColectivoRequestId) {
        return;
      }

      const mapped = (programasLn || []).map((programa) => ({
        codigo: programa.codigo,
        nombre: programa.nombre ?? programa.programa,
        programa: programa.programa ?? programa.nombre,
        grupoPrograma: programa.grupoPrograma ?? '',
        grupoProgramaTexto:
          programa.grupoProgramaTexto ?? programa.grupoPrograma ?? '',
        ...(programa.tipoPrima ? { tipoPrima: programa.tipoPrima } : {}),
      }));

      if (mapped.length > 0) {
        const codProgCtrl = String(
          this.programaDestinoColectivoControl.value?.codigo ?? '',
        ).trim();
        const programaSigueEnLista =
          !!codProgCtrl &&
          mapped.some((p) => String(p?.codigo ?? '').trim() === codProgCtrl);
        const preservarCascadaColectivo =
          opts?.evitarLimpiarCascadaColectivoSiProgramaSigueEnLista === true &&
          programaSigueEnLista;

        this.programasDestinoColectivo = mapped;

        if (!preservarCascadaColectivo) {
          this.cortesSubcuenta = [];
          this.tarifasDestinoColectivo = [];
          this.corteSubcuentaControl.setValue(null);
          this.tarifaDestinoColectivoControl.setValue(null);
        }

        if (mapped.length === 1) {
          const unicoPrograma = mapped[0];
          const unicoCod = String(unicoPrograma.codigo ?? '').trim();
          if (preservarCascadaColectivo && codProgCtrl === unicoCod) {
            this.programaDestinoColectivoControl.setValue(unicoPrograma, {
              emitEvent: false,
            });
          } else {
            this.programaDestinoColectivoControl.setValue(unicoPrograma);
            await this.cargarCortesSubcuenta(unicoPrograma.codigo);
          }
        } else if (mapped.length > 1) {
          this.ajustarProgramaColectivoAMismaReferenciaEnLista();
        }
      } else if (!opts?.preservarSiRespuestaVacia) {
        this.programasDestinoColectivo = [];
        this.cortesSubcuenta = [];
        this.tarifasDestinoColectivo = [];

        this.corteSubcuentaControl.setValue(null);
        this.tarifaDestinoColectivoControl.setValue(null);
      }

      this.programaDestinoColectivoControl.enable();
    } catch (error) {
      console.error('Error cargando programas colectivo:', error);
      if (!opts?.preservarSiRespuestaVacia) {
        this.programasDestinoColectivo = [];
        this.cortesSubcuenta = [];
        this.tarifasDestinoColectivo = [];
        this.corteSubcuentaControl.setValue(null);
        this.tarifaDestinoColectivoControl.setValue(null);
      }
    }
  }

  /**
   * Tras F5: si el padre aún no había llenado contrato, la lista pudo quedar vacía.
   * Reintenta cuando ya tenemos sucursal; al abrir el desplegable también (template).
   */
  private async asegurarProgramasColectivoTrasRestauracion(): Promise<void> {
    if (!this.mostrarCampoColectivo) {
      return;
    }
    await this.refrescarListaProgramasColectivoSiVacía();
    if ((this.programasDestinoColectivo?.length ?? 0) === 0) {
      await new Promise<void>((resolve) => window.setTimeout(resolve, 400));
      await this.refrescarListaProgramasColectivoSiVacía();
    }
  }

  public onPanelProgramaColectivoOpenedChange(abierto: boolean): void {
    if (!abierto || this.disabled) {
      return;
    }
    void this.refrescarListaProgramasColectivoSiVacía();
  }

  private async refrescarListaProgramasColectivoSiVacía(): Promise<void> {
    if (!this.mostrarCampoColectivo) {
      return;
    }
    const suc = this.sucursalDestinoControl.value;
    const codSuc = String(suc?.codigo ?? '').trim();
    if (!codSuc) {
      return;
    }
    if ((this.programasDestinoColectivo?.length ?? 0) > 0) {
      this.ajustarProgramaColectivoAMismaReferenciaEnLista();
      return;
    }
    await this.cargarProgramasColectivo(codSuc, {
      preservarSiRespuestaVacia: true,
      evitarLimpiarCascadaColectivoSiProgramaSigueEnLista: true,
    });
    this.ajustarProgramaColectivoAMismaReferenciaEnLista();
  }

  /** Alinea el valor del control con un elemento de `programasDestinoColectivo` (mat-select por referencia). */
  private ajustarProgramaColectivoAMismaReferenciaEnLista(): void {
    const v = this.programaDestinoColectivoControl.value;
    const cod = String(v?.codigo ?? '').trim();
    if (!cod || !this.programasDestinoColectivo?.length) {
      return;
    }
    const match = this.programasDestinoColectivo.find(
      (p) => String(p?.codigo ?? '').trim() === cod,
    );
    if (match) {
      this.programaDestinoColectivoControl.setValue(match, {
        emitEvent: false,
      });
    }
  }

  private ajustarCorteSubcuentaAMismaReferenciaEnLista(): void {
    const v = this.corteSubcuentaControl.value;
    const cod = String(v?.codigo ?? '').trim();
    if (!cod || !this.cortesSubcuenta?.length) {
      return;
    }
    const match = this.cortesSubcuenta.find(
      (c) => String(c?.codigo ?? '').trim() === cod,
    );
    if (match) {
      this.corteSubcuentaControl.setValue(match, { emitEvent: false });
    }
  }

  private ajustarTarifaDestinoColectivoAMismaReferenciaEnLista(): void {
    const v = this.tarifaDestinoColectivoControl.value;
    const cod = String(v?.codigo ?? '').trim();
    if (!cod || !this.tarifasDestinoColectivo?.length) {
      return;
    }
    const match = this.tarifasDestinoColectivo.find(
      (t) => String(t?.codigo ?? '').trim() === cod,
    );
    if (match) {
      this.tarifaDestinoColectivoControl.setValue(match, { emitEvent: false });
    }
  }

  public async cargarCortesSubcuenta(
    _codigoPrograma: string,
    opts?: { preservarSiError?: boolean },
  ): Promise<void> {
    try {
      const rawCortes = await firstValueFrom(this.cortesService.getCortes());
      const cortes = Array.isArray(rawCortes)
        ? rawCortes
        : (rawCortes as any)?.cortes || (rawCortes as any)?.data || [];

      this.cortesSubcuenta = (cortes || [])
        .map((corte: any) => {
          if (typeof corte === 'number' || typeof corte === 'string') {
            const codigo = corte.toString().trim();
            return codigo ? { codigo, nombre: `Corte ${codigo}` } : null;
          }

          const codigo = (corte.corte ?? corte.codigo ?? corte.id ?? '')
            .toString()
            .trim();

          if (!codigo) {
            return null;
          }

          return {
            codigo,
            nombre: `Corte ${codigo}`,
          };
        })
        .filter((corte: any) => corte);

      this.tarifasDestinoColectivo = [];
      this.tarifaDestinoColectivoControl.setValue(null);

      this.corteSubcuentaControl.enable();
    } catch (error) {
      console.error('Error cargando cortes subcuenta:', error);
      if (!opts?.preservarSiError) {
        this.cortesSubcuenta = [];
      }
    }
  }

  public async cargarTarifasColectivo(
    _codigoCorte: string,
    opts?: { preservarSiVacio?: boolean },
  ): Promise<void> {
    try {
      const params = this.construirRequestTarifasCambioCobertura();
      if (!params) {
        if (!opts?.preservarSiVacio) {
          this.tarifasDestinoColectivo = [];
        }
        return;
      }

      const tarifas = await firstValueFrom(
        this.tarifasDestinoService.getTarifasDestino(params),
      );

      const mapped = (tarifas || []).map((tarifa) => ({
        codigo: tarifa.codigo,
        descripcion: String(tarifa.descripcion ?? tarifa.nombre ?? '').trim(),
        nombre: tarifa.nombre || tarifa.descripcion,
        valorTarifa: Number(tarifa.valorTarifa ?? 0) || 0,
      }));

      if (mapped.length > 0) {
        this.tarifasDestinoColectivo = mapped;
      } else if (!opts?.preservarSiVacio) {
        this.tarifasDestinoColectivo = [];
      }

      if (tarifas.length === 1) {
        this.tarifaDestinoColectivoControl.setValue(tarifas[0], {
          emitEvent: false,
        });
        this.tarifaDestinoColectivoControl.updateValueAndValidity();
      }

      this.tarifaDestinoColectivoControl.enable();
    } catch (error) {
      console.error('Error cargando tarifas colectivo:', error);
      if (!opts?.preservarSiVacio) {
        this.tarifasDestinoColectivo = [];
      }
    } finally {
      this.checkValidacionCompletada();
    }
  }

  private obtenerProgramaContrato(): string {
    const fila = this.obtenerFilaContratoOrigenParaTarifas();
    return String(fila?.ProgramaCodigo ?? '').trim();
  }

  private obtenerTipoPlanContratoOrigen(): string {
    const fila = this.filaContratoAfilmedPaso1;
    const desdeFila = String(fila?.TipoPlan ?? '').trim();
    if (desdeFila) {
      return desdeFila;
    }

    const storage = this.obtenerContratoDesdeStorage();
    const desdeStorage = String(storage?.TipoPlan ?? '').trim();
    if (desdeStorage) {
      return desdeStorage;
    }

    return '';
  }

  private obtenerCuentaContratoOrigen(): string {
    return leerCuentaAfilmed(this.obtenerFilaContratoOrigenParaTarifas());
  }

  /**
   * Cambio de tarifa: `prm_tipo_plan` desde `cuenta` del servicio contratos (no `TipoPlan`).
   * Si viene `2 - FAMILIAR`, solo la parte **después** del guion (`FAMILIAR`).
   */
  private normalizarCuentaParaPrmTipoPlanCambioTarifa(raw: string): string {
    const s = String(raw ?? '').trim();
    if (!s) {
      return '';
    }

    const despuesDeGuion = s.match(/^\d+\s*-\s*(.+)$/);
    if (despuesDeGuion?.[1]) {
      return despuesDeGuion[1].replace(/\s+/g, ' ').trim();
    }

    if (s.includes('|')) {
      const right = String(s.split('|').slice(-1)[0] ?? '').trim();
      if (right) {
        return right.replace(/\s+/g, ' ').trim();
      }
    }

    const codigo = this.extraerCodigoCuentaCotizadorTrl(s);
    return codigo || s.replace(/\s+/g, ' ').trim();
  }

  /**
   * Cambio de tarifa: `prm_tipo_plan` lleva la **cuenta** del contrato (parametrización `idPlan` en BD).
   */
  private construirPrmPlanDesdeCuentaContratoParaCambioTarifa(): string {
    const raw = this.obtenerCuentaContratoOrigen();
    if (!raw) {
      return '';
    }
    return this.normalizarCuentaParaPrmTipoPlanCambioTarifa(raw);
  }

  /**
   * Texto del tipo plan destino seleccionado para `prm_tipo_plan` en tarifas
   * (ej. `FAMILIAR`, `ACU|ACUERDO CORPORATI...`).
   */
  private obtenerPrmTipoPlanTarifasDesdePlanDestinoSeleccionado(): string {
    const plan = this.usaSelectoresDestinoContratoParaTarifas()
      ? this.tipoPlanDestinoContratoControl.value
      : this.tipoPlanDestinoControl.value;
    if (!plan) {
      return '';
    }
    return String(plan.nombre ?? plan.descripcion ?? plan.codigo ?? '').trim();
  }

  /**
   * POST `cambio-tarifa/tarifas`: `prm_tipo_plan` = plan destino elegido en el selector;
   * respaldo con `TipoPlan` del contrato origen si aún no hay selección.
   */
  private construirPrmTipoPlanParaTarifasDesdeContrato(): string {
    const desdeSeleccion =
      this.obtenerPrmTipoPlanTarifasDesdePlanDestinoSeleccionado();
    if (desdeSeleccion) {
      return desdeSeleccion;
    }

    const raw = String(this.obtenerTipoPlanContratoOrigen() ?? '').trim();
    if (!raw) {
      return '';
    }

    if (raw.includes('|')) {
      const right = String(raw.split('|')[1] ?? '').trim();
      if (right) {
        return right.replace(/\s+/g, ' ').toUpperCase();
      }
    }

    return raw.replace(/\s+/g, ' ').toUpperCase();
  }

  /**
   * Texto completo del programa destino para `prm_programa` en tarifas
   * (ej. `ORO | ORO`, `ABTT.COM - ABTT.COM | ABOUTTI I...`).
   */
  private obtenerPrmProgramaTarifasDesdeProgramaDestinoSeleccionado(): string {
    if (this.usaSelectoresDestinoContratoParaTarifas()) {
      const prog = this.programaDestinoContratoControl.value;
      if (!prog) {
        return '';
      }
      const directo = String(prog.programa ?? '').trim();
      if (directo) {
        return directo;
      }
      const codigo = String(prog.codigo ?? '').trim();
      const nombre = String(prog.nombre ?? '').trim();
      if (codigo && nombre) {
        return `${codigo} | ${nombre}`;
      }
      return nombre || codigo;
    }

    const prog = this.mostrarCampoColectivo
      ? this.programaDestinoColectivoControl.value
      : this.programaDestinoControl.value;
    if (!prog) {
      return '';
    }
    return String(
      prog.programa ?? prog.nombre ?? prog.descripcion ?? '',
    ).trim();
  }

  /**
   * POST `cambio-tarifa/tarifas`: `prm_programa` = programa destino elegido
   * (texto del ítem en el selector, no solo el código de grupo).
   */
  private construirPrmProgramaParaTarifasDesdeContrato(): string {
    const desdeSeleccion =
      this.obtenerPrmProgramaTarifasDesdeProgramaDestinoSeleccionado();
    if (desdeSeleccion) {
      return desdeSeleccion;
    }
    const desdeDestino = String(this.grupoProgramaDestino ?? '').trim();
    if (desdeDestino) {
      return desdeDestino;
    }
    return this.obtenerGrupoProgramaDesdeContratoSeleccionadoPaso1();
  }

  /**
   * Cambio de cobertura (incl. traslado a colectivo): tarifas con línea del contrato
   * origen y plan/programa destino seleccionados en el formulario.
   */
  private construirRequestTarifasCambioCobertura(): TarifasDestinoRequest | null {
    const prm_linea_negocio =
      this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato();
    const prm_tipo_plan = this.construirPrmTipoPlanParaTarifasDesdeContrato();
    const prm_programa = this.construirPrmProgramaParaTarifasDesdeContrato();
    if (!prm_linea_negocio || !prm_tipo_plan || !prm_programa) {
      return null;
    }
    return { prm_linea_negocio, prm_tipo_plan, prm_programa };
  }

  /**
   * Cambio de plan y traslado a contrato nuevo: tarifas con línea del contrato origen
   * y plan/programa destino elegidos en `tipoPlanDestinoContratoControl` /
   * `programaDestinoContratoControl`.
   */
  private construirRequestTarifasCambioPlan(): TarifasDestinoRequest | null {
    const prm_linea_negocio =
      this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato();
    const prm_tipo_plan =
      this.obtenerPrmTipoPlanTarifasDesdePlanDestinoSeleccionado();
    const prm_programa =
      this.obtenerPrmProgramaTarifasDesdeProgramaDestinoSeleccionado();
    if (!prm_linea_negocio || !prm_tipo_plan || !prm_programa) {
      if (!environment.production) {
        console.info('[cambio-plan] Faltan datos para tarifas:', {
          prm_linea_negocio: prm_linea_negocio || '(vacío)',
          prm_tipo_plan: prm_tipo_plan || '(vacío)',
          prm_programa: prm_programa || '(vacío)',
          tipoPlanDestino: this.tipoPlanDestinoContratoControl.value,
          programaDestino: this.programaDestinoContratoControl.value,
        });
      }
      return null;
    }
    return { prm_linea_negocio, prm_tipo_plan, prm_programa };
  }

  private construirTarifasDestinoRequestDesdeContrato(): TarifasDestinoRequest | null {
    return this.construirRequestTarifasCambioCobertura();
  }

  /**
   * Solo el código de línea de negocio (antes de `|`), p. ej. `1 | SMP-MEDICINA INTEGRAL` → `1`.
   * Mismo criterio que el POST esperado: `"prm_linea_negocio":"1",...`
   */
  private construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato(): string {
    const raw = String(this.obtenerLineaNegocioContrato() ?? '').trim();
    if (!raw) {
      return '';
    }
    const antesPipe = raw.includes('|')
      ? (raw.split('|')[0]?.trim() ?? '')
      : raw;
    if (!antesPipe) {
      return '';
    }
    const soloNumero = antesPipe.match(/^(\d+)/);
    return soloNumero ? soloNumero[1] : antesPipe;
  }

  /**
   * POST `cambio-tarifa/tarifas` — `prm_tipo_plan` = cuenta del contrato (no TipoPlan), p. ej.:
   * `{"prm_linea_negocio":"1","prm_tipo_plan":"12","prm_programa":"ASOA"}`
   * (`prm_programa` = GrupoPrograma del contrato).
   */
  private construirRequestTarifasCambioOrigen(): TarifasDestinoRequest | null {
    const prm_linea_negocio =
      this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato();
    const prm_tipo_plan =
      this.construirPrmPlanDesdeCuentaContratoParaCambioTarifa();
    const prm_programa =
      this.obtenerGrupoProgramaDesdeContratoSeleccionadoPaso1();
    if (!prm_linea_negocio || !prm_tipo_plan || !prm_programa) {
      if (!environment.production) {
        const fila = this.obtenerFilaContratoOrigenParaTarifas();
        console.warn('[cambio-tarifa] No se arma request — faltan datos:', {
          prm_linea_negocio: prm_linea_negocio || '(vacío)',
          prm_tipo_plan: prm_tipo_plan || '(vacío)',
          prm_programa: prm_programa || '(vacío)',
          cuenta: leerCuentaAfilmed(fila),
          TipoPlan: fila?.TipoPlan,
          LineaNegocio: fila?.LineaNegocio,
          GrupoPrograma: fila?.GrupoPrograma,
          numeroContratoPaso1: this.numeroContratoPaso1,
        });
      }
      return null;
    }
    return {
      prm_linea_negocio,
      prm_tipo_plan,
      prm_programa,
    };
  }

  private obtenerGrupoProgramaContrato(): string {
    if (this.grupoProgramaDestino) {
      return this.grupoProgramaDestino.toString().trim();
    }

    const fila = this.filaContratoAfilmedPaso1;
    const grupoDesdeFila = String(fila?.GrupoPrograma ?? '').trim();
    if (grupoDesdeFila) {
      return grupoDesdeFila;
    }

    const grupoPrograma = (this.contratoSeleccionado?.GrupoPrograma || '')
      .toString()
      .trim();
    if (grupoPrograma) {
      return grupoPrograma;
    }

    const contratoStorage = this.obtenerContratoDesdeStorage();
    return (contratoStorage?.GrupoPrograma || '').toString().trim();
  }

  private sincronizarGrupoProgramaDestinoDesdeSubcuentaColectivo(): void {
    if (!this.mostrarCampoColectivo) {
      return;
    }
    const sub = this.subcuentaDestinoControl?.value;
    const desdeSub = sub?.codigo;
    if (desdeSub) {
      this.grupoProgramaDestino = desdeSub;
    }
  }

  private obtenerLineaNegocioContrato(): string {
    const fila = this.obtenerFilaContratoOrigenParaTarifas();
    return String(
      fila?.LineaNegocio ?? this.contratoSeleccionado?.LineaNegocio ?? '',
    ).trim();
  }

  private obtenerContratoDesdeStorage(): any {
    const state = this.localStorageService.load('frmConsultState');
    const contratos = state?.contratosData || [];
    const numero = String(
      this.numeroContratoPaso1 ??
        state?.selectedContract ??
        this.contratoSeleccionado?.numero ??
        '',
    ).trim();
    if (!numero || !Array.isArray(contratos)) {
      return null;
    }

    return (
      contratos.find(
        (contrato: any) =>
          String(contrato.contrato ?? contrato.Contrato ?? '').trim() ===
          numero,
      ) || null
    );
  }

  /** Fila Afilmed del contrato origen (paso 1) para tarifas y parametrización. */
  private obtenerFilaContratoOrigenParaTarifas(): ContratoAfilmedDTO | null {
    if (this.filaContratoAfilmedPaso1) {
      return this.filaContratoAfilmedPaso1;
    }
    const storage = this.obtenerContratoDesdeStorage();
    if (storage) {
      return storage as ContratoAfilmedDTO;
    }
    const paso1 = this.obtenerContratoPaso1();
    return paso1 ? (paso1 as ContratoAfilmedDTO) : null;
  }

  private obtenerSucursalContrato(): { codigo: string; nombre: string } | null {
    const contratoStorage = this.obtenerContratoDesdeStorage();
    const sucursal = (contratoStorage?.Sucursal || '').toString().trim();

    if (!sucursal) {
      return null;
    }

    return {
      codigo: sucursal,
      nombre: sucursal,
    };
  }

  private async ejecutarCascadaSubcuentaColectivo(
    subcuenta: any,
  ): Promise<void> {
    this.grupoProgramaDestino = subcuenta?.codigo || this.grupoProgramaDestino;
    await this.cargarSucursalesDestino(subcuenta.codigo);
  }

  private async ejecutarCascadaSucursalColectivo(sucursal: any): Promise<void> {
    await this.cargarProgramasColectivo(sucursal.codigo);
  }

  private async ejecutarCascadaProgramaColectivo(programa: any): Promise<void> {
    this.grupoProgramaDestino = String(programa?.grupoPrograma ?? '').trim();
    await this.cargarCortesSubcuenta(programa.codigo);
    const corte = this.corteSubcuentaControl.value;
    if (corte?.codigo) {
      await this.cargarTarifasColectivo(String(corte.codigo));
    }
  }

  private filterContratosDestino(contratos: any[], filterText: string): any[] {
    if (!filterText) {
      return contratos;
    }

    const normalizedFilter = filterText.toLowerCase().trim();
    return contratos.filter(
      (contrato) =>
        String(contrato?.codigo ?? '')
          .toLowerCase()
          .includes(normalizedFilter) ||
        String(contrato?.tipoPlan ?? '')
          .toLowerCase()
          .includes(normalizedFilter) ||
        String(contrato?.nombrePrograma ?? '')
          .toLowerCase()
          .includes(normalizedFilter),
    );
  }

  /** Selección única: marca visual en la lista desplegable. */
  public isContratoDestinoOpcionSeleccionada(contrato: any): boolean {
    const codigoSel =
      this.contratoDestinoSeleccionadoCodigo ??
      String(this.contratoDestinoControl.value?.codigo ?? '').trim();
    if (!codigoSel) {
      return false;
    }
    return String(contrato?.codigo ?? '').trim() === codigoSel;
  }

  public compareContratoDestino = (a: any, b: any): boolean => {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }
    return String(a.codigo ?? '').trim() === String(b.codigo ?? '').trim();
  };

  public trackByProgramaCodigo = (index: number, item: any): string => {
    return item?.codigo || index.toString();
  };

  public trackBySubcuentaCodigo = (index: number, item: any): string => {
    return item?.codigo || index.toString();
  };

  public trackByTarifaCodigo = (index: number, item: any): string => {
    return item?.codigo || index.toString();
  };

  public async cargarTiposPlanesContratoNuevo(): Promise<void> {
    try {
      const tipos = await firstValueFrom(
        this.tiposPlanService.getTiposPlanes(
          this.obtenerIndicadorColectivoTiposPlanes(),
        ),
      );

      const uniq = new Map<string, any>();
      for (const t of tipos || []) {
        const codigo = String((t as any).codigo ?? '').trim();
        const nombre = String((t as any).nombre ?? '').trim();
        if (!codigo || !nombre) continue;

        // Heurística: si el backend ya entrega solo "comercialización" y activos, este filtro no afecta.
        const indicativo = String((t as any).indicativo ?? '').toUpperCase();
        if (
          indicativo &&
          ['N', 'NO', '0', 'INACTIVO', 'INACTIVE'].includes(indicativo)
        ) {
          continue;
        }

        if (!uniq.has(codigo)) {
          uniq.set(codigo, {
            codigo,
            nombre,
            indicativo: (t as any).indicativo,
          });
        }
      }

      this.tiposPlanesContratoNuevo = Array.from(uniq.values()).sort((a, b) =>
        String(a.nombre).localeCompare(String(b.nombre)),
      );
    } catch (error) {
      console.error('Error cargando tipos de plan (Cambio de plan):', error);
      this.tiposPlanesContratoNuevo = [];
    }
  }

  public async cargarProgramasContratoNuevo(_tipoPlan?: any): Promise<void> {
    this.isLoadingProgramasContrato = true;
    this.hasErrorProgramasContrato = false;
    this.errorTrasladoContrato = '';

    try {
      const finalList = await this.consultarProgramasDestinoCambioCobertura();

      if (!finalList.length) {
        this.programasContratoSubject.next([]);
        if (!this.errorTrasladoContrato) {
          this.errorTrasladoContrato =
            'No existen programas disponibles para la línea de negocio del contrato origen.';
        }
        return;
      }

      this.programasContratoSubject.next(finalList);
    } catch (error) {
      console.error('Error cargando programas destino:', error);
      this.hasErrorProgramasContrato = true;
      this.programasContratoSubject.next([]);
      this.errorTrasladoContrato =
        'No fue posible cargar los programas destino. Verifique el servicio o intente nuevamente.';
    } finally {
      this.isLoadingProgramasContrato = false;
    }
  }

  public async cargarSubcuentasContratoNuevo(_programa?: any): Promise<void> {
    this.isLoadingSubcuentasContrato = true;

    try {
      const lineaNegocio = this.obtenerLineaNegocioContrato();
      const tipoPlan = this.tipoPlanDestinoContratoControl.value;
      const nombreTipoPlan = String(tipoPlan?.nombre ?? '').trim();
      if (!lineaNegocio || !nombreTipoPlan) {
        this.subcuentasContratoSubject.next([]);
        return;
      }

      const subcuentas = await this.consultarSubcuentasInfomedical(
        lineaNegocio,
        nombreTipoPlan,
      );

      const mapped = (subcuentas || [])
        .map((s: any) => ({
          codigo: s.plan_codi,
          nombre: s.programa,
        }))
        .filter((s: any) => s.codigo && s.nombre);

      this.subcuentasContratoSubject.next(mapped);
    } catch (error) {
      console.error('Error cargando subcuentas:', error);
      this.subcuentasContratoSubject.next([]);
    } finally {
      this.isLoadingSubcuentasContrato = false;
    }
  }

  private consultarSubcuentasInfomedical(
    lineaNegocio: string,
    tipoPlan: string,
  ): Promise<any[]> {
    return firstValueFrom(
      this.infomedicalSubcuentaProgramaService.getSubcuentasPrograma(
        lineaNegocio,
        tipoPlan,
      ),
    );
  }

  public async cargarCortesDestinoContrato(subcuenta: any): Promise<void> {
    try {
      const tipoPlan = this.tipoPlanDestinoContratoControl.value;
      this.isCorteDestinoReadonly =
        tipoPlan?.codigo === 'COL' || tipoPlan?.codigo === 'ACO';

      // MP-FT-1358 1.1.3.5: "Corte destino" debe contener el valor del corte de la subcuenta seleccionada.
      const corteValue =
        subcuenta?.corte ??
        subcuenta?.Corte ??
        subcuenta?.diaCorte ??
        subcuenta?.DiaCorte ??
        null;

      if (
        corteValue !== null &&
        corteValue !== undefined &&
        corteValue !== ''
      ) {
        this.cortesDestinoContrato = [{ corte: corteValue }];
        this.corteDestinoContratoControl.setValue(corteValue, {
          emitEvent: false,
        });
        // Si ya se definió el corte según la subcuenta, cargar tarifas para habilitar el siguiente campo.
        await this.cargarTarifasContratoNuevo();
        return;
      }

      // Fallback: si el backend no entrega el corte en la subcuenta,
      // cargar el catálogo completo de cortes.
      const data = await firstValueFrom(this.cortesService.getCortes());
      this.cortesDestinoContrato = data || [];

      if (this.cortesDestinoContrato.length > 0) {
        // Mantener el estado del control coherente (obligatorio).
        this.corteDestinoContratoControl.setValue(
          this.cortesDestinoContrato[0].corte,
          { emitEvent: false },
        );

        // Cargar tarifas asociadas para el siguiente paso.
        await this.cargarTarifasContratoNuevo();
      } else {
        this.corteDestinoContratoControl.setValue(null, { emitEvent: false });
      }
    } catch (error) {
      console.error('Error cargando cortes destino (Cambio de plan):', error);
      this.cortesDestinoContrato = [];
      this.corteDestinoContratoControl.setValue(null, { emitEvent: false });
    }
  }

  public async cargarTarifasContratoNuevo(): Promise<void> {
    this.isLoadingTarifasContrato = true;
    this.hasErrorTarifasContrato = false;

    // Limpiar selección actual de tarifa para evitar incoherencias.
    this.tarifaDestinoContratoControl.setValue(null, { emitEvent: false });
    this.tarifasContratoSubject.next([]);

    try {
      const params = this.usaSelectoresDestinoContratoParaTarifas()
        ? this.construirRequestTarifasCambioPlan()
        : this.construirRequestTarifasCambioOrigen();
      if (!params) {
        this.hasErrorTarifasContrato = true;
        return;
      }

      if (!environment.production) {
        console.info('[contrato-nuevo] Consultando tarifas:', params);
      }

      const tarifas = await firstValueFrom(
        this.tarifasDestinoService.getTarifasDestino(params),
      );

      const lista = (tarifas || []).map((t: any) => ({
        codigo: String(t.codigo ?? '').trim(),
        descripcion: String(t.descripcion ?? t.nombre ?? '').trim(),
        nombre: String(t.nombre ?? t.descripcion ?? '').trim(),
        valorTarifa:
          Number(
            t.valorTarifa ??
              t.valor_tarifa ??
              t.valor ??
              t.valorTarifaPrograma ??
              t.tarifa ??
              0,
          ) || 0,
      }));

      if (lista.length === 0) {
        this.hasErrorTarifasContrato = true;
        this.tarifasContratoSubject.next([]);
        return;
      }

      this.tarifasContratoSubject.next(lista);

      if (lista.length === 1) {
        this.tarifaDestinoContratoControl.setValue(lista[0], {
          emitEvent: false,
        });
        this.tarifaDestinoColectivoControl.updateValueAndValidity();
      }
    } catch (error) {
      console.error('Error cargando tarifas (Cambio de plan):', error);
      this.hasErrorTarifasContrato = true;
      this.tarifasContratoSubject.next([]);
    } finally {
      this.isLoadingTarifasContrato = false;
    }
  }

  public async cargarSucursalesComercializablesContrato(): Promise<void> {
    try {
      const subcuenta = this.subcuentaDestinoContratoControl.value;

      const tipoPlan = this.tipoPlanDestinoContratoControl.value;

      this.isSucursalComercializableReadonly =
        tipoPlan?.codigo === 'COL' || tipoPlan?.codigo === 'ACO';

      const partidos = await this.obtenerSucursalesComerciales();

      const codigoSucursal =
        subcuenta?.sucursalComercializable ??
        subcuenta?.sucursal_comercializable ??
        subcuenta?.sucursal ??
        subcuenta?.Sucursal ??
        subcuenta?.partido ??
        (this.contratoSeleccionado as any)?.Sucursal ??
        null;

      const codigoNorm = codigoSucursal ? String(codigoSucursal).trim() : '';

      let sucursalEncontrada: any | null = null;
      if (codigoNorm) {
        sucursalEncontrada = partidos.find(
          (p: any) => String(p.codigo ?? '').trim() === codigoNorm,
        );
      }

      if (sucursalEncontrada) {
        this.sucursalesComercializablesContrato = [sucursalEncontrada];
        this.sucursalComercializableContratoControl.setValue(
          sucursalEncontrada,
          { emitEvent: false },
        );
      } else {
        // No debería ocurrir si la subcuenta viene completa desde Afilmed.
        this.sucursalesComercializablesContrato = partidos;
        if (this.isSucursalComercializableReadonly) {
          this.sucursalComercializableContratoControl.setValue(null, {
            emitEvent: false,
          });
        } else {
          // Para flujos donde el campo es editable, dejar al usuario seleccionar.
          this.sucursalComercializableContratoControl.setValue(null, {
            emitEvent: false,
          });
        }
      }
    } catch (error) {
      console.error(
        'Error cargando sucursales comercializables (Cambio de plan):',
        error,
      );
      this.sucursalesComercializablesContrato = [];
      this.sucursalComercializableContratoControl.setValue(null, {
        emitEvent: false,
      });
    }
  }

  private async obtenerSucursalesComerciales(): Promise<any[]> {
    if (this.partidosComercialesCache) {
      return this.partidosComercialesCache;
    }

    const partidos = await firstValueFrom(
      this.partidosComercialesService.getPartidosComerciales(),
    );

    this.partidosComercialesCache = (partidos || [])
      .map((item: any) => ({
        codigo: (item.partido ?? item.codigo ?? '').toString().trim(),
        nombre: (item.descripcion ?? item.nombre ?? '').toString().trim(),
      }))
      .filter((item: any) => item.codigo);

    return this.partidosComercialesCache;
  }

  public async validarAnexosActivosContrato(
    programa: any,
    forceRefresh = false,
  ): Promise<void> {
    try {
      const payloadConsulta =
        this.construirPayloadConsultaAnexosContratoOrigen();
      if (payloadConsulta?.grupoPrograma) {
        try {
          const resp = await firstValueFrom(
            this.adicionaAnexoConsultaService.consulta(payloadConsulta),
          );
          let catalog = this.extraerAnexosDesdeRespuestaConsulta(resp);
          if (
            catalog.length === 0 &&
            Array.isArray(resp?.filas) &&
            resp.filas.length > 0
          ) {
            catalog = this.catalogoAgregadoDesdeOpcionesFilas(
              resp.filas as any[],
            );
          }
          if (catalog.length > 0) {
            const anexosList = this.mapCatalogoConsultaAListaAnexosUi(catalog);
            const noAplica = {
              codigo: 'NO_APLICA',
              nombre: 'No aplica',
              valorTarifa: 0,
            };
            this.anexosDestinoContrato = [...anexosList, noAplica];
            this.anexosDestino = [...anexosList, noAplica];
            if (Array.isArray(resp?.filas) && resp.filas.length > 0) {
              this.aplicarFilasConsultaAnexoACambioPlan(resp.filas, noAplica);
            } else {
              this.usarRespuestaFilasAnexoCambioPlan = false;
              this.actualizarAnexosHabilitadosBeneficiariosCambioPlan();
            }
            this.isIncluirAnexoContratoEnabled = true;
            this.incluirAnexoControl.enable({ emitEvent: false });
            return;
          }
        } catch {
          // Catálogo genérico (GET) como respaldo
        }
      }

      const tipoPlanCodigo = String(
        this.tipoPlanDestinoContratoControl.value?.codigo ?? '',
      ).trim();
      const lineaNegocio = String(this.lineaNegocioDestino ?? '').trim();
      const grupoPrograma = String(this.grupoProgramaDestino ?? '').trim();
      const programaCodigo = String(programa?.codigo ?? '').trim();

      const getField = (obj: any, keys: string[]): any => {
        if (!obj) return undefined;
        for (const k of keys) {
          if (k in obj) return obj[k];
        }
        return undefined;
      };

      const normalize = (v: any): string =>
        String(v ?? '')
          .trim()
          .toUpperCase();

      const todosAnexos = await firstValueFrom(
        this.anexosDestinoService.getAnexosDestino(),
      );

      const esCambioPlanFlujo = this.esCambioPlanTipoSeleccionado();

      const filtrarAnexos = (opts: {
        skipModulo: boolean;
        soloActivo?: boolean;
      }): any[] => {
        return (todosAnexos || []).filter((a: any) => {
          const estado = normalize(getField(a, ['estado', 'Estado', 'ESTADO']));
          if (estado && estado !== 'ACTIVO') return false;
          if (opts.soloActivo) return true;

          if (!opts.skipModulo) {
            const modulo = normalize(
              getField(a, ['modulo', 'Modulo', 'Módulo', 'MODULO']),
            );
            if (modulo && !modulo.includes('NOVEDADES DE TRASLADOS'))
              return false;
          }

          const tipoPlanAnexo = normalize(
            getField(a, ['tipoPlan', 'TipoPlan', 'tipo_plan']),
          );
          if (
            tipoPlanCodigo &&
            tipoPlanAnexo &&
            tipoPlanAnexo !== tipoPlanCodigo
          ) {
            return false;
          }

          const lineaAnexo = normalize(
            getField(a, ['lineaNegocio', 'LineaNegocio', 'linea_negocio']),
          );
          if (lineaNegocio && lineaAnexo && lineaAnexo !== lineaNegocio) {
            return false;
          }

          const grupoAnexo = normalize(
            getField(a, ['grupoPrograma', 'GrupoPrograma', 'grupo_programa']),
          );
          if (grupoPrograma && grupoAnexo && grupoAnexo !== grupoPrograma) {
            return false;
          }

          const programaAnexo = normalize(
            getField(a, [
              'programa',
              'Programa',
              'programa_codigo',
              'prm_programa',
            ]),
          );
          if (
            programaCodigo &&
            programaAnexo &&
            programaAnexo !== programaCodigo
          ) {
            return false;
          }

          return true;
        });
      };

      let filtrados = filtrarAnexos({ skipModulo: false });
      if (!filtrados.length && esCambioPlanFlujo) {
        filtrados = filtrarAnexos({ skipModulo: true });
      }
      if (!filtrados.length && esCambioPlanFlujo) {
        filtrados = filtrarAnexos({ skipModulo: true, soloActivo: true });
      }

      const anexosList = filtrados
        .map((a: any) => ({
          codigo: String(a.codigo ?? a.Codigo ?? a.CODIGO ?? '').trim(),
          nombre: String(
            a.nombre ?? a.Nombre ?? a.descripcion ?? a.Descripcion ?? '',
          ).trim(),
          valorTarifa:
            Number(
              a.valorTarifa ??
                a.valor_tarifa ??
                a.valor ??
                a.VALOR ??
                a.valorTarifaAnexo ??
                0,
            ) || 0,
          condiciones: {
            edadMinima: (() => {
              const raw = getField(a, ['edadMinima', 'edad_minima', 'edadMin']);
              const n = Number(raw);
              return raw == null || raw === '' || !Number.isFinite(n)
                ? null
                : n;
            })(),
            edadMaxima: (() => {
              const raw = getField(a, ['edadMaxima', 'edad_maxima', 'edadMax']);
              const n = Number(raw);
              return raw == null || raw === '' || !Number.isFinite(n)
                ? null
                : n;
            })(),
            genero: (() => {
              const raw = getField(a, [
                'genero',
                'Genero',
                'sexo',
                'GeneroAnexo',
              ]);
              const s = raw == null ? '' : String(raw).trim();
              return s ? s : null;
            })(),
            parentesco: getField(a, [
              'parentesco',
              'Parentesco',
              'parentescos',
              'Parentescos',
            ]),
          },
        }))
        .filter((x: any) => x.codigo && x.nombre);

      const noAplica = {
        codigo: 'NO_APLICA',
        nombre: 'No aplica',
        valorTarifa: 0,
      };
      this.anexosDestinoContrato = [...anexosList, noAplica];
      this.anexosDestino = [...anexosList, noAplica]; // MP-FT-1358: mismo catálogo para la tabla principal del tipo 5.

      // MP-FT-1358: calcular opciones de anexo por integrante (elegibilidad).
      this.usarRespuestaFilasAnexoCambioPlan = false;
      this.actualizarAnexosHabilitadosBeneficiariosCambioPlan();

      if (!anexosList.length) {
        if (esCambioPlanFlujo || payloadConsulta?.grupoPrograma) {
          // Cambio de plan u otro flujo con contrato: permitir "Incluir anexo" aunque no haya catálogo
          // (desplegables con "No aplica" hasta que haya datos o el usuario elija).
          const noAplicaSolo = {
            codigo: 'NO_APLICA',
            nombre: 'No aplica',
            valorTarifa: 0,
          };
          this.anexosDestinoContrato = [noAplicaSolo];
          this.anexosDestino = [noAplicaSolo];
          this.actualizarAnexosHabilitadosBeneficiariosCambioPlan();
          this.isIncluirAnexoContratoEnabled = true;
          this.incluirAnexoControl.enable({ emitEvent: false });
          // No forzar false aquí: puede completarse en carrera tras marcar "Incluir anexo".
          return;
        }

        this.isIncluirAnexoContratoEnabled = false;
        this.incluirAnexoControl.disable({ emitEvent: false });
        this.incluirAnexoControl.setValue(false, { emitEvent: false });

        // MP-FT-1358: si no hay anexos, "Valor tarifa Anexo" debe quedar en 0.
        if (this.beneficiariosTarifa?.length) {
          for (const b of this.beneficiariosTarifa) {
            b.anexoDestino = ['NO_APLICA'];
            b.anexoDestinoLabel = '';
            b.valorTarifaAnexo = 0;
            b.totalTarifa = Number(b.valorTarifaPrograma ?? 0) + 0;
          }
        }
        return;
      }

      // Hay anexos activos: habilitar checkbox. No pisar el valor (evita carrera con
      // `validarAnexosActivosContrato` async y el usuario ya marcó "Incluir anexo").
      // Al cambiar programa, `onProgramaContratoSelected` ya reinicia en false.
      this.isIncluirAnexoContratoEnabled = true;
      this.incluirAnexoControl.enable({ emitEvent: false });
    } catch (error) {
      console.error('Error validando anexos activos (Cambio de plan):', error);
      const grupoPrograma =
        this.obtenerGrupoProgramaParaConsultaAnexos().trim();
      if (this.esCambioPlanTipoSeleccionado() || grupoPrograma) {
        const noAplicaSolo = {
          codigo: 'NO_APLICA',
          nombre: 'No aplica',
          valorTarifa: 0,
        };
        this.anexosDestinoContrato = [noAplicaSolo];
        this.anexosDestino = [noAplicaSolo];
        this.usarRespuestaFilasAnexoCambioPlan = false;
        this.actualizarAnexosHabilitadosBeneficiariosCambioPlan();
        this.isIncluirAnexoContratoEnabled = true;
        this.incluirAnexoControl.enable({ emitEvent: false });
        return;
      }
      this.isIncluirAnexoContratoEnabled = true;
      this.anexosDestinoContrato = [];
      this.anexosDestino = [];
      this.incluirAnexoControl.enable({ emitEvent: false });
      this.incluirAnexoControl.setValue(false, { emitEvent: false });
    }
  }

  private aplicarFilasConsultaAnexoACambioPlan(
    filas: AdicionaAnexoFilaConsultaDTO[] | any[],
    noAplica: { codigo: string; nombre: string; valorTarifa: number },
  ): void {
    this.usarRespuestaFilasAnexoCambioPlan = true;
    const esPlan = this.esCambioPlanTipoSeleccionado();
    const byNro = new Map<number, any>();
    for (const raw of filas || []) {
      const nro = Number(raw?.nro ?? raw?.Nro ?? NaN);
      if (Number.isFinite(nro) && nro > 0) {
        byNro.set(nro, raw);
      }
    }

    const dedupe = (items: any[]): any[] => {
      const seen = new Set<string>();
      const out: any[] = [];
      for (const a of items || []) {
        const c = String(a?.codigo ?? '')
          .trim()
          .toUpperCase();
        if (!c || seen.has(c)) {
          continue;
        }
        seen.add(c);
        out.push(a);
      }
      return out;
    };

    for (let i = 0; i < (this.beneficiariosTarifa || []).length; i++) {
      const b: any = this.beneficiariosTarifa[i];
      const nroBeneficiario = Number(
        b?.inte ?? b?.nro ?? b?.no ?? b?.numero ?? i + 1,
      );
      const fila = byNro.get(
        Number.isFinite(nroBeneficiario) && nroBeneficiario > 0
          ? nroBeneficiario
          : i + 1,
      );

      const opcionesRaw =
        fila?.opcionesAnexo ??
        fila?.OpcionesAnexo ??
        fila?.anexosPermitidos ??
        fila?.AnexosPermitidos ??
        [];
      const opciones = Array.isArray(opcionesRaw)
        ? opcionesRaw
            .map((o: any) => this.mapCatalogoItemInternoDesdeApi(o))
            .filter((x: any) => !!x?.codigo && x.codigo !== 'NO_APLICA')
        : [];

      const tieneOpciones = opciones.length > 0;
      const incluyeNoAplica = !!(
        fila?.incluyeNoAplica ?? fila?.IncluyeNoAplica
      );
      const apiHabilitadoRaw =
        fila?.anexoDestinoHabilitado ?? fila?.AnexoDestinoHabilitado;

      let anexosHabilitados: any[] = [];
      if (tieneOpciones) {
        anexosHabilitados = incluyeNoAplica
          ? dedupe([...opciones, noAplica])
          : dedupe([...opciones]);
      } else if (incluyeNoAplica) {
        anexosHabilitados = [noAplica];
      }

      const sinOpcionesElegibles = anexosHabilitados.length === 0;
      let habilitadoUi: boolean;
      if (typeof apiHabilitadoRaw === 'boolean') {
        habilitadoUi = apiHabilitadoRaw;
      } else {
        habilitadoUi = !sinOpcionesElegibles;
      }

      if (sinOpcionesElegibles || !habilitadoUi) {
        b.anexoDestinoHabilitado = false;
        b.anexosHabilitados = [];
        b.anexoDestino = esPlan ? ['NO_APLICA'] : '';
        this.recalcularTarifasBeneficiario(b);
        continue;
      }

      b.anexoDestinoHabilitado = habilitadoUi;
      b.anexosHabilitados = anexosHabilitados;

      const seleccionActual = this.normalizarAnexosSeleccionadosCambioPlan(
        b.anexoDestino,
      ).map((c) => String(c).trim().toUpperCase());
      const permitidos = new Set(
        anexosHabilitados.map((a: any) =>
          String(a?.codigo ?? '')
            .trim()
            .toUpperCase(),
        ),
      );
      let seleccion = seleccionActual.filter((c) => permitidos.has(c));

      if (esPlan) {
        if (!tieneOpciones && !incluyeNoAplica) {
          seleccion = ['NO_APLICA'];
        } else if (!seleccion.length && permitidos.has('NO_APLICA')) {
          seleccion = ['NO_APLICA'];
        }
        if (seleccion.includes('NO_APLICA') && seleccion.length > 1) {
          seleccion = seleccion.filter((c) => c !== 'NO_APLICA');
        }
        b.anexoDestino = seleccion;
      } else {
        if (!seleccion.length) {
          if (incluyeNoAplica && permitidos.has('NO_APLICA')) {
            b.anexoDestino = '';
          } else if (tieneOpciones) {
            b.anexoDestino = String(opciones[0]?.codigo ?? '').trim();
          } else {
            b.anexoDestino = '';
          }
        } else {
          const head = seleccion[0];
          b.anexoDestino = head === 'NO_APLICA' ? '' : head;
        }
      }

      this.recalcularTarifasBeneficiario(b);
    }

    this.calcularTotalCuotaIva();
  }

  // Cascada destino contrato nuevo (invocada solo cuando el FormControl cambia de verdad).
  public onTipoPlanDestinoContratoSelected(tipoPlan: any): void {
    if (this.suprimirEfectosSeleccionContratoNuevo) {
      return;
    }

    // Limpiar campos dependientes
    this.programaDestinoContratoControl.setValue(null);
    this.subcuentaDestinoContratoControl.setValue(null);
    this.corteDestinoContratoControl.setValue(null);
    this.tarifaDestinoContratoControl.setValue(null);
    this.sucursalComercializableContratoControl.setValue(null);

    // MP-FT-1358: al cambiar la jerarquía, reiniciar anexos y checkbox.
    this.incluirAnexoControl.enable({ emitEvent: false });
    this.incluirAnexoControl.setValue(false, { emitEvent: false });
    this.isIncluirAnexoContratoEnabled = true;
    this.anexosDestino = [];
    this.anexosDestinoContrato = [];
    this.cortesDestinoContrato = [];
    this.sucursalesComercializablesContrato = [];
    this.programasContratoSubject.next([]);
    this.subcuentasContratoSubject.next([]);
    this.tarifasContratoSubject.next([]);
    this.errorTrasladoContrato = '';

    // Cambio de plan: mantener la tabla intacta; no mutar filas al cambiar jerarquía.

    // Si es colectivo o acuerdo corporativo, aplicar lógica de colectivo
    if (tipoPlan?.codigo === 'COL' || tipoPlan?.codigo === 'ACO') {
      this.mostrarCampoColectivo = true;
      this.mostrarCamposTrasladoContratoNuevo = false;
      this.tiposPlanes = [...this.tiposPlanesContratoNuevo];
      this.tipoPlanDestinoControl.setValue(tipoPlan, { emitEvent: false });
      const c = this.obtenerDtoContratoParaCambioPlan();
      if (c) {
        this.grupoProgramaDestino = String(c.GrupoPrograma ?? '').trim();
      }
      void this.loadColectivos();
    } else {
      this.mostrarCampoColectivo = false;
      this.mostrarCamposTrasladoContratoNuevo = true;
      this.cargarProgramasContratoNuevo(tipoPlan);
    }
  }

  public async onProgramaContratoSelected(programa: any): Promise<void> {
    if (this.suprimirEfectosSeleccionContratoNuevo) {
      return;
    }

    this.grupoProgramaDestino = programa.grupoPrograma;

    // Limpiar campos dependientes
    this.subcuentaDestinoContratoControl.setValue(null);
    this.corteDestinoContratoControl.setValue(null);
    this.tarifaDestinoContratoControl.setValue(null);
    this.sucursalComercializableContratoControl.setValue(null);
    this.cortesDestinoContrato = [];
    this.tarifasContratoSubject.next([]);

    // Reset de anexos hasta validar con el nuevo programa.
    this.incluirAnexoControl.enable({ emitEvent: false });
    this.incluirAnexoControl.setValue(false, { emitEvent: false });
    this.isIncluirAnexoContratoEnabled = true;
    this.anexosDestino = [];
    this.anexosDestinoContrato = [];

    // Cambio de plan: mantener la tabla intacta; no mutar filas al cambiar programa.

    await this.validarAnexosActivosContrato(programa);
    this.cdr.markForCheck();
  }

  public onSubcuentaContratoSelected(subcuenta: any): void {
    if (this.suprimirEfectosSeleccionContratoNuevo) {
      return;
    }

    // Limpiar campos dependientes
    this.corteDestinoContratoControl.setValue(null);
    this.tarifaDestinoContratoControl.setValue(null);
    this.sucursalComercializableContratoControl.setValue(null);

    // Cambio de plan: mantener tabla intacta al cambiar subcuenta.

    this.cargarCortesDestinoContrato(subcuenta);
    // MP-FT-1358: sucursal comercializable destino depende de la subcuenta.
    this.cargarSucursalesComercializablesContrato();
  }

  public async onCorteContratoSelected(corte: any): Promise<void> {
    if (this.suprimirEfectosSeleccionContratoNuevo) {
      return;
    }

    // Limpiar campo dependiente
    this.tarifaDestinoContratoControl.setValue(null);

    // Cambio de plan: NO recargar integrantes aquí.
    // La tabla se carga una sola vez al seleccionar el tipo de novedad.
    // Cambio de plan: mantener tabla intacta al cambiar corte.

    this.cargarTarifasContratoNuevo();
  }

  public async onTarifaContratoSelected(tarifa: any): Promise<void> {
    if (this.suprimirEfectosSeleccionContratoNuevo) {
      return;
    }

    this.cargarSucursalesComercializablesContrato();
    // MP-FT-1358 1.1.3.5: Cambio de plan usa la tabla principal de beneficiarios (no la tabla "integrantesContratoNuevo").
    // Por eso, se evita cargar la tabla de "Traslado a contrato nuevo".
    if (this.esCambioPlanTipoSeleccionado()) {
      this.mostrarTablaIntegrantesContratoNuevo = false;
      this.integrantesContratoNuevo = [];
      // Cambio de plan: mantener tabla intacta al seleccionar tarifa.
      this.checkValidacionCompletada();
      return;
    }

    // Reintentar precarga del contratante cuando el flujo ya está resuelto con tarifa.
    this.precargarDatosContratanteActual();
    this.cargarIntegrantesContratoNuevo();
  }

  public onSucursalComercializableContratoSelected(sucursal: any): void {
    this.sucursalComercializableContratoControl.setValue(sucursal);
  }

  // Métodos de limpieza para Traslado a contrato nuevo
  public clearProgramaContratoSelection(): void {
    this.programaDestinoContratoControl.setValue(null);
  }

  /** Limpia tarifa y sucursal (la sucursal se recalcula con la tarifa). */
  public clearTarifaContratoSelection(): void {
    this.tarifaDestinoContratoControl.setValue(null);
    this.sucursalComercializableContratoControl.setValue(null);
    if (this.esCambioPlanTipoSeleccionado()) {
      // Cambio de plan: mantener tabla intacta al limpiar tarifa.
      this.checkValidacionCompletada();
    }
  }

  /** Limpia subcuenta y campos que dependen de ella (corte, tarifa, sucursal). */
  public clearSubcuentaContratoSelection(): void {
    this.subcuentaDestinoContratoControl.setValue(null);
    this.corteDestinoContratoControl.setValue(null);
    this.tarifaDestinoContratoControl.setValue(null);
    this.sucursalComercializableContratoControl.setValue(null);
    this.cortesDestinoContrato = [];
    this.tarifasContratoSubject.next([]);
    if (this.esCambioPlanTipoSeleccionado()) {
      // Cambio de plan: mantener tabla intacta al limpiar subcuenta.
    }
  }

  public retryLoadProgramasContrato(): void {
    const tipoPlan = this.tipoPlanDestinoContratoControl.value;
    if (tipoPlan) {
      this.cargarProgramasContratoNuevo(tipoPlan);
    }
  }

  public retryLoadTarifasContrato(): void {
    this.cargarTarifasContratoNuevo();
  }

  /** POST `info-contrato-user`: fila en PascalCase o cache de radicación (camelCase). */
  private normalizarFilaDtoInfoContratoUser(row: any): any {
    if (!row) {
      return row;
    }
    return {
      Identificacion: row.Identificacion ?? row.identificacion,
      NombreUsuario: row.NombreUsuario ?? row.nombreUsuario,
      Parentesco: row.Parentesco ?? row.parentesco,
      Edad: row.Edad ?? row.edad,
      Genero: row.Genero ?? row.genero,
      Anexo: row.Anexo ?? row.anexo,
      ValorTarifaAnexo: row.ValorTarifaAnexo ?? row.valorTarifaAnexo,
      ValorTarifaPrograma: row.ValorTarifaPrograma ?? row.valorTarifaPrograma,
      TotalTarifa: row.TotalTarifa ?? row.totalTarifa,
      TipoDocumento: row.TipoDocumento ?? row.tipoDocumento,
      NumeroDocumento: row.NumeroDocumento ?? row.numeroDocumento,
    };
  }

  /** Nombre para tabla: API a veces envía solo nombres/apellidos sueltos. */
  private resolverNombreUsuarioDesdeFilaValidacion(row: any): string {
    if (!row) {
      return '';
    }
    const direct = String(
      row.NombreUsuario ??
        row.nombreUsuario ??
        row.NombreCompleto ??
        row.nombreCompleto ??
        '',
    ).trim();
    if (direct) {
      return direct;
    }
    const partes = [
      row.PrimerNombre ?? row.primerNombre,
      row.SegundoNombre ?? row.segundoNombre,
      row.PrimerApellido ?? row.primerApellido,
      row.SegundoApellido ?? row.segundoApellido,
    ];
    const joined = partes
      .map((p) => String(p ?? '').trim())
      .filter(Boolean)
      .join(' ');
    if (joined) {
      return joined;
    }
    return String(
      row.Nombre ?? row.nombre ?? row.RazonSocial ?? row.razonSocial ?? '',
    ).trim();
  }

  private mapValidacionContratoRowToIntegranteContratoNuevo(
    row: any,
    origenLista: 'contrato_destino' | 'paso_1',
  ): any {
    const r = this.normalizarFilaDtoInfoContratoUser(row);
    const parsedId = this.parseIdentificacion(String(r.Identificacion ?? ''));
    const tipoDocumento = parsedId.tipo || r.TipoDocumento || 'CC';
    const numeroDocumento =
      parsedId.numero ||
      String(r.NumeroDocumento ?? '').trim() ||
      String(r.Identificacion ?? '').replace(/\D/g, '') ||
      '';
    const parentescoOrigen = String(r.Parentesco ?? '').trim();
    const parentescoDestino =
      this.normalizarParentescoDestino(parentescoOrigen);
    const anexoInfo = this.parseAnexoValor(r.Anexo ?? '');
    const valorTarifaAnexo = Number(r.ValorTarifaAnexo ?? 0) || 0;
    const valorTarifaPrograma = Number(r.ValorTarifaPrograma ?? 0) || 0;
    const totalTarifa =
      Number(r.TotalTarifa ?? valorTarifaAnexo + valorTarifaPrograma) || 0;
    const generoRaw = r.Genero ?? '';
    const g = String(generoRaw).trim();
    const genero = g.length === 1 ? g.toUpperCase() : g || '—';

    const identificacion =
      numeroDocumento !== ''
        ? `${tipoDocumento} - ${numeroDocumento}`.trim()
        : String(r.Identificacion ?? '').trim();

    return {
      origenLista,
      tipoDocumento,
      numeroDocumento,
      nombreCompleto: this.resolverNombreUsuarioDesdeFilaValidacion(r),
      parentescoDestino,
      edad: Number(r.Edad ?? 0) || 0,
      genero,
      anexoDestino: anexoInfo?.codigo || '',
      valorTarifaAnexo,
      valorTarifaPrograma,
      totalTarifa,
      showParentescoError: false,
      identificacion,
    };
  }

  // Métodos para manejo de tabla de integrantes
  public async cargarIntegrantesContratoNuevo(): Promise<void> {
    this.cargandoIntegrantesContrato = true;
    this.mostrarTablaIntegrantesContratoNuevo = true;

    try {
      await this.cargarParentescosActivos();

      const numeroContrato = this.obtenerNumeroContratoSeleccionado();
      if (!numeroContrato) {
        this.integrantesContratoNuevo = [];
        this.totalCuotaIvaContratoNuevo = 0;
        return;
      }

      const state = this.localStorageService.load('frmConsultState');
      const stateContract = (state?.selectedContract || '').toString().trim();
      const cached = state?.validacionTablaData;

      let rawRows: any[] = [];
      if (
        Array.isArray(cached) &&
        cached.length > 0 &&
        stateContract === numeroContrato
      ) {
        rawRows = cached;
      } else {
        const res = await firstValueFrom(
          this.validacionContratoService
            .getInfoContratoUser(numeroContrato)
            .pipe(
              takeUntil(this.destroy$),
              catchError(() => of(null)),
            ),
        );
        const arr = Array.isArray(res) ? res : res ? [res] : [];
        rawRows = arr;
      }

      const seleccionados = this.obtenerIntegrantesSeleccionados();
      const baseMapped = rawRows.map((row) =>
        this.mapValidacionContratoRowToIntegranteContratoNuevo(row, 'paso_1'),
      );

      // MP-FT-1358 1.1.3.x — Traslado a contrato nuevo: tabla con integrantes seleccionados en paso 1.
      if (seleccionados.length === 0) {
        this.integrantesContratoNuevo = [];
        this.errorValidacionIntegrantes =
          'No se encontraron integrantes seleccionados en el paso 1 para aplicar la novedad.';
        this.totalCuotaIvaContratoNuevo = 0;
        return;
      }

      const paso1 = baseMapped
        .filter((m) =>
          this.filaBeneficiarioCoincideConSeleccion(m, seleccionados),
        )
        .map((m) => ({
          ...m,
          origenLista: 'paso_1' as const,
        }));

      this.integrantesContratoNuevo = paso1.map((r, i) => ({
        ...r,
        id: i + 1,
      }));
      this.errorValidacionIntegrantes = '';

      this.calcularTotalCuotaContratoNuevo();
    } catch (error) {
      console.error('Error cargando integrantes:', error);
      this.integrantesContratoNuevo = [];
      this.totalCuotaIvaContratoNuevo = 0;
    } finally {
      this.cargandoIntegrantesContrato = false;
    }
  }

  public onParentescoDestinoContratoNuevoChange(
    integranteIndex: number,
    parentesco: any,
  ): void {
    const integrante = this.integrantesContratoNuevo[integranteIndex];
    if (!integrante) {
      return;
    }

    if (!parentesco) {
      integrante.parentescoDestino = null;
      integrante.parentesco = '';
      return;
    }

    const codigo = String(parentesco?.codigo ?? '')
      .trim()
      .toLowerCase();
    const nombre = String(parentesco?.nombre ?? '').trim();

    if (codigo === 'titular' || codigo === 'conyugue') {
      const duplicado = this.integrantesContratoNuevo.some((it, idx) => {
        if (idx === integranteIndex) return false;
        const codIt = String(it?.parentescoDestino?.codigo ?? '')
          .trim()
          .toLowerCase();
        return codIt === codigo;
      });

      if (duplicado) {
        this.errorValidacionIntegrantes = `Ya existe un integrante en el contrato destino con el parentesco ${nombre}. No es posible asignar este parentesco a más de una persona en el contrato destino`;
        integrante.parentescoDestino = null;
        integrante.parentesco = '';
        return;
      }
    }

    integrante.parentescoDestino = parentesco;
    integrante.parentesco = nombre;
    this.errorValidacionIntegrantes = '';
  }

  public onAnexoDestinoChange(integranteIndex: number, anexo: string): void {
    const integrante = this.integrantesContratoNuevo[integranteIndex];
    integrante.anexoDestino = anexo;

    // TODO: Calcular valor de tarifa de anexo basado en la selección
    integrante.valorTarifaAnexo = anexo ? 50000 : 0; // Mock
    integrante.totalTarifa =
      integrante.valorTarifaPrograma + integrante.valorTarifaAnexo;

    this.calcularTotalCuotaContratoNuevo();
  }

  private calcularTotalCuotaContratoNuevo(): void {
    const subtotal = this.integrantesContratoNuevo.reduce(
      (sum, integrante) => sum + (Number(integrante.totalTarifa) || 0),
      0,
    );
    /** Valores por fila ya vienen con IVA desde servicios; el pie es la suma. */
    this.totalCuotaIvaContratoNuevo = subtotal;
    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  public getIncluirAnexoContratoValue(): boolean {
    return this.incluirAnexoControl.value === true;
  }

  /**
   * Traslado a contrato nuevo: no permitir que en paso 1 estén seleccionados todos los integrantes del contrato actual.
   */
  public validarNoTrasladarTodosIntegrantes(): boolean {
    if (!this.esTipoTrasladoContratoNuevoActivo()) {
      return true;
    }
    return !this.hayTodosLosIntegrantesSeleccionadosParaTrasladoNuevo();
  }

  private esTipoTrasladoContratoNuevoActivo(): boolean {
    const tipo = this.tipoNovedadControl.value ?? this.selectedTipoNovedad;
    if (!tipo) {
      return false;
    }
    const codigoTipo = String(tipo.codigo).trim();
    return (
      codigoTipo === '3' || this.esTipoNombre(tipo, 'traslado a contrato nuevo')
    );
  }

  private esSubtipoCambioTitularResponsableActivo(): boolean {
    const subtipo =
      this.subtipoNovedadControl.value ?? this.selectedSubtipoNovedad;
    const nombre = String((subtipo as any)?.nombre ?? '')
      .trim()
      .toLowerCase();
    return nombre === 'cambio de titular a responsable pagador';
  }

  private esSubtipoCambioResponsablePagadorActivo(): boolean {
    const subtipo =
      this.subtipoNovedadControl.value ?? this.selectedSubtipoNovedad;
    return this.esSubtipoCambioResponsablePagador(subtipo);
  }

  private esSubtipoCambioResponsablePagador(
    subtipo: SubtipoNovedad | null,
  ): boolean {
    const nombre = String((subtipo as any)?.nombre ?? '')
      .trim()
      .toLowerCase();
    return nombre === 'cambio de responsable pagador';
  }

  private hayTodosLosIntegrantesSeleccionadosParaTrasladoNuevo(): boolean {
    const total = this.integrantesTotalesContratoActual?.length ?? 0;
    const sel = this.obtenerIntegrantesSeleccionados()?.length ?? 0;
    if (total <= 0) {
      return false;
    }
    if (sel <= 0) {
      return false;
    }
    return sel === total;
  }

  private cargarTiposIdentificacionContratante(): void {
    this.tiposIdentificacionContratante = [
      { codigo: 'CC', nombre: 'Cédula de Ciudadanía' },
      { codigo: 'NIT', nombre: 'Número de Identificación Tributaria' },
      { codigo: 'CE', nombre: 'Cédula de Extranjería' },
      { codigo: 'PA', nombre: 'Pasaporte' },
    ];
  }

  public onTipoIdentificacionContratanteSelected(tipoId: any): void {
    // Limpiar campos dependientes
    this.numeroIdentificacionContratanteDestinoControl.setValue('');
    this.contratoDestinoControl.setValue(null);
    this.contratoDestinoSeleccionadoCodigo = null;
    this.contratoDestinoTransitorioBloqueado = false;
    this.errorTrasladoContratoExistente = '';
    this.clearContractDependentFields();
  }

  public onNumeroIdentificacionChange(event?: Event): void {
    const target = event?.target as HTMLInputElement | null;
    // En `paste` el FormControl puede no estar sincronizado todavía cuando corre este handler,
    // por eso usamos el valor del input (DOM) si está disponible.
    let numero = String(
      target?.value ??
        this.numeroIdentificacionContratanteDestinoControl.value ??
        '',
    );

    // Remover caracteres no numéricos
    numero = numero.replace(/\D/g, '');

    // Limitar a 30 dígitos
    if (numero.length > 30) {
      numero = numero.substring(0, 30);
    }

    // Formatear con separadores de miles para mostrar
    const numeroFormateado = numero.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Actualizar el control con el valor formateado
    this.numeroIdentificacionContratanteDestinoControl.setValue(
      numeroFormateado,
      { emitEvent: false },
    );

    const tipoId = this.tipoIdentificacionContratanteDestinoControl.value;

    if (numero && tipoId && numero.length >= 3) {
      this.cargarContratosDestino(tipoId.codigo, numero);
    } else {
      this.contratosDestinoSubject.next([]);
      this.contratoDestinoControl.setValue(null);
      this.contratoDestinoSeleccionadoCodigo = null;
      this.clearContractDependentFields();
    }
  }

  private cargarContratosDestino(
    tipoIdentificacion: string,
    numeroIdentificacion: string,
  ): void {
    this.isLoadingContratosDestino = true;
    this.hasErrorContratosDestino = false;
    this.errorTrasladoContratoExistente = '';
    this.contratoDestinoTransitorioBloqueado = false;
    this.contratoDestinoSeleccionadoCodigo = null;
    this.contratoDestinoControl.setValue(null, { emitEvent: false });

    const numeroLimpio = String(numeroIdentificacion ?? '').replace(/\D/g, '');
    const payload = {
      prm_docu_tipo: String(tipoIdentificacion ?? '').trim(),
      prm_docu_nro: numeroLimpio,
      prm_contra: '',
      prm_linea_negocio:
        this.construirPrmLineaNegocioCodigoCambioTarifaDesdeContrato(),
    };

    this.contratosUsersService.getContratosUsers(payload).subscribe({
      next: (contratos) => {
        const activos = (contratos || []).filter((c) =>
          this.esContratoActivoAfilmed(c),
        );

        const mappedAll = activos.map((c) =>
          this.mapContratoAfilmedToContratoDestino(c),
        );

        const filtradosLn = mappedAll.filter((c) =>
          this.contratoDestinoCoincideLineaNegocioOrigen(c.lineaNegocio),
        );

        const contratosOrdenados = [...filtradosLn].sort((a, b) =>
          String(a.nombrePrograma ?? '').localeCompare(
            String(b.nombrePrograma ?? ''),
          ),
        );

        if (activos.length > 0 && mappedAll.length === 0) {
          this.errorTrasladoContratoExistente =
            MSG_CONTRATO_DESTINO_TRANSITORIO_24690;
          this.contratoDestinoTransitorioBloqueado = true;
        } else if (
          mappedAll.length > 0 &&
          filtradosLn.length === 0 &&
          String(this.obtenerLineaNegocioContrato() ?? '').trim()
        ) {
          this.errorTrasladoContratoExistente =
            MSG_MP_FT_1358_CONTRATO_DESTINO_OTRA_LINEA;
        } else if (contratosOrdenados.length === 0) {
          this.errorTrasladoContratoExistente =
            MSG_CONTRATO_DESTINO_SIN_RESULTADOS;
        }

        this.contratosDestinoSubject.next(contratosOrdenados as any[]);
        this.isLoadingContratosDestino = false;
        this.checkValidacionCompletada();
      },
      error: (error) => {
        console.error('Error cargando contratos destino:', error);
        this.hasErrorContratosDestino = true;
        this.isLoadingContratosDestino = false;
        this.errorTrasladoContratoExistente =
          'Error al cargar contratos destino';
        this.contratosDestinoSubject.next([]);
        this.checkValidacionCompletada();
      },
    });
  }

  /** Activo Afilmed: sin fecha de retiro / baja. */
  private esContratoActivoAfilmed(dto: any): boolean {
    const retiro = String(
      dto?.fecha_baja ??
        dto?.fechaBaja ??
        dto?.FechaBaja ??
        dto?.fecha_retiro ??
        dto?.fechaRetiro ??
        dto?.FechaRetiro ??
        '',
    ).trim();
    return retiro.length === 0;
  }

  /**
   * MP-FT-1358 1.1.3.2 — cuenta 24690 o estado transitorio persuasión sin servicio.
   */
  private esContratoTransitorioPersuasionSinServicio(
    contratoOrDto: any,
  ): boolean {
    if (!contratoOrDto) {
      return false;
    }
    const cuentaRaw =
      leerCuentaAfilmed(contratoOrDto) ||
      String(contratoOrDto.cuenta ?? contratoOrDto.Cuenta ?? '').trim();
    const codigoCuenta = this.extraerCodigoCuentaCotizadorTrl(cuentaRaw);
    if (codigoCuenta === '24690') {
      return true;
    }
    const estado = String(
      contratoOrDto.estado ?? contratoOrDto.EstadoContrato ?? '',
    )
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    return estado.includes('TRANSITORIO') && codigoCuenta === '24690';
  }

  private esTipoPlanColectivoContratoDestino(contratoOrDto: any): boolean {
    if (
      contratoOrDto?.ColectivoEspecial != null &&
      String(contratoOrDto.ColectivoEspecial).trim() !== ''
    ) {
      return true;
    }
    const tipoPlan = String(
      contratoOrDto?.tipoPlan ?? contratoOrDto?.TipoPlan ?? '',
    )
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    if (tipoPlan.includes('COLECTIVO')) {
      return true;
    }
    const cuenta = String(leerCuentaAfilmed(contratoOrDto) ?? '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    return cuenta.includes('COLECTIVO');
  }

  public onContratoDestinoSelected(contrato: any): void {
    if (!contrato) {
      return;
    }
    if (this.esContratoTransitorioPersuasionSinServicio(contrato)) {
      this.errorTrasladoContratoExistente =
        MSG_CONTRATO_DESTINO_TRANSITORIO_24690;
      this.contratoDestinoTransitorioBloqueado = true;
      this.contratoDestinoSeleccionadoCodigo = null;
      this.contratoDestinoControl.setValue(null, { emitEvent: false });
      this.clearContractDependentFields();
      this.checkValidacionCompletada();
      this.cdr.markForCheck();
      return;
    }
    this.contratoDestinoTransitorioBloqueado = false;
    this.contratoDestinoSeleccionadoCodigo = String(
      contrato?.codigo ?? '',
    ).trim();
    this.contratoDestinoControl.setValue(contrato, { emitEvent: false });

    // Preparar visualización de tabla mientras se cargan integrantes
    this.mostrarTablaIntegrantesTrasladoExistente = true;
    this.cargandoBeneficiarios = true;

    // Llenar campos dependientes
    this.corteContratoDestinoControl.setValue(contrato.corte);
    this.tipoPlanDestinoExistenteControl.setValue(contrato.tipoPlan);
    this.lineaNegocioDestinoExistenteControl.setValue(contrato.lineaNegocio);
    this.grupoProgramaDestinoExistenteControl.setValue(contrato.grupoPrograma);
    this.programaDestinoExistenteControl.setValue(contrato.programa);
    this.tipoPrimaDestinoExistenteControl.setValue(contrato.tipoPrima);
    this.codTarifaDestinoExistenteControl.setValue(
      `${contrato.codigoTarifa} - ${contrato.descripcionTarifa}`,
    );

    if (contrato.esColectivo) {
      console.info(
        'MP-FT-1358: contrato destino colectivo — se requiere Vobo del colectivo como documento soporte.',
      );
    }

    // Validar anexos para este programa (Traslado a contrato existente).
    void this.validarAnexosPrograma(contrato);

    // Cargar integrantes del contrato destino y preparar tabla
    this.cargarIntegrantesContratoDestino(contrato.codigo);
    this.errorTrasladoContratoExistente = '';
    this.checkValidacionCompletada();
    this.cdr.markForCheck();
  }

  private clearContractDependentFields(): void {
    this.corteContratoDestinoControl.setValue(null);
    this.tipoPlanDestinoExistenteControl.setValue(null);
    this.lineaNegocioDestinoExistenteControl.setValue(null);
    this.grupoProgramaDestinoExistenteControl.setValue(null);
    this.programaDestinoExistenteControl.setValue(null);
    this.tipoPrimaDestinoExistenteControl.setValue(null);
    this.codTarifaDestinoExistenteControl.setValue(null);
    this.incluirAnexoExistenteControl.setValue(false);
    this.incluirAnexoExistenteControl.enable({ emitEvent: false });
    this.mostrarTablaIntegrantesTrasladoExistente = false;
  }

  private async validarAnexosPrograma(contrato: any): Promise<void> {
    this.incluirAnexoExistenteControl.setValue(false, { emitEvent: false });
    this.anexosDestinoExistente = [];
    this.incluirAnexoExistenteControl.enable({ emitEvent: false });

    const grupoPrograma = this.normalizarCodigoGrupoPrograma(
      contrato?.grupoPrograma ?? contrato?.programa ?? '',
    );
    if (!grupoPrograma) {
      return;
    }

    try {
      const resp = await firstValueFrom(
        this.adicionaAnexoConsultaService.consulta({ grupoPrograma }),
      );
      const catalogo = this.extraerAnexosDesdeRespuestaConsulta(resp);

      this.anexosDestinoExistente = catalogo
        .map((a: any) => {
          const id = Number(a?.idPAnexos ?? a?.IdPAnexos ?? NaN);
          const codigoFormato = String(a?.codigo ?? a?.Codigo ?? '').trim();
          const nombre = String(a?.nombre ?? a?.Nombre ?? '').trim();
          if (!Number.isFinite(id) || id < 0) {
            return null;
          }
          return {
            codigo: `ID_${id}`,
            nombre: nombre || codigoFormato || `Anexo ${id}`,
            codigoFormato,
            idPAnexos: id,
          };
        })
        .filter((x: any) => !!x);

      if (this.anexosDestinoExistente.length > 0) {
        this.incluirAnexoExistenteControl.enable({ emitEvent: false });
      } else {
        this.incluirAnexoExistenteControl.enable({ emitEvent: false });
      }
    } catch (error) {
      console.error(
        'Error consultando anexos para traslado a contrato existente:',
        error,
      );
      this.anexosDestinoExistente = [];
      this.incluirAnexoExistenteControl.enable({ emitEvent: false });
    }
  }

  private cargarIntegrantesContratoDestino(codigoContrato: string): void {
    this.cargandoBeneficiarios = true;
    this.validacionContratoService
      .getInfoContratoUser(codigoContrato)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (rows) => {
          if (!this.parentescosActivos.length) {
            await this.cargarParentescosActivos();
          }

          const integrantes = (rows || []).map((row: any, index: number) => {
            const r = this.normalizarFilaDtoInfoContratoUser(row);
            const parsedId = this.parseIdentificacion(
              String(r.Identificacion ?? ''),
            );
            const tipoDocumento = parsedId.tipo || r.TipoDocumento || 'CC';
            const numeroDocumento =
              parsedId.numero ||
              String(r.NumeroDocumento ?? '').trim() ||
              String(r.Identificacion ?? '').replace(/\D/g, '') ||
              '';
            const parentescoOrigen = String(r.Parentesco ?? '').trim();
            const parentescoDestino =
              this.normalizarParentescoDestino(parentescoOrigen);
            const anexoInfo = this.parseAnexoValor(r.Anexo ?? '');
            const valorTarifaAnexo = Number(r.ValorTarifaAnexo ?? 0) || 0;
            const valorTarifaPrograma = Number(r.ValorTarifaPrograma ?? 0) || 0;
            const totalTarifa =
              Number(r.TotalTarifa ?? valorTarifaAnexo + valorTarifaPrograma) ||
              0;
            const generoRaw = String(r.Genero ?? '').trim();
            const genero =
              generoRaw.length === 1
                ? generoRaw.toUpperCase()
                : generoRaw || '—';

            return {
              id: index + 1,
              tipoDocumento,
              numeroDocumento,
              nombreCompleto: this.resolverNombreUsuarioDesdeFilaValidacion({
                ...row,
                ...r,
              }),
              parentesco: parentescoOrigen || '',
              parentescoDestino,
              edad: Number(r.Edad ?? 0) || 0,
              genero,
              esContratoDestino: true,
              esTitularContratoDestino:
                this.esParentescoTitularFlexible(parentescoOrigen),
              anexoDestino: anexoInfo?.codigo || '',
              anexoDestinoLabel:
                anexoInfo?.nombre || String(r.Anexo ?? '') || '',
              valorTarifaAnexo,
              valorTarifaPrograma,
              totalTarifa,
            };
          });

          this.integrantesContratoDestino = integrantes;

          const loadOrigen = this.beneficiariosTarifa?.length
            ? Promise.resolve()
            : this.cargarBeneficiariosTarifa();

          Promise.resolve(loadOrigen).then(() => {
            this.prepararTablaIntegrantesTrasladoExistente();
          });
        },
        error: (error) => {
          console.error(
            'Error cargando integrantes de contrato destino:',
            error,
          );
          this.integrantesContratoDestino = [];
          this.mostrarTablaIntegrantesTrasladoExistente = false;
          this.errorTrasladoContratoExistente =
            'No se pudieron cargar los integrantes del contrato destino.';
          this.cargandoBeneficiarios = false;
        },
        complete: () => {
          this.cargandoBeneficiarios = false;
        },
      });
  }

  private prepararTablaIntegrantesTrasladoExistente(): void {
    // Combinar integrantes del contrato destino + integrantes seleccionados para traslado
    const destinoKeysDoc = new Set(
      this.integrantesContratoDestino.map((integrante) =>
        this.buildIntegranteDocumentoKey(
          integrante.tipoDocumento,
          integrante.numeroDocumento,
        ),
      ),
    );

    const integrantesTraslado: any[] = [];
    const seleccionadosPaso1 = this.obtenerIntegrantesSeleccionados() || [];
    const fuenteOrigen =
      seleccionadosPaso1.length > 0
        ? seleccionadosPaso1
        : this.beneficiariosTarifa;

    const buscarBeneficiarioTarifa = (row: any): any => {
      const idRow = this.soloDigitosIdentificacion(
        String(
          row?.identificacion ??
            row?.Identificacion ??
            row?.numeroDocumento ??
            row?.NumeroDocumento ??
            row?.numeroIdentificacion ??
            '',
        ),
      );
      if (!idRow) {
        return null;
      }
      return (this.beneficiariosTarifa || []).find((b: any) => {
        const idB = this.soloDigitosIdentificacion(
          String(
            b?.identificacion ??
              b?.Identificacion ??
              b?.numeroDocumento ??
              b?.NumeroDocumento ??
              '',
          ),
        );
        return idB && idB === idRow;
      });
    };

    (fuenteOrigen || []).forEach((row: any) => {
      const beneficiario = buscarBeneficiarioTarifa(row) ?? row;
      const parentescoContratoActual = String(
        beneficiario?.parentesco ??
          beneficiario?.Parentesco ??
          row?.parentesco ??
          row?.Parentesco ??
          '',
      );
      // RS 1.1.3.2: no listar el titular del contrato actual en el bloque de paso 1.
      if (this.esParentescoTitularFlexible(parentescoContratoActual)) {
        return;
      }

      const rawIdent = String(
        beneficiario.identificacion ??
          beneficiario.Identificacion ??
          beneficiario.numeroDocumento ??
          beneficiario.NumeroDocumento ??
          '',
      ).trim();
      const parsedId = this.parseIdentificacion(rawIdent);
      const tipoDocumento = parsedId.tipo || beneficiario.tipoDocumento || 'CC';
      const numeroDocumento =
        parsedId.numero ||
        beneficiario.numeroDocumento ||
        beneficiario.NumeroDocumento ||
        rawIdent ||
        '';
      const parentescoDestino = this.normalizarParentescoDestino(
        beneficiario.parentescoDestino ??
          beneficiario.ParentescoDestino ??
          beneficiario.parentesco ??
          beneficiario.Parentesco,
      );
      const rawAnexoDestino = beneficiario.anexoDestino as
        | string
        | string[]
        | undefined;
      const anexoActual =
        (Array.isArray(rawAnexoDestino)
          ? rawAnexoDestino.join(',')
          : rawAnexoDestino) ||
        this.parseAnexoValor(beneficiario.anexoDestinoLabel || '')?.codigo ||
        '';

      const integrante = {
        id:
          this.integrantesContratoDestino.length +
          integrantesTraslado.length +
          1,
        tipoDocumento: tipoDocumento || 'CC',
        numeroDocumento,
        nombreCompleto:
          String(
            beneficiario.nombreUsuario ??
              beneficiario.NombreUsuario ??
              beneficiario.nombre ??
              beneficiario.Nombre ??
              beneficiario.nombreCompleto ??
              beneficiario.NombreCompleto ??
              '',
          ).trim() || this.resolverNombreUsuarioDesdeFilaValidacion(row),
        parentescoDestino,
        edad: Number(beneficiario.edad ?? beneficiario.Edad ?? 0) || 0,
        genero: String(beneficiario.genero ?? beneficiario.Genero ?? '').trim(),
        esContratoDestino: false,
        anexoDestino: anexoActual,
        anexoDestinoLabel: beneficiario.anexoDestinoLabel || '',
        valorTarifaAnexo: beneficiario.valorTarifaAnexo || 0,
        valorTarifaPrograma: beneficiario.valorTarifaPrograma || 0,
        totalTarifa: beneficiario.totalTarifa || 0,
        showParentescoError: false,
        esTitularContratoDestino: false,
        parentescoDisponibles: this.parentescosActivos.filter(
          (p) => !this.existeParentescoEnDestino(p.codigo),
        ),
      };

      const keyDoc = this.buildIntegranteDocumentoKey(
        integrante.tipoDocumento,
        integrante.numeroDocumento,
      );

      if (destinoKeysDoc.has(keyDoc)) {
        return;
      }

      destinoKeysDoc.add(keyDoc);
      integrantesTraslado.push(integrante);
    });

    const destinoOrdenado = [...this.integrantesContratoDestino].sort(
      (a, b) => {
        const ta = this.esParentescoTitularFlexible(a?.parentesco) ? 0 : 1;
        const tb = this.esParentescoTitularFlexible(b?.parentesco) ? 0 : 1;
        return ta - tb;
      },
    );

    this.integrantesTrasladoExistente = [
      ...destinoOrdenado,
      ...integrantesTraslado,
    ];

    // Calcular total de cuota + IVA
    this.calcularTotalCuotaTrasladoExistente();
    this.sincronizarCatalogoAnexos();
    this.mostrarTablaIntegrantesTrasladoExistente = true;
  }

  private parseIdentificacion(raw: string | null | undefined): {
    tipo: string;
    numero: string;
  } {
    const valor = (raw || '').trim();
    if (!valor) {
      return { tipo: '', numero: '' };
    }

    const delimitadores = [' - ', '-'];
    for (const delim of delimitadores) {
      const index = valor.indexOf(delim);
      if (index > 0) {
        return {
          tipo: valor
            .slice(0, index)
            .replace(/[^A-Za-z]/g, '')
            .trim(),
          numero: valor.slice(index + delim.length).trim(),
        };
      }
    }

    const partes = valor.split(/\s+/);
    if (partes.length > 1) {
      const tipo = partes.shift() || '';
      return {
        tipo: tipo.replace(/[^A-Za-z]/g, '').trim(),
        numero: partes.join(' ').trim(),
      };
    }

    return { tipo: '', numero: valor };
  }

  private normalizeText(value: string | null | undefined): string {
    return (value || '')
      .normalize('NFD')
      .replace(/[^\w\s-]/g, '')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase();
  }

  private normalizarParentescoDestino(valor: any): any {
    if (!valor) {
      return null;
    }

    if (typeof valor === 'string') {
      const catalogo = this.obtenerParentescoCatalogo(valor);
      if (catalogo) {
        return catalogo;
      }
      return { codigo: valor.trim(), nombre: valor.trim() };
    }

    return valor;
  }

  private obtenerParentescoCatalogo(
    raw: string | null | undefined,
  ): { codigo: string; nombre: string } | null {
    const valor = (raw || '').trim();
    if (!valor || !this.parentescosActivos?.length) {
      return null;
    }

    const partes = valor.split('-');
    const nombreParte = (partes[1] ?? partes[0]).trim();
    const normalized = this.normalizeText(nombreParte);

    const encontrado = this.parentescosActivos.find((parentesco: any) => {
      return this.normalizeText(parentesco.nombre) === normalized;
    });

    if (encontrado) {
      return encontrado;
    }

    const codigoParte = (partes[0] || '').trim();
    if (codigoParte) {
      const porCodigo = this.parentescosActivos.find(
        (parentesco: any) =>
          this.normalizeText(parentesco.codigo) ===
          this.normalizeText(codigoParte),
      );
      if (porCodigo) {
        return porCodigo;
      }
    }

    if (valor) {
      return {
        codigo: partes[0]?.trim() || valor,
        nombre: nombreParte || valor,
      };
    }

    return null;
  }

  private parseAnexoValor(
    raw: string | null | undefined,
  ): { codigo: string; nombre: string } | null {
    const valor = (raw || '').trim();
    if (!valor) {
      return null;
    }

    const [codigoParte, ...descripcionPartes] = valor.split('-');
    const codigo = (codigoParte || '').trim();
    const descripcion = descripcionPartes.length
      ? descripcionPartes.join('-').trim()
      : valor;

    return {
      codigo: codigo || valor,
      nombre: descripcion || valor,
    };
  }

  private sincronizarCatalogoAnexos(): void {
    const fuentes = [
      ...(this.integrantesTrasladoExistente || []),
      ...(this.beneficiariosTarifa || []),
    ];

    const acumulado: { codigo: string; nombre: string }[] = [];

    fuentes.forEach((fuente: any) => {
      const opcion = this.parseAnexoValor(
        fuente.anexoDestinoLabel ||
          fuente.anexoDestinoDescripcion ||
          fuente.anexoDestino ||
          fuente.Anexo,
      );
      if (opcion && !acumulado.some((a) => a.codigo === opcion.codigo)) {
        acumulado.push(opcion);
      }
    });

    // Mantener catálogo consultado por endpoint + anexos ya presentes en filas.
    const merged = [...(this.anexosDestinoExistente || [])];
    for (const a of acumulado) {
      if (
        !merged.some((x: any) => String(x?.codigo ?? '').trim() === a.codigo)
      ) {
        merged.push(a);
      }
    }
    this.anexosDestinoExistente = merged;

    if (this.anexosDestinoExistente.length) {
      this.incluirAnexoExistenteControl.enable({ emitEvent: false });
    } else {
      this.incluirAnexoExistenteControl.enable({ emitEvent: false });
      this.incluirAnexoExistenteControl.setValue(false, { emitEvent: false });
    }
  }

  public compareParentesco = (a: any, b: any): boolean => {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }

    const codigoA = this.normalizeText(a.codigo || a.nombre);
    const codigoB = this.normalizeText(b.codigo || b.nombre);
    return codigoA === codigoB;
  };

  private buildIntegranteUniqueKey(
    tipoDocumento?: string,
    numeroDocumento?: string,
    valorTarifaAnexo?: number,
    valorTarifaPrograma?: number,
    totalTarifa?: number,
    anexoDestino?: string,
  ): string {
    const tipo = (tipoDocumento || '').replace(/[^A-Za-z]/g, '').toUpperCase();
    const numero = (numeroDocumento || '').trim();
    const anexo = (anexoDestino || '').trim().toUpperCase();

    const valorAnexo = Number(valorTarifaAnexo || 0).toFixed(2);
    const valorPrograma = Number(valorTarifaPrograma || 0).toFixed(2);
    const total = Number(totalTarifa || 0).toFixed(2);

    return [tipo, numero, valorAnexo, valorPrograma, total, anexo].join('|');
  }

  private existeParentescoEnDestino(codigoParentesco: string): boolean {
    // Validar si ya existe un integrante con ese parentesco en el contrato destino
    if (!codigoParentesco) {
      return false;
    }

    const catalogo = this.parentescosActivos.find(
      (parentesco) =>
        this.normalizeText(parentesco.codigo) ===
        this.normalizeText(codigoParentesco),
    );

    const referencia = catalogo?.nombre || codigoParentesco;
    const valorComparar = this.normalizeText(referencia);

    return this.integrantesContratoDestino.some((integrante) => {
      const nombreIntegrante =
        integrante.parentescoDestino?.nombre || integrante.parentesco || '';
      return this.normalizeText(nombreIntegrante) === valorComparar;
    });
  }

  public onParentescoDestinoExistenteChange(
    integranteIndex: number,
    parentesco: any,
  ): void {
    const integrante = this.integrantesTrasladoExistente[integranteIndex];

    if (!parentesco) {
      integrante.parentescoDestino = null;
      integrante.parentesco = '';
      return;
    }

    // Validar si ya existe ese parentesco en el contrato destino
    if (
      (parentesco.codigo === 'titular' || parentesco.codigo === 'conyugue') &&
      this.existeParentescoEnDestino(parentesco.codigo)
    ) {
      this.errorTrasladoContratoExistente = `Ya existe un integrante en el contrato destino con el parentesco ${parentesco.nombre}. No es posible asignar este parentesco a más de una persona en el contrato destino`;
      // Limpiar selección
      integrante.parentesco = '';
      return;
    }

    integrante.parentescoDestino = parentesco;
    integrante.parentesco = parentesco.nombre;
    this.errorTrasladoContratoExistente = '';
  }

  public onIncluirAnexoExistenteChange(): void {
    const incluir = this.incluirAnexoExistenteControl.value;

    if (incluir) {
      // Validar condiciones por integrante desde backend (`filas`).
      void this.validarCondicionesAnexosPorIntegrante();
    } else {
      // Deshabilitar y limpiar campos de anexo
      this.integrantesTrasladoExistente.forEach((integrante) => {
        integrante.anexoDestino = '';
        integrante.valorTarifaAnexo = 0;
        integrante.totalTarifa = integrante.valorTarifaPrograma;
      });
      this.calcularTotalCuotaTrasladoExistente();
    }
  }

  private async validarCondicionesAnexosPorIntegrante(): Promise<void> {
    const contrato = this.contratoDestinoControl.value;
    const grupoPrograma = this.normalizarCodigoGrupoPrograma(
      contrato?.grupoPrograma ?? contrato?.programa ?? '',
    );
    if (grupoPrograma) {
      try {
        const resp = await firstValueFrom(
          this.adicionaAnexoConsultaService.consulta({ grupoPrograma }),
        );
        if (Array.isArray(resp?.filas) && resp.filas.length > 0) {
          this.aplicarFilasConsultaAnexoATrasladoExistente(resp.filas);
        } else {
          // Sin `filas` no hay elegibilidad por integrante: dejar todas en "Ninguno".
          this.integrantesTrasladoExistente.forEach((integrante: any) => {
            integrante.anexoDestinoHabilitado = false;
            integrante.anexosDisponibles = [];
            integrante.anexoDestino = '';
            integrante.valorTarifaAnexo = 0;
            integrante.totalTarifa = integrante.valorTarifaPrograma;
          });
        }
      } catch (error) {
        console.error(
          'Error consultando condiciones de anexo por integrante (existente):',
          error,
        );
      }
    }

    if (!this.anexosDestinoExistente.length) {
      this.errorTrasladoContratoExistente =
        "No es posible asociar Anexos a esta novedad. Verifique la configuración de plan, línea de negocio, grupo programa y programa destino en el módulo 'Parametrización Anexos'.";
      this.incluirAnexoExistenteControl.setValue(false, { emitEvent: false });
      return;
    }

    this.integrantesTrasladoExistente.forEach((integrante) => {
      const habilitado = integrante.anexoDestinoHabilitado !== false;
      const opts = Array.isArray(integrante.anexosDisponibles)
        ? integrante.anexosDisponibles
        : [];
      // Regla por `nro`: si la fila no trae opciones, no heredar catálogo global.
      integrante.anexosDisponibles = opts;
      if (!habilitado) {
        integrante.anexoDestino = '';
        integrante.valorTarifaAnexo = 0;
        integrante.totalTarifa = integrante.valorTarifaPrograma;
      }
    });

    this.errorTrasladoContratoExistente = '';
    this.calcularTotalCuotaTrasladoExistente();
  }

  private construirIntegrantesConsultaAnexos(sourceRows?: any[]): Array<{
    inte: number;
    edad: number;
    genero: string;
    parentesco: string;
  }> {
    const baseRows =
      sourceRows && sourceRows.length
        ? sourceRows
        : this.integrantesTrasladoExistente?.length
          ? this.integrantesTrasladoExistente
          : this.beneficiariosTarifa?.length
            ? this.beneficiariosTarifa
            : (this.integrantesSeleccionados ?? []);

    return (baseRows || []).map((row: any, idx: number) => {
      const edadNum = Number(row?.edad);
      const generoRaw = String(row?.genero ?? '')
        .trim()
        .toUpperCase();
      const parentescoRaw =
        row?.parentescoDestino?.nombre ??
        row?.parentescoDestino?.codigo ??
        row?.parentesco ??
        '';
      return {
        inte: Number(row?.inte ?? row?.nro ?? row?.no ?? idx + 1) || idx + 1,
        edad:
          Number.isFinite(edadNum) && edadNum >= 0 ? Math.floor(edadNum) : 0,
        genero: generoRaw ? generoRaw.charAt(0) : '',
        parentesco: String(parentescoRaw ?? '').trim(),
      };
    });
  }

  private aplicarFilasConsultaAnexoATrasladoExistente(
    filas: AdicionaAnexoFilaConsultaDTO[] | any[],
  ): void {
    const byNro = new Map<number, any>();
    for (const raw of filas || []) {
      const nro = Number(raw?.nro ?? raw?.Nro ?? NaN);
      if (Number.isFinite(nro) && nro > 0) {
        byNro.set(nro, raw);
      }
    }

    const unionCatalog: any[] = [];
    for (let i = 0; i < this.integrantesTrasladoExistente.length; i++) {
      const integrante = this.integrantesTrasladoExistente[i];
      const nroIntegrante = Number(
        integrante?.inte ??
          integrante?.nro ??
          integrante?.no ??
          integrante?.numero ??
          i + 1,
      );
      const fila = byNro.get(
        Number.isFinite(nroIntegrante) && nroIntegrante > 0
          ? nroIntegrante
          : i + 1,
      );
      const opcionesRaw =
        fila?.opcionesAnexo ??
        fila?.OpcionesAnexo ??
        fila?.anexosPermitidos ??
        fila?.AnexosPermitidos ??
        [];
      const opciones: any[] = Array.isArray(opcionesRaw)
        ? opcionesRaw
            .map((a: any) => {
              const id = Number(a?.idPAnexos ?? a?.IdPAnexos ?? NaN);
              if (!Number.isFinite(id) || id < 0) {
                return null;
              }
              const nombre = String(a?.nombre ?? a?.Nombre ?? '').trim();
              const codigoFormato = String(a?.codigo ?? a?.Codigo ?? '').trim();
              return {
                codigo: `ID_${id}`,
                nombre: nombre || codigoFormato || `Anexo ${id}`,
                codigoFormato,
                idPAnexos: id,
              };
            })
            .filter((x: any) => !!x)
        : [];

      let habilitado = true;
      if (
        typeof (
          fila?.anexoDestinoHabilitado ?? fila?.AnexoDestinoHabilitado
        ) === 'boolean'
      ) {
        habilitado = !!(
          fila?.anexoDestinoHabilitado ?? fila?.AnexoDestinoHabilitado
        );
      } else if (
        typeof (fila?.campoHabilitado ?? fila?.CampoHabilitado) === 'boolean'
      ) {
        habilitado = !!(fila?.campoHabilitado ?? fila?.CampoHabilitado);
      } else {
        habilitado = opciones.length > 0;
      }

      const incluyeNoAplica = !!(
        fila?.incluyeNoAplica ?? fila?.IncluyeNoAplica
      );
      const disponibles = [...opciones];
      if (incluyeNoAplica) {
        disponibles.push({
          codigo: '',
          nombre: 'Ninguno',
          codigoFormato: 'NINGUNO',
          idPAnexos: 0,
        });
      }

      integrante.anexoDestinoHabilitado = habilitado;
      integrante.anexosDisponibles = habilitado ? disponibles : [];
      if (!habilitado) {
        integrante.anexoDestino = '';
      }

      for (const d of opciones) {
        if (!d) {
          continue;
        }
        if (!unionCatalog.some((x: any) => x.codigo === d.codigo)) {
          unionCatalog.push(d);
        }
      }
    }

    if (unionCatalog.length > 0) {
      this.anexosDestinoExistente = unionCatalog;
      this.incluirAnexoExistenteControl.enable({ emitEvent: false });
    }
  }

  public onAnexoExistenteChange(integranteIndex: number, anexo: string): void {
    const integrante = this.integrantesTrasladoExistente[integranteIndex];

    integrante.anexoDestino = anexo || '';
    const info = this.anexosDestinoExistente.find(
      (item) => item.codigo === anexo,
    );

    if (!anexo) {
      integrante.valorTarifaAnexo = 0;
      integrante.anexoDestinoLabel = '';
    } else {
      integrante.anexoDestinoLabel = info?.nombre || '';
    }

    integrante.totalTarifa =
      integrante.valorTarifaPrograma + (integrante.valorTarifaAnexo || 0);
    this.calcularTotalCuotaTrasladoExistente();
    this.errorTrasladoContratoExistente = '';
  }

  private calcularTotalCuotaTrasladoExistente(): void {
    const subtotal = this.integrantesTrasladoExistente.reduce(
      (sum, integrante) => sum + (Number(integrante.totalTarifa) || 0),
      0,
    );
    this.totalCuotaIvaTrasladoExistente = subtotal;
    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  private etiquetaTipoPlanContratoDestino(contrato: any): string {
    const tipoPlan = String(contrato?.tipoPlan ?? '').trim();
    if (tipoPlan) {
      return tipoPlan;
    }
    const cuenta = String(contrato?.cuenta ?? '').trim();
    const despuesGuion = cuenta.match(/^\d+\s*-\s*(.+)$/);
    if (despuesGuion?.[1]) {
      return despuesGuion[1].trim();
    }
    return cuenta;
  }

  public displayContratoDestino(contrato: any): string {
    if (!contrato) {
      return '';
    }
    const partes = [
      String(contrato.codigo ?? '').trim(),
      this.etiquetaTipoPlanContratoDestino(contrato),
      String(contrato.nombrePrograma ?? '').trim(),
    ].filter((p) => p.length > 0);
    return partes.join(' - ');
  }

  /**
   * MP-FT-1358 1.1.3.2 — contrato destino en la misma línea de negocio que el contrato origen.
   */
  private contratoDestinoCoincideLineaNegocioOrigen(
    lineaDestinoRaw: unknown,
  ): boolean {
    const origen = String(this.obtenerLineaNegocioContrato() ?? '').trim();
    if (!origen) {
      return true;
    }
    const destino = String(lineaDestinoRaw ?? '').trim();
    if (!destino) {
      return false;
    }
    const nOrigen = this.extraerSoloNumeroLineaNegocio(origen);
    const nDest = this.extraerSoloNumeroLineaNegocio(destino);
    if (nOrigen && nDest) {
      return nOrigen === nDest;
    }
    return (
      this.normalizarTextoLineaNegocioCmp(origen) ===
      this.normalizarTextoLineaNegocioCmp(destino)
    );
  }

  private normalizarTextoLineaNegocioCmp(s: string): string {
    return String(s ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s*\|\s*/g, '|')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private mapContratoAfilmedToContratoDestino(dto: any): any {
    if (!dto) return null;

    return {
      codigo: dto.contrato || dto.numero || dto.Contrato || '',
      tipoPlan: dto.TipoPlan || dto.tipoPlan || dto.tipo_plan || '',
      nombrePrograma:
        dto.ProgramaNombre || dto.ProgramaCodigo || dto.programaNombre || '',
      programa: dto.ProgramaNombre || dto.ProgramaCodigo || dto.programa || '',
      corte: dto.DiaCorte ? `Corte ${dto.DiaCorte}` : dto.corte || null,
      lineaNegocio:
        dto.LineaNegocio || dto.lineaNegocio || dto.linea_negocio || '',
      grupoPrograma:
        dto.GrupoPrograma || dto.grupoPrograma || dto.grupo_programa || '',
      tipoPrima: dto.TipoPrima || dto.tipoPrima || '',
      codigoTarifa: dto.CodigoTarifa || dto.codigoTarifa || '',
      descripcionTarifa:
        dto.DescripcionTarifa ||
        dto.descripcionTarifa ||
        dto.TarifaDescripcion ||
        dto.CodigoTarifa ||
        '',
      estado: dto.EstadoContrato || dto.estadoContrato || dto.estado || '',
      cuenta: leerCuentaAfilmed(dto) || String(dto.Cuenta ?? dto.cuenta ?? ''),
      esColectivo: this.esTipoPlanColectivoContratoDestino(dto),
      tipoDocumentoTitular:
        dto.tipoDocumentoTitular ??
        dto.TipoDocumentoTitular ??
        dto.tipoDocumento ??
        dto.TipoDocumento ??
        '',
      numeroDocumentoTitular:
        dto.numeroDocumentoTitular ??
        dto.NumeroDocumentoTitular ??
        dto.numeroDocumento ??
        dto.NumeroDocumento ??
        dto.docu_nro ??
        dto.DocuNro ??
        '',
    };
  }

  private formatearNumeroConMiles(valor: string): string {
    const soloDigitos = String(valor ?? '').replace(/\D/g, '');
    if (!soloDigitos) {
      return '';
    }
    return soloDigitos.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  private clearAllContratoExistenteFields(): void {
    this.tipoIdentificacionContratanteDestinoControl.setValue(null);
    this.numeroIdentificacionContratanteDestinoControl.setValue('');
    this.contratoDestinoControl.setValue(null);
    this.contratoDestinoSeleccionadoCodigo = null;
    this.proporcionalidadExistenteControl.setValue('Si');
    this.clearContractDependentFields();
    this.integrantesTrasladoExistente = [];
    this.integrantesContratoDestino = [];
    this.errorTrasladoContratoExistente = '';
  }

  // Propiedad para el total de cuota con IVA
  public totalCuotaIvaTrasladoExistente: number = 0;

  public async procesarTrasladoContratoExistente(): Promise<void> {
    this.mostrarCamposTrasladoContratoExistente = true;
    this.errorTrasladoContratoExistente = '';
    this.isLoadingTrasladoContratoExistente = false;
    if (!this.isRestoringState) {
      this.tipoIdentificacionContratanteDestinoControl.setValue(null, {
        emitEvent: false,
      });
      this.numeroIdentificacionContratanteDestinoControl.setValue('', {
        emitEvent: false,
      });
      this.contratoDestinoControl.setValue(null, { emitEvent: false });
      this.contratoDestinoSeleccionadoCodigo = null;
    }
    this.contratosDestinoSubject.next([]);
    this.cortesContratoDestino = [];
    this.programasDestino = [];
    this.tarifasDestino = [];
    this.anexosDestinoExistente = [];
    this.incluirAnexoExistenteControl.setValue(false, { emitEvent: false });
    this.incluirAnexoExistenteControl.enable({ emitEvent: false });
  }

  // Métodos para el formulario de contratante destino
  private initializeMockDataContratante(): void {
    // Tipos de vía
    this.tiposVia = [
      {
        codigo: 'AD',
        nombre: 'Administracion',
      },

      {
        codigo: 'AE',
        nombre: 'Aeropuerto',
      },

      {
        codigo: 'AL',
        nombre: 'Altillo',
      },

      {
        codigo: 'AA',
        nombre: 'Apartado Aereo',
      },

      {
        codigo: 'AP',
        nombre: 'Apartamento',
      },

      {
        codigo: 'AU',
        nombre: 'Autopista',
      },

      {
        codigo: 'AV',
        nombre: 'Avenida',
      },

      {
        codigo: 'AC',
        nombre: 'Avenida Calle',
      },

      {
        codigo: 'AK',
        nombre: 'Avenida Carrera',
      },

      {
        codigo: 'BR',
        nombre: 'Barrio',
      },

      {
        codigo: 'BQ',
        nombre: 'Bloque',
      },

      {
        codigo: 'BG',
        nombre: 'Bodega',
      },

      {
        codigo: 'BL',
        nombre: 'Bulevar',
      },

      {
        codigo: 'CL',
        nombre: 'Calle',
      },

      {
        codigo: 'KR',
        nombre: 'Carrera',
      },

      {
        codigo: 'CT',
        nombre: 'Carretera',
      },
    ];

    forkJoin({
      tiposDocumento: this.tiposDocumentoService.getTiposDocumento().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      estadosCiviles: this.estadosCivilesService.getEstadosCiviles().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      generos: this.generosService.getGeneros().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      estratosSociales: this.estratosSocialesService.getEstratosSociales().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      nacionalidades: this.nacionalidadesService.getNacionalidades().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      profesiones: this.profesionesService.getProfesiones().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      ocupaciones: this.ocupacionesService.getOcupaciones().pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        }),
      ),
      departamentos: this.provinciasXPaisService
        .getProvinciasPorPais('01')
        .pipe(
          catchError((err) => {
            console.error(err);
            return of([]);
          }),
        ),
    }).subscribe({
      next: (catalogos) => {
        this.tiposDocumentoContratante = catalogos.tiposDocumento as any[];
        this.estadosCiviles = catalogos.estadosCiviles as any[];
        this.generos = catalogos.generos as any[];
        this.estratosSociales = catalogos.estratosSociales as any[];
        this.nacionalidades = catalogos.nacionalidades as any[];
        this.profesiones = catalogos.profesiones as any[];
        this.ocupaciones = catalogos.ocupaciones as any[];
        this.departamentos = (
          catalogos.departamentos as ProvinciaXPaisDTO[]
        ).map((d) => ({
          codigo: d.provin,
          nombre: d.deno,
          descripcion: d.depto,
        }));
        this.precargarDatosContratanteActual();
      },
      error: (err) => {
        console.error(err);
        this.precargarDatosContratanteActual();
      },
    });
  }

  /**
   * Número de contrato para consultar cabecera (soporta camelCase / PascalCase en la fila Afilmed).
   */
  private normalizarNumeroContratoFila(fila: any): string {
    if (!fila || typeof fila !== 'object') {
      return '';
    }
    const v =
      fila.contrato ??
      fila.Contrato ??
      fila.numero ??
      fila.Numero ??
      fila.numeroContrato ??
      fila.NumeroContrato;
    return String(v ?? '').trim();
  }

  /**
   * Fila completa del POST contratos-users del contrato elegido en paso 1 (ojo),
   * alineada con `selectedContract` en `frmConsultState`. Si no hay fila en storage,
   * usa mínimo desde `@Input() contratoSeleccionado` (p. ej. `titular` = Contratante).
   */
  private obtenerContratoParaDatosContratante(): any {
    const desdeInput = this.filaContratoAfilmedPaso1 as any;
    const nroInput = desdeInput
      ? this.normalizarNumeroContratoFila(desdeInput)
      : '';
    if (desdeInput && nroInput) {
      const merged = { ...desdeInput, contrato: nroInput };
      const sel = this.contratoSeleccionado;
      const titular = sel?.titular ? String(sel.titular).trim() : '';
      if (
        titular &&
        (!merged.Contratante || !String(merged.Contratante).trim())
      ) {
        return { ...merged, Contratante: titular };
      }
      return merged;
    }

    const rowRaw = this.obtenerContratoDesdeStorage();
    const sel = this.contratoSeleccionado;
    if (rowRaw) {
      const nroRow = this.normalizarNumeroContratoFila(rowRaw);
      const row = nroRow ? { ...rowRaw, contrato: nroRow } : rowRaw;
      if (this.normalizarNumeroContratoFila(row)) {
        const titular = sel?.titular ? String(sel.titular).trim() : '';
        if (titular && (!row.Contratante || !String(row.Contratante).trim())) {
          return { ...row, Contratante: titular };
        }
        return row;
      }
    }
    const nroExplicit = String(this.numeroContratoPaso1 ?? '').trim();
    const nroDeSel =
      sel?.numero != null && String(sel.numero).trim() !== ''
        ? String(sel.numero).trim()
        : '';
    const nroFallback = nroExplicit || nroDeSel;
    if (nroFallback) {
      return {
        contrato: nroFallback,
        Contratante: sel?.titular,
        ProgramaCodigo: sel?.ProgramaCodigo,
        ProgramaNombre: sel?.ProgramaNombre,
        LineaNegocio: sel?.LineaNegocio,
        GrupoPrograma: sel?.GrupoPrograma,
        TipoPrima: sel?.TipoPrima,
      };
    }
    return {};
  }

  private precargarDatosContratanteActual(): void {
    const requestId = ++this.precargaContratanteRequestId;
    const contratoPaso1 = this.obtenerContratoParaDatosContratante();
    const nroContrato =
      this.normalizarNumeroContratoFila(contratoPaso1) ||
      String(this.obtenerNumeroContratoSeleccionado() ?? '').trim() ||
      String(this.numeroContratoPaso1 ?? '').trim();

    const aplicarSoloFila = () => {
      const datos =
        this.construirDatosOriginalesContratanteDesdeFila(contratoPaso1);
      this.aplicarDatosOriginalesContratanteAlFormulario(datos);
    };

    if (!nroContrato) {
      // En traslado a contrato nuevo, evitar que una recarga sin contrato
      // sobreescriba con placeholders una precarga válida previa.
      if (
        this.mostrarCamposTrasladoContratoNuevo &&
        this.datosContratanteActual
      ) {
        return;
      }
      aplicarSoloFila();
      return;
    }

    this.consultarCabeceraContratanteDestino(
      contratoPaso1,
      nroContrato,
    ).subscribe({
      next: (cab) => {
        if (requestId !== this.precargaContratanteRequestId) {
          return;
        }

        const datos =
          this.construirDatosOriginalesContratanteDesdeFila(contratoPaso1);

        if (
          this.mostrarCamposTrasladoContratoNuevo ||
          this.esTipoTrasladoContratoNuevoActivo() ||
          this.esSubtipoCambioTitularResponsableActivo() ||
          this.esSubtipoCambioResponsablePagadorActivo()
        ) {
          // usar directamente la respuesta de getDatosAfiliadoPagador
          Object.assign(datos, {
            tipoDocumento: cab?.tipoDocumento ?? '',
            numeroDocumento: cab?.numeroDocumento ?? '',

            primerApellido: cab?.primerApellido ?? '',
            segundoApellido: cab?.segundoApellido ?? '',

            primerNombre: cab?.primerNombre ?? '',
            segundoNombre: cab?.segundoNombre ?? '',

            fechaNacimiento: cab?.fechaNacimiento
              ? new Date(Number(cab.fechaNacimiento))
              : null,

            genero: this.resolverCodigoGeneroDesdeTexto(cab?.genero),
            nacionalidad: cab?.nacionalidad ?? null,
            estadoCivil: cab?.estadoCivil ?? null,
            estratoSocial: cab?.estratoSocial ?? null,
            profesion: cab?.profesion ?? null,
            ocupacion: cab?.ocupacion ?? null,

            email: cab?.email ?? '',

            telefonoResidencia: cab?.telefonoFijo ?? '',
            celular: cab?.telefonoCelular ?? '',

            tipoVia: cab?.tipoVia ?? null,
            numeroVia: cab?.numeroVia ?? null,
            numeroPlaca: cab?.numeroPlaca ?? null,
            complementoDireccion: cab?.complementoDireccion ?? null,

            barrio: cab?.barrio ?? null,
            departamento: cab?.departamento ?? null,
            municipio: cab?.municipio ?? null,
          });

          this.contratoContratanteCabeceraService
            .getCabeceraContratante(nroContrato)
            .subscribe((cabecera) => {
              datos.codigoAsesor = String(cabecera?.codigoAsesor ?? '').trim();

              this.aplicarDatosOriginalesContratanteAlFormulario(datos);
            });

          return;
        }

        if (cab) {
          this.fusionarCabeceraBackendEnDatosOriginales(datos, cab);
        }

        this.aplicarDatosOriginalesContratanteAlFormulario(datos);
      },
      error: () => {
        if (requestId !== this.precargaContratanteRequestId) {
          return;
        }
        // En traslado a contrato nuevo no degradar a placeholders si falla una llamada tardía.
        if (
          this.mostrarCamposTrasladoContratoNuevo &&
          this.datosContratanteActual
        ) {
          return;
        }
        aplicarSoloFila();
      },
    });
  }

  private consultarCabeceraContratanteDestino(
    contratoPaso1: any,
    nroContrato: string,
  ): Observable<ContratoContratanteCabeceraDTO | null> {
    if (
      this.mostrarCamposTrasladoContratoNuevo ||
      this.esTipoTrasladoContratoNuevoActivo() ||
      this.esSubtipoCambioTitularResponsableActivo() ||
      this.esSubtipoCambioResponsablePagadorActivo()
    ) {
      return this.consultarDatosAfiliadoPagadorConDocumento(nroContrato);
    }
    return this.contratoContratanteCabeceraService.getCabeceraContratante(
      nroContrato,
    );
  }

  private consultarDatosAfiliadoPagadorConDocumento(
    numeroContrato: string,
  ): Observable<ContratoContratanteCabeceraDTO | null> {
    return this.contratoContratanteCabeceraService
      .getCabeceraContratante(numeroContrato)
      .pipe(
        switchMap((cabecera) =>
          this.datosAfiliadoPagadorService.getDatosAfiliadoPagador({
            prepaga: '1',
            contra: String(numeroContrato).trim(),
            docu_tipo: String(cabecera?.tipoDocumento ?? '').trim(),
            docu_nro: this.soloDigitosIdentificacion(cabecera?.numeroDocumento),
          }),
        ),
      );
  }

  private fusionarCabeceraBackendEnDatosOriginales(
    datos: DatosContratantePrecarga,
    cab: ContratoContratanteCabeceraDTO,
  ): void {
    const putStr = (setter: (s: string) => void, v: string | undefined) => {
      const t = String(v ?? '').trim();
      if (t) {
        setter(t);
      }
    };
    putStr((s) => (datos.codigoAsesor = s), cab.codigoAsesor);
    putStr((s) => (datos.email = s), cab.email);
    if (cab.telefonoCelular) {
      datos.celular = String(cab.telefonoCelular).trim();
    }
    if (cab.telefonoFijo) {
      datos.telefonoResidencia = this.normalizarTelefonoFijoContrato(
        cab.telefonoFijo,
      );
    }
    const td = cab.tipoDocumento
      ? this.normalizarCodigoTipoDocumento(cab.tipoDocumento)
      : '';
    const nd = String(cab.numeroDocumento ?? '').trim();
    if (td) {
      datos.tipoDocumento = td;
    }
    if (nd) {
      datos.numeroDocumento = nd;
    }
    putStr((s) => (datos.primerNombre = s), cab.primerNombre);
    putStr((s) => (datos.primerApellido = s), cab.primerApellido);

    if (cab.segundoNombre !== undefined) {
      datos.segundoNombre =
        cab.segundoNombre == null ? '' : String(cab.segundoNombre).trim();
    }
    if (cab.segundoApellido !== undefined) {
      datos.segundoApellido =
        cab.segundoApellido == null ? '' : String(cab.segundoApellido).trim();
    }

    if (cab.fechaNacimiento) {
      datos.fechaNacimiento = new Date(Number(cab.fechaNacimiento));
    }

    if (cab.genero != null) {
      const rawGenero = String(cab.genero).trim();
      let codGenero = '';
      const sel = this.resolverCatalogoPorCodigoOTexto(
        this.generos,
        rawGenero,
        ['Codigo', 'codigo'],
        ['Nombre'],
      );
      if (sel) {
        codGenero = String(sel.Codigo ?? sel.codigo ?? '').trim();
      } else {
        const gNorm = this.normalizarTextoComparacion(rawGenero);
        // Algunos servicios envían `M/F`, mientras el catálogo maneja códigos distintos (p. ej. 1/2).
        if (gNorm === 'm' || gNorm === 'masculino') {
          const rowMasc = (this.generos || []).find((g: any) =>
            this.normalizarTextoComparacion(
              String(g?.Nombre ?? g?.nombre ?? ''),
            ).includes('mascul'),
          );
          codGenero = rowMasc
            ? String(rowMasc.Codigo ?? rowMasc.codigo ?? '').trim()
            : rawGenero;
        } else if (gNorm === 'f' || gNorm === 'femenino') {
          const rowFem = (this.generos || []).find((g: any) =>
            this.normalizarTextoComparacion(
              String(g?.Nombre ?? g?.nombre ?? ''),
            ).includes('femen'),
          );
          codGenero = rowFem
            ? String(rowFem.Codigo ?? rowFem.codigo ?? '').trim()
            : rawGenero;
        } else {
          codGenero = rawGenero;
        }
      }
      if (codGenero) {
        datos.genero = codGenero as any;
      }
    }

    if (cab.estadoCivil != null) {
      const row = this.resolverCatalogoPorCodigoOTexto(
        this.estadosCiviles,
        cab.estadoCivil,
        ['civil_esta'],
        ['deno'],
      );
      if (row?.civil_esta != null) {
        datos.estadoCivil = row.civil_esta;
      }
    }

    if (cab.estratoSocial != null) {
      const row = this.resolverCatalogoPorCodigoOTexto(
        this.estratosSociales,
        cab.estratoSocial,
        ['estrato_social'],
        ['deno'],
      );
      if (row?.estrato_social) {
        datos.estratoSocial = row.estrato_social;
      }
    }

    if (cab.nacionalidad != null) {
      const row = this.resolverCatalogoPorCodigoOTexto(
        this.nacionalidades,
        cab.nacionalidad,
        ['nacio', 'nacio_sss'],
        ['denominacion'],
      );
      if (row?.nacio) {
        datos.nacionalidad = row.nacio;
      }
    }

    if (cab.profesion != null) {
      const row = this.resolverCatalogoPorCodigoOTexto(
        this.profesiones,
        cab.profesion,
        ['profesion'],
        ['deno'],
      );
      if (row?.profesion) {
        datos.profesion = row.profesion;
      }
    }

    if (cab.ocupacion != null) {
      const row = this.resolverCatalogoPorCodigoOTexto(
        this.ocupaciones,
        cab.ocupacion,
        ['ocupacion'],
        ['deno'],
      );
      if (row?.ocupacion) {
        datos.ocupacion = row.ocupacion;
      } else {
        const t = String(cab.ocupacion).trim();
        if (t) {
          datos.ocupacion = t;
        }
      }
    }

    if (
      cab.deseaCorrespondenciaFisica != null &&
      cab.deseaCorrespondenciaFisica !== ''
    ) {
      const v = cab.deseaCorrespondenciaFisica;
      let s: string | undefined;
      if (typeof v === 'boolean') {
        s = v ? 'Si' : 'No';
      } else {
        const t = String(v).trim().toLowerCase();
        if (['s', 'si', 'true', '1', 'y'].includes(t)) {
          s = 'Si';
        } else if (['n', 'no', 'false', '0'].includes(t)) {
          s = 'No';
        }
      }
      if (s) {
        datos.recibirCorrespondencia = s;
      }
    }

    const linea = String(cab.contratanteLinea ?? '').trim();
    if (linea) {
      const p = this.parseLineaContratanteContratoUsers(linea);
      if (p.tipoDoc && !datos.tipoDocumento) {
        datos.tipoDocumento = p.tipoDoc;
      }
      if (p.numeroDoc && !datos.numeroDocumento) {
        datos.numeroDocumento = p.numeroDoc;
      }
      if (p.nombreRemanente) {
        const soloNombres =
          !datos.primerNombre &&
          !datos.primerApellido &&
          !datos.segundoApellido;
        if (soloNombres) {
          const part = this.particionarNombreContratante(p.nombreRemanente);
          if (part.primerNombre) {
            datos.primerNombre = part.primerNombre;
          }
          if (part.segundoNombre) {
            datos.segundoNombre = part.segundoNombre;
          }
          if (part.primerApellido) {
            datos.primerApellido = part.primerApellido;
          }
          if (part.segundoApellido) {
            datos.segundoApellido = part.segundoApellido;
          }
        }
      }
    }

    if (cab.tipoVia != null) {
      datos.tipoVia = cab.tipoVia;
    }

    if (cab.numeroVia != null) {
      const t = String(cab.numeroVia).trim();
      if (t) {
        datos.numeroVia = t;
      }
    }

    if (cab.numeroPlaca != null) {
      const t = String(cab.numeroPlaca).trim();
      if (t) {
        datos.numeroPlaca = t;
      }
    }

    if (cab.complementoDireccion != null) {
      datos.complementoDireccion = String(cab.complementoDireccion).trim();
    }

    if (cab.barrio != null) {
      datos.barrio = cab.barrio;
    }

    if (cab.departamento != null) {
      datos.departamento = cab.departamento;
    }

    if (cab.municipio != null) {
      datos.municipio = cab.municipio;
    }
  }

  private construirDatosOriginalesContratanteDesdeFila(
    contratoPaso1: any,
  ): DatosContratantePrecarga {
    const codigoAsesorGestion = this.obtenerValorContrato(
      contratoPaso1,
      ['AsesorGestion', 'asesorGestion'],
      '',
    );

    const codigoAsesorPoblacion = this.obtenerValorContrato(
      contratoPaso1,
      ['AsesorPoblacion', 'asesorPoblacion'],
      '',
    );

    const codigoAsesorExplicito = this.obtenerValorContrato(
      contratoPaso1,
      ['CodigoAsesor', 'codigoAsesor'],
      '',
    );

    const codigoAsesor =
      this.extraerCodigoPrefijoDescripcion(codigoAsesorExplicito) ||
      this.extraerCodigoPrefijoDescripcion(codigoAsesorGestion) ||
      this.extraerCodigoPrefijoDescripcion(codigoAsesorPoblacion) ||
      '';

    return {
      codigoAsesor: String(codigoAsesor),

      tipoDocumento: '',
      numeroDocumento: '',
      primerApellido: '',
      segundoApellido: '',
      primerNombre: '',
      segundoNombre: '',

      fechaNacimiento: null as any,
      estadoCivil: null,
      genero: null,
      estratoSocial: null,
      nacionalidad: null,
      profesion: null,

      recibirCorrespondencia: 'Si',

      email: '',

      ocupacion: null,
      tipoVia: null,
      numeroVia: null,
      numeroPlaca: '',
      direccion: '',
      complementoDireccion: '',

      barrio: null,
      departamento: null,
      municipio: null,

      telefonoResidencia: '',
      celular: '',
    };
  }

  private aplicarDatosOriginalesContratanteAlFormulario(
    datosOriginales: DatosContratantePrecarga,
  ): void {
    this.datosContratanteActual = { ...datosOriginales };

    this.codigoAsesorDestinoControl.setValue(datosOriginales.codigoAsesor);
    this.tipoDocumentoContratanteControl.setValue(
      datosOriginales.tipoDocumento,
    );
    this.numeroDocumentoContratanteControl.setValue(
      datosOriginales.numeroDocumento,
    );
    this.primerApellidoContratanteControl.setValue(
      datosOriginales.primerApellido,
    );
    this.segundoApellidoContratanteControl.setValue(
      datosOriginales.segundoApellido,
    );
    this.primerNombreContratanteControl.setValue(datosOriginales.primerNombre);
    this.segundoNombreContratanteControl.setValue(
      datosOriginales.segundoNombre,
    );
    this.fechaNacimientoContratanteControl.setValue(
      datosOriginales.fechaNacimiento,
    );
    this.estadoCivilContratanteControl.setValue(datosOriginales.estadoCivil);
    this.generoContratanteControl.setValue(datosOriginales.genero);
    this.estratoSocialContratanteControl.setValue(
      datosOriginales.estratoSocial,
    );
    this.nacionalidadContratanteControl.setValue(datosOriginales.nacionalidad);
    this.profesionContratanteControl.setValue(datosOriginales.profesion);
    this.recibirCorrespondenciaControl.setValue(
      datosOriginales.recibirCorrespondencia,
    );
    this.emailContratanteControl.setValue(datosOriginales.email);
    this.ocupacionContratanteControl.setValue(datosOriginales.ocupacion);
    this.tipoViaControl.setValue(datosOriginales.tipoVia);
    this.numeroViaControl.setValue(datosOriginales.numeroVia);
    this.numeroPlacaControl.setValue(datosOriginales.numeroPlaca);

    const tieneDireccionCompleta =
      datosOriginales.tipoVia &&
      datosOriginales.numeroVia &&
      datosOriginales.numeroPlaca;

    const direccion = tieneDireccionCompleta
      ? `${datosOriginales.tipoVia} ${datosOriginales.numeroVia} # ${datosOriginales.numeroPlaca}`
      : '';

    this.direccionControl.setValue(direccion);
    this.complementoDireccionControl.setValue(
      datosOriginales.complementoDireccion,
    );
    this.barrioControl.setValue(datosOriginales.barrio);
    this.departamentoControl.setValue(datosOriginales.departamento);
    this.municipioControl.setValue(datosOriginales.municipio);

    const codDepto = datosOriginales.departamento;
    if (codDepto) {
      this.municipiosPorDepartamentoService
        .getMunicipiosPorDepartamento(codDepto)
        .subscribe({
          next: (data) => {
            this.municipios = data.map((m) => ({
              codigo: m.codigo,
              nombre: m.municipio,
              descripcion: m.muncp,
            }));

            this.barrios = [...this.municipios];

            const matchMunicipio = this.municipios.find(
              (m) =>
                String(m.codigo).trim() ===
                String(datosOriginales.municipio ?? '').trim(),
            );

            if (matchMunicipio) {
              this.municipioControl.setValue(matchMunicipio.codigo, {
                emitEvent: false,
              });
            }

            const matchBarrio = this.barrios.find(
              (b) =>
                String(b.codigo).trim() ===
                String(datosOriginales.barrio ?? '').trim(),
            );

            if (matchBarrio) {
              this.barrioControl.setValue(matchBarrio.codigo, {
                emitEvent: false,
              });
            }
          },
          error: () => {
            this.municipios = [];
            this.barrios = [];
          },
        });
    }

    this.telefonoResidenciaControl.setValue(datosOriginales.telefonoResidencia);
    this.celularControl.setValue(datosOriginales.celular);

    this.evaluarEstadoFormularioContratante();
  }

  private obtenerValorContrato(
    contrato: any,
    keys: string[],
    fallback: any = '',
  ): any {
    for (const key of keys) {
      const value = contrato?.[key];
      if (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ''
      ) {
        return value;
      }
    }
    return fallback;
  }

  private normalizarCodigoTipoDocumento(raw: any): string {
    const text = String(raw || '').trim();
    if (!text) return '';
    const maybeCode = text.split('-')[0]?.trim();
    return maybeCode || text;
  }

  /**
   * Formato típico contratos-users / Afilmed: "CC - 94449309 ALEJANDRO PEÑA"
   */
  private parseLineaContratanteContratoUsers(text: string): {
    tipoDoc: string;
    numeroDoc: string;
    nombreRemanente: string;
  } {
    const limpio = String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!limpio) {
      return { tipoDoc: '', numeroDoc: '', nombreRemanente: '' };
    }
    const m = limpio.match(/^([A-Za-z0-9]+)\s*-\s*([\d.]+)\s+(.+)$/);
    if (m) {
      return {
        tipoDoc: m[1].toUpperCase(),
        numeroDoc: m[2].trim(),
        nombreRemanente: m[3].trim(),
      };
    }
    return { tipoDoc: '', numeroDoc: '', nombreRemanente: limpio };
  }

  /** "20 - PREPAGADA ..." → "20"; si no hay guión, devuelve el texto recortado. */
  private extraerCodigoPrefijoDescripcion(raw: any): string {
    const s = String(raw ?? '').trim();
    if (!s) return '';
    const left = s.split(/\s*-\s*/)[0]?.trim();
    return left || s;
  }

  private normalizarTelefonoFijoContrato(raw: any): string {
    return String(raw ?? '')
      .replace(/\s*EXT\.?\s*$/i, '')
      .replace(/\u00A0/g, ' ')
      .trim();
  }

  private resolverCatalogoPorCodigoOTexto<T extends Record<string, any>>(
    lista: T[],
    codigoRaw: string | null | undefined,
    camposCodigo: (keyof T)[],
    camposTexto?: (keyof T)[],
  ): T | undefined {
    const raw = String(codigoRaw ?? '').trim();
    if (!raw || !lista?.length) {
      return undefined;
    }
    const up = raw.toUpperCase();
    return lista.find((item) => {
      for (const k of camposCodigo) {
        const v = item[k];
        if (v != null && String(v).trim().toUpperCase() === up) {
          return true;
        }
      }
      if (camposTexto) {
        for (const k of camposTexto) {
          const v = item[k];
          if (v != null && String(v).trim().toUpperCase() === up) {
            return true;
          }
        }
      }
      return false;
    });
  }

  private particionarNombreContratante(nombreCompleto: string): {
    primerApellido: string;
    segundoApellido: string;
    primerNombre: string;
    segundoNombre: string;
  } {
    const limpio = String(nombreCompleto || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!limpio) {
      return {
        primerApellido: '',
        segundoApellido: '',
        primerNombre: '',
        segundoNombre: '',
      };
    }

    // Soporta formato "APELLIDOS, NOMBRES".
    if (limpio.includes(',')) {
      const [apellidosRaw, nombresRaw] = limpio.split(',');
      const apellidos = String(apellidosRaw || '')
        .trim()
        .split(' ')
        .filter(Boolean);
      const nombres = String(nombresRaw || '')
        .trim()
        .split(' ')
        .filter(Boolean);
      return {
        primerApellido: apellidos[0] || '',
        segundoApellido: apellidos.slice(1).join(' '),
        primerNombre: nombres[0] || '',
        segundoNombre: nombres.slice(1).join(' '),
      };
    }

    const partes = limpio.split(' ').filter(Boolean);
    if (partes.length === 1) {
      return {
        primerApellido: '',
        segundoApellido: '',
        primerNombre: partes[0],
        segundoNombre: '',
      };
    }
    if (partes.length === 2) {
      return {
        primerApellido: partes[1],
        segundoApellido: '',
        primerNombre: partes[0],
        segundoNombre: '',
      };
    }
    if (partes.length === 3) {
      return {
        primerApellido: partes[2],
        segundoApellido: '',
        primerNombre: partes[0],
        segundoNombre: partes[1],
      };
    }
    return {
      primerApellido: partes[2] || '',
      segundoApellido: partes.slice(3).join(' '),
      primerNombre: partes[0] || '',
      segundoNombre: partes[1] || '',
    };
  }

  public onTipoContratanteChange(tipo: string): void {
    this.cambiarDatosContratanteControl.setValue(false, {
      emitEvent: false,
    });

    this.actualizarEstadoTipoNumeroDocumento();
    this.precargarDatosContratanteActual();
    this.evaluarEstadoFormularioContratante();
  }

  public buscarContratante(): void {
    const tipoDoc = this.tipoDocumentoContratanteControl.value;
    const numeroDoc = this.numeroDocumentoContratanteControl.value;

    if (!tipoDoc || !numeroDoc) {
      return;
    }

    const nroContrato = String(
      this.obtenerNumeroContratoSeleccionado() ?? '',
    ).trim();

    this.datosAfiliadoPagadorService
      .getDatosAfiliadoPagador({
        prepaga: '1',
        contra: nroContrato,
        docu_tipo: tipoDoc,
        docu_nro: String(numeroDoc).trim(),
      })
      .subscribe((contratante) => {
        if (!contratante) {
          const modalRef = this.modalService.open(ModalBasicComponent, {
            centered: true,
            windowClass: 'custom-modal-radius',
          });
          modalRef.componentInstance.title = 'Información';
          modalRef.componentInstance.content =
            'No se encontraron coincidencias';
          modalRef.componentInstance.buttons = [
            {
              text: 'Cerrar',
              color: 'btn-primary',
              action: 'close',
              value: true,
            },
          ];
          return;
        }

        const datos: DatosContratantePrecarga = {
          codigoAsesor: '',

          tipoDocumento: contratante.tipoDocumento ?? '',
          numeroDocumento: contratante.numeroDocumento ?? '',

          primerApellido: contratante.primerApellido ?? '',
          segundoApellido: contratante.segundoApellido ?? '',

          primerNombre: contratante.primerNombre ?? '',
          segundoNombre: contratante.segundoNombre ?? '',

          fechaNacimiento: contratante.fechaNacimiento
            ? new Date(Number(contratante.fechaNacimiento))
            : (undefined as any),

          estadoCivil: contratante.estadoCivil ?? '',
          genero: this.resolverCodigoGeneroDesdeTexto(contratante.genero),
          estratoSocial: contratante.estratoSocial ?? '',
          nacionalidad: contratante.nacionalidad ?? '',
          profesion: contratante.profesion ?? '',
          ocupacion: contratante.ocupacion ?? '',

          recibirCorrespondencia: '',

          email: contratante.email ?? '',

          tipoVia: contratante.tipoVia ?? '',
          numeroVia: contratante.numeroVia ?? '',
          numeroPlaca: contratante.numeroPlaca ?? '',
          direccion: '',
          complementoDireccion: contratante.complementoDireccion ?? '',

          barrio: contratante.barrio ?? '',
          departamento: contratante.departamento ?? '',
          municipio: contratante.municipio ?? '',

          telefonoResidencia: contratante.telefonoFijo ?? '',
          celular: contratante.telefonoCelular ?? '',
        };

        this.aplicarDatosOriginalesContratanteAlFormulario(datos);

        this.actualizarEstadoCamposBusquedaContratante(contratante);
      });
  }

  private actualizarEstadoCamposBusquedaContratante(
    contratante: ContratoContratanteCabeceraDTO,
  ): void {
    const toggle = (control: FormControl, valor: unknown): void => {
      if (valor === null || valor === undefined || valor === '') {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    };

    toggle(this.estadoCivilContratanteControl, contratante.estadoCivil);

    toggle(this.generoContratanteControl, contratante.genero);

    toggle(this.estratoSocialContratanteControl, contratante.estratoSocial);

    toggle(this.nacionalidadContratanteControl, contratante.nacionalidad);

    toggle(this.profesionContratanteControl, contratante.profesion);

    toggle(this.ocupacionContratanteControl, contratante.ocupacion);

    toggle(this.emailContratanteControl, contratante.email);

    toggle(this.tipoViaControl, contratante.tipoVia);

    toggle(this.numeroViaControl, contratante.numeroVia);

    toggle(this.numeroPlacaControl, contratante.numeroPlaca);

    toggle(this.complementoDireccionControl, contratante.complementoDireccion);

    toggle(this.barrioControl, contratante.barrio);

    toggle(this.departamentoControl, contratante.departamento);

    toggle(this.municipioControl, contratante.municipio);

    toggle(this.telefonoResidenciaControl, contratante.telefonoFijo);

    toggle(this.celularControl, contratante.telefonoCelular);
  }

  private evaluarEstadoFormularioContratante(): void {
    const esMantenerContratante =
      this.tipoContratanteControl.value === 'mantener';
    const esCambiarContratante =
      this.tipoContratanteControl.value === 'cambiar';
    const esCambiarDatos = Boolean(this.cambiarDatosContratanteControl.value);
    const hayDatosContratante =
      (this.primerNombreContratanteControl.value || '').toString().trim() !==
      '';

    const hayBaseParaCheckbox = esMantenerContratante
      ? this.datosContratanteActual != null
      : hayDatosContratante;

    this.puedeEditarDatosContratante = hayBaseParaCheckbox;
    this.contratanteEdicionComplementariaActiva =
      esCambiarDatos && hayBaseParaCheckbox;
    this.esCampoEditableContratante =
      this.contratanteEdicionComplementariaActiva;

    this.puedeActualizarAfilmed =
      this.contratanteEdicionComplementariaActiva &&
      this.datosContratanteActual != null &&
      this.formulariosContratanteCambiado();

    this.puedeEditarCodigoAsesor = false;

    this.actualizarValidacionesContratante(
      esCambiarContratante,
      esCambiarDatos,
      hayDatosContratante,
    );
  }

  private formulariosContratanteCambiado(): boolean {
    if (!this.datosContratanteActual) return false;

    // Comparar valores actuales con los datos originales precargados
    const cambios = [
      this.estadoCivilContratanteControl.value?.codigo !==
        this.datosContratanteActual.estadoCivil?.codigo,
      this.generoContratanteControl.value?.codigo !==
        this.datosContratanteActual.genero?.codigo,
      this.estratoSocialContratanteControl.value?.codigo !==
        this.datosContratanteActual.estratoSocial?.codigo,
      this.nacionalidadContratanteControl.value?.codigo !==
        this.datosContratanteActual.nacionalidad?.codigo,
      this.profesionContratanteControl.value?.codigo !==
        this.datosContratanteActual.profesion?.codigo,
      this.emailContratanteControl.value !== this.datosContratanteActual.email,
      this.ocupacionContratanteControl.value?.codigo !==
        this.datosContratanteActual.ocupacion?.codigo,
      this.tipoViaControl.value?.codigo !==
        this.datosContratanteActual.tipoVia?.codigo,
      this.direccionControl.value !== this.datosContratanteActual.direccion,
      this.complementoDireccionControl.value !==
        this.datosContratanteActual.complementoDireccion,
      this.barrioControl.value?.codigo !==
        this.datosContratanteActual.barrio?.codigo,
      this.departamentoControl.value?.codigo !==
        this.datosContratanteActual.departamento?.codigo,
      this.municipioControl.value?.codigo !==
        this.datosContratanteActual.municipio?.codigo,
      this.telefonoResidenciaControl.value !==
        this.datosContratanteActual.telefonoResidencia,
      this.celularControl.value !== this.datosContratanteActual.celular,
    ];

    return cambios.some((cambio) => cambio === true);
  }

  private actualizarValidacionesContratante(
    esCambiarContratante: boolean,
    esCambiarDatos: boolean,
    hayDatos: boolean,
  ): void {
    // Si es cambio de contratante pero no hay datos completos, marcar campos faltantes como requeridos
    if (esCambiarContratante && hayDatos) {
      this.marcarCamposFaltantesComoRequeridos();
    }

    // Actualizar estado visual de campos requeridos faltantes
    this.actualizarEstadoVisualCampos(esCambiarContratante, !hayDatos);
  }

  private marcarCamposFaltantesComoRequeridos(): void {
    // Validar cuáles campos están vacíos y marcarlos como requeridos visualmente
    const camposRequeridos = [
      { control: this.estadoCivilContratanteControl, nombre: 'Estado civil' },
      {
        control: this.estratoSocialContratanteControl,
        nombre: 'Estrato social',
      },
      { control: this.nacionalidadContratanteControl, nombre: 'Nacionalidad' },
      { control: this.profesionContratanteControl, nombre: 'Profesión' },
      { control: this.ocupacionContratanteControl, nombre: 'Ocupación' },
      { control: this.tipoViaControl, nombre: 'Tipo vía' },
      { control: this.direccionControl, nombre: 'Dirección' },
      { control: this.barrioControl, nombre: 'Barrio' },
      { control: this.departamentoControl, nombre: 'Departamento' },
      { control: this.municipioControl, nombre: 'Municipio' },
      { control: this.telefonoResidenciaControl, nombre: 'Teléfono' },
      { control: this.celularControl, nombre: 'Celular' },
    ];

    camposRequeridos.forEach((campo) => {
      if (
        !campo.control.value ||
        (typeof campo.control.value === 'object' &&
          !campo.control.value.codigo) ||
        (typeof campo.control.value === 'string' &&
          campo.control.value.trim() === '')
      ) {
        campo.control.setErrors({ required: true });
      }
    });
  }

  private actualizarEstadoVisualCampos(
    esCambiarContratante: boolean,
    faltanDatos: boolean,
  ): void {
    // Esta lógica se manejará en el template con clases CSS condicionales
  }

  private updateTipoControlState(): void {
    const shouldDisable =
      this.disabled || this.isLoadingTipos || this.hasErrorTipos;

    if (shouldDisable && this.tipoNovedadControl.enabled) {
      this.tipoNovedadControl.disable({ emitEvent: false });
    } else if (!shouldDisable && this.tipoNovedadControl.disabled) {
      this.tipoNovedadControl.enable({ emitEvent: false });
    }
  }

  private updateSubtipoControlState(): void {
    const shouldDisable =
      this.disabled ||
      this.isLoadingSubtipos ||
      this.hasErrorSubtipos ||
      !this.subtipoHabilitado;

    if (shouldDisable && this.subtipoNovedadControl.enabled) {
      this.subtipoNovedadControl.disable({ emitEvent: false });
    } else if (!shouldDisable && this.subtipoNovedadControl.disabled) {
      this.subtipoNovedadControl.enable({ emitEvent: false });
    }
  }

  public onDepartamentoChange(codigoDepartamento: string): void {
    this.municipioControl.setValue(null);

    this.municipiosPorDepartamentoService
      .getMunicipiosPorDepartamento(codigoDepartamento)
      .subscribe({
        next: (data) => {
          this.municipios = data.map((m) => ({
            codigo: m.codigo,
            nombre: m.municipio,
            descripcion: m.muncp,
          }));

          this.barrios = [...this.municipios];
        },
        error: (err) => {
          console.error(err);
          this.municipios = [];
        },
      });
  }

  public actualizarDatosAfilmed(): void {
    if (!this.puedeActualizarAfilmed) return;

    // Mostrar confirmación antes de guardar
    const confirmacion = confirm(
      '¿Desea guardar los cambios realizados en los datos del contratante? ' +
        'Esta acción actualizará los datos en Afilmed.',
    );

    if (!confirmacion) {
      return; // Usuario canceló la operación
    }

    // Simular llamada al servicio de Afilmed
    this.isLoadingActualizacionAfilmed = true;

    setTimeout(() => {
      this.isLoadingActualizacionAfilmed = false;

      // Mock: simular diferentes tipos de respuesta
      const simulacionRespuesta = Math.random();

      if (simulacionRespuesta > 0.8) {
        // Simular error de validación de datos
        this.mostrarErrorValidacionAfilmed({
          campo: 'email',
          mensaje:
            'El formato del correo electrónico no es válido. Debe tener máximo 100 caracteres.',
        });
      } else if (simulacionRespuesta > 0.6) {
        // Simular error de servicio
        alert(
          'Error al conectar con Afilmed. Por favor, intente nuevamente o contacte al administrador del sistema.',
        );
      } else {
        // Simular éxito
        alert(
          'Datos actualizados exitosamente en Afilmed. Los cambios han sido registrados en la trazabilidad del sistema.',
        );

        // Actualizar datos originales con los nuevos valores
        this.actualizarDatosOriginales();
        this.puedeActualizarAfilmed = false;

        // Permitir avanzar al siguiente paso
        this.validacionCompletada.emit(true);
      }
    }, 2000);
  }

  private mostrarErrorValidacionAfilmed(error: {
    campo: string;
    mensaje: string;
  }): void {
    // Marcar el campo específico con error
    const control = this.getControlByCampo(error.campo);
    if (control) {
      control.setErrors({ afilmedValidation: { message: error.mensaje } });
    }

    // Mostrar mensaje general
    alert(`Error de validación en ${error.campo}: ${error.mensaje}`);
  }

  private getControlByCampo(campo: string): any {
    const mapaCampos: { [key: string]: any } = {
      email: this.emailContratanteControl,
      telefono: this.telefonoResidenciaControl,
      celular: this.celularControl,
      direccion: this.direccionControl,
    };

    return mapaCampos[campo];
  }

  private actualizarDatosOriginales(): void {
    // Actualizar los datos originales con los valores actuales para futuras comparaciones
    this.datosContratanteActual = {
      ...this.datosContratanteActual,
      estadoCivil: this.estadoCivilContratanteControl.value,
      genero: this.generoContratanteControl.value,
      estratoSocial: this.estratoSocialContratanteControl.value,
      nacionalidad: this.nacionalidadContratanteControl.value,
      profesion: this.profesionContratanteControl.value,
      email: this.emailContratanteControl.value,
      ocupacion: this.ocupacionContratanteControl.value,
      tipoVia: this.tipoViaControl.value,
      direccion: this.direccionControl.value,
      complementoDireccion: this.complementoDireccionControl.value,
      barrio: this.barrioControl.value,
      departamento: this.departamentoControl.value,
      municipio: this.municipioControl.value,
      telefonoResidencia: this.telefonoResidenciaControl.value,
      celular: this.celularControl.value,
    };
  }

  // Métodos para Cambio de titular a responsable pagador (MP-FT-1358 1.1.3.4)
  private limpiarEstadoUiCambioTitularResponsable(): void {
    this.titularActualVista = null;
    this.cambioTitularMensajeAlerta = '';
    this.cambioTitularRequisitosPreviosOk = false;
    this.integrantesSinTitular = [];
    this.nuevoTitularSeleccionadoControl.setValue(null, { emitEvent: false });
    this.tipoIdentificacionNuevoContratanteControl.setValue(null, {
      emitEvent: false,
    });
    this.numeroIdentificacionNuevoContratanteControl.setValue('', {
      emitEvent: false,
    });
    this.nombreNuevoContratanteControl.setValue('', { emitEvent: false });
    this.motivoRetiroResponsableControl.setValue(null, { emitEvent: false });
    this.activarDebitoAutomaticoNuevoResponsableControl.setValue(false, {
      emitEvent: false,
    });
    this.metodoDebitoAutomaticoControl.setValue(null, { emitEvent: false });
    this.confirmacionGestionTarjetaControl.setValue(false, {
      emitEvent: false,
    });
    this.tipoCuentaDebitoControl.setValue(null, { emitEvent: false });
    this.bancoDebitoControl.setValue(null, { emitEvent: false });
    this.numeroCuentaDebitoControl.setValue('', { emitEvent: false });
    this.advertenciaDebitoActualCambioResponsable = '';
    this.tieneDebitoAutomaticoContratoActual = null;
  }

  private extraerBanderaDebitoAutomaticoContrato(
    cab: ContratoContratanteCabeceraDTO,
  ): boolean | null {
    const raw: any = cab as any;
    const candidato =
      raw?.debitoAutomatico ??
      raw?.debito_automatico ??
      raw?.tieneDebitoAutomatico ??
      raw?.tiene_debito_automatico ??
      raw?.aplicaDebitoAutomatico ??
      raw?.aplica_debito_automatico;
    if (candidato == null || candidato === '') {
      return null;
    }
    if (typeof candidato === 'boolean') {
      return candidato;
    }
    const txt = String(candidato).trim().toLowerCase();
    if (['1', 's', 'si', 'y', 'yes', 'true'].includes(txt)) {
      return true;
    }
    if (['0', 'n', 'no', 'false'].includes(txt)) {
      return false;
    }
    return null;
  }

  private async inicializarCambioResponsablePagador(): Promise<void> {
    this.limpiarEstadoUiCambioTitularResponsable();
    this.tipoContratanteControl.setValue('cambiar', { emitEvent: false });
    const numeroContrato = this.obtenerNumeroContratoSeleccionado();
    if (!numeroContrato) {
      this.cambioTitularMensajeAlerta =
        'No hay contrato seleccionado para cargar el responsable pagador actual.';
      this.checkValidacionCompletada();
      return;
    }

    const integrantesContrato =
      await this.cargarIntegrantesDesdeContratoActual();
    if (!this.parentescosActivos.length) {
      await this.cargarParentescosActivos();
    }
    const cab = await firstValueFrom(
      this.consultarDatosAfiliadoPagadorConDocumento(numeroContrato).pipe(
        catchError(() => of(null)),
      ),
    );
    if (!cab) {
      this.cambioTitularMensajeAlerta =
        'No fue posible obtener los datos del responsable de pago para validar la novedad. Intente nuevamente.';
      this.checkValidacionCompletada();
      return;
    }
    this.poblarVistaTitularActualDesdeResponsablePagador(cab);
    this.cargarIntegrantesSinResponsablePago(cab, integrantesContrato);
    this.precargarDatosContratanteActual();
    this.sincronizarFechaAplicacionPorDefectoSiCorresponde();
    this.cambioTitularRequisitosPreviosOk = true;
    this.tieneDebitoAutomaticoContratoActual =
      this.extraerBanderaDebitoAutomaticoContrato(cab);
    if (this.tieneDebitoAutomaticoContratoActual === true) {
      this.advertenciaDebitoActualCambioResponsable =
        'El cambio de responsable de pago desactiva el débito automático actual. Podrá activarlo nuevamente con el nuevo responsable si así lo desea.';
      this.showDebitoAutomaticoWarningModal();
    } else {
      this.advertenciaDebitoActualCambioResponsable = '';
    }
    this.checkValidacionCompletada();
  }

  private async inicializarCambioTitular(): Promise<void> {
    this.limpiarEstadoUiCambioTitularResponsable();
    const numeroContrato = this.obtenerNumeroContratoSeleccionado();
    if (!numeroContrato) {
      this.cambioTitularMensajeAlerta =
        'No hay contrato seleccionado para cargar el titular actual.';
      this.checkValidacionCompletada();
      return;
    }

    const integrantesContrato =
      await this.cargarIntegrantesDesdeContratoActual();

    const cab = await firstValueFrom(
      this.consultarDatosAfiliadoPagadorConDocumento(numeroContrato).pipe(
        catchError(() => of(null)),
      ),
    );
    if (!cab) {
      this.cambioTitularMensajeAlerta =
        'No fue posible obtener los datos del responsable de pago para validar la novedad. Intente nuevamente.';
      this.checkValidacionCompletada();
      return;
    }
    this.poblarVistaTitularActualDesdeResponsablePagador(cab);
    this.cargarIntegrantesSinResponsablePago(cab, integrantesContrato);
    this.inicializarCambioResponsablePagador();

    this.sincronizarFechaAplicacionPorDefectoSiCorresponde();
    this.cambioTitularRequisitosPreviosOk = true;
    this.checkValidacionCompletada();
  }

  private esParentescoTitular(parentesco: string): boolean {
    return (
      String(parentesco ?? '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase() === 'titular'
    );
  }

  /** Titular en textos tipo «1 - Titular», «Titular - …», etc. */
  private esParentescoTitularFlexible(valor: unknown): boolean {
    if (valor && typeof valor === 'object') {
      const o = valor as Record<string, unknown>;
      const nested = String(
        o['nombre'] ?? o['Nombre'] ?? o['codigo'] ?? o['Codigo'] ?? '',
      );
      return nested ? this.esParentescoTitularFlexible(nested) : false;
    }
    const t = this.normalizarParentescoTabla(valor);
    if (!t) {
      return false;
    }
    if (t === 'titular') {
      return true;
    }
    return /\btitular\b/.test(t);
  }

  /** Clave estable por documento (sin tarifas/anexo) para cruzar origen/destino. */
  private buildIntegranteDocumentoKey(
    tipoDocumento?: string,
    numeroDocumento?: string,
  ): string {
    const tipo = (tipoDocumento || '').replace(/[^A-Za-z]/g, '').toUpperCase();
    const dig = this.soloDigitosIdentificacion(String(numeroDocumento ?? ''));
    return `${tipo}|${dig}`;
  }

  private buscarIntegranteTitularDesdeContrato(): IntegranteContrato | null {
    const lista = this.contratoSeleccionado?.integrantes ?? [];
    const titular = lista.find((i) => this.esParentescoTitular(i?.parentesco));
    return titular ?? null;
  }

  private poblarVistaTitularActualDesdeIntegrante(
    integrante: IntegranteContrato,
  ): void {
    const rawId = String(integrante?.identificacion ?? '').trim();
    const parsed = this.parseIdentificacionTipoNumero(rawId);
    let tipoTexto = '—';
    if (parsed.tipoCodigo) {
      const tipo = (this.tiposDocumentoContratante ?? []).find(
        (t: any) =>
          String(t?.codigo ?? '')
            .trim()
            .toUpperCase() === parsed.tipoCodigo.toUpperCase(),
      );
      const nombreTipo =
        String(
          (tipo as any)?.nombre ??
            (tipo as any)?.tipo_documento ??
            (tipo as any)?.tipoDocumento ??
            '',
        ).trim() || parsed.tipoCodigo;
      tipoTexto = `${parsed.tipoCodigo} — ${nombreTipo}`;
    }
    const numeroTexto = parsed.numero
      ? this.formatearNumeroConPuntos(parsed.numero)
      : this.formatearNumeroConPuntos(this.soloDigitosIdentificacion(rawId));

    this.titularActualVista = {
      tipoTexto,
      numeroTexto,
      nombreCompleto: String(integrante?.nombre ?? '').trim(),
    };
  }

  private poblarVistaTitularActualDesdeResponsablePagador(
    cab: ContratoContratanteCabeceraDTO,
  ): void {
    const tipoCodigo = String(cab.tipoDocumento ?? '').trim();
    const numero = String(cab.numeroDocumento ?? '').trim();
    const tipo = (this.tiposDocumentoContratante ?? []).find(
      (t: any) =>
        String(t?.codigo ?? '')
          .trim()
          .toUpperCase() === tipoCodigo.toUpperCase(),
    );
    const nombreTipo =
      String(
        (tipo as any)?.nombre ??
          (tipo as any)?.tipo_documento ??
          (tipo as any)?.tipoDocumento ??
          '',
      ).trim() || tipoCodigo;
    const nombreCompleto = [
      String(cab.primerNombre ?? '').trim(),
      String(cab.segundoNombre ?? '').trim(),
      String(cab.primerApellido ?? '').trim(),
      String(cab.segundoApellido ?? '').trim(),
    ]
      .filter(Boolean)
      .join(' ');

    this.titularActualVista = {
      tipoTexto: tipoCodigo ? `${tipoCodigo} — ${nombreTipo}` : '—',
      numeroTexto: this.formatearNumeroConPuntos(numero),
      nombreCompleto: nombreCompleto || '—',
    };
  }

  private cargarIntegrantesSinResponsablePago(
    cab: ContratoContratanteCabeceraDTO,
    integrantesBase: IntegranteContrato[],
  ): void {
    const tipoResp = this.normalizarCodigoTipoDocumento(
      String(cab.tipoDocumento ?? ''),
    );
    const numResp = this.soloDigitosIdentificacion(
      String(cab.numeroDocumento ?? ''),
    );
    const integrantes = Array.isArray(integrantesBase) ? integrantesBase : [];

    this.integrantesSinTitular = integrantes
      .filter((integrante: IntegranteContrato) => {
        if (this.esParentescoTitularFlexible(integrante?.parentesco)) {
          return false;
        }

        const rawId = String(integrante?.identificacion ?? '').trim();
        const parsed = this.parseIdentificacionTipoNumero(rawId);
        const tipoInt = this.normalizarCodigoTipoDocumento(
          parsed.tipoCodigo || '',
        );
        const numInt = parsed.numero || this.soloDigitosIdentificacion(rawId);
        const esResponsable =
          !!numResp &&
          !!numInt &&
          numInt === numResp &&
          tipoInt.toUpperCase() === tipoResp.toUpperCase();
        return !esResponsable;
      })
      .map((i) => ({
        ...i,
        seleccionado: false,
      }));
  }

  /**
   * MP-FT-1358: obtener integrantes del contrato actual desde backend.
   * Usamos `beneficiariosTarifa` como fuente de integrantes y parentescos.
   */
  private async cargarIntegrantesDesdeContratoActual(): Promise<
    IntegranteContrato[]
  > {
    const numeroContrato = this.obtenerNumeroContratoSeleccionado();
    if (!numeroContrato) {
      return this.contratoSeleccionado?.integrantes ?? [];
    }
    const existentes = this.contratoSeleccionado?.integrantes ?? [];

    try {
      const resp = await firstValueFrom(
        this.beneficiariosTarifaService
          .getBeneficiariosTarifa(numeroContrato)
          .pipe(catchError(() => of(null))),
      );

      const lista = resp?.beneficiarios;
      if (!Array.isArray(lista) || lista.length === 0) {
        return existentes;
      }
      return lista.map((item: any, idx: number) =>
        this.mapearBeneficiarioATIntegrante(item, idx),
      );
    } catch {
      // Si el backend falla, preferimos no llenar información quemada.
      return existentes;
    }
  }

  private mapearBeneficiarioATIntegrante(
    item: any,
    idx: number,
  ): IntegranteContrato {
    const identificacionRaw =
      item?.Identificacion ??
      item?.identificacion ??
      item?.numeroIdentificacion ??
      '';

    const nombreUsuario =
      item?.NombreUsuario ??
      item?.nombreUsuario ??
      item?.Nombre ??
      item?.nombre ??
      '';

    const parentesco =
      item?.Parentesco ?? item?.parentesco ?? item?.parentescoActual ?? '';

    const tipoNumero = this.parseIdentificacionTipoNumero(
      String(identificacionRaw ?? ''),
    );

    const identificacion =
      String(identificacionRaw ?? '').trim() ||
      (tipoNumero.tipoCodigo && tipoNumero.numero
        ? `${tipoNumero.tipoCodigo} - ${tipoNumero.numero}`
        : '');

    return {
      id: String(idx + 1),
      identificacion,
      nombre: String(nombreUsuario).trim(),
      parentesco: String(parentesco).trim(),
      seleccionado: false,
    };
  }

  private parseIdentificacionTipoNumero(raw: string): {
    tipoCodigo: string;
    numero: string;
  } {
    const s = String(raw ?? '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!s) {
      return { tipoCodigo: '', numero: '' };
    }

    const m = s.match(/^([A-Za-z0-9]+)\s*-\s*(.+)$/);
    if (m) {
      const tipoCodigo = String(m[1] ?? '')
        .trim()
        .toUpperCase();
      const numero = this.soloDigitosIdentificacion(m[2] ?? '');
      return { tipoCodigo, numero };
    }

    // Si viene sin el formato "CC - 123", asumimos que todo es número.
    return { tipoCodigo: '', numero: this.soloDigitosIdentificacion(s) };
  }

  private formatearNumeroConPuntos(rawNumero: string): string {
    const digits = this.soloDigitosIdentificacion(rawNumero);
    if (!digits) return '';

    // Inserta "." cada 3 dígitos desde la derecha.
    const withDots = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return withDots;
  }

  private cargarIntegrantesSinTitular(): void {
    const integrantes = this.contratoSeleccionado?.integrantes ?? [];

    // Mostrar integrantes distintos a Titular. No precargamos un nuevo titular por defecto.
    this.integrantesSinTitular = integrantes
      .filter(
        (integrante: IntegranteContrato) =>
          !this.esParentescoTitular(integrante?.parentesco),
      )
      .map((i) => ({
        ...i,
        seleccionado: false,
      }));
  }

  public seleccionarNuevoTitular(integrante: IntegranteContrato): void {
    if (!this.cambioTitularRequisitosPreviosOk || this.disabled) {
      return;
    }

    this.nuevoTitularSeleccionadoControl.setValue(integrante);

    // Deseleccionar otros integrantes
    this.integrantesSinTitular.forEach((i) => (i.seleccionado = false));
    integrante.seleccionado = true;

    this.checkValidacionCompletada();
  }

  public isTitularSeleccionado(integrante: IntegranteContrato): boolean {
    return this.nuevoTitularSeleccionadoControl.value?.id === integrante.id;
  }

  public onParentescoDestinoCambioResponsable(
    integrante: IntegranteContrato,
    parentesco: any,
  ): void {
    if (!integrante) {
      return;
    }
    (integrante as any).parentescoDestino = parentesco;
    this.checkValidacionCompletada();
  }

  private esParentescoNombre(
    parentesco: any,
    nombreEsperado: 'titular' | 'conyuge',
  ): boolean {
    const nombre = String(
      parentesco?.nombre ?? parentesco?.Nombre ?? parentesco ?? '',
    )
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
    return nombre === nombreEsperado;
  }

  public obtenerParentescosDestinoCambioResponsable(
    integrante: IntegranteContrato,
  ): any[] {
    const usados = (this.integrantesSinTitular || [])
      .filter((i: any) => i !== integrante)
      .map((i: any) => i?.parentescoDestino)
      .filter(Boolean);

    const titularYaUsado = usados.some((p: any) =>
      this.esParentescoNombre(p, 'titular'),
    );
    const conyugeYaUsado = usados.some((p: any) =>
      this.esParentescoNombre(p, 'conyuge'),
    );

    return (this.parentescosActivos || []).filter((p: any) => {
      if (this.esParentescoNombre(p, 'titular')) {
        return false;
      }
      if (this.esParentescoNombre(p, 'conyuge') && conyugeYaUsado) {
        return false;
      }
      // Si en algún ambiente llegara a venir "Titular" habilitado por código distinto,
      // también bloquearlo por control de unicidad.
      if (this.esParentescoNombre(p, 'titular') && titularYaUsado) {
        return false;
      }
      return true;
    });
  }

  // Métodos para Cambio de tarifa (tipo 6)
  private cargarTarifasParaCambio(): void {
    const tieneOrigen = !!this.obtenerFilaContratoOrigenParaTarifas();
    if (!tieneOrigen) {
      this.errorMessageTarifasCambio = 'No se ha seleccionado un contrato';
      this.hasErrorTarifasCambio = true;
      this.tarifasCambioDisponibles = [];
      this.tarifasCambioSubject.next([]);
      this.checkValidacionCompletada();
      this.syncTarifaCambioControlDisabled();
      return;
    }

    const params = this.construirRequestTarifasCambioOrigen();
    if (!params) {
      this.hasErrorTarifasCambio = true;
      this.errorMessageTarifasCambio =
        'No se pudo determinar la línea de negocio, la cuenta o el programa del contrato origen.';
      this.tarifasCambioDisponibles = [];
      this.tarifasCambioSubject.next([]);
      this.checkValidacionCompletada();
      this.syncTarifaCambioControlDisabled();
      return;
    }

    if (!environment.production) {
      const fila = this.obtenerFilaContratoOrigenParaTarifas();
      console.info('[cambio-tarifa] prm_tipo_plan desde cuenta (tras guion):', {
        cuentaRaw: leerCuentaAfilmed(fila),
        prm_tipo_plan: params.prm_tipo_plan,
        prm_programa: params.prm_programa,
        prm_linea_negocio: params.prm_linea_negocio,
        TipoPlan: fila?.TipoPlan,
      });
    }

    this.isLoadingTarifasCambio = true;
    this.hasErrorTarifasCambio = false;
    this.errorMessageTarifasCambio = '';
    this.syncTarifaCambioControlDisabled();

    this.tarifasDestinoService
      .getTarifasDestino(params)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoadingTarifasCambio = false;
          this.syncTarifaCambioControlDisabled();
        }),
      )
      .subscribe({
        next: (tarifas) => {
          const list = (tarifas || []).map((t) => {
            const nombre = (t.nombre || t.descripcion || t.codigo || '').trim();
            const valorTarifa = Number(t.valorTarifa ?? 0);
            return {
              codigo: t.codigo,
              descripcion: t.descripcion ?? nombre,
              idSubcuenta: String(t.idSubcuenta ?? '').trim(),
              nombre,
              valorTarifa,
              valorBase: valorTarifa,
            };
          });
          if (list.length === 0) {
            this.errorMessageTarifasCambio =
              MSG_MP_FT_1358_CAMBIO_TARIFA_SIN_REGISTROS;
            this.hasErrorTarifasCambio = true;
            this.tarifasCambioDisponibles = [];
            this.tarifasCambioSubject.next([]);
          } else {
            this.tarifasCambioDisponibles = list;
            this.tarifasCambioSubject.next(list);
          }
          this.checkValidacionCompletada();
        },
        error: () => {
          this.hasErrorTarifasCambio = true;
          this.errorMessageTarifasCambio =
            'Error al cargar las tarifas. Intente nuevamente.';
          this.tarifasCambioDisponibles = [];
          this.tarifasCambioSubject.next([]);
          this.checkValidacionCompletada();
        },
      });
  }

  public onTarifaCambioSelected(tarifa: any): void {
    this.tarifaCambioControl.setValue(tarifa);

    if (tarifa) {
      const req = this.construirRequestValorTarifaCotizadorTrl(tarifa);
      if (!req) {
        const valorBase = Number(tarifa.valorTarifa ?? tarifa.valorBase ?? 0);
        this.valorTotalCuotaIvaControl.setValue(
          Number.isFinite(valorBase) ? valorBase : null,
        );
        this.checkValidacionCompletada();
        return;
      }
      this.tarifasDestinoService
        .getValorTarifaCotizadorTrl(req)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (valor) => {
            if (valor != null) {
              this.valorTotalCuotaIvaControl.setValue(valor);
            } else {
              const valorBase = Number(
                tarifa.valorTarifa ?? tarifa.valorBase ?? 0,
              );
              this.valorTotalCuotaIvaControl.setValue(
                Number.isFinite(valorBase) ? valorBase : null,
              );
            }
            this.checkValidacionCompletada();
          },
          error: () => {
            const valorBase = Number(
              tarifa.valorTarifa ?? tarifa.valorBase ?? 0,
            );
            this.valorTotalCuotaIvaControl.setValue(
              Number.isFinite(valorBase) ? valorBase : null,
            );
            this.checkValidacionCompletada();
          },
        });
    } else {
      this.valorTotalCuotaIvaControl.setValue(null);
      this.checkValidacionCompletada();
    }
  }

  private construirRequestValorTarifaCotizadorTrl(
    tarifa: any,
  ): TarifaCotizadorTrlRequest | null {
    const contrato = (this.filaContratoAfilmedPaso1 ||
      this.obtenerContratoDesdeStorage() ||
      {}) as any;
    const integrante = this.obtenerIntegranteReferenciaCotizadorTrl();
    const prm_cuenta = this.extraerCodigoCuentaCotizadorTrl(
      leerCuentaAfilmed(contrato as ContratoAfilmedDTO),
    );
    const prm_subcta = String(
      tarifa?.idSubcuenta ??
        contrato.TipoSubCuenta ??
        contrato.tipoSubCuenta ??
        contrato.SubCuenta ??
        '',
    ).trim();
    const prm_plan_codi = String(
      this.obtenerProgramaContrato().split('|')[0] ?? '',
    ).trim();
    const prm_tari = String(tarifa?.codigo ?? '').trim();
    if (!prm_cuenta || !prm_subcta || !prm_plan_codi || !prm_tari) {
      return null;
    }
    return {
      prm_cuenta,
      prm_subcta,
      prm_plan_codi,
      prm_tari,
      prm_edad: this.resolverEdadCotizadorTrl(integrante),
      prm_fecha: '',
      vigen_desde: '',
      prm_paren: this.resolverParentescoCotizadorTrl(integrante),
      prm_sexo: this.resolverSexoCotizadorTrl(integrante),
      prm_inte_tipo:
        String(integrante?.inte_tipo ?? integrante?.inteTipo ?? 'I').trim() ||
        'I',
      cant_inte: '',
    };
  }

  private extraerCodigoCuentaCotizadorTrl(rawCuenta: unknown): string {
    const raw = String(rawCuenta ?? '').trim();
    if (!raw) {
      return '';
    }
    const beforeSeparator = raw.split('-')[0]?.split('|')[0]?.trim() ?? raw;
    const soloNumero = beforeSeparator.match(/^(\d+)/);
    return soloNumero ? soloNumero[1] : beforeSeparator;
  }

  private obtenerIntegranteReferenciaCotizadorTrl(): any | null {
    const seleccionados = this.obtenerIntegrantesSeleccionados();
    const filas = Array.isArray(this.beneficiariosTarifa)
      ? this.beneficiariosTarifa
      : [];

    if (seleccionados.length > 0 && filas.length > 0) {
      const seleccionado = seleccionados[0];
      const match = filas.find((fila: any) =>
        this.filaBeneficiarioCoincideConSeleccion(fila, [seleccionado]),
      );
      if (match) {
        return match;
      }
    }

    if (seleccionados.length > 0) {
      return seleccionados[0];
    }

    const titular = filas.find((fila: any) => {
      const codigo = String(
        fila?.codigoParentesco ?? fila?.CodigoParentesco ?? '',
      )
        .trim()
        .toUpperCase();
      const parentesco = String(fila?.parentesco ?? '')
        .trim()
        .toUpperCase();
      return codigo === 'T' || parentesco.includes('TITULAR');
    });
    if (titular) {
      return titular;
    }

    return filas.length > 0 ? filas[0] : null;
  }

  private resolverEdadCotizadorTrl(integrante: any): string {
    const edad = Number(integrante?.edad ?? integrante?.Edad ?? NaN);
    if (Number.isFinite(edad) && edad > 0) {
      return String(Math.trunc(edad));
    }
    return '50';
  }

  private resolverParentescoCotizadorTrl(integrante: any): string {
    const codPar = String(
      integrante?.codigoParentesco ?? integrante?.CodigoParentesco ?? '',
    )
      .trim()
      .toUpperCase();
    if (codPar) {
      return codPar;
    }

    const parentesco = String(integrante?.parentesco ?? '')
      .trim()
      .toUpperCase();
    if (parentesco.includes('TITULAR')) {
      return 'T';
    }
    return 'T';
  }

  private resolverSexoCotizadorTrl(integrante: any): string {
    const raw = String(
      integrante?.sexo ??
        integrante?.Sexo ??
        integrante?.genero ??
        integrante?.Genero ??
        '',
    )
      .trim()
      .toUpperCase();
    if (!raw) {
      return 'A';
    }
    if (raw === 'M' || raw.includes('MASC')) {
      return 'M';
    }
    if (raw === 'F' || raw.includes('FEM')) {
      return 'F';
    }
    if (raw === 'A') {
      return 'A';
    }
    return 'A';
  }

  public displayTarifaCambio = (tarifa: any): string => {
    if (!tarifa) return '';
    const cod = String(tarifa.codigo ?? '').trim();
    const nombre = String(tarifa.nombre || tarifa.descripcion || '').trim();
    if (!nombre || nombre === cod) {
      return cod;
    }
    return `${cod} - ${nombre}`;
  };

  public clearTarifaCambioSelection(): void {
    this.tarifaCambioControl.setValue(null);
    this.valorTotalCuotaIvaControl.setValue(null);
    this.checkValidacionCompletada();
  }

  public retryLoadTarifasCambio(): void {
    this.cargarTarifasParaCambio();
  }

  public trackByTarifaCambioCodigo(index: number, tarifa: any): string {
    return tarifa ? tarifa.codigo : index.toString();
  }

  // Métodos para Adiciona Anexo (tipo 7) — consulta MP-FT-1358 `adiciona-anexo/consulta`
  private procesarAdicionaAnexo(): void {
    this.mostrarTablaAdicionaAnexo = true;
    this.cargandoIntegrantesAdicionaAnexo = true;
    this.errorAdicionaAnexo = '';
    this.advertenciaAdicionaAnexo = '';

    if (
      !this.integrantesSeleccionados ||
      this.integrantesSeleccionados.length === 0
    ) {
      this.errorAdicionaAnexo =
        'Debe seleccionar al menos un integrante en el paso 1 para continuar con Adiciona anexo.';
      this.cargandoIntegrantesAdicionaAnexo = false;
      this.mostrarTablaAdicionaAnexo = false;
      this.checkValidacionCompletada();
      return;
    }

    const payload = this.construirPayloadAdicionaAnexoConsulta();
    if (!payload) {
      this.errorAdicionaAnexo =
        'No se pudo armar la consulta de anexos: verifique el contrato seleccionado (ProgramaCódigo o número de contrato) y los integrantes elegidos en el paso 1.';
      this.cargandoIntegrantesAdicionaAnexo = false;
      this.mostrarTablaAdicionaAnexo = false;
      this.checkValidacionCompletada();
      return;
    }

    this.isLoadingAnexos = true;
    this.hasErrorAnexos = false;
    this.anexosCargados = false;

    this.adicionaAnexoConsultaService
      .consulta(payload)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.cargandoIntegrantesAdicionaAnexo = false;
          this.isLoadingAnexos = false;
        }),
      )
      .subscribe({
        next: (resp) => this.aplicarRespuestaAdicionaAnexoConsulta(resp),
        error: () => {
          this.hasErrorAnexos = true;
          this.errorAdicionaAnexo =
            'Error al consultar anexos para esta novedad. Intente nuevamente.';
          this.anexosDisponibles = [];
          this.integrantesAdicionaAnexo = [];
          this.mostrarTablaAdicionaAnexo = false;
          this.anexosCargados = false;
          this.checkValidacionCompletada();
        },
      });
  }

  private construirPayloadAdicionaAnexoConsulta(): AdicionaAnexoConsultaRequestPayload | null {
    return this.construirPayloadConsultaAnexosContratoOrigen();
  }

  /** `GrupoPrograma` del contrato seleccionado en paso 1 (sin programa/grupo destino del formulario). */
  private obtenerGrupoProgramaDesdeContratoSeleccionadoPaso1(): string {
    const fila =
      this.filaContratoAfilmedPaso1 ??
      this.obtenerFilaContratoOrigenParaTarifas();
    const cs = this.contratoSeleccionado;
    const raw = String(
      fila?.GrupoPrograma ??
        cs?.GrupoPrograma ??
        (cs as { grupoPrograma?: string })?.grupoPrograma ??
        '',
    ).trim();
    if (raw) {
      return raw;
    }
    const storage = this.obtenerContratoDesdeStorage();
    return String(
      storage?.GrupoPrograma ?? storage?.grupoPrograma ?? '',
    ).trim();
  }

  private construirIntegrantesRequestAdicionaAnexo(): any[] {
    const rows = this.integrantesSeleccionados ?? [];
    return rows.map((row: any, index: number) => {
      const ident = String(row.identificacion ?? '').trim();
      const { tipoDocumento, nroDocumento } =
        this.parseTipoYNroDocumentoDesdeIdentificacion(ident);
      const edadRaw = Number(row.edad);
      const edad =
        Number.isFinite(edadRaw) && edadRaw >= 0 ? Math.floor(edadRaw) : 0;
      const gen = String(row.genero ?? '')
        .trim()
        .toUpperCase();
      const genero = gen ? gen.charAt(0) : '';
      const nro = Number(row.no);
      return {
        nro: Number.isFinite(nro) && nro > 0 ? nro : index + 1,
        tipoDocumento,
        nroDocumento,
        nombreUsuario: String(row.nombreUsuario ?? row.nombre ?? '').trim(),
        edad,
        genero,
        parentesco: String(row.parentesco ?? '').trim(),
        tieneAnexoActual: this.tieneAnexoActualDesdeFilaIntegrante(row),
      };
    });
  }

  /**
   * Separa tipo y número desde el texto de identificación del paso 1 (p. ej. `CC 94449309`).
   */
  private parseTipoYNroDocumentoDesdeIdentificacion(ident: string): {
    tipoDocumento: string;
    nroDocumento: string;
  } {
    const s = String(ident ?? '').trim();
    if (!s) {
      return { tipoDocumento: '', nroDocumento: '' };
    }
    const m = s.match(/^([A-Za-zÁÉÍÓÚÑñ]{1,6})[\s\-]+(.+)$/);
    if (m) {
      const tipoDocumento = m[1].toUpperCase();
      const rest = m[2].trim();
      const soloDigitos = rest.replace(/\D/g, '');
      const nroDocumento = soloDigitos || rest;
      return { tipoDocumento, nroDocumento };
    }
    const soloDigitos = s.replace(/\D/g, '');
    if (soloDigitos.length >= 5) {
      return { tipoDocumento: '', nroDocumento: soloDigitos };
    }
    return { tipoDocumento: '', nroDocumento: s };
  }

  private tieneAnexoActualDesdeFilaIntegrante(row: any): boolean {
    const v = row?.anexo;
    if (typeof v === 'boolean') {
      return v;
    }
    if (typeof v === 'number') {
      return v > 0;
    }
    const t = String(v ?? '')
      .trim()
      .toLowerCase();
    if (!t) {
      return false;
    }
    if (
      t === 'no' ||
      t === 'n' ||
      t === '0' ||
      t === 'n/a' ||
      t === 'ninguno' ||
      t === 'sin anexo'
    ) {
      return false;
    }
    if (
      t === 'sí' ||
      t === 'si' ||
      t === 's' ||
      t === '1' ||
      t === 'true' ||
      t === 'x'
    ) {
      return true;
    }
    return true;
  }

  /**
   * Afilmed devuelve p. ej. `3 | CEM-EMERGENCIA MEDICA`; para anexos solo el id: `3`.
   */
  private extraerSoloNumeroLineaNegocio(
    raw: string | undefined | null,
  ): string {
    const s = String(raw ?? '').trim();
    if (!s) {
      return '';
    }
    const antesDePipe = (s.split('|')[0] ?? s).trim();
    const m = antesDePipe.match(/^(\d+)/);
    return m ? m[1] : '';
  }

  private mapCatalogoItemInterno(d: CatalogoAnexoConsultaDTO): any {
    return {
      codigo: `ID_${d.idPAnexos}`,
      codigoFormato: d.codigo,
      nombre: d.nombre,
      requiereAuditoria: !!d.requiereAuditoria,
      valorTarifa: 0,
      condiciones: {},
      idPAnexos: d.idPAnexos,
    };
  }

  /** Ítems de tabla/checkbox (cambio de plan / contrato) a partir del catálogo de `adiciona-anexo/consulta`. */
  private mapCatalogoConsultaAListaAnexosUi(
    catalog: CatalogoAnexoConsultaDTO[],
  ): any[] {
    return catalog
      .map((c) => {
        const m = this.mapCatalogoItemInterno(c);
        return {
          codigo: m.codigo,
          nombre: m.nombre,
          valorTarifa: m.valorTarifa ?? 0,
          codigoFormato: m.codigoFormato,
          idPAnexos: m.idPAnexos,
          requiereAuditoria: m.requiereAuditoria,
          condiciones: {
            edadMinima: null,
            edadMaxima: null,
            genero: null,
            parentesco: undefined,
          },
        };
      })
      .filter((x: any) => x.codigo && x.nombre);
  }

  /** Normaliza ítems del API (camelCase / PascalCase) antes de `mapCatalogoItemInterno`. */
  private mapCatalogoItemInternoDesdeApi(raw: any): any {
    const id = Number(raw?.idPAnexos ?? raw?.IdPAnexos ?? NaN);
    const dto: CatalogoAnexoConsultaDTO = {
      idPAnexos: Number.isFinite(id) ? id : 0,
      codigo: String(raw?.codigo ?? raw?.Codigo ?? ''),
      nombre: String(raw?.nombre ?? raw?.Nombre ?? ''),
      requiereAuditoria: !!(raw?.requiereAuditoria ?? raw?.RequiereAuditoria),
    };
    return this.mapCatalogoItemInterno(dto);
  }

  private crearAnexoNoAplicaInterno(): any {
    return {
      codigo: 'NO_APLICA',
      codigoFormato: 'NO_APLICA',
      nombre: 'No aplica',
      requiereAuditoria: false,
      valorTarifa: 0,
      condiciones: {},
    };
  }

  private aplicarRespuestaAdicionaAnexoConsulta(
    resp: AdicionaAnexoConsultaResponse,
  ): void {
    if (resp?.mensajeAdvertencia) {
      this.advertenciaAdicionaAnexo = resp.mensajeAdvertencia;
    }

    const filasApi = resp?.filas ?? [];
    let catalog = this.extraerAnexosDesdeRespuestaConsulta(resp);
    if (catalog.length === 0 && filasApi.length > 0) {
      catalog = this.catalogoAgregadoDesdeOpcionesFilas(filasApi);
    }

    const mappedCatalog = catalog.map((c) => this.mapCatalogoItemInterno(c));

    if (catalog.length === 0) {
      this.anexosDisponibles = [];
      this.anexosCargados = false;
      this.errorAdicionaAnexo =
        this.advertenciaAdicionaAnexo ||
        'No se encontraron anexos parametrizados para la línea de negocio, plan y grupo programa indicados.';
      this.integrantesAdicionaAnexo = [];
      this.mostrarTablaAdicionaAnexo = false;
      this.checkValidacionCompletada();
      return;
    }

    this.anexosDisponibles = [
      ...mappedCatalog,
      this.crearAnexoNoAplicaInterno(),
    ];
    this.anexosCargados = true;

    if (filasApi.length > 0) {
      this.integrantesAdicionaAnexo =
        this.construirIntegrantesDesdeFilasApi(filasApi);
      this.finalizarEstadoTablaAdicionaAnexo();
    } else {
      this.cargarIntegrantesAdicionaAnexoDesdePaso1();
      this.evaluarCondicionesAnexos();
    }

    this.checkValidacionCompletada();
  }

  /** Si `catalogoAnexos` viene vacío pero las filas traen `opcionesAnexo`, arma el catálogo global (evita error falso). */
  private catalogoAgregadoDesdeOpcionesFilas(
    filas: any[],
  ): CatalogoAnexoConsultaDTO[] {
    const byId = new Map<number, CatalogoAnexoConsultaDTO>();
    for (const raw of filas) {
      const opts =
        raw.opcionesAnexo ??
        raw.OpcionesAnexo ??
        raw.anexosPermitidos ??
        raw.AnexosPermitidos ??
        [];
      if (!Array.isArray(opts)) {
        continue;
      }
      for (const o of opts) {
        const id = Number(o?.idPAnexos ?? o?.IdPAnexos);
        if (!Number.isFinite(id) || id < 0) {
          continue;
        }
        if (!byId.has(id)) {
          byId.set(id, {
            idPAnexos: id,
            codigo: String(o?.codigo ?? o?.Codigo ?? ''),
            nombre: String(o?.nombre ?? o?.Nombre ?? ''),
            requiereAuditoria: !!(o?.requiereAuditoria ?? o?.RequiereAuditoria),
          });
        }
      }
    }
    return Array.from(byId.values());
  }

  /**
   * Respuesta por fila: solo `opcionesAnexo` + `incluyeNoAplica` para ese integrante.
   * No rellenar con el catálogo global si `opcionesAnexo` viene vacío.
   */
  private construirIntegrantesDesdeFilasApi(
    filas: AdicionaAnexoFilaConsultaDTO[] | any[],
  ): any[] {
    return filas.map((raw, index) => {
      const f = raw as any;
      const opcionesRaw =
        f.opcionesAnexo ??
        f.OpcionesAnexo ??
        f.anexosPermitidos ??
        f.AnexosPermitidos ??
        [];
      const permitidosMapped = Array.isArray(opcionesRaw)
        ? opcionesRaw.map((d: any) => this.mapCatalogoItemInternoDesdeApi(d))
        : [];

      const incluyeNoAplica = !!(
        f.incluyeNoAplica ??
        f.IncluyeNoAplica ??
        false
      );

      const destinoHab = f.anexoDestinoHabilitado ?? f.AnexoDestinoHabilitado;
      const legacyCampo = f.campoHabilitado ?? f.CampoHabilitado;

      let campoHabilitado: boolean;
      if (typeof destinoHab === 'boolean') {
        campoHabilitado = destinoHab;
      } else if (typeof legacyCampo === 'boolean') {
        campoHabilitado = legacyCampo;
      } else {
        campoHabilitado = permitidosMapped.length > 0 || incluyeNoAplica;
      }

      const anexosHabilitados: any[] = [];
      if (campoHabilitado) {
        anexosHabilitados.push(...permitidosMapped);
        if (incluyeNoAplica) {
          anexosHabilitados.push(this.crearAnexoNoAplicaInterno());
        }
        if (permitidosMapped.length === 0 && !incluyeNoAplica) {
          campoHabilitado = false;
        }
      }

      const nro = f.nro ?? f.Nro ?? index + 1;
      const vProg = Number(f.valorTarifaPrograma ?? f.ValorTarifaPrograma);
      const valorPrograma =
        Number.isFinite(vProg) && vProg > 0 ? vProg : 261000;
      const vAnexo = Number(f.valorTarifaAnexo ?? f.ValorTarifaAnexo);
      const valorTarifaAnexo = Number.isFinite(vAnexo) ? vAnexo : 0;

      return {
        numero: Number(nro) > 0 ? Number(nro) : index + 1,
        id: `fila-${index}`,
        identificacion: f.identificacion ?? f.Identificacion ?? '',
        nombreUsuario: f.nombreUsuario ?? f.NombreUsuario ?? '',
        parentesco: f.parentesco ?? f.Parentesco ?? '',
        edad: f.edad ?? f.Edad ?? 30,
        genero: f.genero ?? f.Genero ?? '',
        anexoDestino: [],
        anexosHabilitados,
        campoHabilitado,
        valorTarifaAnexo,
        valorTarifaPrograma: valorPrograma,
        totalTarifa: valorTarifaAnexo + valorPrograma,
        requiereAuditoria: false,
      };
    });
  }

  private cargarIntegrantesAdicionaAnexoDesdePaso1(): void {
    this.integrantesAdicionaAnexo = this.integrantesSeleccionados.map(
      (integrante: any, index) => {
        const nombreUsuario = String(
          integrante.nombreUsuario ?? integrante.nombre ?? '',
        ).trim();
        const edadRaw = Number(integrante.edad);
        const edad =
          Number.isFinite(edadRaw) && edadRaw >= 0 ? Math.floor(edadRaw) : 30;
        const gen = String(integrante.genero ?? '')
          .trim()
          .toUpperCase();
        const genero = gen ? gen.charAt(0) : 'F';
        const nro = Number(integrante.no);

        return {
          numero: Number.isFinite(nro) && nro > 0 ? nro : index + 1,
          id: integrante.id ?? `paso1-${index}`,
          identificacion: integrante.identificacion ?? '',
          nombreUsuario,
          parentesco: integrante.parentesco ?? '',
          edad,
          genero,
          anexoDestino: [],
          anexosHabilitados: [],
          campoHabilitado: false,
          valorTarifaAnexo: 0,
          valorTarifaPrograma: 0,
          totalTarifa: 0,
          requiereAuditoria: false,
        };
      },
    );

    // `evaluarCondicionesAnexos` la invoca `aplicarRespuestaAdicionaAnexoConsulta` (evita doble pasada).
  }

  private evaluarCondicionesAnexos(): void {
    if (!this.anexosCargados) {
      return;
    }

    this.integrantesAdicionaAnexo.forEach((integrante) => {
      const anexosAplicables = this.anexosDisponibles.filter((anexo) => {
        if (anexo.codigo === 'NO_APLICA') return true;
        return this.cumpleCondicionesAnexo(integrante, anexo.condiciones);
      });

      integrante.anexosHabilitados = anexosAplicables;
      const anexosReales = anexosAplicables.filter(
        (anexo) => anexo.codigo !== 'NO_APLICA',
      );
      integrante.campoHabilitado = anexosReales.length > 0;

      if (!integrante.campoHabilitado) {
        integrante.anexoDestino = [];
        integrante.valorTarifaAnexo = 0;
        this.calcularTotalTarifa(integrante);
      }
    });

    this.finalizarEstadoTablaAdicionaAnexo();
  }

  private finalizarEstadoTablaAdicionaAnexo(): void {
    const integrantesConAnexos = this.integrantesAdicionaAnexo.filter(
      (i) => i.campoHabilitado,
    );
    if (integrantesConAnexos.length === 0) {
      this.errorAdicionaAnexo =
        this.errorAdicionaAnexo ||
        "No es posible asociar Anexos a esta novedad. Verifique la configuración de plan, línea de negocio, grupo programa y programa destino en el módulo 'Parametrización Anexos'.";
      this.mostrarTablaAdicionaAnexo = false;
    } else {
      this.errorAdicionaAnexo = '';
      this.mostrarTablaAdicionaAnexo = true;
      this.calcularTotalCuotaIvaAdicionaAnexo();
    }
  }

  /**
   * Condiciones vacías o con propiedades no definidas = no filtran (MP-FT-1358).
   * Importante: usar `!= null`, no `!== null`, porque `undefined !== null` era true y
   * el género vacío del integrante fallaba contra `condiciones.genero` undefined.
   */
  private cumpleCondicionesAnexo(integrante: any, condiciones: any): boolean {
    if (!condiciones || typeof condiciones !== 'object') {
      return true;
    }

    const edadMin = condiciones.edadMinima;
    if (
      edadMin != null &&
      Number.isFinite(Number(edadMin)) &&
      integrante.edad < Number(edadMin)
    ) {
      return false;
    }

    const edadMax = condiciones.edadMaxima;
    if (
      edadMax != null &&
      Number.isFinite(Number(edadMax)) &&
      integrante.edad > Number(edadMax)
    ) {
      return false;
    }

    const gen = condiciones.genero;
    if (gen != null && String(gen).trim() !== '' && integrante.genero !== gen) {
      return false;
    }

    const par = condiciones.parentesco;
    if (Array.isArray(par) && par.length > 0) {
      if (!par.includes(integrante.parentesco)) {
        return false;
      }
    }

    return true;
  }

  public onAnexoDestinoSelected(
    integrante: any,
    anexosSeleccionados: any[] | any,
  ): void {
    let seleccion = Array.isArray(anexosSeleccionados)
      ? [...anexosSeleccionados]
      : anexosSeleccionados
        ? [anexosSeleccionados]
        : [];

    // Validar que no se seleccione "No aplica" con otros anexos
    const tieneNoAplica = seleccion.some(
      (a: any) => this.codigoAnexoSeleccionado(a) === 'NO_APLICA',
    );
    const tieneOtrosAnexos = seleccion.some(
      (a: any) => this.codigoAnexoSeleccionado(a) !== 'NO_APLICA',
    );

    if (tieneNoAplica && tieneOtrosAnexos) {
      // Remover "No aplica" si hay otros anexos seleccionados
      seleccion = seleccion.filter(
        (a: any) => this.codigoAnexoSeleccionado(a) !== 'NO_APLICA',
      );
    }

    integrante.anexoDestino = seleccion;

    // Calcular valor de tarifa de anexos
    let valorTotalAnexos = 0;
    let requiereAuditoria = false;

    seleccion.forEach((anexo: any) => {
      if (this.codigoAnexoSeleccionado(anexo) !== 'NO_APLICA') {
        valorTotalAnexos += Number(anexo?.valorTarifa ?? 0);
        if (anexo?.requiereAuditoria) {
          requiereAuditoria = true;
        }
      }
    });

    integrante.valorTarifaAnexo = valorTotalAnexos;
    integrante.requiereAuditoria = requiereAuditoria;

    this.calcularTotalTarifa(integrante);
    this.calcularTotalCuotaIvaAdicionaAnexo();
    this.checkValidacionCompletada();
  }

  private calcularTotalTarifa(integrante: any): void {
    integrante.totalTarifa =
      integrante.valorTarifaAnexo + integrante.valorTarifaPrograma;
  }

  private calcularTotalCuotaIvaAdicionaAnexo(): void {
    const subtotal = this.integrantesAdicionaAnexo.reduce(
      (total, integrante) => total + (Number(integrante.totalTarifa) || 0),
      0,
    );
    this.totalCuotaIvaAdicionaAnexo = subtotal;
    if (!this.isRestoringState) {
      this.persistState();
    }
  }

  /**
   * Tras F5: recalcula pies desde filas (valores de API ya con IVA).
   * Si no hay filas pero el JSON trae totales guardados (sesión previa), conserva ese número.
   */
  private sincronizarTotalesCuotaPostRestauracion(
    saved: TipoNovedadSelectorState,
  ): void {
    this.calcularTotalCuotaContratoNuevo();
    this.calcularTotalCuotaTrasladoExistente();
    this.calcularTotalCuotaIva();
    this.calcularTotalCuotaIvaAdicionaAnexo();

    if (
      this.integrantesContratoNuevo.length === 0 &&
      typeof saved.totalCuotaIvaContratoNuevo === 'number'
    ) {
      this.totalCuotaIvaContratoNuevo = saved.totalCuotaIvaContratoNuevo;
    }
    if (
      this.integrantesTrasladoExistente.length === 0 &&
      typeof saved.totalCuotaIvaTrasladoExistente === 'number'
    ) {
      this.totalCuotaIvaTrasladoExistente =
        saved.totalCuotaIvaTrasladoExistente;
    }
    if (
      this.beneficiariosTarifa.length === 0 &&
      typeof saved.totalCuotaIva === 'number'
    ) {
      this.totalCuotaIva = saved.totalCuotaIva;
    }
    if (
      this.integrantesAdicionaAnexo.length === 0 &&
      typeof saved.totalCuotaIvaAdicionaAnexo === 'number'
    ) {
      this.totalCuotaIvaAdicionaAnexo = saved.totalCuotaIvaAdicionaAnexo;
    }
  }

  public displayAnexo(anexo: any): string {
    if (!anexo) return '';
    const cod = String(anexo.codigoFormato ?? anexo.codigo ?? '').trim();
    return `${cod} - ${anexo.nombre ?? ''}`.trim();
  }

  public trackByIntegranteId(index: number, integrante: any): string {
    return integrante ? integrante.id : index.toString();
  }

  private codigoAnexoSeleccionado(anexo: any): string {
    if (anexo == null) {
      return '';
    }
    if (typeof anexo === 'string') {
      return anexo.trim().toUpperCase();
    }
    return String(anexo.codigo ?? anexo.codigoFormato ?? '')
      .trim()
      .toUpperCase();
  }

  private integranteTieneAnexoValido(integrante: any): boolean {
    const destinos = Array.isArray(integrante?.anexoDestino)
      ? integrante.anexoDestino
      : integrante?.anexoDestino
        ? [integrante.anexoDestino]
        : [];
    return (
      destinos.length > 0 &&
      destinos.some((a: any) => {
        const cod = this.codigoAnexoSeleccionado(a);
        return cod !== '' && cod !== 'NO_APLICA';
      })
    );
  }

  public validarAnexosRequeridos(): boolean {
    const integrantesHabilitados = this.integrantesAdicionaAnexo.filter(
      (i) => i.campoHabilitado,
    );

    if (integrantesHabilitados.length === 0) {
      return true; // Si no hay integrantes habilitados, no hay validación
    }

    return integrantesHabilitados.every((integrante) =>
      this.integranteTieneAnexoValido(integrante),
    );
  }

  public tieneAnexosConAuditoria(): boolean {
    return this.integrantesAdicionaAnexo.some(
      (integrante) => integrante.requiereAuditoria,
    );
  }

  private clearAllAdicionaAnexoFields(): void {
    this.mostrarTablaAdicionaAnexo = false;
    this.integrantesAdicionaAnexo = [];
    this.anexosDisponibles = [];
    this.totalCuotaIvaAdicionaAnexo = 0;
    this.cargandoIntegrantesAdicionaAnexo = false;
    this.errorAdicionaAnexo = '';
    this.advertenciaAdicionaAnexo = '';
    this.isLoadingAnexos = false;
    this.anexosCargados = false;
    this.hasErrorAnexos = false;
  }

  private setupContratanteListeners(): void {
    const camposEditables = [
      this.estadoCivilContratanteControl,
      this.generoContratanteControl,
      this.estratoSocialContratanteControl,
      this.nacionalidadContratanteControl,
      this.profesionContratanteControl,
      this.emailContratanteControl,
      this.ocupacionContratanteControl,
      this.tipoViaControl,
      this.direccionControl,
      this.complementoDireccionControl,
      this.barrioControl,
      this.departamentoControl,
      this.municipioControl,
      this.telefonoResidenciaControl,
      this.celularControl,
    ];

    camposEditables.forEach((control) => {
      control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.evaluarEstadoFormularioContratante();
      });
    });

    this.tipoContratanteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.actualizarEstadoTipoNumeroDocumento();
        this.evaluarEstadoFormularioContratante();
      });

    this.cambiarDatosContratanteControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.actualizarEstadoTipoNumeroDocumento();
        this.evaluarEstadoFormularioContratante();
      });
  }

  get numeroColumnasTabla(): number {
    return this.esTipoTrasladoContratoExistenteActivo() ? 11 : 10;
  }

  get numeroColumnasTablaBeneficiarios(): number {
    return this.esAdicionaAnexoSeleccionado() ? 7 : 10;
  }

  soloNumeros(event: Event, limite?: number): void {
    const input = event.target as HTMLInputElement;

    let valor = input.value.replace(/[^0-9]/g, '');

    if (limite != null) {
      valor = valor.slice(0, limite);
    }

    input.value = valor;

    this.numeroCuentaDebitoControl.setValue(valor, {
      emitEvent: false,
    });
  }

  private actualizarEstadoTipoNumeroDocumento(): void {
    const esMantener = this.tipoContratanteControl.value === 'mantener';

    if (esMantener) {
      this.tipoDocumentoContratanteControl.disable();
      this.numeroDocumentoContratanteControl.disable();
    } else {
      this.tipoDocumentoContratanteControl.enable();
      this.numeroDocumentoContratanteControl.enable();
    }

    // Siempre solo lectura
    this.codigoAsesorDestinoControl.disable();
    this.primerApellidoContratanteControl.disable();
    this.segundoApellidoContratanteControl.disable();
    this.primerNombreContratanteControl.disable();
    this.segundoNombreContratanteControl.disable();
    this.fechaNacimientoContratanteControl.disable();

    // Solo editable con el checkbox
    if (this.cambiarDatosContratanteControl.value) {
      this.estadoCivilContratanteControl.enable();
      this.generoContratanteControl.enable();
      this.estratoSocialContratanteControl.enable();
      this.nacionalidadContratanteControl.enable();
      this.profesionContratanteControl.enable();
      this.recibirCorrespondenciaControl.enable();
      this.emailContratanteControl.enable();
      this.ocupacionContratanteControl.enable();
      this.tipoViaControl.enable();
      this.numeroViaControl.enable();
      this.numeroPlacaControl.enable();
      this.direccionControl.enable();
      this.complementoDireccionControl.enable();
      this.barrioControl.enable();
      this.departamentoControl.enable();
      this.municipioControl.enable();
      this.telefonoResidenciaControl.enable();
      this.celularControl.enable();
    } else {
      this.estadoCivilContratanteControl.disable();
      this.generoContratanteControl.disable();
      this.estratoSocialContratanteControl.disable();
      this.nacionalidadContratanteControl.disable();
      this.profesionContratanteControl.disable();
      this.recibirCorrespondenciaControl.disable();
      this.emailContratanteControl.disable();
      this.ocupacionContratanteControl.disable();
      this.tipoViaControl.disable();
      this.numeroViaControl.disable();
      this.numeroPlacaControl.disable();
      this.direccionControl.disable();
      this.complementoDireccionControl.disable();
      this.barrioControl.disable();
      this.departamentoControl.disable();
      this.municipioControl.disable();
      this.telefonoResidenciaControl.disable();
      this.celularControl.disable();
    }
  }

  public onCambioDatosContratanteChange(): void {
    this.actualizarEstadoTipoNumeroDocumento();
  }

  /** Resuelve el código de género del catálogo (`FEM`/`MSC`) desde cualquier variante de texto del backend. */
  private resolverCodigoGeneroDesdeTexto(raw: unknown): string | null {
    const valor = String(raw ?? '').trim();
    if (!valor) {
      return null;
    }

    // 1) Coincidencia directa por código de catálogo (ej. ya viene "FEM"/"MSC").
    const porCodigo = (this.generos || []).find(
      (g: any) =>
        String(g?.Codigo ?? g?.codigo ?? '')
          .trim()
          .toUpperCase() === valor.toUpperCase(),
    );
    if (porCodigo) {
      return String(porCodigo.Codigo ?? porCodigo.codigo ?? '').trim();
    }

    // 2) Normalizar variantes tipo "F", "M", "Femenino", "Masculino".
    const norm = this.normalizarTextoComparacion(valor);

    if (norm === 'f' || norm.startsWith('femen')) {
      const row = (this.generos || []).find((g: any) =>
        this.normalizarTextoComparacion(
          String(g?.Nombre ?? g?.nombre ?? ''),
        ).includes('femen'),
      );
      return row ? String(row.Codigo ?? row.codigo ?? '').trim() : valor;
    }

    if (norm === 'm' || norm.startsWith('mascul')) {
      const row = (this.generos || []).find((g: any) =>
        this.normalizarTextoComparacion(
          String(g?.Nombre ?? g?.nombre ?? ''),
        ).includes('mascul'),
      );
      return row ? String(row.Codigo ?? row.codigo ?? '').trim() : valor;
    }

    // 3) Coincidencia directa por nombre completo.
    const porNombre = (this.generos || []).find(
      (g: any) =>
        this.normalizarTextoComparacion(
          String(g?.Nombre ?? g?.nombre ?? ''),
        ) === norm,
    );
    if (porNombre) {
      return String(porNombre.Codigo ?? porNombre.codigo ?? '').trim();
    }

    return valor;
  }

  public onTipoPlanDestinoColectivoSelected(tipoPlan: any): void {
    const enFlujoContratoNuevoOCambioPlan =
      this.esCambioPlanTipoSeleccionado() ||
      this.esTipoTrasladoContratoNuevoActivo();

    if (!enFlujoContratoNuevoOCambioPlan) {
      return;
    }

    const cod = String(tipoPlan?.codigo ?? '').toUpperCase();
    if (cod === 'COL' || cod === 'ACO') {
      this.tipoPlanDestinoContratoControl.setValue(tipoPlan, {
        emitEvent: false,
      });
      return;
    }

    this.colectivoControl.setValue(null, { emitEvent: true });
    this.subcuentaDestinoControl.setValue(null, { emitEvent: false });
    this.sucursalDestinoControl.setValue(null, { emitEvent: false });
    this.subcuentasDestino = [];
    this.sucursalesDestino = [];
    this.programaDestinoColectivoControl.setValue(null, { emitEvent: false });
    this.corteSubcuentaControl.setValue(null, { emitEvent: false });
    this.tarifaDestinoColectivoControl.setValue(null, { emitEvent: false });

    this.tipoPlanDestinoContratoControl.setValue(tipoPlan, {
      emitEvent: false,
    });
    this.onTipoPlanDestinoContratoSelected(tipoPlan);
  }
}
